/**
 * Map of known animation IDs to human-readable names.
 * Names are concise and suitable for UI display.
 *
 * Auto-generated from https://media.z-kris.com/2025/10/234.1%20anims.json
 * (Sourced from https://rune-server.org/threads/osrs-animation-dump.698658/)
 */
export const ANIMATION_NAMES: Map<number, string> = new Map([
    [0, "Swarm Walk"],
    [1, "Swarm Attack"],
    [2, "Swarm Block"],
    [3, "Paintball"],
    [4, "Paintsplash"],
    [5, "Paintball Travel"],
    [6, "Boulder Rolling"],
    [7, "Lore Bird Chathead Happy"],
    [8, "Lore Bird Chathead Idle"],
    [9, "Lore Bird Chathead Quizical"],
    [10, "Shark Walk"],
    [11, "Shark Divedown"],
    [12, "Shark Diveup"],
    [13, "Ghosthuman Walk Forward"],
    [14, "Ibansboltcasting"],
    [15, "Ghosthuman Ready"],
    [16, "Dm Walk"],
    [17, "Dm Ready"],
    [18, "Dm Attack"],
    [19, "Dm Block"],
    [20, "Dm Death"],
    [21, "Bdrag Walk"],
    [22, "Anma Chopping Failed Trailblazer Axe No Infernal"],
    [23, "Human Canoeing Carve Trailblazer Axe No Infernal"],
    [24, "Human Woodcutting Trailblazer Axe No Infernal"],
    [25, "Bdrag Attack"],
    [26, "Bdrag Block"],
    [27, "Bdrag Ready"],
    [28, "Bdrag Death"],
    [29, "Bat Walk"],
    [30, "Bat Attack"],
    [31, "Bat Parry"],
    [32, "Bat Walkbackwards"],
    [33, "Bat Walkleft"],
    [34, "Bat Walkright"],
    [35, "Bat Ready"],
    [36, "Bat Death"],
    [37, "Bear Walk"],
    [38, "Bear Walkbackwards"],
    [39, "Bear Walkleft"],
    [40, "Bear Walkright"],
    [41, "Bear Attack"],
    [42, "Bear Block"],
    [43, "Bear Ready"],
    [44, "Bear Death"],
    [45, "Camel Walk"],
    [46, "Camel Walkbackwards"],
    [47, "Camel Walkleft"],
    [48, "Camel Walkright"],
    [49, "Camel Attack"],
    [50, "Camel Block"],
    [51, "Camel Ready"],
    [52, "Camel Death"],
    [53, "Chicken Walk"],
    [54, "Chicken Ready"],
    [55, "Chicken Attack"],
    [56, "Chicken Block"],
    [57, "Chicken Death"],
    [58, "Cow Walk"],
    [59, "Cow Attack"],
    [60, "Cow Block"],
    [61, "Cow Ready"],
    [62, "Cow Death"],
    [63, "Demon Walk"],
    [64, "Demon Attack"],
    [65, "Demon Block"],
    [66, "Demon Ready"],
    [67, "Demon Death"],
    [68, "Demon Death Greater"],
    [69, "Demon Casting"],
    [70, "Demon Portal"],
    [71, "Demon Portalend"],
    [72, "Demon Portalend Reverse"],
    [73, "Deadtree Attack"],
    [74, "Dog Walk"],
    [75, "Dog Attack"],
    [76, "Dog Block"],
    [77, "Dog Ready"],
    [78, "Dog Death"],
    [79, "Dragon Walk"],
    [80, "Dragon Attack"],
    [81, "Dragon Firebreath All Attack"],
    [82, "Dragon Firebreath Left Attack"],
    [83, "Dragon Firebreath Right Attack"],
    [84, "Dragon Firebreath Middle Attack"],
    [85, "Human Woodcrafting Axe Trailblazer No Infernal"],
    [86, "Dragon Firebreath Attack"],
    [87, "Brut Human Canoeing Carve Trailblazer Axe No Infernal"],
    [88, "Human Harpoon Trailblazer No Infernal"],
    [89, "Dragon Block"],
    [90, "Dragon Ready"],
    [91, "Dragon Head Attack"],
    [92, "Dragon Death"],
    [93, "Dryhad Walk"],
    [94, "Dryhad Attack"],
    [95, "Dryhad Block"],
    [96, "Dryhad Ready"],
    [97, "Dryhad Death"],
    [98, "Dwarf Walk"],
    [99, "Dwarf Attack"],
    [100, "Dwarf Block"],
    [101, "Dwarf Ready"],
    [102, "Dwarf Death"],
    [103, "Dwarf Drunkangry"],
    [104, "Dwarf Drunkwalk"],
    [105, "Dwarf Drunkwave"],
    [106, "Fairy Walk"],
    [107, "Fairy Walkbackwards"],
    [108, "Fairy Walkleft"],
    [109, "Fairy Walkright"],
    [110, "Fairy Attack"],
    [111, "Fairy Block"],
    [112, "Fairy Ready"],
    [113, "Fairy Death"],
    [114, "Firebird Walk"],
    [115, "Firebird Attack"],
    [116, "Firebird Block"],
    [117, "Firebird Ready"],
    [118, "Firebird Death"],
    [119, "Ghost Walk"],
    [120, "Ghost Walkbackwards"],
    [121, "Ghost Walkleft"],
    [122, "Ghost Walkright"],
    [123, "Ghost Attack"],
    [124, "Ghost Block"],
    [125, "Ghost Ready"],
    [126, "Ghost Death"],
    [127, "Giant Walk"],
    [128, "Giant Attack"],
    [129, "Giant Block"],
    [130, "Giant Ready"],
    [131, "Giant Death"],
    [132, "Giant Casting"],
    [133, "Giant Teleport"],
    [134, "Giant Teleport Reverse"],
    [135, "G Teleport"],
    [136, "G Teleport Reverse"],
    [137, "Giantrat Walk"],
    [138, "Giantrat Attack"],
    [139, "Giantrat Block"],
    [140, "Giantrat Ready"],
    [141, "Giantrat Death"],
    [142, "Giantspider Walk"],
    [143, "Giantspider Attack"],
    [144, "Giantspider Block"],
    [145, "Giantspider Ready"],
    [146, "Giantspider Death"],
    [147, "Giantspider Casting"],
    [148, "Giantspider Teleport"],
    [149, "Giantspider Teleport Reverse"],
    [150, "S Teleport"],
    [151, "S Teleport Reverse"],
    [152, "Golem Walk"],
    [153, "Golem Attack"],
    [154, "Golem Block"],
    [155, "Golem Ready"],
    [156, "Golem Death"],
    [157, "Hell Walk"],
    [158, "Hell Attack"],
    [159, "Hell Block"],
    [160, "Hell Ready"],
    [161, "Hell Death"],
    [162, "Hobgoblin Walk"],
    [163, "Hobgoblin Attack"],
    [164, "Hobgoblin Attackunarmed"],
    [165, "Hobgoblin Block"],
    [166, "Hobgoblin Ready"],
    [167, "Hobgoblin Death"],
    [168, "Imp Walk"],
    [169, "Imp Attack"],
    [170, "Imp Block"],
    [171, "Imp Ready"],
    [172, "Imp Death"],
    [173, "Brownimp Grab"],
    [174, "Brownimp Appear"],
    [175, "Brownimp Disappear"],
    [176, "Anim Cagetrap01 Close"],
    [177, "Anim Cagetrap01 Idle"],
    [178, "Anim Cagetrap01 Caught"],
    [179, "Human Pray Loop"],
    [180, "Monkey Cow Idle"],
    [181, "Magicaxe Walk"],
    [182, "Magicaxe Walkbackwards"],
    [183, "Magicaxe Walkright"],
    [184, "Magicaxe Walkleft"],
    [185, "Magicaxe Attack"],
    [186, "Magicaxe Block"],
    [187, "Magicaxe Ready"],
    [188, "Magicaxe Death"],
    [189, "Emote Yes Loop"],
    [190, "Emote No Loop"],
    [191, "Emote Think Loop"],
    [192, "Emote Bow Loop"],
    [193, "Emote Angry Loop"],
    [194, "Emote Cry Loop"],
    [195, "Emote Laugh Loop"],
    [196, "Emote Cheer Loop"],
    [197, "Emote Wave Loop"],
    [198, "Gnome Cast Teleport"],
    [199, "Gnome Cast Globes"],
    [200, "Gnome Catch"],
    [201, "Gnome Throw"],
    [202, "Gnome Walk Withball"],
    [203, "Gnome Tackled"],
    [204, "Gnome Dodge Tackle"],
    [205, "Gnome Onfloor"],
    [206, "Gnome Getup"],
    [207, "Gnome Human Tackle Fail"],
    [208, "Gnome Human Tackle Fail Ready"],
    [209, "Gnome Human Tackle Fail Getup"],
    [210, "Gnome Human Tackle"],
    [211, "Gnome Cl1"],
    [212, "Gnome Cl2"],
    [213, "Gnome Cl3"],
    [214, "Gnome Cl4"],
    [215, "Gnome Cl5"],
    [216, "Gnome Cl6"],
    [217, "Gnome Cl7"],
    [218, "Gnome Cl8"],
    [219, "Monkey Walk"],
    [220, "Monkey Attack"],
    [221, "Monkey Block"],
    [222, "Monkey Ready"],
    [223, "Monkey Death"],
    [224, "Slayer Dustdevil Dust"],
    [225, "Crawler Walk"],
    [226, "Crawler Ready"],
    [227, "Crawler Attack"],
    [228, "Crawler Death"],
    [229, "Monkey Cow Walk"],
    [230, "Monkey Cow Mount"],
    [231, "Monkey Cow Dismount"],
    [232, "Monkey Sheep Idle"],
    [233, "Monkey Sheep Walk"],
    [234, "Penguin Walk"],
    [235, "Penguin Ready"],
    [236, "Penguin Death"],
    [237, "Penguin Attack"],
    [238, "Penguin Block"],
    [239, "Rat Walk"],
    [240, "Rat Attack"],
    [241, "Rat Block"],
    [242, "Rat Ready"],
    [243, "Rat Death"],
    [244, "Wild Cave Chainmace Ready"],
    [245, "Wild Cave Chainmace Crush"],
    [246, "Wild Cave Chainmace Stab"],
    [247, "Wild Cave Chainmace Walk"],
    [248, "Wild Cave Chainmace Run"],
    [249, "Sheep Walk"],
    [250, "Sheep Attack"],
    [251, "Sheep Block"],
    [252, "Sheep Ready"],
    [253, "Sheep Death"],
    [254, "Skavid Walk"],
    [255, "Skavid Attack"],
    [256, "Skavid Block"],
    [257, "Skavid Ready"],
    [258, "Skavid Death"],
    [259, "Skeleton Walk"],
    [260, "Skeleton Attack"],
    [261, "Skeleton Block"],
    [262, "Skeleton Ready"],
    [263, "Skeleton Death"],
    [264, "Skeleton Trans Walk"],
    [265, "Skeleton Trans Attack"],
    [266, "Skeleton Trans Block"],
    [267, "Skeleton Trans Ready"],
    [268, "Skeleton Trans Death"],
    [269, "Smallscorpion Walk"],
    [270, "Smallscorpion Attack"],
    [271, "Smallscorpion Block"],
    [272, "Smallscorpion Ready"],
    [273, "Smallscorpion Death"],
    [274, "Snake Walk"],
    [275, "Snake Attack"],
    [276, "Snake Block"],
    [277, "Snake Ready"],
    [278, "Snake Death"],
    [279, "Spider Walk"],
    [280, "Spider Attack"],
    [281, "Spider Block"],
    [282, "Spider Death"],
    [283, "Troll Walk"],
    [284, "Troll Attack"],
    [285, "Troll Block"],
    [286, "Troll Ready"],
    [287, "Troll Death"],
    [288, "Unicorn Walk"],
    [289, "Unicorn Attack"],
    [290, "Unicorn Block"],
    [291, "Unicorn Ready"],
    [292, "Unicorn Death"],
    [293, "Yeti Walk"],
    [294, "Yeti Attack"],
    [295, "Yeti Block"],
    [296, "Yeti Ready"],
    [297, "Yeti Death"],
    [298, "Zombie Walk"],
    [299, "Zombie Attack"],
    [300, "Zombie Block"],
    [301, "Zombie Ready"],
    [302, "Zombie Death"],
    [303, "Mammoth Walk"],
    [304, "Mammoth Attack"],
    [305, "Mammoth Block"],
    [306, "Mammoth Ready"],
    [307, "Mammoth Death"],
    [308, "Goblin Walk"],
    [309, "Goblin Attack Unarmed"],
    [310, "Goblin Attack Armed"],
    [311, "Goblin Ready"],
    [312, "Goblin Block"],
    [313, "Goblin Death"],
    [314, "Cat Walk"],
    [315, "Cat Attack"],
    [316, "Cat Block"],
    [317, "Cat Ready"],
    [318, "Cat Rollingover"],
    [319, "Cat Pounce"],
    [320, "Cat Death"],
    [321, "Terrorbird Walk"],
    [322, "Terrorbird Attack"],
    [323, "Terrorbird Block"],
    [324, "Terrorbird Ready"],
    [325, "Terrorbird Death"],
    [326, "Terrorbird Mounted Walk"],
    [327, "Terrorbird Mounted Attack"],
    [328, "Terrorbird Mounted Attack Spear"],
    [329, "Terrorbird Mounted Block"],
    [330, "Terrorbird Mounted Ready"],
    [331, "Terrorbird Mounted Death"],
    [332, "Entready"],
    [333, "Entendseq"],
    [334, "Rockknocker Pretty"],
    [335, "Human Mining Dragon Pickaxe Pretty Wall"],
    [336, "Souless Walk"],
    [337, "Souless Ready"],
    [338, "Souless Attack"],
    [339, "Souless Block"],
    [340, "Souless Death"],
    [341, "Bird Walk"],
    [342, "Bird Ready"],
    [343, "Bird Death"],
    [344, "Bird Attack"],
    [345, "Bird Block"],
    [346, "Sitting Throne"],
    [347, "Sitting Throne Attack"],
    [348, "Triffid Grow"],
    [349, "Triffid Ready"],
    [350, "Triffid Fruit Picked"],
    [351, "Triffid Angry Grow"],
    [352, "Triffid Angry Ready"],
    [353, "Triffid Angry Attack"],
    [354, "Triffid Angry Block"],
    [355, "Triffid Angry Death"],
    [356, "Triffid Angry Walk"],
    [357, "Ogre Ready"],
    [358, "Ogre Walk"],
    [359, "Ogre Attack"],
    [360, "Ogre Block"],
    [361, "Ogre Death"],
    [362, "Butterfly Hover"],
    [363, "Human Herbing Vial"],
    [364, "Human Herbing Grind"],
    [365, "Human Explodingvial"],
    [366, "Arrow Launch"],
    [367, "Poh Nexus"],
    [368, "Human Blown Middle Priority"],
    [369, "Tknife Launch"],
    [370, "Dart Launch"],
    [371, "Taxe Launch"],
    [372, "Taxe Travel"],
    [373, "Firebreath Travel"],
    [374, "Vial Launch"],
    [375, "Vial Travel"],
    [376, "Human Ddagger Lunge"],
    [377, "Human Ddagger Hack"],
    [378, "Human Ddagger Block"],
    [379, "Human Ddagger Def"],
    [380, "Human Dspear Slash"],
    [381, "Human Dspear Stab"],
    [382, "Human Dspear Lunge"],
    [383, "Human Dspear Block"],
    [384, "Human Dspear Def"],
    [385, "Human Throw"],
    [386, "Human Sword Stab"],
    [387, "Human Sword Block"],
    [388, "Human Sword Def"],
    [389, "Human Sword Transdef"],
    [390, "Human Sword Slash"],
    [391, "Human Sword Transslash"],
    [392, "Human Sword Lunge"],
    [393, "Human Axe Chop"],
    [394, "Human Trans Axe Chop"],
    [395, "Human Axe Hack"],
    [396, "Human Axe Smash"],
    [397, "Human Axe Block"],
    [398, "Human Axe Def"],
    [399, "Human Trans Axe Def"],
    [400, "Human Blunt Spike"],
    [401, "Human Blunt Pound"],
    [402, "Human Blunt Pummel"],
    [403, "Human Blunt Block"],
    [404, "Human Blunt Def"],
    [405, "Human Dhsword Stab"],
    [406, "Human Dhsword Chop"],
    [407, "Human Dhsword Slash"],
    [408, "Human Dhsword Lunge"],
    [409, "Human Dhsword Spin"],
    [410, "Human Dhsword Block"],
    [411, "Human Dhsword Def"],
    [412, "Human Staff Spike"],
    [413, "Human Staff Pound"],
    [414, "Human Staff Pummel"],
    [415, "Human Staff Block"],
    [416, "Human Staff Def"],
    [417, "Human Stafforb Spike"],
    [418, "Human Stafforb Pound"],
    [419, "Human Stafforb Pummel"],
    [420, "Human Stafforb Block"],
    [421, "Human Stafforb Def"],
    [422, "Human Unarmedpunch"],
    [423, "Human Unarmedkick"],
    [424, "Human Unarmedblock"],
    [425, "Human Unarmed Def"],
    [426, "Human Bow"],
    [427, "Human Crossbow"],
    [428, "Human Spear Spike"],
    [429, "Human Spear Lunge"],
    [430, "Human Spear Block"],
    [431, "Human Spear Def"],
    [432, "Human Spear Throw"],
    [433, "Human Farmersfork Stab"],
    [434, "Human Farmersfork Def"],
    [435, "Human Scythe Block"],
    [436, "Human Scythe Def"],
    [437, "Human Scythe Slash"],
    [438, "Human Scythe Lunge"],
    [439, "Human Scythe Spin"],
    [440, "Human Scythe Sweep"],
    [441, "Catapult Release"],
    [442, "Catapult Reset"],
    [443, "Catapult Release Reset"],
    [444, "Catapult Ready Loaded"],
    [445, "Catapult Ready Unloaded"],
    [446, "Magicwall"],
    [447, "Fishingspot Ready"],
    [448, "Fishingspot Walk"],
    [449, "Barrel"],
    [450, "Balloondrop Lever"],
    [451, "Chateasterbunny4"],
    [452, "Rootdoor Open"],
    [453, "Rootdoor Close"],
    [454, "Portcullisclose"],
    [455, "Portcullisopen"],
    [456, "Whirlpool"],
    [457, "Rockfall"],
    [458, "Swinginglogtrap Release"],
    [459, "Speartrap Release"],
    [460, "Springtrap Release"],
    [461, "Springtrap Reset"],
    [462, "Double Springtrap Release"],
    [463, "Double Springtrap Reset"],
    [464, "Shiphull Leaking"],
    [465, "Watersplash"],
    [466, "Spinningwheel"],
    [467, "Glamp"],
    [468, "Witchcharms"],
    [469, "Tentacles"],
    [470, "Spookypic"],
    [471, "Flagpole"],
    [472, "Millsail"],
    [473, "Wiztorch"],
    [474, "Oldbridge"],
    [475, "Fire"],
    [476, "Firewall"],
    [477, "Fireplace"],
    [478, "Grandfireplace"],
    [479, "Cauldron"],
    [480, "Swampbubs"],
    [481, "Torch"],
    [482, "Cupboard Close"],
    [483, "Cupboard Open"],
    [484, "Cupboardhigh Close"],
    [485, "Cupboardhigh Open"],
    [486, "Cupboardbig Close"],
    [487, "Cupboardbig Open"],
    [488, "Weathervane"],
    [489, "Rope Piece"],
    [490, "Fishingcraneright"],
    [491, "Monkey Sheep Mount"],
    [492, "Flytrap"],
    [493, "Lavabubbles"],
    [494, "Lavafire"],
    [495, "Lavafire2"],
    [496, "Whippingplant Attack"],
    [497, "Ropeswing Long"],
    [498, "Balloon Drop"],
    [499, "Balloon Burst"],
    [500, "Balloon Burst 2"],
    [501, "Balloon Burst 3"],
    [502, "Stoneglow"],
    [503, "Rune Altar"],
    [504, "Glowingcircle"],
    [505, "Greatrunestone"],
    [506, "Mcannon N Fire"],
    [507, "Mcannon Ne Fire"],
    [508, "Mcannon E Fire"],
    [509, "Mcannon Se Fire"],
    [510, "Mcannon S Fire"],
    [511, "Mcannon Sw Fire"],
    [512, "Mcannon W Fire"],
    [513, "Mcannon Nw Fire"],
    [514, "Mcannon N Turn"],
    [515, "Mcannon Ne Turn"],
    [516, "Mcannon E Turn"],
    [517, "Mcannon Se Turn"],
    [518, "Mcannon S Turn"],
    [519, "Mcannon Sw Turn"],
    [520, "Mcannon W Turn"],
    [521, "Mcannon Nw Turn"],
    [522, "Water Foam"],
    [523, "Gas"],
    [524, "Crater"],
    [525, "Lava Ripples"],
    [526, "Wake"],
    [527, "Wake2"],
    [528, "Human Whirlpool"],
    [529, "Human Rockfall"],
    [530, "Human Swingingbouldertrap2"],
    [531, "Human Swingingbouldertrap"],
    [532, "Human Speartrap"],
    [533, "Human Springtrap"],
    [534, "Human Getup"],
    [535, "Human Closechest"],
    [536, "Human Openchest"],
    [537, "Human Lockedchest"],
    [538, "Human Opencupboard"],
    [539, "Human Closecupboard"],
    [540, "Human Lockedcupboard"],
    [541, "Human Closehighcupboard"],
    [542, "Human Openhighcupboard"],
    [543, "Human Lockedhighcupboard"],
    [544, "Human Closebigcupboard"],
    [545, "Human Openbigcupboard"],
    [546, "Human Lockedbigcupboard"],
    [547, "Human Opendoor"],
    [548, "Human Opendesertdoor"],
    [549, "Human Gothroughdesertdoor"],
    [550, "Human Opendoorl"],
    [551, "Human Opendoorr"],
    [552, "Human Closedoorl"],
    [553, "Human Closedoorr"],
    [554, "Chatquiz1"],
    [555, "Chatquiz2"],
    [556, "Chatquiz3"],
    [557, "Chatquiz4"],
    [558, "Chatskull1"],
    [559, "Chatskull2"],
    [560, "Chatskull3"],
    [561, "Chatskull4"],
    [562, "Chatbored1"],
    [563, "Chatbored2"],
    [564, "Chatbored3"],
    [565, "Chatbored4"],
    [566, "Shortchatneu1"],
    [567, "Chathap1"],
    [568, "Chathap2"],
    [569, "Chathap3"],
    [570, "Chathap4"],
    [571, "Chatshock1"],
    [572, "Chatshock2"],
    [573, "Chatshock3"],
    [574, "Chatshock4"],
    [575, "Chatcon1"],
    [576, "Chatcon2"],
    [577, "Chatcon3"],
    [578, "Chatcon4"],
    [579, "Chatidleneu1"],
    [580, "Chatgoblin1"],
    [581, "Chatgoblin2"],
    [582, "Chatgoblin3"],
    [583, "Chatgoblin4"],
    [584, "Chatent1"],
    [585, "Chatent2"],
    [586, "Chatent3"],
    [587, "Chatent4"],
    [588, "Chatneu1"],
    [589, "Chatneu2"],
    [590, "Chatneu3"],
    [591, "Chatneu4"],
    [592, "Chatshifty1"],
    [593, "Chatshifty2"],
    [594, "Chatshifty3"],
    [595, "Chatshifty4"],
    [596, "Chatscared1"],
    [597, "Chatscared2"],
    [598, "Chatscared3"],
    [599, "Chatscared4"],
    [600, "Chatdrunk1"],
    [601, "Chatdrunk2"],
    [602, "Chatdrunk3"],
    [603, "Chatdrunk4"],
    [604, "Evilidle1"],
    [605, "Chatlaugh1"],
    [606, "Chatlaugh2"],
    [607, "Chatlaugh3"],
    [608, "Chatlaugh4"],
    [609, "Evillaugh1"],
    [610, "Chatsad1"],
    [611, "Chatsad2"],
    [612, "Chatsad3"],
    [613, "Chatsad4"],
    [614, "Chatang1"],
    [615, "Chatang2"],
    [616, "Chatang3"],
    [617, "Chatang4"],
    [618, "Human Harpoon"],
    [619, "Human Lobster"],
    [620, "Human Largenet"],
    [621, "Human Smallnet"],
    [622, "Human Fishing Casting"],
    [623, "Human Fish Onspot"],
    [624, "Human Mining Rune Pickaxe"],
    [625, "Human Mining Bronze Pickaxe"],
    [626, "Human Mining Iron Pickaxe"],
    [627, "Human Mining Steel Pickaxe"],
    [628, "Human Mining Adamant Pickaxe"],
    [629, "Human Mining Mithril Pickaxe"],
    [630, "Sarim Crandor"],
    [631, "Crandor Sarim"],
    [632, "Sarim Entrana"],
    [633, "Entrana Sarim"],
    [634, "Sarim Karamja"],
    [635, "Karamja Sarim"],
    [636, "Sp Attackglow Quick"],
    [637, "Ii Human Walk Thru Wheat Fast Affinity"],
    [638, "Cairn Khazzard"],
    [639, "Khazzard Trawler"],
    [640, "Trawler Khazzard"],
    [641, "Cairn Sarim"],
    [642, "Human Mining Dragon Pickaxe Pretty"],
    [643, "Human Mining Dragon Pickaxe Pretty Noreachforward"],
    [644, "Sang Mining Wall Dragon Pickaxe Pretty"],
    [645, "Human Pray"],
    [646, "X Mark"],
    [647, "Saradomin Lightning"],
    [648, "Gunthix Claw"],
    [649, "Ibansbolt"],
    [650, "Gnome Globes"],
    [651, "Zap"],
    [652, "Heal Casting"],
    [653, "Failedspell"],
    [654, "Smokepuff"],
    [655, "Ibanblast Casting"],
    [656, "Ibanblast Travel"],
    [657, "Ibanblast Impact"],
    [658, "Strike Casting"],
    [659, "Strike Travel"],
    [660, "Strike Impact"],
    [661, "Bolt Travel"],
    [662, "Bolt Impact"],
    [663, "Blast Travel"],
    [664, "Blast Impact"],
    [665, "Lowlvlalchemy"],
    [666, "Highlvlalchemy"],
    [667, "Teleport"],
    [668, "Confuse Casting"],
    [669, "Confuse Travel"],
    [670, "Confuse Impact"],
    [671, "Weaken Casting"],
    [672, "Weaken Travel"],
    [673, "Weaken Impact"],
    [674, "Curse Casting"],
    [675, "Curse Travel"],
    [676, "Curse Impact"],
    [677, "Enchant Amulet Lvl1"],
    [678, "Enchant Amulet Lvl2"],
    [679, "Enchant Amulet Lvl3"],
    [680, "Bonestobananas Casting"],
    [681, "Telegrab Casting"],
    [682, "Telegrab Travel"],
    [683, "Telegrab Impact"],
    [684, "Crumbleundead Casting"],
    [685, "Crumbleundead Travel"],
    [686, "Crumbleundead Impact"],
    [687, "Superheatitem Casting"],
    [688, "Chargeorb Casting"],
    [689, "Enchant Amulet2 Lvl4"],
    [690, "Enchant Amulet2 Lvl5"],
    [691, "Wave Casting"],
    [692, "Wave Travel"],
    [693, "Wave Impact"],
    [694, "Vulnerability Casting"],
    [695, "Vulnerability Impact"],
    [696, "Enfeeble Casting"],
    [697, "Enfeeble Travel"],
    [698, "Enfeeble Impact"],
    [699, "Stun Casting"],
    [700, "Stun Travel"],
    [701, "Explodingvial"],
    [702, "Entangle Casting"],
    [703, "Entangle Travel"],
    [704, "Entangle Impact"],
    [705, "Bullroarer"],
    [706, "Stunned"],
    [707, "Human Castzap"],
    [708, "Human Castibanblast"],
    [709, "Human Castheal"],
    [710, "Human Castentangle"],
    [711, "Human Caststrike"],
    [712, "Human Castlowlvlalchemy"],
    [713, "Human Casthighlvlalchemy"],
    [714, "Human Castteleport"],
    [715, "Human Castteleport Reverse"],
    [716, "Human Castconfuse"],
    [717, "Human Castweaken"],
    [718, "Human Castcurse"],
    [719, "Human Enchantamuletlvl1"],
    [720, "Human Enchantamuletlvl2"],
    [721, "Human Enchantamuletlvl3"],
    [722, "Human Castbonestobananas"],
    [723, "Human Casttelegrab"],
    [724, "Human Castcrumbleundead"],
    [725, "Human Castsuperheatitem"],
    [726, "Human Castchargeorb"],
    [727, "Human Castwave"],
    [728, "Human Castenfeeble"],
    [729, "Human Caststun"],
    [730, "Catabow Launch"],
    [731, "Catabow Travel"],
    [732, "Catabow End"],
    [733, "Human Createfire"],
    [734, "Human Blown Start"],
    [735, "Human Blown Middle"],
    [736, "Human Blown End Getup"],
    [737, "Human Climbing"],
    [738, "Human Climbing Ready"],
    [739, "Human Climbing Fall"],
    [740, "Human Climbing Down"],
    [741, "Human Spot Jump"],
    [742, "Human Monkeybars On"],
    [743, "Human Monkeybars Off"],
    [744, "Human Monkeybars Walk"],
    [745, "Human Monkeybars Ready"],
    [746, "Human Pipesqueeze"],
    [747, "Human Pipesqueeze Ready"],
    [748, "Human Pipeunsqueeze"],
    [749, "Human Doublepipesqueeze"],
    [750, "Human Ropeswing"],
    [751, "Human Ropeswing Long"],
    [752, "Human Into Sidestep"],
    [753, "Human Into Sidestepl"],
    [754, "Human Walk Sidestep"],
    [755, "Human Ready Sidestep"],
    [756, "Human Walk Sidestepl"],
    [757, "Human Ready Sidestepl"],
    [758, "Human Outof Sidestep"],
    [759, "Human Outof Sidestepl"],
    [760, "Human Sidestep Fall"],
    [761, "Human Sidestep Falll"],
    [762, "Human Walk Logbalance"],
    [763, "Human Walk Logbalance Ready"],
    [764, "Human Walk Logbalance Stumble"],
    [765, "Human Drowning"],
    [766, "Human Falling"],
    [767, "Human Falling End"],
    [768, "Human Falling 4"],
    [769, "Human Steppingstonejump"],
    [770, "Human Wobbleandfall L"],
    [771, "Human Wobbleandfall R"],
    [772, "Human Swim"],
    [773, "Human Swim Ready"],
    [774, "Human Throwrope"],
    [775, "Human Throwrope Up"],
    [776, "Human Wading"],
    [777, "Human Wading Ready"],
    [778, "Human Gnome Tackle"],
    [779, "Human Tackled"],
    [780, "Human Gnome Tackle Fail"],
    [781, "Human Gnome Tackle Ready"],
    [782, "Human Catch"],
    [783, "Human Throw Gnomeball"],
    [784, "Partyroom Dance"],
    [785, "Human Blown End Getup Priority"],
    [786, "Mm2 Hunter Maniacal Monkey Idle"],
    [787, "Poweringcrystal"],
    [788, "Glowingorb"],
    [789, "Glowingorbs"],
    [790, "Runecrafting"],
    [791, "Human Runecraft"],
    [792, "Human Geni Walkandready"],
    [793, "Human Cast2 Teleport"],
    [794, "Human Stamp"],
    [795, "Human Stumble And Hang"],
    [796, "Human Stumble And Hang Ready"],
    [797, "Human Stumble And Hang Climbup"],
    [798, "Human Boxlever"],
    [799, "Cattleprod"],
    [800, "Caged"],
    [801, "Hazeel Coffin"],
    [802, "Human Fishsize"],
    [803, "Human Smokepuff Tele Appear"],
    [804, "Human Smokepuff Tele Disappear"],
    [805, "Human Mindtrick"],
    [806, "Human Stake"],
    [807, "Human Longjump"],
    [808, "Human Ready"],
    [809, "Human Ds Ready"],
    [810, "Human Push"],
    [811, "Human Casting"],
    [812, "Human Trans Casting"],
    [813, "Human Staffready"],
    [814, "Human Getinbed"],
    [815, "Human Getoutbed"],
    [816, "Human Getinbed Left"],
    [817, "Human Getoutbed Left"],
    [818, "Human Dancing"],
    [819, "Human Walk F"],
    [820, "Human Walk B"],
    [821, "Human Walk L"],
    [822, "Human Walk R"],
    [823, "Human Turnonspot"],
    [824, "Human Running"],
    [825, "Human Ready Dh"],
    [826, "Human Walk F Dh"],
    [827, "Human Pickupfloor"],
    [828, "Human Reachforladder"],
    [829, "Human Eat"],
    [830, "Human Dig"],
    [831, "Human Dig Long"],
    [832, "Human Pickuptable"],
    [833, "Human Reachforladdertop"],
    [834, "Human Leverdown"],
    [835, "Human Leverup"],
    [836, "Human Death"],
    [837, "Human Death Backwards"],
    [838, "Human Unconscious"],
    [839, "Human Walk Style"],
    [840, "Human Walk Crumbledwall"],
    [841, "Human Transwalk F"],
    [842, "Human Transready"],
    [843, "Human Transdeath"],
    [844, "Human Crawling"],
    [845, "Human Crawling Ready"],
    [846, "Human Stumble Back"],
    [847, "Human Ready Scythe"],
    [848, "Human Stunned"],
    [849, "Human Ledge On Left"],
    [850, "Human Ledge Off Left"],
    [851, "Human Ledge On Right"],
    [852, "Human Ledge Off Right"],
    [853, "Human Ledge Walk Left"],
    [854, "Human Ledge Walk Right"],
    [855, "Emote Yes"],
    [856, "Emote No"],
    [857, "Emote Think"],
    [858, "Emote Bow"],
    [859, "Emote Angry"],
    [860, "Emote Cry"],
    [861, "Emote Laugh"],
    [862, "Emote Cheer"],
    [863, "Emote Wave"],
    [864, "Emote Beckon"],
    [865, "Emote Clap"],
    [866, "Emote Dance"],
    [867, "Human Woodcutting Rune Axe"],
    [868, "Emote Run On Spot"],
    [869, "Human Woodcutting Adamant Axe"],
    [870, "Emote Starjump 5"],
    [871, "Human Woodcutting Mithril Axe"],
    [872, "Emote Pushups 5"],
    [873, "Human Woodcutting Black Axe"],
    [874, "Emote Situps 5"],
    [875, "Human Woodcutting Steel Axe"],
    [876, "Toxic Blowpipe Special"],
    [877, "Human Woodcutting Iron Axe"],
    [878, "Ahoy Ecto Teleport"],
    [879, "Human Woodcutting Bronze Axe"],
    [880, "Ectophial Pour Slime Cover"],
    [881, "Human Pickpocket"],
    [882, "Human Walk Fence North"],
    [883, "Human Potterywheel"],
    [884, "Human Glassblowing"],
    [885, "Human Dragonstonecutting"],
    [886, "Human Diamondcutting"],
    [887, "Human Rubycutting"],
    [888, "Human Sapphirecutting"],
    [889, "Human Emeraldcutting"],
    [890, "Human Opalcutting"],
    [891, "Human Jadecutting"],
    [892, "Human Redtopazcutting"],
    [893, "Human Shearing"],
    [894, "Human Spinningwheel"],
    [895, "Human Fillbucket Sandpit"],
    [896, "Human Cooking"],
    [897, "Human Firecooking"],
    [898, "Human Smithing"],
    [899, "Human Furnace"],
    [900, "Dwarf Drunkready"],
    [901, "Flamewall"],
    [902, "Fire Arrow"],
    [903, "Palmleaf Falling"],
    [904, "Human Upass Hang Ready"],
    [905, "Human Upass Stumble Into Hang"],
    [906, "Human Upass Climb Out Of Hang"],
    [907, "Barberspole Spin"],
    [908, "Human Bullroarer"],
    [909, "Human Mapping"],
    [910, "Human Machette Chop"],
    [911, "Human Knife Chop"],
    [912, "Flower Growing"],
    [913, "Levelup Anim"],
    [914, "Watersplash Small"],
    [915, "Human Lean"],
    [916, "Human Lean Ready"],
    [917, "Flagblowing"],
    [918, "Human Playhorsey Brown"],
    [919, "Human Playhorsey White"],
    [920, "Human Playhorsey Black"],
    [921, "Human Playhorsey Grey"],
    [922, "Dwarf Stone Throw Launch"],
    [923, "Impale"],
    [924, "Sp Attack Impale Spotanim"],
    [925, "Troll Ready Sword"],
    [926, "Troll Ready Shield"],
    [927, "Troll Ready Sword+shield"],
    [928, "Dwarf Stone Launch"],
    [929, "Human Stake2"],
    [930, "Enchant Ring"],
    [931, "Human Cast Enchantring"],
    [932, "Seaslug Ready"],
    [933, "Seaslug Walk"],
    [934, "Trail Sextant Back01"],
    [935, "Trail Sextant Back02"],
    [936, "Trail Sextant Back03"],
    [937, "Trail Sextant Back04"],
    [938, "Trail Sextant Back05"],
    [939, "Trail Sextant Back06"],
    [940, "Trail Sextant Back07"],
    [941, "Trail Sextant Back08"],
    [942, "Trail Sextant Back09"],
    [943, "Trail Sextant Back10"],
    [944, "Trail Sextant Back11"],
    [945, "Trail Sextant Back12"],
    [946, "Trail Sextant Back13"],
    [947, "Trail Sextant Back14"],
    [948, "Trail Sextant Back15"],
    [949, "Trail Sextant Arm01"],
    [950, "Trail Sextant Arm02"],
    [951, "Trail Sextant Arm03"],
    [952, "Trail Sextant Arm04"],
    [953, "Trail Sextant Arm05"],
    [954, "Trail Sextant Arm06"],
    [955, "Trail Sextant Arm07"],
    [956, "Trail Sextant Arm08"],
    [957, "Trail Sextant Arm09"],
    [958, "Trail Sextant Arm10"],
    [959, "Trail Sextant Arm11"],
    [960, "Trail Sextant Arm12"],
    [961, "Trail Sextant Arm13"],
    [962, "Trail Sextant Arm14"],
    [963, "Trail Sextant Arm15"],
    [964, "Trail Sextant Arm16"],
    [965, "Trail Sextant Arm17"],
    [966, "Trail Sextant Arm18"],
    [967, "Trail Sextant Arm19"],
    [968, "Trail Sextant Arm20"],
    [969, "Trail Sextant Arm21"],
    [970, "Trail Sextant Arm22"],
    [971, "Trail Sextant Arm23"],
    [972, "Trail Sextant Arm24"],
    [973, "Trail Sextant Arm25"],
    [974, "Trail Sextant Arm26"],
    [975, "Trail Sextant Arm27"],
    [976, "Trail Sextant Arm28"],
    [977, "Trail Sextant Arm29"],
    [978, "Trail Sextant Arm30"],
    [979, "Trail Sextant Arm31"],
    [980, "Trail Sextant Arm32"],
    [981, "Trail Sextant Arm33"],
    [982, "Trail Sextant Arm34"],
    [983, "Trail Sextant Arm35"],
    [984, "Trail Sextant Arm36"],
    [985, "Trail Sextant Arm37"],
    [986, "Trail Sextant Arm38"],
    [987, "Trail Sextant Arm39"],
    [988, "Trail Sextant Arm40"],
    [989, "Trail Sextant Arm41"],
    [990, "Trail Sextant Arm42"],
    [991, "Trail Sextant Arm43"],
    [992, "Trail Sextant Arm44"],
    [993, "Trail Sextant Arm45"],
    [994, "Trail Sextant Arm46"],
    [995, "Trail Sextant Arm47"],
    [996, "Trail Sextant Arm48"],
    [997, "Trail Sextant Arm49"],
    [998, "Trail Sextant Arm50"],
    [999, "Trail Sextant Arm51"],
    [1000, "Trail Sextant Arm52"],
    [1001, "Trail Sextant Arm53"],
    [1002, "Trail Sextant Arm54"],
    [1003, "Trail Sextant Arm55"],
    [1004, "Trail Sextant Arm56"],
    [1005, "Trail Sextant Arm57"],
    [1006, "Trail Sextant Arm58"],
    [1007, "Pog Terror Bird Walk"],
    [1008, "Pog Terror Bird Ready"],
    [1009, "Pog Terror Bird Ready Extra"],
    [1010, "Pog Terror Bird Attack"],
    [1011, "Chompy Attack"],
    [1012, "Pog Terror Bird Defend"],
    [1013, "Pog Terror Bird Death"],
    [1014, "Seagull Defend"],
    [1015, "Seagull Death"],
    [1016, "Spit Fire"],
    [1017, "Roast"],
    [1018, "Chompy Toad Ready"],
    [1019, "Chompy Toad Inflate"],
    [1020, "Bloated Toad Stay"],
    [1021, "Chompy Toad Walk"],
    [1022, "Chompy Toad Death"],
    [1023, "Chompy Toad Explode"],
    [1024, "Ogre Bellows Use"],
    [1025, "Ogre Longbow"],
    [1026, "Human Chompybird Ogrebellows"],
    [1027, "Elemental Fire Ready"],
    [1028, "Elemental Fire Walk"],
    [1029, "Elemental Fire Attack"],
    [1030, "Elemental Fire Defend"],
    [1031, "Elemental Fire Death"],
    [1032, "Elemental Fire Summon"],
    [1033, "Elemental Earth Ready"],
    [1034, "Elemental Earth Walk"],
    [1035, "Elemental Earth Attack"],
    [1036, "Elemental Earth Defend"],
    [1037, "Elemental Earth Death"],
    [1038, "Elemental Earth Summon"],
    [1039, "Elemental Air Ready"],
    [1040, "Elemental Air Attack"],
    [1041, "Elemental Air Death"],
    [1042, "Elemental Air Defend"],
    [1043, "Elemental Air Summon"],
    [1044, "Elemental Water Attack"],
    [1045, "Elemental Water Ready"],
    [1046, "Elemental Water Defend"],
    [1047, "Elemental Water Walk"],
    [1048, "Elemental Water Death"],
    [1049, "Elemental Bellow Pump"],
    [1050, "Elemental Bellow Pump Reverse"],
    [1051, "Elemental Wheel Spin"],
    [1052, "Elemental Pipe End"],
    [1053, "Elemental Shield Appear"],
    [1054, "Stunned Thieving"],
    [1055, "Sp Attackglow"],
    [1056, "Rampage"],
    [1057, "Sanctuary"],
    [1058, "Cleave"],
    [1059, "Sp Attack Cleave Spotanim"],
    [1060, "Shatter"],
    [1061, "Sp Attack Shatter Spotanim"],
    [1062, "Puncture"],
    [1063, "Sp Attack Puncture Spotanim"],
    [1064, "Shove"],
    [1065, "Sp Attack Shove Spotanim"],
    [1066, "Stunned Shove"],
    [1067, "D Claws Punch"],
    [1068, "Chainhit"],
    [1069, "Sp Attack Chainhit Launch Spotanim"],
    [1070, "Sp Attack Chainhit Travel Spotanim"],
    [1071, "Willowthewisp"],
    [1072, "Priestperil Gravemonument"],
    [1073, "Hanginglantern"],
    [1074, "Snapshot"],
    [1075, "Sp Attack Snapshot Spotanim"],
    [1076, "Priestperil Coffin Neutralised"],
    [1077, "Throw Bucketofwater"],
    [1078, "Human Transform"],
    [1079, "Werewolf Walk"],
    [1080, "Werewolf Attack"],
    [1081, "Werewolf Block"],
    [1082, "Werewolf Death"],
    [1083, "Werewolf Ready"],
    [1084, "Surok Surok Spell Casting"],
    [1085, "Ghast Walk"],
    [1086, "Ghast Ready"],
    [1087, "Ghast Attack"],
    [1088, "Ghast Block"],
    [1089, "Ghast Death"],
    [1090, "Ghast Spotdeath"],
    [1091, "Inv Ghast Walk"],
    [1092, "Inv Ghast Ready"],
    [1093, "Inv Ghast Attack"],
    [1094, "Inv Ghast Block"],
    [1095, "Inv Ghast Death"],
    [1096, "Mushroom Growing"],
    [1097, "Pears Growing"],
    [1098, "Leaves Growing"],
    [1099, "Druidicspirit Bloom Spotanim"],
    [1100, "Druidicspirit Human Bloom"],
    [1101, "Druidicspirit Bloom Player Spotanim"],
    [1102, "Druidicspirit Druidsshield Spotanim"],
    [1103, "Agilityarena Timedblades Spin2"],
    [1104, "Screaming Banshee Walk"],
    [1105, "Human Ropeswing Long Miss"],
    [1106, "Human Lowwall Fail"],
    [1107, "Agilityarena Sawblades Twist"],
    [1108, "Agilityarena Dartfire"],
    [1109, "Agilityarena Dart Flight"],
    [1110, "Agilityarena Dartduck"],
    [1111, "Agilityarena Floorspikes Activate"],
    [1112, "Agilityarena Floorspikes Normal"],
    [1113, "Agilityarena Player Spiked"],
    [1114, "Agilityarena Player Spikedback"],
    [1115, "Agilityarena Dive Player"],
    [1116, "Agilityarena Land Player"],
    [1117, "Agilityarena Handholds First"],
    [1118, "Agilityarena Handholds Middle"],
    [1119, "Agilityarena Handholds Middlefall"],
    [1120, "Agilityarena Handholds Last"],
    [1121, "Agilityarena Handholds Firstreverse"],
    [1122, "Agilityarena Handholds Middlereverse"],
    [1123, "Agilityarena Handholds Middlefallreverse"],
    [1124, "Agilityarena Handholds Lastreverse"],
    [1125, "Agilityarena Roofcollapse Hitandstumble"],
    [1126, "Town Crier Book"],
    [1127, "Godstatue Spin"],
    [1128, "Emote Glass Wall"],
    [1129, "Emote Mime Lean"],
    [1130, "Emote Climbing Rope"],
    [1131, "Emote Glass Box"],
    [1132, "Saradomin Sword Special Player"],
    [1133, "Blessed Saradomin Sword Special Player"],
    [1134, "Star Attack"],
    [1135, "Macro Spotlight Off"],
    [1136, "Macro Spotlight On"],
    [1137, "Human Sitting Chair"],
    [1138, "Godsorb"],
    [1139, "Troll Walk Shield"],
    [1140, "Troll Walk Sword"],
    [1141, "Troll Walk Sword+shield"],
    [1142, "Troll Rock Throw"],
    [1143, "Troll Rock Launch"],
    [1144, "Sitting Ready"],
    [1145, "Sitting Eating"],
    [1146, "Walk Walkingstick"],
    [1147, "Wounded Sitting"],
    [1148, "Death Human Climbing Down"],
    [1149, "Dice Idle"],
    [1150, "Dice Roll 1"],
    [1151, "Dice Roll 2"],
    [1152, "Dice Roll 3"],
    [1153, "Dice Roll 4"],
    [1154, "Dice Roll 5"],
    [1155, "Dice Roll 6"],
    [1156, "Human Shield Defence"],
    [1157, "Human Troll Flyback"],
    [1158, "Troll Treetrunk Attack"],
    [1159, "Troll Sleep"],
    [1160, "Troll Zeds"],
    [1161, "Human Castentangle Staff"],
    [1162, "Human Caststrike Staff"],
    [1163, "Human Castconfuse Staff"],
    [1164, "Human Castweaken Staff"],
    [1165, "Human Castcurse Staff"],
    [1166, "Human Castcrumbleundead Staff"],
    [1167, "Human Castwave Staff"],
    [1168, "Human Castenfeeble Staff"],
    [1169, "Human Caststun Staff"],
    [1170, "Kalphite Queen Lightning"],
    [1171, "Kalphite Queen Glow"],
    [1172, "Kalphite Lightning"],
    [1173, "Kalphite Glow"],
    [1174, "Kalphite Egg Open"],
    [1175, "Kalphite Egg Close"],
    [1176, "Kalphite Queen Ready"],
    [1177, "Kalphite Queen Attack Mandibles"],
    [1178, "Kalphite Queen Attack Claws"],
    [1179, "Kalphite Queen Block"],
    [1180, "Kalphite Queen Still"],
    [1181, "Kalphite Queen Rising"],
    [1182, "Kalphite Queen Death"],
    [1183, "Kalphite Ready"],
    [1184, "Kalphite Attack Mandibles"],
    [1185, "Kalphite Attack Claws"],
    [1186, "Kalphite Block"],
    [1187, "Kalphite Crackopen"],
    [1188, "Kalphite Hatching"],
    [1189, "Kalphite Walk"],
    [1190, "Kalphite Death"],
    [1191, "Human Eat Banana"],
    [1192, "Banana Slicing"],
    [1193, "Human Octopus Pot"],
    [1194, "Human Drink Rum"],
    [1195, "Rum Stuffing"],
    [1196, "Human Wretch"],
    [1197, "Lion Walk"],
    [1198, "Lion Ready"],
    [1199, "Lion Attack"],
    [1200, "Lion Block"],
    [1201, "Lion Death"],
    [1202, "Lion Death Hold Last Frame"],
    [1203, "Dragon Halberd Special Attack"],
    [1204, "Sp D Halberd Glow"],
    [1205, "Human Halberdwalk F"],
    [1206, "Human Halberdwalk B"],
    [1207, "Human Halberdwalk L"],
    [1208, "Human Halberdwalk R"],
    [1209, "Human Halberdturnonspot"],
    [1210, "Human Halberdrunning"],
    [1211, "Crystal Float"],
    [1212, "Crystallamp Float"],
    [1213, "Arrowtrip"],
    [1214, "Tripwire"],
    [1215, "Logswing"],
    [1216, "Logswing Ready"],
    [1217, "Logslam"],
    [1218, "Logslam Ready"],
    [1219, "Woodspring"],
    [1220, "Wind Catapult"],
    [1221, "Trigger Catapult"],
    [1222, "Unlitbarrel"],
    [1223, "Up Catapult"],
    [1224, "Down Catapult"],
    [1225, "Burningbarrel Catapult"],
    [1226, "Lightbarrel Catapult"],
    [1227, "Fire Catapult"],
    [1228, "Winddown Catapult"],
    [1229, "Inair Barrel"],
    [1230, "Barrel Explode"],
    [1231, "Propbarrel Exploding Ready"],
    [1232, "Propbarrel Exploding"],
    [1233, "Propbarrel Burning"],
    [1234, "Tent Burn"],
    [1235, "Voyage Well"],
    [1236, "Regicide Stepover"],
    [1237, "Regicide Tightfit"],
    [1238, "Regicide Useloom"],
    [1239, "Regicide Catapultwind"],
    [1240, "Regicide Catapault Trigger"],
    [1241, "Regicide Player Vanish"],
    [1242, "Rabbit Ready"],
    [1243, "Rabbit Walk"],
    [1244, "Rabbit Block"],
    [1245, "Rabbit Attack"],
    [1246, "Rabbit Death"],
    [1247, "Flytrap Attack"],
    [1248, "Human Fletching"],
    [1249, "Human Leather Crafting"],
    [1250, "Kalphite Queen Ranged Attack"],
    [1251, "Kalphite Ranged Attack"],
    [1252, "Human Lowwall"],
    [1253, "Dwarf Drunkdeath"],
    [1254, "Anma Chopping Failed Mithril Axe"],
    [1255, "Anma Chopping Failed Adamant Axe"],
    [1256, "Anma Chopping Failed Rune Axe"],
    [1257, "Eadgar Stunned"],
    [1258, "Eadgar Knockout"],
    [1259, "Eadgar Troll Axethrow"],
    [1260, "Mist"],
    [1261, "Misty"],
    [1262, "Mist Disappear"],
    [1263, "Vamp Bite"],
    [1264, "Vamp Claw"],
    [1265, "Vamp Land"],
    [1266, "Vamp Lifedrain"],
    [1267, "Vamp Weaken"],
    [1268, "Vamp Mistappear"],
    [1269, "Leechwalk"],
    [1270, "Leechready"],
    [1271, "Leechblock"],
    [1272, "Leechdeath"],
    [1273, "Leechattack"],
    [1274, "Snail Walk"],
    [1275, "Ghoul Ready"],
    [1276, "Snail Ready"],
    [1277, "Snail Attack"],
    [1278, "Snail Defend"],
    [1279, "Snail Death"],
    [1280, "Human Snailshellcutting"],
    [1281, "Shade Walk"],
    [1282, "Shade Ready"],
    [1283, "Shade Attack"],
    [1284, "Shade Attack Wall"],
    [1285, "Shade Attack2"],
    [1286, "Shade Block"],
    [1287, "Shade Sink"],
    [1288, "Shade Rise"],
    [1289, "Shadeshadow Walk"],
    [1290, "Shadeshadow Ready"],
    [1291, "Shadeshadow Sink"],
    [1292, "Shadeshadow Rise"],
    [1293, "Temple Build1"],
    [1294, "Temple Build2"],
    [1295, "Temple Build3"],
    [1296, "Temple Build4"],
    [1297, "Temple Build5"],
    [1298, "Temple Build6"],
    [1299, "Temple Build7"],
    [1300, "Temple Build8"],
    [1301, "Temple Build9"],
    [1302, "Temple Build10"],
    [1303, "Temple Pyre Nowood"],
    [1304, "Temple Pyre Nobones"],
    [1305, "Temple Pyre Fire"],
    [1306, "Human Zombie Walk"],
    [1307, "Human Shade Defence"],
    [1308, "Shade Heaven"],
    [1309, "Human Limestonecutting"],
    [1310, "Horror Crab Ready"],
    [1311, "Horror Crab Walk"],
    [1312, "Horror Crab Attack"],
    [1313, "Horror Crab Defend"],
    [1314, "Horror Crab Hide"],
    [1315, "Horror Crab Hide Ready"],
    [1316, "Horror Crab Reveal"],
    [1317, "Potteryoven Quick"],
    [1318, "Viking Lyre Ready"],
    [1319, "Viking Lyre Putaway"],
    [1320, "Viking Lyre Play Once"],
    [1321, "Viking Lyre Playing Loop"],
    [1322, "Viking Drinking Ready"],
    [1323, "Human Walk Tankard F"],
    [1324, "Human Walk Tankard B"],
    [1325, "Human Walk Tankard L"],
    [1326, "Human Walk Tankard R"],
    [1327, "Viking Tankard Drink"],
    [1328, "Viking Keg Drink Start"],
    [1329, "Viking Keg Drink Finish"],
    [1330, "Viking Keg Drink Full"],
    [1331, "Viking Drop To Knee"],
    [1332, "Viking Drop To Knee And Backtoready"],
    [1333, "Viking Pet Rock Stroke"],
    [1334, "Viking Pig Roast"],
    [1335, "Horror Preach Saradomin"],
    [1336, "Horror Preach Zamorak"],
    [1337, "Horror Preach Guthix"],
    [1338, "Horror Dagannoth Ready"],
    [1339, "Horror Dagannoth Walk"],
    [1340, "Horror Dagannoth Defend"],
    [1341, "Horror Dagannoth Attack"],
    [1342, "Horror Dagannoth Death"],
    [1343, "Horror Dagannoth Rangeattack"],
    [1344, "Horror Dagannoth Emerge A"],
    [1345, "Horror Dagannoth Emerge B"],
    [1346, "Horror Dagannoth Emerge C"],
    [1347, "Horror Lighthouse Working"],
    [1348, "Horror Lighthouse Windpower"],
    [1349, "Horror Lighthouse Divider"],
    [1350, "Human Readbook"],
    [1351, "Human Sittingdown Ready"],
    [1352, "Human Sittingdown Scratch"],
    [1353, "Human Sittingdown Think"],
    [1354, "Human Sittingdown Move"],
    [1355, "Runeflash"],
    [1356, "Runeflash Off"],
    [1357, "Sandtimer Off"],
    [1358, "Sandtimer 15secs"],
    [1359, "Sandtimer 30secs"],
    [1360, "Sandtimer 60secs"],
    [1361, "Sandtimer 120secs"],
    [1362, "Lantern Glow"],
    [1363, "Misc Fish Onspot"],
    [1364, "Poh Smash Magic Tablet Spell"],
    [1365, "Misc Human Woodcutting Steel Axe"],
    [1366, "Misc Npc Herb Weeding Iron Sickle"],
    [1367, "Misc Sitting Fishing"],
    [1368, "Misc Blow Kiss"],
    [1369, "Misc Herb Weeding Iron Sickle"],
    [1370, "Misc Herb Weeding Silver Sickle"],
    [1371, "Misc Herb Weeding Silver Sickle Blessed"],
    [1372, "Misc Shipjourney To Misc"],
    [1373, "Misc Shipjourney To Rellekka"],
    [1374, "Emote Blow Kiss"],
    [1375, "Barrows Verac Desolation"],
    [1376, "Searchcape Pestle"],
    [1377, "Searchcape Grapple"],
    [1378, "Dragon Warhammer Sa Player"],
    [1379, "Human Mm Flyback"],
    [1380, "M Monkey Walk"],
    [1381, "M Monkey Run"],
    [1382, "M Zombie Walk"],
    [1383, "M Zombie Attack"],
    [1384, "M Monkey Death"],
    [1385, "M Monkey Dh Walk"],
    [1386, "M Monkey Ready"],
    [1387, "M Monkey Acolyte Ready"],
    [1388, "M Monkey Jailofficer Ready"],
    [1389, "M Monkey Jailofficer Getup"],
    [1390, "M Monkey Jailofficer Liedown"],
    [1391, "Quest Lunar Spell Energy Exchange Long"],
    [1392, "M Monkey Attack Scimitar"],
    [1393, "M Monkey Block Scimitar"],
    [1394, "M Monkey Attack Bow"],
    [1395, "M Monkey Block Bow"],
    [1396, "M Monkey Attack Doublescimitar"],
    [1397, "M Monkey Block Doublescimitar"],
    [1398, "M Monkey Ape Ruler Nod"],
    [1399, "M Gorilla Walk"],
    [1400, "M Gorilla Run"],
    [1401, "M Gorilla Ready"],
    [1402, "M Gorilla Attack"],
    [1403, "M Gorilla Block"],
    [1404, "M Gorilla Death"],
    [1405, "M Gorilla Poundchest"],
    [1406, "M Gorilla Guard Attack"],
    [1407, "M Human Catlike Land"],
    [1408, "M Human Land"],
    [1409, "M Human Land Getup"],
    [1410, "M Glider Unfold"],
    [1411, "M Glider Ready"],
    [1412, "M Assassin Ready"],
    [1413, "M Assassin Attack"],
    [1414, "M Sapper Wallwipe"],
    [1415, "M Mage Attack"],
    [1416, "M Pyre Glow"],
    [1417, "Skeleton Reverse Death"],
    [1418, "Demon Appear"],
    [1419, "M Normalmonkey Run"],
    [1420, "Mm Floorspikes Activate"],
    [1421, "Human Bannerready"],
    [1422, "Human Bannerwalk F"],
    [1423, "Human Bannerwalk B"],
    [1424, "Human Bannerwalk L"],
    [1425, "Human Bannerwalk R"],
    [1426, "Human Bannerturnonspot"],
    [1427, "Human Bannerrunning"],
    [1428, "Human Banner Spike"],
    [1429, "Human Banner Block"],
    [1430, "Castlewars Banner"],
    [1431, "Catapult Fire"],
    [1432, "Castlewars Rockfall"],
    [1433, "Castlewars Portalglow"],
    [1434, "Bossghost Death"],
    [1435, "Bossghost Attack"],
    [1436, "Bossghost Run"],
    [1437, "Bossghost Summon"],
    [1438, "Bossghost Fade In"],
    [1439, "Bossghost Fade Out"],
    [1440, "Human Crawling Long"],
    [1441, "Human Stumble Back Continuous"],
    [1442, "Skeleton Beforesummon"],
    [1443, "Skeleton Summon"],
    [1444, "Skeleton Sitdown"],
    [1445, "Pickaxe Beforesummon"],
    [1446, "Pickaxe Summon"],
    [1447, "Pickaxe Projectile Summon Spotanim"],
    [1448, "Pickaxe Projectile Summon"],
    [1449, "Pickaxe Projectile Travel"],
    [1450, "Possessed Key Ready"],
    [1451, "Possessed Key Drifting"],
    [1452, "Mining Crane Attack"],
    [1453, "Hauntedmine Cart Travel"],
    [1454, "Hauntedmine Cartstart"],
    [1455, "Hauntedmine Cartleft"],
    [1456, "Hauntedmine Cartright"],
    [1457, "Yoyo Updown"],
    [1458, "Yoyo Roundworld"],
    [1459, "Yoyo Walkdog"],
    [1460, "Yoyo Advanced"],
    [1461, "Trollromance Toboggan Ready"],
    [1462, "Trollromance Toboggan Moving"],
    [1463, "Trollromance Toboggan Flying"],
    [1464, "Trollromance Toboggan Crashing"],
    [1465, "Trollromance Toboggan Getup"],
    [1466, "Trollromance Toboggan Defend"],
    [1467, "Trollromance Toboggan Stunt"],
    [1468, "Trollromance Toboggan Walking"],
    [1469, "Trollromance Toboggan Eat"],
    [1470, "Trollromance Toboggan Waxing"],
    [1471, "Altar Inactive"],
    [1472, "Altar Spawn"],
    [1473, "Altar Active"],
    [1474, "Trollromance Cry Test"],
    [1475, "Altar Death"],
    [1476, "Trollromance Cry Loop"],
    [1477, "Atar Spawn And Die"],
    [1478, "Trollromance Kiss Test"],
    [1479, "Trollromance Heart Test"],
    [1480, "Trollromance Eat"],
    [1481, "Trollromance Emote Angry"],
    [1482, "Trollromance Emote Cheer"],
    [1483, "Trollromance Emote Wave"],
    [1484, "Trollromance Emote Beckon"],
    [1485, "Trollromance Emote Clap"],
    [1486, "Human Pickuptrollweiss Down"],
    [1487, "Human Pickuptrollweiss Up"],
    [1488, "Troll Rock Throw Lefthand"],
    [1489, "Snowfall"],
    [1490, "Snowfall2"],
    [1491, "Swamp Boatjourney"],
    [1492, "Swamp Boatjourney Back"],
    [1493, "Skeleton Hound Walk"],
    [1494, "Skeleton Hound Ready"],
    [1495, "Skeleton Hound Attack"],
    [1496, "Skeleton Hound Block"],
    [1497, "Skeleton Hound Death"],
    [1498, "Skeleton Hound Summon"],
    [1499, "Wings Unfold"],
    [1500, "Wings Launch"],
    [1501, "Wings Ready"],
    [1502, "Wings Summon"],
    [1503, "Summon Spell"],
    [1504, "Crawler Parry"],
    [1505, "Specter Walk"],
    [1506, "Specter Ready"],
    [1507, "Specter Attack"],
    [1508, "Specter Death"],
    [1509, "Specter Parry"],
    [1510, "Kursk Walk"],
    [1511, "Kursk Ready"],
    [1512, "Kursk Attack"],
    [1513, "Kursk Death"],
    [1514, "Kursk Parry"],
    [1515, "Gargoyle Fly"],
    [1516, "Gargoyle Ready"],
    [1517, "Gargoyle Attack"],
    [1518, "Gargoyle Death"],
    [1519, "Gargoyle Parry"],
    [1520, "Gargoyle Boom"],
    [1521, "Banshee Walk"],
    [1522, "Banshee Ready"],
    [1523, "Banshee Attack"],
    [1524, "Banshee Death"],
    [1525, "Banshee Parry"],
    [1526, "Demons Walk"],
    [1527, "Demons Ready"],
    [1528, "Demons Attack"],
    [1529, "Demons Bringdead"],
    [1530, "Demons Death"],
    [1531, "Demons Parry"],
    [1532, "Gargoyle Statue Close"],
    [1533, "Gargoyle Statue Open"],
    [1534, "Abyssal Walk"],
    [1535, "Abyssal Teleport"],
    [1536, "Abyssal Ready"],
    [1537, "Abyssal Attack"],
    [1538, "Abyssal Death"],
    [1539, "Demon Spawn Fly"],
    [1540, "Demon Spawn Attack"],
    [1541, "Demon Spawn Death"],
    [1542, "Demon Spawn Parry"],
    [1543, "Demon Spawn Spotanim"],
    [1544, "Basilisk Walk"],
    [1545, "Basilisk Ready"],
    [1546, "Basilisk Attack"],
    [1547, "Basilisk Defend"],
    [1548, "Basilisk Death"],
    [1549, "Bloodveld Walk"],
    [1550, "Bloodveld Defend"],
    [1551, "Bloodveld Ready"],
    [1552, "Bloodveld Attack"],
    [1553, "Bloodveld Death"],
    [1554, "Dustdevil Walk"],
    [1555, "Dustdevil Defend"],
    [1556, "Dustdevil Ready"],
    [1557, "Dustdevil Attack"],
    [1558, "Dustdevil Death"],
    [1559, "Cockatrice Walk"],
    [1560, "Cockatrice Defend"],
    [1561, "Cockatrice Ready"],
    [1562, "Cockatrice Attack"],
    [1563, "Cockatrice Death"],
    [1564, "Rockslug Walk"],
    [1565, "Rockslug Defend"],
    [1566, "Rockslug Ready"],
    [1567, "Rockslug Attack"],
    [1568, "Rockslug Death"],
    [1569, "Specter Goo Launch"],
    [1570, "Specter Goo Travel"],
    [1571, "Specter Goo Impact"],
    [1572, "Ears Bleed"],
    [1573, "Sonic Attack"],
    [1574, "Slayer Salt Sprinkle"],
    [1575, "Slayer Salt Sprinkle Spotanim"],
    [1576, "Slayer Magicdart Cast"],
    [1577, "Slayer Magicdart Travel"],
    [1578, "Pyrefiend Ready"],
    [1579, "Pyrefiend Walk"],
    [1580, "Pyrefiend Death"],
    [1581, "Pyrefiend Defend"],
    [1582, "Pyrefiend Attack"],
    [1583, "Jelly Ready"],
    [1584, "Jelly Walk"],
    [1585, "Jelly Defend"],
    [1586, "Jelly Attack"],
    [1587, "Jelly Death"],
    [1588, "Crawlinghand Ready"],
    [1589, "Crawlinghand Walk"],
    [1590, "Crawlinghand Death"],
    [1591, "Crawlinghand Defend"],
    [1592, "Crawlinghand Attack"],
    [1593, "Turoth Walk"],
    [1594, "Turoth Ready"],
    [1595, "Turoth Attack"],
    [1596, "Turoth Defend"],
    [1597, "Turoth Death"],
    [1598, "Waa Goal Forward"],
    [1599, "Waa Goal Backward"],
    [1600, "Waa Goal Ready"],
    [1601, "Zipline Bite"],
    [1602, "Zipline Slide"],
    [1603, "Human Jump Hurdle"],
    [1604, "Human Jump Stones"],
    [1605, "Goal Lazio"],
    [1606, "Kick Skull Ball"],
    [1607, "Waa Skullball Ready"],
    [1608, "Waa Skullball Walk"],
    [1609, "Waa Ovinocanus Ready"],
    [1610, "Waa Ovinocanus Walk"],
    [1611, "Waa Ovinocanus Death"],
    [1612, "Waa Ovinocanus Attack"],
    [1613, "Waa Ovinocanus Defend"],
    [1614, "Waa Homo Arachnus Ready"],
    [1615, "Waa Homo Arachnus Walk"],
    [1616, "Waa Homo Arachnus Attack"],
    [1617, "Waa Homo Arachnus Defend"],
    [1618, "Waa Homo Arachnus Death"],
    [1619, "Waa Werewolf Stick Throw"],
    [1620, "Fenk Capstone Moves"],
    [1621, "Fenk Bookcase Open"],
    [1622, "Frank Walk"],
    [1623, "Frank Ready"],
    [1624, "Homolupus Walk"],
    [1625, "Homolupus Ready"],
    [1626, "Homolupus Attack"],
    [1627, "Homolupus Defend"],
    [1628, "Homolupus Death"],
    [1629, "Fenk Fireplace Glow"],
    [1630, "Fenk Fireplace Candle"],
    [1631, "Fenk Signpost Swing"],
    [1632, "Fenk Lightning"],
    [1633, "Fenk Human Poke"],
    [1634, "Fenk Human Poke Short"],
    [1635, "Roving Crystal Growth Anim"],
    [1636, "Roving Crystal Growth Start"],
    [1637, "Chatchant1"],
    [1638, "Pvpa Dungeon Palantir Idle"],
    [1639, "Ahoy Ghost Disguise Ready"],
    [1640, "Ahoy Ghost Disguise Walk"],
    [1641, "Green Gloop"],
    [1642, "Green Gloop2"],
    [1643, "Green Gloop3"],
    [1644, "Goopy Snake"],
    [1645, "Goopy Snake Walk"],
    [1646, "Goop Launch"],
    [1647, "Goop Travel"],
    [1648, "Ahoy Bone Grind"],
    [1649, "Ahoy Bone Dump"],
    [1650, "Ahoy Fillbucket Bonedust"],
    [1651, "Ahoy Prayer"],
    [1652, "Abyssal Bludgeon Ready"],
    [1653, "Gloop Transport Spotanim"],
    [1654, "Ahoy Lean Right"],
    [1655, "Ahoy Lean Left"],
    [1656, "Ahoy Lean Centre"],
    [1657, "Ahoy Ectofuntus Glow"],
    [1658, "Slayer Abyssal Whip Attack"],
    [1659, "Slayer Abyssal Whip Defend"],
    [1660, "Slayer Abyssal Whip Walk"],
    [1661, "Slayer Abyssal Whip Run"],
    [1662, "Slayer Granite Maul Ready"],
    [1663, "Slayer Granite Maul Walk"],
    [1664, "Slayer Granite Maul Run"],
    [1665, "Slayer Granite Maul Attack"],
    [1666, "Slayer Granite Maul Defend"],
    [1667, "Slayer Granite Maul Special Attack"],
    [1668, "Slayer Maul Sp Attack"],
    [1669, "Slayer Whip Sp Attack"],
    [1670, "Favour Preach"],
    [1671, "Favour Preach 2"],
    [1672, "Favour Preach 3"],
    [1673, "Sitting Ready Backwards"],
    [1674, "Claw Attack Burst"],
    [1675, "Claw Attack"],
    [1676, "Corpbeast Death"],
    [1677, "Corpbeast Defend"],
    [1678, "Corpbeast Idle"],
    [1679, "Corpbeast Sprite Shoot 1"],
    [1680, "Corpbeast Sprite Shoot 2"],
    [1681, "Corpbeast Sprite Shoot 3"],
    [1682, "Corpbeast Stomp Attack"],
    [1683, "Corpbeast Swiping Attack"],
    [1684, "Corpbeast Walking"],
    [1685, "Ball Attack"],
    [1686, "Corp Double Stomp"],
    [1687, "Corpbeast Doublestomp Spotanim"],
    [1688, "Darkcore Idle"],
    [1689, "Flip"],
    [1690, "Cow Walk Rf A"],
    [1691, "Cow Walk Rf B"],
    [1692, "Cow Walk Rf C"],
    [1693, "Cow Walk Rf D"],
    [1694, "Cow Walk Rf E"],
    [1695, "Cow Walk Rf F"],
    [1696, "Human Dodge Rf A"],
    [1697, "Human Dodge Rf B"],
    [1698, "Human Dodge Rf C"],
    [1699, "Human Dodge Rf D"],
    [1700, "Human Dodge Rf E"],
    [1701, "Human Dodge Rf F"],
    [1702, "Human Zamorakspear Turnonspot"],
    [1703, "Human Zamorakspear Walk F"],
    [1704, "Human Zamorakspear Walk B"],
    [1705, "Human Zamorakspear Walkright"],
    [1706, "Human Zamorakspear Walkleft"],
    [1707, "Human Zamorakspear Run"],
    [1708, "Hw07 Arm From The Ground Emote"],
    [1709, "Human Zamorakspear Block"],
    [1710, "Human Zamorakspear Lunge"],
    [1711, "Human Zamorakspear Stab"],
    [1712, "Human Zamorakspear Slash"],
    [1713, "Human Zamorakspear Ready"],
    [1714, "Armadyl Special Attack"],
    [1715, "Elysian Shield Defend"],
    [1716, "Badger Ready"],
    [1717, "Hw07 Arm From The Ground Spotanim"],
    [1718, "Badger Walk"],
    [1719, "Sotd Special Toxic Uncharged"],
    [1720, "Sotd Special Toxic Charged"],
    [1721, "Snakeboss Pet Idle"],
    [1722, "Crow Walk"],
    [1723, "Crow Ready"],
    [1724, "Crow Ready2"],
    [1725, "Crow Ready3"],
    [1726, "Tic Toc"],
    [1727, "Rock Pool"],
    [1728, "Human Farming"],
    [1729, "Waterwheel Spin"],
    [1730, "Flag Moves"],
    [1731, "Mill Rotate"],
    [1732, "Embers"],
    [1733, "Weathervain"],
    [1734, "Flagflutter"],
    [1735, "Cow Graze"],
    [1736, "Sheep Graze"],
    [1737, "Goblin Ready Spear"],
    [1738, "Goblin Walk Spear"],
    [1739, "Cape Seller Walk"],
    [1740, "Cape Seller Ready"],
    [1741, "Snakeboss Pet Attack"],
    [1742, "Snakeboss Pet Defend"],
    [1743, "Anger1"],
    [1744, "Anger2"],
    [1745, "Anger3"],
    [1746, "Anger4"],
    [1747, "Land Light Glow"],
    [1748, "Rock Walk"],
    [1749, "Rock Ready"],
    [1750, "Rock Attack"],
    [1751, "Rock Parry"],
    [1752, "Rock Death"],
    [1753, "Rock Birth"],
    [1754, "Rock Hybernate"],
    [1755, "Human Hammer Hit"],
    [1756, "Bearsuit Ready"],
    [1757, "Bearsuit Walk"],
    [1758, "Bearsuit Defend"],
    [1759, "Bearsuit Death"],
    [1760, "Bearsuit Attack"],
    [1761, "Ancient Rock Splitting"],
    [1762, "Mdaughter Tree Climb"],
    [1763, "Mdaughter Tree Climb2"],
    [1764, "Mdaughter Tree Climb3"],
    [1765, "Mdaughter Tree Climb Combi"],
    [1766, "Mdaughter Pole Vault"],
    [1767, "Mdaughter Place Stone"],
    [1768, "Mdaughter Bury"],
    [1769, "Mdaughter Absail Lean"],
    [1770, "Mdaughter Absail Jump"],
    [1771, "Mdaughter Absail Combi Old"],
    [1772, "Mdaughter Absail Combi"],
    [1773, "Giant Eagle Fly"],
    [1774, "Cave Bug Walks"],
    [1775, "Cave Bug Defend"],
    [1776, "Cave Bug Idle"],
    [1777, "Cave Bug Attack"],
    [1778, "Cave Bug Death"],
    [1779, "Cave Bug Fade In"],
    [1780, "Cave Bug Fade Out"],
    [1781, "Cave Littlebug Walk"],
    [1782, "Cave Littlebug Ready"],
    [1783, "Cave Goblin Ready"],
    [1784, "Cave Goblin Walk"],
    [1785, "Cave Goblin Attack"],
    [1786, "Cave Goblin Defend"],
    [1787, "Cave Goblin Death"],
    [1788, "Cave Slime Walks"],
    [1789, "Cave Slime Attack"],
    [1790, "Cave Slime Idle"],
    [1791, "Cave Slime Defend"],
    [1792, "Cave Slime Death"],
    [1793, "Giant Frog Attack"],
    [1794, "Giant Frog Block"],
    [1795, "Giant Frog Death"],
    [1796, "Giant Frog Ready"],
    [1797, "Giant Frog Walk"],
    [1798, "Wall Beast Ready"],
    [1799, "Wall Beast Combat Ready"],
    [1800, "Wall Beast Specialattack Appear"],
    [1801, "Wall Beast Specialattack Disappear"],
    [1802, "Wall Beast Specialattack Attack"],
    [1803, "Wall Beast Specialattack Defend"],
    [1804, "Wall Beast Specialattack Death"],
    [1805, "Wall Beast Specialattack Fail"],
    [1806, "Wall Beast Specialattack Start"],
    [1807, "Wall Beast Specialattack Ready"],
    [1808, "Wall Beast Specialattack End"],
    [1809, "Human Wall Beast Specialattack Start"],
    [1810, "Human Wall Beast Specialattack Ready"],
    [1811, "Human Wall Beast Specialattack End"],
    [1812, "Goblin Cavewall Flowinggungywater"],
    [1813, "Teleport Other Impact"],
    [1814, "Teleport Other Interface"],
    [1815, "Teleport Other Interface Right"],
    [1816, "Human Teleport Other Impact"],
    [1817, "Teleport Other Casting"],
    [1818, "Human Teleport Other Casting"],
    [1819, "Human Casting Tele Block"],
    [1820, "Human Casting Tele Block Staff"],
    [1821, "Tele Block Travel"],
    [1822, "Tele Block Impact"],
    [1823, "Cat Archback"],
    [1824, "Oddskull Ready"],
    [1825, "Oddskull Run"],
    [1826, "Oddskull Turnonspot"],
    [1827, "Oddskull Walk"],
    [1828, "Lore Dust Devil Walk"],
    [1829, "Lore Dust Devil Ready"],
    [1830, "Human Rubber Chicken Walk"],
    [1831, "Human Rubber Chicken Running"],
    [1832, "Human Rubber Chicken Ready"],
    [1833, "Human Rubber Chicken Attack"],
    [1834, "Human Rubber Chicken Block"],
    [1835, "Human Chicken Dance"],
    [1836, "Human Skipping Walk"],
    [1837, "Human Skipping Ready"],
    [1838, "Rock Avatar Ready"],
    [1839, "Rock Avatar Walk"],
    [1840, "Rock Avatar Attack"],
    [1841, "Rock Avatar Death"],
    [1842, "Rock Avatar Block"],
    [1843, "Rock Avatar Archer Attack"],
    [1844, "Rock Avatar Mage Attack"],
    [1845, "Dwarf Rock Cannonball"],
    [1846, "Dwarf Rock Cannonball Gold"],
    [1847, "Land Light"],
    [1848, "Dwarf Rock Moves"],
    [1849, "Dwarf Rock Firewall Low"],
    [1850, "Dwarfrock Cannon Incannon"],
    [1851, "Dwarfrock Cannon Flying"],
    [1852, "Dwarfrock Cannon Fly Getup"],
    [1853, "Dwarfrock Dwarf Kickrock"],
    [1854, "Dwarf Rock Interface Anim"],
    [1855, "Dwarf Rock Fade Out"],
    [1856, "Dwarf Rock Schematic1 Rot1"],
    [1857, "Dwarf Rock Schematic1 Rot2"],
    [1858, "Dwarf Rock Schematic1 Rot3"],
    [1859, "Dwarf Rock Schematic1 Rot4"],
    [1860, "Dwarf Rock Schematic2 Rot1"],
    [1861, "Dwarf Rock Schematic2 Rot2"],
    [1862, "Dwarf Rock Schematic2 Rot3"],
    [1863, "Dwarf Rock Schematic2 Rot4"],
    [1864, "Dwarf Rock Schematic3 Rot1"],
    [1865, "Dwarf Rock Schematic3 Rot2"],
    [1866, "Dwarf Rock Schematic3 Rot3"],
    [1867, "Dwarf Rock Schematic3 Rot4"],
    [1868, "Dwarf Lamp"],
    [1869, "Dwarf Fireplace"],
    [1870, "Spinning Machine"],
    [1871, "Misc Herb Weeding Npc Loop"],
    [1872, "Sp Attack Dragon Scimitar"],
    [1873, "Sp Attack Dragon Scimitar Trail"],
    [1874, "Stunned Blackjack"],
    [1875, "Green Beer Ready"],
    [1876, "Green Beer Glows"],
    [1877, "Snake Charming"],
    [1878, "Charming Loop"],
    [1879, "Snakecharmer Charming"],
    [1880, "Snakecharmer Ready"],
    [1881, "Camel Steam"],
    [1882, "Feud Safe Turns"],
    [1883, "Feud Safe Opens"],
    [1884, "Feud Safe Opens Jewels"],
    [1885, "Feud Turns 9"],
    [1886, "Feud Turns 8"],
    [1887, "Feud Turns 7"],
    [1888, "Feud Turns 6"],
    [1889, "Feud Turns 5"],
    [1890, "Feud Turns 4"],
    [1891, "Feud Turns 3"],
    [1892, "Feud Turns 2"],
    [1893, "Feud Turns 1"],
    [1894, "Feud Poisoning Beer"],
    [1895, "Feud Hot Sauce Poisoning"],
    [1896, "Camel Eats From Trough"],
    [1897, "Feud Crawling Ready"],
    [1898, "Camel Eat From Trough"],
    [1899, "Snake Into Charm"],
    [1900, "Snake Charmed"],
    [1901, "Snake Outof Charm"],
    [1902, "Start Spinning Plate"],
    [1903, "Start Spinning Plate F"],
    [1904, "Stop Spinning Plate"],
    [1905, "Stop Spinning Plate F"],
    [1906, "Drop Spinning Plate"],
    [1907, "Drop Spinning Plate F"],
    [1908, "Golem Portal Spin"],
    [1909, "Golem Door Open"],
    [1910, "Golem Display Open"],
    [1911, "Golem Display Close"],
    [1912, "Clay Golem Walk"],
    [1913, "Clay Golem Ready"],
    [1914, "Vampire Summonbats"],
    [1915, "Vampire Coffin Open"],
    [1916, "Bat Cluster Attack"],
    [1917, "Vampire Rise1"],
    [1918, "Vampire Rise2"],
    [1919, "Vampire Rise"],
    [1920, "Fire Object"],
    [1921, "Smokeoverlay"],
    [1922, "Legend Mirror Bling"],
    [1923, "Legend Mirror Ready"],
    [1924, "Legend Mirror Beam"],
    [1925, "Deserttreasure Mummy Walk"],
    [1926, "Deserttreasure Mummy Attack"],
    [1927, "Deserttreasure Mummy Block"],
    [1928, "Deserttreasure Mummy Ready"],
    [1929, "Deserttreasure Mummy Death"],
    [1930, "Deserttreasure Mummy Emerge"],
    [1931, "Deserttreasure Mummy Emerge East"],
    [1932, "Deserttreasure Mummy Emerge South"],
    [1933, "Deserttreasure Mummy Emerge West"],
    [1934, "Deserttreasure Mummy Walk On Fire"],
    [1935, "Deserttreasure Mummy Turn To Ash"],
    [1936, "Deserttreasure Scarab Cracks Wall"],
    [1937, "Deserttreasure Scarab Cracks Floor"],
    [1938, "Deserttreasure Scarab Pour"],
    [1939, "Deserttreasure Pitfall Open"],
    [1940, "Door Ready"],
    [1941, "Door Open"],
    [1942, "Door Close"],
    [1943, "Oblix Open"],
    [1944, "Tomb Wall Crushing"],
    [1945, "Scarab Swarming"],
    [1946, "Scarab Parry"],
    [1947, "Scarab Ready"],
    [1948, "Scarab Attack"],
    [1949, "Scarab Spiral"],
    [1950, "Desert Comedy Fall"],
    [1951, "Falling Comedy Smoke"],
    [1952, "Sitting Ready East"],
    [1953, "Sitting Ready North"],
    [1954, "Sitting Ready West"],
    [1955, "Sitting Ready South"],
    [1956, "Burn Firewarrior"],
    [1957, "Rise Azzaanadra"],
    [1958, "Ice Rush Travel"],
    [1959, "Ice Rush Impact"],
    [1960, "Ice Blitz Travel"],
    [1961, "Ice Blitz Impact"],
    [1962, "Ice Burst Travel"],
    [1963, "Ice Burst Impact"],
    [1964, "Ice Barrage Travel"],
    [1965, "Ice Barrage Impact"],
    [1966, "Spell Blood Burst Impact"],
    [1967, "Spell Blood Barrage Impact"],
    [1968, "Blood Rush Travel"],
    [1969, "Blood Blitz Travel"],
    [1970, "Blood Rush Impact"],
    [1971, "Blood Blitz Impact"],
    [1972, "Blood Barrage Impact"],
    [1973, "Spell Shadow Rush Impact"],
    [1974, "Spell Shadow Rush Travel"],
    [1975, "Spell Shadow Blitz Travel"],
    [1976, "Spell Shadow Burst Impact"],
    [1977, "Spell Shadow Barrage Impact"],
    [1978, "Zaros Casting"],
    [1979, "Zaros Vertical Casting"],
    [1980, "Smoke Rush Travel"],
    [1981, "Smoke Blitz Travel"],
    [1982, "Smoke Rush Impact"],
    [1983, "Smoke Blitz Impact"],
    [1984, "Smoke Burst Travel"],
    [1985, "Smoke Burst Impact"],
    [1986, "Smoke Barrage Travel"],
    [1987, "Smoke Barrage Impact"],
    [1988, "Zaros Teleport"],
    [1989, "Human Chocolate Fletching"],
    [1990, "Dragon Ranged Attacks"],
    [1991, "Icthal Daze"],
    [1992, "Ic Pit Jump"],
    [1993, "Ic Up Ons"],
    [1994, "Ic Pit Fall"],
    [1995, "Ic Running"],
    [1996, "Ic Flyout"],
    [1997, "Ics Pit Secret Door"],
    [1998, "Ics Secret Door"],
    [1999, "Icthalarins Door Closes"],
    [2000, "Icthalarins Door Opens"],
    [2001, "Ics Tile Turn F2b"],
    [2002, "Ics Tile Turn B2f"],
    [2003, "Ics Tilecounter4"],
    [2004, "Ics Tilecounter4 3"],
    [2005, "Ics Tilecounter3 2"],
    [2006, "Ics Tilecounter2 1"],
    [2007, "Ics Tilecounter1 0"],
    [2008, "Ics Overlay"],
    [2009, "Human Collect Sap"],
    [2010, "Scrape Salt"],
    [2011, "Locust Walk"],
    [2012, "Locust Ready"],
    [2013, "Locust Death"],
    [2014, "Locust Parry"],
    [2015, "Locust Attack"],
    [2016, "Vulture Walk"],
    [2017, "Vulture Ground Ready"],
    [2018, "Vulture Ground Peck"],
    [2019, "Vulture Ground Attack"],
    [2020, "Vulture Ground Block"],
    [2021, "Vulture Ground Death"],
    [2022, "Vulture Takeoff"],
    [2023, "Vulture Land"],
    [2024, "Vulture Fly"],
    [2025, "Vulture Fly Attack"],
    [2026, "Vulture Fly Death"],
    [2027, "Sphinx Walk"],
    [2028, "Sphinx Ready"],
    [2029, "Sphinx Attack"],
    [2030, "Sphinx Parry"],
    [2031, "Sphinx Death"],
    [2032, "Sphinx Sit Down"],
    [2033, "Spinx Sit"],
    [2034, "Sphinx Sit Up"],
    [2035, "Croc Parry"],
    [2036, "Croc Walk"],
    [2037, "Croc Ready"],
    [2038, "Croc Death"],
    [2039, "Croc Attack"],
    [2040, "Tog Ready Bowl"],
    [2041, "Tog Walk Bowl"],
    [2042, "Tog Run Bowl"],
    [2043, "Tog Lean Forward Bowl"],
    [2044, "Tog Lean Back Bowl"],
    [2045, "Tog Drink Bowl"],
    [2046, "Tog Player Float Up"],
    [2047, "Tog Player Float Down"],
    [2048, "Tog Player Float Across"],
    [2049, "Tog Climb Slope Up"],
    [2050, "Tog Climb Slope Down"],
    [2051, "Light Creature Ready"],
    [2052, "Light Creature Grow"],
    [2053, "Light Creature Shrink"],
    [2054, "Tog Weeping Wall"],
    [2055, "Tog Snake Openclose"],
    [2056, "Tog Snake Sleep"],
    [2057, "Tog Snake Ready"],
    [2058, "Flob"],
    [2059, "Human Readbook Posh"],
    [2060, "Barrow Guthan Walk"],
    [2061, "Barrow Guthan Ready"],
    [2062, "Barrow Guthan Crush"],
    [2063, "Barrow Guthan Defend"],
    [2064, "Barrow Dharok Walk"],
    [2065, "Barrow Dharok Ready"],
    [2066, "Barrow Dharok Slash"],
    [2067, "Barrow Dharok Crush"],
    [2068, "Barrow Torag Crush"],
    [2069, "Bloodworm Walk"],
    [2070, "Bloodworm Attack"],
    [2071, "Bloodworm Ready"],
    [2072, "Bloodworm Block"],
    [2073, "Bloodworm Death"],
    [2074, "Barrows Repeating Crossbow Ready"],
    [2075, "Barrows Repeating Crossbow Fire"],
    [2076, "Barrows Repeating Crossbow Walk"],
    [2077, "Barrows Repeating Crossbow Run"],
    [2078, "Barrows Quarterstaff Attack"],
    [2079, "Barrows Quarterstaff Defend"],
    [2080, "Barrows War Spear Stab"],
    [2081, "Barrows War Spear Slash"],
    [2082, "Barrows War Spear Crush"],
    [2083, "Barrows Guthan Infestation"],
    [2084, "Barrows Torag Corruption"],
    [2085, "Barrows Chathead Fade"],
    [2086, "Barrows Ahrim Blighted Aura"],
    [2087, "Barrows Karil Tainted Shot"],
    [2088, "Ogre Injured1"],
    [2089, "Ogre Injured2"],
    [2090, "Ogre Fake Death"],
    [2091, "Bedman Sleep"],
    [2092, "Desease Rough"],
    [2093, "Human Openingchest Start"],
    [2094, "Human Openingchest Mid"],
    [2095, "Human Openingchest End"],
    [2096, "Human Pick Wall Start"],
    [2097, "Human Pick Wall Middle"],
    [2098, "Human Pick Wall End"],
    [2099, "Ogre Dance"],
    [2100, "Ogre Drum"],
    [2101, "Ogre Breath"],
    [2102, "Ogre Kick"],
    [2103, "Zogre Bell Ring"],
    [2104, "Zombie Ogre Walk"],
    [2105, "Emote Panic"],
    [2106, "Emote Dance Scottish"],
    [2107, "Emote Dance Spin"],
    [2108, "Emote Dance Headbang"],
    [2109, "Emote Jump With Joy"],
    [2110, "Emote Ya Boo Sucks"],
    [2111, "Emote Yawn"],
    [2112, "Emote Fremmenik Salute"],
    [2113, "Emote Shrug"],
    [2114, "Anma Chopping Failed Dragon Axe"],
    [2115, "Anma Chopping Failed Infernal Axe"],
    [2116, "Human Canoeing Carve Infernal Axe"],
    [2117, "Human Woodcutting Infernal Axe"],
    [2118, "Cave Goblin Mining"],
    [2119, "Cave Goblin Bone Spear Walk"],
    [2120, "Cave Goblin Bone Spear Attack"],
    [2121, "Cave Goblin Bone Spear Block"],
    [2122, "Cave Goblin Bow"],
    [2123, "Cave Goblin Bone Club Attack"],
    [2124, "Cave Goblin Bone Spear Ready"],
    [2125, "Cave Goblin Dance"],
    [2126, "Swamp Fishing Point"],
    [2127, "Human Cave Goblin Bow"],
    [2128, "Human Cave Goblin Dance"],
    [2129, "Goblin Dance"],
    [2130, "Goblin Bow"],
    [2131, "Collapsing Floor"],
    [2132, "Big Rockfall"],
    [2133, "Church Windowlight"],
    [2134, "Cat On Stool Ready"],
    [2135, "Crush Rock"],
    [2136, "Ladder Wobble"],
    [2137, "Pitcher Plant"],
    [2138, "Mini Statue Explodes"],
    [2139, "Macro Lever Switch Up"],
    [2140, "Macro Lever Switch Down"],
    [2141, "Lever Switch Up Down"],
    [2142, "Keldagrim Fill Machine"],
    [2143, "Keldagrim Ignite Machine"],
    [2144, "Keldagrim Crafting Sapphires Blunt"],
    [2145, "Keldagrim Crafting Sapphires Sharp"],
    [2146, "Human Climbing Bookcase"],
    [2147, "Human Climbing Bookcase Fail"],
    [2148, "Human Minecart Anim"],
    [2149, "Human Geni Bowing"],
    [2150, "Dwarf Minecart Ready"],
    [2151, "Dwarf Director Table Ready"],
    [2152, "Dwarf Director Table Ready Nod"],
    [2153, "Dwarf Director Table Woman Ready Nod"],
    [2154, "Dwarf Walk Walkingstick"],
    [2155, "Dwarf Ready Walkingstick"],
    [2156, "Dwarf Walk Woman"],
    [2157, "Dwarf Ready Woman"],
    [2158, "Dwarf Secretary Ready"],
    [2159, "Cat Sleep Ready"],
    [2160, "Cat Lay Down"],
    [2161, "Cat Get Up"],
    [2162, "Cow Just Ready"],
    [2163, "Spade Ready"],
    [2164, "Spade Walk"],
    [2165, "Farming Pig Walk"],
    [2166, "Farming Pig Ready"],
    [2167, "Wom Bed Attack"],
    [2168, "Wom Bed Block"],
    [2169, "Wom Bed Death"],
    [2170, "Wom Bed Ready"],
    [2171, "Human Use Wom Telecope"],
    [2172, "Rcu Apocalyse Spins"],
    [2173, "Rcu Abyssal Tendrils"],
    [2174, "Rcu Abyssal Hole Open"],
    [2175, "Rcu Abyssal Hole Closed"],
    [2176, "Rcu Abyssal Hole Closed Loop"],
    [2177, "Rcu Abyssal Hole Open Loop"],
    [2178, "Rcu Rune Icon Float"],
    [2179, "Abyssal Leech Walk"],
    [2180, "Abyssal Leech Ready"],
    [2181, "Abyssal Leech Attack"],
    [2182, "Abyssal Leech Defend"],
    [2183, "Abyssal Leech Death"],
    [2184, "Abyssal Pyramid Walk"],
    [2185, "Abyssal Pyramid Ready"],
    [2186, "Abyssal Pyramid Ranged Attack"],
    [2187, "Abyssal Pyramid Attack"],
    [2188, "Abyssal Pyramid Defend"],
    [2189, "Abyssal Pyramid Death"],
    [2190, "Abyssal Walker Walk"],
    [2191, "Abyssal Walker Ready"],
    [2192, "Abyssal Walker Attack"],
    [2193, "Abyssal Walker Defend"],
    [2194, "Abyssal Walker Death"],
    [2195, "Rogue Wall Spikes"],
    [2196, "Rogue Wall Spikes Non Active"],
    [2197, "Rogue Wall Scythe"],
    [2198, "Rogue Wall Scythe Non Active"],
    [2199, "Rogue Floor Scythe"],
    [2200, "Rogue Poison Gas"],
    [2201, "Rogue Poison Gas Non Active"],
    [2202, "Rogue Explosion"],
    [2203, "Rogue Explosion Non Active"],
    [2204, "Rogue Pendulum Swings"],
    [2205, "Rogue Magic Door"],
    [2206, "Rogue Scytheblades Twist"],
    [2207, "Rogue Springy Death"],
    [2208, "Rogue Wall Saw"],
    [2209, "Rogue Wall Saw Non Active"],
    [2210, "Rogue Timedblade Non Active"],
    [2211, "Rogue Wall Crush"],
    [2212, "Rogue Spinblades"],
    [2213, "Rogue Karate All"],
    [2214, "Rogue Karate Chop"],
    [2215, "Rogue Karate Kick"],
    [2216, "Rogue Blocking Grill"],
    [2217, "Roguesden Interface Mosaic N"],
    [2218, "Roguesden Interface Mosaic E"],
    [2219, "Roguesden Interface Mosaic S"],
    [2220, "Roguesden Interface Mosaic W"],
    [2221, "Roguesden Interface Dial"],
    [2222, "Roguesden Interface Dial Ne Clockwise"],
    [2223, "Roguesden Interface Dial En Anticlockwise"],
    [2224, "Roguesden Interface Dial Es Clockwise"],
    [2225, "Roguesden Interface Dial Se Anticlockwise"],
    [2226, "Roguesden Interface Dial Sw Clockwise"],
    [2227, "Roguesden Interface Dial Ws Anticlockwise"],
    [2228, "Roguesden Interface Dial Wn Clockwise"],
    [2229, "Roguesden Interface Dial Nw Anticlockwise"],
    [2230, "Roguesden Interface Gear1"],
    [2231, "Roguesden Interface Gear2"],
    [2232, "Roguesden Interface Gear3"],
    [2233, "Roguesden Interface Gear4"],
    [2234, "Roguesden Interface Gear5"],
    [2235, "Roguesden Interface Gear6"],
    [2236, "Roguesden Interface Gear7"],
    [2237, "Roguesden Interface Gear8"],
    [2238, "Roguesden Interface Gear9"],
    [2239, "Roguesden Spring Trap"],
    [2240, "Roguesden Contortion"],
    [2241, "Roguesden Player Poison Choke"],
    [2242, "Roguesden Player Explosion"],
    [2243, "Roguesden Player Enchant Door"],
    [2244, "Roguesden Player Disarm Floor"],
    [2245, "Roguesden Player Disarm Wall Right"],
    [2246, "Roguesden Player Disarm Wall Infront"],
    [2247, "Rogue Player Crack Safe Start"],
    [2248, "Rogue Player Crack Safe Mid"],
    [2249, "Rogue Player Crack Safe End"],
    [2250, "Roguesden Camp Walk"],
    [2251, "Rd Fox Run"],
    [2252, "Rd Sitting At Bench"],
    [2253, "Rd Knight Relaxed Ready"],
    [2254, "Rd Knight Walk"],
    [2255, "Rd Throne Sit"],
    [2256, "Rd Knight Crossed Arms"],
    [2257, "Rd Carry Fox Ready"],
    [2258, "Rd Carry Fox Walk"],
    [2259, "Rd Pour Vial"],
    [2260, "Rcu Apocalypse Spins"],
    [2261, "Dragon Warhammer Sa Spotanim"],
    [2262, "Carpet Raise"],
    [2263, "Carpet Land"],
    [2264, "Carpet Bank Right"],
    [2265, "Carpet Bank Left"],
    [2266, "Carpet Sit Down"],
    [2267, "Bear Headless Beast Attack"],
    [2268, "Sittingdog Ready"],
    [2269, "Farming Slice Watermelon"],
    [2270, "Farming Useloom"],
    [2271, "Farming Trowel Dig"],
    [2272, "Farming Trowel Digging"],
    [2273, "Farming Raking"],
    [2274, "Pruning All"],
    [2275, "Pruning Mid High"],
    [2276, "Pruning Mid Low"],
    [2277, "Pruning High"],
    [2278, "Pruning Mid"],
    [2279, "Pruning Low"],
    [2280, "Picking High"],
    [2281, "Picking Mid"],
    [2282, "Picking Low"],
    [2283, "Farming Pour Water"],
    [2284, "Farming Fill Keg"],
    [2285, "Farming Fill Glass"],
    [2286, "Farming Turn Valve"],
    [2287, "Farming Filling Plantpot"],
    [2288, "Farming Plant Cure"],
    [2289, "Farming Keg Drink"],
    [2290, "Farming Keg Scoop"],
    [2291, "Farming Seed Dibbing"],
    [2292, "Farming Pick Mushroom"],
    [2293, "Farming Watering"],
    [2294, "Farming Watering Water"],
    [2295, "Farming Ingredient Sprinkle"],
    [2296, "Farming Ingredient Sprinkle Spotanim"],
    [2297, "Roosterwalk"],
    [2298, "Roosterready"],
    [2299, "Roosterattack"],
    [2300, "Roosterparry"],
    [2301, "Roosterdeath"],
    [2302, "Roostermagic"],
    [2303, "Cow Chews Grass"],
    [2304, "Macro Sandwich Lady Knockout"],
    [2305, "Milkit"],
    [2306, "Human Applecrush"],
    [2307, "Applebarrel Forcrush"],
    [2308, "Bear Headless Beast Walk"],
    [2309, "Abyssal Demon Teleport"],
    [2310, "Slayer Infernalmage Caststrike"],
    [2311, "Ics Comedy Fall"],
    [2312, "Cow Attack Dead"],
    [2313, "Treegate Close"],
    [2314, "Treegate Closed"],
    [2315, "Treegate Open"],
    [2316, "Human Toadcannon Ready"],
    [2317, "Human Toadcannon Walk F"],
    [2318, "Human Toadcannon Walk B"],
    [2319, "Human Toadcannon Walk L"],
    [2320, "Human Toadcannon Walk R"],
    [2321, "Human Toadcannon Turnonspot"],
    [2322, "Human Toadcannon Running"],
    [2323, "Human Toadcannon Attack"],
    [2324, "Human Toadcannon Parry"],
    [2325, "Human Toadcannon Prepare"],
    [2326, "Human Toadcannon Fire"],
    [2327, "Human Woodcrafting Axe Bronze"],
    [2328, "Paint Frog Travel"],
    [2329, "Paint Frog Hit"],
    [2330, "Gnome Tickle"],
    [2331, "Gnome Ready"],
    [2332, "Mourning Player Tickle"],
    [2333, "Human Secret Ghost Transwalk F"],
    [2334, "Human Secret Ghost Transready"],
    [2335, "Dwarf Walk Withhelmet"],
    [2336, "Dwarf Ready Withhelmet"],
    [2337, "Dwarf Ready Sitting And Drinking"],
    [2338, "Human Crawl Ready For Forget"],
    [2339, "Human Sitting Drunk Ready"],
    [2340, "Human Sitting Drunk Fall"],
    [2341, "Forgettable Evil Dwarf Laugh"],
    [2342, "Dwarf Clink Beerglass"],
    [2343, "Human Clink Beerglass"],
    [2344, "Dagganoth Shipjourney To Dagganoth"],
    [2345, "Dagganoth Shipjourney To Rellekka"],
    [2346, "Dagannoth Boat Sail"],
    [2347, "Pressure Door Open"],
    [2348, "Pressure Door Open2"],
    [2349, "Pressure Door Close"],
    [2350, "Pressure Door Opened"],
    [2351, "Weak Door Fall"],
    [2352, "Weak Door Fallen"],
    [2353, "Weak Door Fall West"],
    [2354, "Weak Door West"],
    [2355, "Weak Door Fallen West"],
    [2356, "Weak Door Fall North"],
    [2357, "Weak Door North"],
    [2358, "Weak Door Fallen North"],
    [2359, "Dagannoth Flag"],
    [2360, "Dagannoth Flag2"],
    [2361, "Dagganoth Walk Quickly"],
    [2362, "Dagganoth Egg Open"],
    [2363, "Wallasalki Walk"],
    [2364, "Wallasalki Ready"],
    [2365, "Wallasalki Attack"],
    [2366, "Wallasalki Defend"],
    [2367, "Wallasalki Death"],
    [2368, "Horror Crab Pincer Attack"],
    [2369, "Pheasent Walk"],
    [2370, "Pheasent Ready"],
    [2371, "Pheasent Attack"],
    [2372, "Pheasent Defend"],
    [2373, "Pheasent Death"],
    [2374, "Giant Frog Kiss"],
    [2375, "Frog Change Into Human"],
    [2376, "Human Frog Kiss"],
    [2377, "Human Change Into Frog"],
    [2378, "Quiz Sit"],
    [2379, "Beamy"],
    [2380, "Tbw Cleanup Bush Shake"],
    [2381, "Tbw Cleanup Chippings"],
    [2382, "Tbw Cleanup Player Hack"],
    [2383, "Tbw Cleanup Player Hack Stall"],
    [2384, "Tbw Cleanup Player Fixfence Start"],
    [2385, "Tbw Cleanup Player Fixfence Mid"],
    [2386, "Tbw Cleanup Player Fixfence End"],
    [2387, "Tbw Cleanup Player Hack Success"],
    [2388, "Tbw Cleanup Player Hack Fail"],
    [2389, "Tbw Cleanup Player Prepare Wood"],
    [2390, "Tbw Cleanup Player Surprise Stepback"],
    [2391, "Tbw Cleanup Spider Surprise Attack"],
    [2392, "Tbw Cleanup Snake Surprise Attack"],
    [2393, "Tbw Cleanup Player Spider On Stick"],
    [2394, "Human Use Insect Repellant"],
    [2395, "Tbw Mosquito Ready"],
    [2396, "Tbw Mosquito Walk"],
    [2397, "Tbw Mosquito Attack"],
    [2398, "Tbw Mosquito Death"],
    [2399, "Tbw Mosquito Defend"],
    [2400, "Tbw Cleanup Tribesmen Surprise"],
    [2401, "Tbw Broodoo Dance"],
    [2402, "Change Jekyll Hyde1"],
    [2403, "Tbw Broodoo Shield Block"],
    [2404, "Tbw Broodoo Shield Spotanim"],
    [2405, "Snakeboss Pet Walk Forward"],
    [2406, "Snakeboss Pet Walk Back"],
    [2407, "Snakeboss Pet Walk Left"],
    [2408, "Snakeboss Pet Death"],
    [2409, "Human Shield Crafting Combat"],
    [2410, "Human Shield Crafting Poison"],
    [2411, "Human Shield Crafting Disease"],
    [2412, "Change Jekyll Hyde2"],
    [2413, "Snakeboss Pet Spawn"],
    [2414, "Snakeboss Pet Walk Right"],
    [2415, "Snakeboss Pet Chathead Talk"],
    [2416, "Fight Arena Hk Hearth Fire"],
    [2417, "Darkcore Walk"],
    [2418, "Fedora Tip"],
    [2419, "Diary Emote Spotanim"],
    [2420, "Tbw Cleanup Player Fixfence Start Opal"],
    [2421, "Tbw Cleanup Player Fixfence Mid Opal"],
    [2422, "Tbw Cleanup Player Fixfence End Opal"],
    [2423, "Tbw Cleanup Player Fixfence Start Jade"],
    [2424, "Tbw Cleanup Player Fixfence Mid Jade"],
    [2425, "Tbw Cleanup Player Fixfence End Jade"],
    [2426, "Tbw Cleanup Player Fixfence Start Redtopaz"],
    [2427, "Tbw Cleanup Player Fixfence Mid Redtopaz"],
    [2428, "Tbw Cleanup Player Fixfence End Redtopaz"],
    [2429, "Tbw Cleanup Player Prepare Wood Opal"],
    [2430, "Tbw Cleanup Player Prepare Wood Jade"],
    [2431, "Tbw Cleanup Player Prepare Wood Redtopaz"],
    [2432, "Blast Furnace Human Air Pump"],
    [2433, "Blast Furnace Human Conveyer Cycle"],
    [2434, "Blast Furnace Conveyer Ore Fall"],
    [2435, "Blast Furnace Conveyer Belt"],
    [2436, "Blast Furnace Conveyer Cogs"],
    [2437, "Blast Furnace Conveyer Belt End"],
    [2438, "Blast Furnace Conveyer Cogs End"],
    [2439, "Blast Furnace Smoke"],
    [2440, "Blast Furnace Ore Dispense"],
    [2441, "Human Shovel Coke Up"],
    [2442, "Human Shovel Coke Down"],
    [2443, "Human Shovel Coke Fin"],
    [2444, "Temp Gauge Flag Fuel Low Out"],
    [2445, "Temp Gauge Flag Fuel Low In"],
    [2446, "Temp Gauge Flag Pipe Broken Out"],
    [2447, "Temp Gauge Flag Pipe Broken In"],
    [2448, "Flashing X"],
    [2449, "Flashing X Off"],
    [2450, "Human Throw Bucket"],
    [2451, "Blast Furnace Conveyer Cogs Broken"],
    [2452, "Blast Furnace Temp Gauge1"],
    [2453, "Blast Furnace Temp Gauge2"],
    [2454, "Blast Furnace Temp Gauge3"],
    [2455, "Blast Furnace Temp Gauge4"],
    [2456, "Blast Furnace Temp Gauge5"],
    [2457, "Blast Furnace Temp Gauge6"],
    [2458, "Blast Furnace Temp Gauge7"],
    [2459, "Blast Furnace Temp Gauge8"],
    [2460, "Blast Furnace Temp Gauge9"],
    [2461, "Blast Furnace Temp Gauge10"],
    [2462, "Blast Furnace Temp Gauge11"],
    [2463, "Blast Furnace Temp Gauge12"],
    [2464, "Blast Furnace Temp Gauge13"],
    [2465, "Blast Furnace Temp Gauge14"],
    [2466, "Blast Furnace Temp Gauge15"],
    [2467, "Blast Furnace Temp Gauge16"],
    [2468, "Blast Furnace Temp Gauge17"],
    [2469, "Blast Furnace Temp Gauge18"],
    [2470, "Blast Furnace Temp Gauge19"],
    [2471, "Blast Furnace Temp Gauge20"],
    [2472, "Blast Furnace Temp Gauge21"],
    [2473, "Blast Furnace Temp Gauge22"],
    [2474, "Blast Furnace Temp Gauge23"],
    [2475, "Blast Furnace Temp Gauge24"],
    [2476, "Blast Furnace Temp Gauge25"],
    [2477, "Blast Furnace Temp Gauge26"],
    [2478, "Blast Furnace Temp Gauge27"],
    [2479, "Blast Furnace Temp Gauge28"],
    [2480, "Blast Furnace Temp Gauge29"],
    [2481, "Blast Furnace Temp Gauge30"],
    [2482, "Blast Furnace Temp Gauge31"],
    [2483, "Blast Furnace Temp Gauge32"],
    [2484, "Blast Furnace Temp Gauge33"],
    [2485, "Blast Furnace Temp Gauge34"],
    [2486, "Blast Furnace Temp Gauge35"],
    [2487, "Blast Furnace Temp Gauge36"],
    [2488, "Blast Furnace Temp Gauge37"],
    [2489, "Blast Furnace Temp Gauge38"],
    [2490, "Blast Furnace Temp Gauge39"],
    [2491, "Blast Furnace Temp Gauge40"],
    [2492, "Blast Furnace Temp Gauge41"],
    [2493, "Blast Furnace Temp Gauge42"],
    [2494, "Blast Furnace Temp Gauge43"],
    [2495, "Blast Furnace Temp Gauge44"],
    [2496, "Blast Furnace Temp Gauge45"],
    [2497, "Blast Furnace Temp Gauge46"],
    [2498, "Blast Furnace Temp Gauge47"],
    [2499, "Blast Furnace Temp Gauge48"],
    [2500, "Blast Furnace Temp Gauge49"],
    [2501, "Blast Furnace Temp Gauge50"],
    [2502, "Blast Furnace Temp Gauge51"],
    [2503, "Blast Furnace Temp Gauge52"],
    [2504, "Blast Furnace Temp Gauge53"],
    [2505, "Blast Furnace Temp Gauge54"],
    [2506, "Blast Furnace Temp Gauge55"],
    [2507, "Blast Furnace Temp Gauge56"],
    [2508, "Blast Furnace Temp Gauge57"],
    [2509, "Blast Furnace Temp Gauge58"],
    [2510, "Blast Furnace Temp Gauge59"],
    [2511, "Blast Furnace Temp Gauge60"],
    [2512, "Blast Furnace Temp Gauge61"],
    [2513, "Blast Furnace Temp Gauge62"],
    [2514, "Blast Furnace Temp Gauge63"],
    [2515, "Blast Furnace Temp Gauge64"],
    [2516, "Blast Furnace Temp Gauge65"],
    [2517, "Blast Furnace Temp Gauge66"],
    [2518, "Blast Furnace Temp Gauge67"],
    [2519, "Blast Furnace Temp Gauge68"],
    [2520, "Blast Furnace Temp Gauge69"],
    [2521, "Blast Furnace Temp Gauge70"],
    [2522, "Blast Furnace Temp Gauge71"],
    [2523, "Blast Furnace Temp Gauge72"],
    [2524, "Blast Furnace Temp Gauge73"],
    [2525, "Blast Furnace Temp Gauge74"],
    [2526, "Blast Furnace Temp Gauge75"],
    [2527, "Blast Furnace Temp Gauge76"],
    [2528, "Blast Furnace Temp Gauge77"],
    [2529, "Blast Furnace Temp Gauge78"],
    [2530, "Blast Furnace Temp Gauge79"],
    [2531, "Blast Furnace Temp Gauge80"],
    [2532, "Blast Furnace Temp Gauge81"],
    [2533, "Blast Furnace Temp Gauge82"],
    [2534, "Blast Furnace Temp Gauge83"],
    [2535, "Blast Furnace Temp Gauge84"],
    [2536, "Blast Furnace Temp Gauge85"],
    [2537, "Blast Furnace Temp Gauge86"],
    [2538, "Blast Furnace Temp Gauge87"],
    [2539, "Blast Furnace Temp Gauge88"],
    [2540, "Blast Furnace Temp Gauge89"],
    [2541, "Blast Furnace Temp Gauge90"],
    [2542, "Blast Furnace Temp Gauge91"],
    [2543, "Blast Furnace Temp Gauge92"],
    [2544, "Blast Furnace Temp Gauge93"],
    [2545, "Blast Furnace Temp Gauge94"],
    [2546, "Blast Furnace Temp Gauge95"],
    [2547, "Blast Furnace Temp Gauge96"],
    [2548, "Blast Furnace Temp Gauge97"],
    [2549, "Blast Furnace Temp Gauge98"],
    [2550, "Blast Furnace Temp Gauge99"],
    [2551, "Blast Furnace Temp Gauge100"],
    [2552, "Blast Furnace Temp Gauge101"],
    [2553, "Human Become Skeleton Death"],
    [2554, "Skeleton Become Skeleton Death"],
    [2555, "Wom Kung Fu Attack"],
    [2556, "Wom Recoil"],
    [2557, "Wom Watchman Death"],
    [2558, "Wall Crush Spell Casting"],
    [2559, "Wall Crush Spell Travel"],
    [2560, "Wall Crush Spell Impact"],
    [2561, "Human Dh Weapon Ready"],
    [2562, "Human Dh Weapon Walk"],
    [2563, "Human Dh Weapon Run"],
    [2564, "Candle Flicker"],
    [2565, "Garden Push Trolley"],
    [2566, "Garden Pull Trolley"],
    [2567, "Garden Trolley Ready"],
    [2568, "Garden Trolley Walk"],
    [2569, "Garden Apply Potion"],
    [2570, "Garden Cut Shoot"],
    [2571, "Tranquillity Trolley Move One Square"],
    [2572, "Garden Statue Push"],
    [2573, "Garden Laugh With Shield"],
    [2574, "Garden Statue Push For Cutscene"],
    [2575, "Garden Cast Well"],
    [2576, "Garden Fish Well"],
    [2577, "Garden Picking"],
    [2578, "Garden Queen Ready"],
    [2579, "Garden Queen Slap"],
    [2580, "Garden Slap Hit"],
    [2581, "Human Wobbleandfall Short L"],
    [2582, "Human Wobbleandfall Short R"],
    [2583, "Agility Shortcut Wall Jump"],
    [2584, "Agility Shortcut Wall Jump Static"],
    [2585, "Agility Shortcut Wall Jump2"],
    [2586, "Agility Shortcut Wall Jumpdown"],
    [2587, "Agility Shortcut Wall Jumpdown Static"],
    [2588, "Agility Shortcut Wall Jumpdown2"],
    [2589, "Agilty Shortcut Enter Hole"],
    [2590, "Agilty Shortcut Tunnel Walk"],
    [2591, "Agilty Shortcut Exit Hole"],
    [2592, "Side Hurt"],
    [2593, "Side Hurtl"],
    [2594, "Agility Shortcut Crack Enter"],
    [2595, "Agility Shortcut Crack Leave"],
    [2596, "Redemption Spotanim"],
    [2597, "Retribution Spotanim"],
    [2598, "Glowy Thing"],
    [2599, "Lava Flow"],
    [2600, "Tzhaar Lava Egg"],
    [2601, "Thzaar Walk"],
    [2602, "Thzaar Staff Walk"],
    [2603, "Thzaar Ready"],
    [2604, "Thzaar Staff Ready"],
    [2605, "Thzaar Parry"],
    [2606, "Thzaar Staff Parry"],
    [2607, "Thzaar Death"],
    [2608, "Thzaar Staff Death"],
    [2609, "Thzaar Unarmed Attack"],
    [2610, "Thzaar Armed Attack"],
    [2611, "Thzaar Ring Attack"],
    [2612, "Thzaar Staff Attack"],
    [2613, "Thzaar Magic Attack"],
    [2614, "Thzarr Ring Chuck"],
    [2615, "Thzaar Ring Fly"],
    [2616, "Tzhaar Firebreath Attack"],
    [2617, "Tzhaar Fire Floor"],
    [2618, "Firebat Ready"],
    [2619, "Firebat Walk"],
    [2620, "Firebat Death"],
    [2621, "Firebat Attack"],
    [2622, "Firebat Defend"],
    [2623, "Lavabeast Walk"],
    [2624, "Lavabeast Ready"],
    [2625, "Lavabeast Attack"],
    [2626, "Lavabeast Defend"],
    [2627, "Lavabeast Death"],
    [2628, "Magmaquris Punch"],
    [2629, "Magmaquris Defend"],
    [2630, "Magmaquris Death"],
    [2631, "Magmaquris Ready"],
    [2632, "Magmaquris Walk"],
    [2633, "Magmaquris Spine Attack"],
    [2634, "Lizard Cleric Walk"],
    [2635, "Lizard Cleric Defend"],
    [2636, "Lizard Cleric Ready"],
    [2637, "Lizard Cleric Attack"],
    [2638, "Lizard Cleric Death"],
    [2639, "Lizard Cleric Heal"],
    [2640, "Lizard Cleric Heal Spot"],
    [2641, "Lava Forge"],
    [2642, "Igniferum Ready"],
    [2643, "Igniferum Walk"],
    [2644, "Igniferum Attack"],
    [2645, "Igniferum Defend"],
    [2646, "Igniferum Death"],
    [2647, "Igniferum Ranged"],
    [2648, "Igniferum Fire Launch Travel"],
    [2649, "Igniferum Fire Launch Impact"],
    [2650, "Lordmagmus Ready"],
    [2651, "Lordmagmus Walk"],
    [2652, "Lordmagmus Smash"],
    [2653, "Lordmagmus Defend"],
    [2654, "Lordmagmus Death"],
    [2655, "Lordmagmus Attack"],
    [2656, "Lordmagmus Fire"],
    [2657, "Tzhaar Viewing Orb"],
    [2658, "Tzhaar Fire Spit Launch"],
    [2659, "Tzhaar Fire Spit"],
    [2660, "Tzhaar Rock Smash"],
    [2661, "Dragon Pickaxe Anim"],
    [2662, "Kitten Walk"],
    [2663, "Cat Paw"],
    [2664, "Kitten Idle Anim"],
    [2665, "Fadeout2"],
    [2666, "Panther Ghost Sits"],
    [2667, "Panther Walk"],
    [2668, "Panther Ready"],
    [2669, "Panther Pounce"],
    [2670, "Panther Death"],
    [2671, "Twocats Cats Trawler"],
    [2672, "Twocats Cats Fly"],
    [2673, "Twocats Cats Love"],
    [2674, "Bob Hypnotised Face"],
    [2675, "Bob Locator Nose Rotate"],
    [2676, "Bob Locator Nose North"],
    [2677, "Bob Locator Nose Northeast"],
    [2678, "Bob Locator Nose East"],
    [2679, "Bob Locator Nose Southeast"],
    [2680, "Bob Locator Nose South"],
    [2681, "Bob Locator Nose Southwest"],
    [2682, "Bob Locator Nose West"],
    [2683, "Bob Locator Nose Northwest"],
    [2684, "Bob Locator Eyes"],
    [2685, "Ds2 Fleet Whiteknight Steeringwheel"],
    [2686, "Ds2 Memory Pool Idle"],
    [2687, "Dragonkin Special Death"],
    [2688, "Dragonkin Ready"],
    [2689, "Dragonkin Walk"],
    [2690, "Twocats Arrow Spins"],
    [2691, "Emote Beckon Loop"],
    [2692, "Mousetoy Walk"],
    [2693, "Mousetoy Ready"],
    [2694, "Twocats Cat Sits"],
    [2695, "Human Shearing Unferth"],
    [2696, "Roberts Death"],
    [2697, "Human Twocats Got Wood"],
    [2698, "Human Twocats Ignite Wood"],
    [2699, "Hammock Swing"],
    [2700, "Prison Guard Sleep"],
    [2701, "Prisoner Ready Angry"],
    [2702, "Prisoner Ready Crying"],
    [2703, "Mouse Walk"],
    [2704, "Mouse Ready"],
    [2705, "Mouse Attack"],
    [2706, "Mouse Defend"],
    [2707, "Mouse Death"],
    [2708, "Prison Coals Bucket"],
    [2709, "Diary Emote Playeranim"],
    [2710, "Human Pull Magearena Lever"],
    [2711, "Pull Magearena Lever"],
    [2712, "Ready Drinking"],
    [2713, "Ready Playing Cards"],
    [2714, "Old Rune Temple"],
    [2715, "Banner Bacteria Moves"],
    [2716, "Banner Virus Moves"],
    [2717, "Human Onyxcutting"],
    [2718, "Enchant Amulet2 Lvl6"],
    [2719, "Tzhaar Inferno"],
    [2720, "Wanted Solus Summon"],
    [2721, "Wanted Crystal Ball Scan"],
    [2722, "Wanted Crystal Ball Scan Spot"],
    [2723, "Wanted Fade To Black Smoke"],
    [2724, "Wanted Human Injured Cutscene"],
    [2725, "Wanted Teleport In"],
    [2726, "Wanted Prayer Anim"],
    [2727, "Wanted Interrupt Teleport"],
    [2728, "Wanted Ranger Ready"],
    [2729, "Dark Beast Walk"],
    [2730, "Dark Beast Ready"],
    [2731, "Dark Beast Attack"],
    [2732, "Dark Beast Defend"],
    [2733, "Dark Beast Death"],
    [2734, "Mourning Temple Lever"],
    [2735, "Shadow Ready Stand"],
    [2736, "Shadow Defend"],
    [2737, "Shadow Walk"],
    [2738, "Shadow Attack"],
    [2739, "Shadow Death"],
    [2740, "Shadow Ready"],
    [2741, "Player Tickle"],
    [2742, "Mourning Light Crossed"],
    [2743, "Elf Light Crystal"],
    [2744, "Largecrystal Glow"],
    [2745, "Bladewall Cuts"],
    [2746, "Mourning Door Glow"],
    [2747, "Mourning Light Glow"],
    [2748, "Mourning Light Glow2"],
    [2749, "Wom Stuck In Tree"],
    [2750, "Overlog"],
    [2751, "Underlog"],
    [2752, "Undernet"],
    [2753, "Overnet"],
    [2754, "Starjump"],
    [2755, "Vfx Doom Hole Idle Unique"],
    [2756, "Pushups"],
    [2757, "Human Ledge Walk Left Looped"],
    [2758, "Situps Getdown"],
    [2759, "Situps"],
    [2760, "Situps Getup"],
    [2761, "Starjump 5"],
    [2762, "Pushups 5"],
    [2763, "Situps 5"],
    [2764, "Run On Spot"],
    [2765, "Pillory Lock Rotate"],
    [2766, "Smalllock Rotate"],
    [2767, "Pillory Key Rotate"],
    [2768, "Raceflag Flutter"],
    [2769, "Drunk Player Walk"],
    [2770, "Drunk Player Ready"],
    [2771, "Skip Throw Bucketofwater"],
    [2772, "Fishbowl Swims"],
    [2773, "Fishbowl Excited"],
    [2774, "Slayer Lizard Ready"],
    [2775, "Slayer Lizard Walk"],
    [2776, "Slayer Lizard Attack"],
    [2777, "Slayer Lizard Defend"],
    [2778, "Slayer Lizard Death"],
    [2779, "Human Chinchompa Attack"],
    [2780, "Human Play With Pet Fish Blue"],
    [2781, "Human Feed Pet Fish Blue"],
    [2782, "Human Talk To Pet Fish Blue"],
    [2783, "Human Play With Pet Fish Green"],
    [2784, "Human Feed Pet Fish Green"],
    [2785, "Human Talk To Pet Fish Green"],
    [2786, "Human Play With Pet Fish Spine"],
    [2787, "Human Feed Pet Fish Spine"],
    [2788, "Human Talk To Pet Fish Spine"],
    [2789, "Churn Milk"],
    [2790, "Churn Milk Short"],
    [2791, "Churn Milk Medium"],
    [2792, "Churn Milk Long"],
    [2793, "Player Churns Milk Short"],
    [2794, "Player Churns Milk Medium"],
    [2795, "Player Churns Milk Long"],
    [2796, "Human Longcrawl"],
    [2797, "Human Protest Ready"],
    [2798, "Squidy Walk"],
    [2799, "Squidy Ready"],
    [2800, "Squidy Tickle"],
    [2801, "Half Wood Walk"],
    [2802, "Spirit Walk"],
    [2803, "Spirit Ready"],
    [2804, "Spirit Attack"],
    [2805, "Spirit Death"],
    [2806, "Spirit Parry"],
    [2807, "Brew Control"],
    [2808, "Press Press"],
    [2809, "Spider Dead"],
    [2810, "Deal Smite Control"],
    [2811, "Deal Wrench Flourish"],
    [2812, "Deal Fillbucket Stagnent"],
    [2813, "Deal Bowl Fish"],
    [2814, "Summon Summon Spot"],
    [2815, "Zombie Torso Walk"],
    [2816, "Zombie Torso Ready"],
    [2817, "Zombie Torso Death"],
    [2818, "Zombie Head Walk"],
    [2819, "Zombie Head Death"],
    [2820, "Zombie Death Melt"],
    [2821, "Half Zombie Death"],
    [2822, "Half Zombie Death2"],
    [2823, "Half Zombie Walk"],
    [2824, "Half Zombie Walk2"],
    [2825, "Half Zombie Ready"],
    [2826, "Half Zombie Ready2"],
    [2827, "Half Zombie Punch"],
    [2828, "Split Mid Spot"],
    [2829, "Split Mid"],
    [2830, "Split Head Spot"],
    [2831, "Split Head"],
    [2832, "Split Hip Spot"],
    [2833, "Split Hip"],
    [2834, "Steam Head Spot"],
    [2835, "Steam Head Play"],
    [2836, "Terrified Emote"],
    [2837, "Hamlet Head Start"],
    [2838, "Hamlet Head Loop"],
    [2839, "Hamlet Head Stop"],
    [2840, "Hamlet Head All"],
    [2841, "Child Scared"],
    [2842, "Child Praise"],
    [2843, "Zombie Head Dig"],
    [2844, "Scare Kid Zombie"],
    [2845, "Tbw Broodoo Mask Eat"],
    [2846, "Human Woodcutting Dragon Axe"],
    [2847, "Abyssal Bludgeon Run"],
    [2848, "Dagannoth Whirlwind Spins"],
    [2849, "Dagannoth Meganoth Walk"],
    [2850, "Dagannoth Meganoth Ready"],
    [2851, "Gg Dusk Fly Transition"],
    [2852, "Dagannoth Meganoth Defend"],
    [2853, "Dagannoth Meganoth Attack Melee"],
    [2854, "Dagannoth Meganoth Attack Mage"],
    [2855, "Dagannoth Meganoth Attack Range"],
    [2856, "Dagannoth Meganoth Death"],
    [2857, "Dagannoth Rock Lobster Walk"],
    [2858, "Dagannoth Rock Lobster Ready"],
    [2859, "Dagannoth Rock Lobster Attack"],
    [2860, "Dagannoth Rock Lobster Defend"],
    [2861, "Dagannoth Rock Lobster Spring Up"],
    [2862, "Dagannoth Rock Lobster Death"],
    [2863, "Dagannoth Water Creature Walk"],
    [2864, "Dagannoth Water Creature Spring Up"],
    [2865, "Dagannoth Water Creature Go Down"],
    [2866, "Dagannoth Water Creature Death"],
    [2867, "Dagannoth Water Creature Ready"],
    [2868, "Dagannoth Water Creature Attack"],
    [2869, "Dagannoth Water Creature Defend"],
    [2870, "Dagannoth Standing Torch Flame"],
    [2871, "Dagannoth Water Spill"],
    [2872, "Dagannoth Arrow Flight"],
    [2873, "Dagannoth Arrow Impact"],
    [2874, "Dagannoth Spine Travel"],
    [2875, "Dagannoth Water Creature Spine Travel"],
    [2876, "Dragon Smallaxe Anim"],
    [2877, "Dragon Smallaxe Swoosh"],
    [2878, "Summon Portal End"],
    [2879, "Summon Summon Start"],
    [2880, "Summon Summon"],
    [2881, "Ntk Human Tele"],
    [2882, "Sand Storm Npc"],
    [2883, "Summon Floor Spot"],
    [2884, "Golem Summon Start"],
    [2885, "Golem Summon Summon"],
    [2886, "Golem Summon New"],
    [2887, "Demon Summon"],
    [2888, "Denath Leave"],
    [2889, "Dark Spec Spot"],
    [2890, "Dark Spec Player"],
    [2891, "Summon Point"],
    [2892, "Burgh Hold Hit"],
    [2893, "Makinghistory Ghost Fade"],
    [2894, "Rat Pier Death"],
    [2895, "Kitten Angel Goes To Heaven"],
    [2896, "Ratcatcher Smokes"],
    [2897, "Mousetrap Spring"],
    [2898, "Vc Rats In Barrel"],
    [2899, "Vc Rat Valve"],
    [2900, "Vc Lantern Glows"],
    [2901, "Vc Rat Wriggle"],
    [2902, "Ratcatcher Create Smoke"],
    [2903, "Ratcatcher Walk With Flute"],
    [2904, "Farming Tools Leprechaun Ready"],
    [2905, "Elid Water Pour"],
    [2906, "Elid Waterspirit Ready"],
    [2907, "Elid Waterspirit Walk"],
    [2908, "Elid Waterspirit Sitting"],
    [2909, "Elid Climb Rope"],
    [2910, "Elid Rope Lasso"],
    [2911, "Elid Choc Ice Seller Ready"],
    [2912, "Elid Choc Ice Walk"],
    [2913, "Elid Robetop Crafting"],
    [2914, "Elid Robebottoms Crafting"],
    [2915, "Elid Rope Climb Long"],
    [2916, "Elid Robe Climb Spotanim"],
    [2917, "Clay Golem Attack"],
    [2918, "Clay Golem Defend"],
    [2919, "Clay Golem Death"],
    [2920, "Intro Banner Santa Dance"],
    [2921, "Intro Banner Security Lock"],
    [2922, "Intro Banner Scamming Happy"],
    [2923, "Intro Banner Scamming Sad"],
    [2924, "Intro Banner Scamming Swap"],
    [2925, "Champions Zombie Death"],
    [2926, "Champions Zombie Defend"],
    [2927, "Champions Zombie Catcrush"],
    [2928, "Champions Zombie Ready"],
    [2929, "Champions Zombie Walk"],
    [2930, "Champions Jogre Attack"],
    [2931, "Champions Jogre Ready"],
    [2932, "Champions Jogre Walk"],
    [2933, "Champions Giant Ready"],
    [2934, "Champions Giant Walk"],
    [2935, "Champions Giant Attack Vertical"],
    [2936, "Champions Giant Attack Horizontal"],
    [2937, "Champions Giant Defend"],
    [2938, "Champions Giant Death"],
    [2939, "Champions Throne Sit"],
    [2940, "Elf Throne Sit"],
    [2941, "Tzhaar Throne Sit"],
    [2942, "Dwarf Throne Sit"],
    [2943, "Gnome Throne Sit"],
    [2944, "Werewolf Throne Sit"],
    [2945, "Earthwarrior Ready"],
    [2946, "Earthwarrior Death"],
    [2947, "Earthwarrior Walk F"],
    [2948, "Earthwarrior Walk B"],
    [2949, "Earthwarrior Walk L"],
    [2950, "Earthwarrior Walk R"],
    [2951, "Earthwarrior Chop"],
    [2952, "Earthwarrior Def"],
    [2953, "Champions Imp Ready"],
    [2954, "Champions Imp Stab"],
    [2955, "Champions Imp Throw"],
    [2956, "Champions Imp Dagger Launch"],
    [2957, "Champions Imp Dagger Travel"],
    [2958, "Champions Hobgoblin Ready"],
    [2959, "Champions Hobgoblin Range"],
    [2960, "Champions Hobgoblin Spear"],
    [2961, "Champions Hobgoblin Drain"],
    [2962, "Champions Goblin Ready"],
    [2963, "Champions Goblin Drain"],
    [2964, "Champions Goblin Spellcast"],
    [2965, "Champions Goblin Casting Glow"],
    [2966, "Champions Ghoul Ready"],
    [2967, "Champions Ghoul Club"],
    [2968, "Champions Ghoul Throw"],
    [2969, "Champions Ghoul Skull Launch"],
    [2970, "Champions Ghoul Skull Travel"],
    [2971, "Champions Lesserdemon Ready"],
    [2972, "Champions Lesserdemon Slash"],
    [2973, "Champions Lesserdemon Fire Cast"],
    [2974, "Champions Lesserdemon Fire Launch"],
    [2975, "Champions Lesserdemon Fire Travel"],
    [2976, "Champions Grill"],
    [2977, "Champion Lesserdemon Ready"],
    [2978, "Champion Lesserdemon Slash"],
    [2979, "Champion Lesserdemon Fire Cast"],
    [2980, "Champion Lesserdemon Fire Launch"],
    [2981, "Champion Lesserdemon Fire Travel"],
    [2982, "Wyvern Skeleton Walk"],
    [2983, "Wyvern Skeleton Block"],
    [2984, "Wyvern Skeleton Ready"],
    [2985, "Wyvern Skeleton Bite"],
    [2986, "Wyvern Skeleton Tail Swipe"],
    [2987, "Wyvern Skeleton Death"],
    [2988, "Wyvern Skeleton Ice Breath"],
    [2989, "Wyvern Skeleton Iceball"],
    [2990, "Wyvern Skeleton Launch Iceball"],
    [2991, "Wyvern Skeleton Travel Iceball"],
    [2992, "Wyvern Skeleton Travel Breath"],
    [2993, "Devious Relic Ready"],
    [2994, "Devious Relic Walk"],
    [2995, "Devious Dead"],
    [2996, "Devious Assassin Teleport"],
    [2997, "Devious Whetstone Spin No Sparks"],
    [2998, "Devious Whetstone Spin Sparks"],
    [2999, "Devious Human Whetstone"],
    [3000, "Human Ball Attack"],
    [3001, "Human Ball Kick Attack"],
    [3002, "Human Ball Defend"],
    [3003, "Human Marionette Jump"],
    [3004, "Human Marionette Walk"],
    [3005, "Human Marionette Bow"],
    [3006, "Human Marionette Dance"],
    [3007, "Vetion Talk"],
    [3008, "Scorpia Talk"],
    [3009, "Venetatis Talk"],
    [3010, "Callisto Talk"],
    [3011, "Oddskull Walkleft"],
    [3012, "Oddskull Walkright"],
    [3013, "Oddskull Walkback"],
    [3014, "Tan Leather"],
    [3015, "Snakeboss Fletching"],
    [3016, "Marionette Jump"],
    [3017, "Marionette Walk"],
    [3018, "Marionette Bow"],
    [3019, "Marionette Dance"],
    [3020, "Enchant Dragonstone"],
    [3021, "Magictraining Spotanim Bones"],
    [3022, "Magictraining Painting Float"],
    [3023, "Magictraining Flying Book Ready"],
    [3024, "Magictraining Light Door Open"],
    [3025, "Slayer Tots I Charge"],
    [3026, "Magictraining Ghost Ready"],
    [3027, "Magictraining Ghost Walk"],
    [3028, "Magictraining Lighting"],
    [3029, "Magictraining Statue Rotate"],
    [3030, "Magictraining Door Rotate"],
    [3031, "Magictraining Door Open"],
    [3032, "Human Magictraining Open Cupboard"],
    [3033, "Mage Training Area Ready"],
    [3034, "Mage Training Area Walk"],
    [3035, "Mage Training Area Walk Large"],
    [3036, "Handsand Sandy Lookready"],
    [3037, "Handsand Sand Magic"],
    [3038, "Handsand Sand Magic Static"],
    [3039, "Drunk Holditem Walk"],
    [3040, "Drunk Holditem Ready"],
    [3041, "Human Shrink"],
    [3042, "Macro Sandwich Lady Walk"],
    [3043, "Macro Sandwich Lady Ready"],
    [3044, "Macro Sandwich Lady Parry"],
    [3045, "Macro Sandwich Lady Attack"],
    [3046, "Macro Sandwich Lady Death"],
    [3047, "Sarnie Rotate"],
    [3048, "Balloon Walk"],
    [3049, "Balloon Ready"],
    [3050, "Balloon Walk2"],
    [3051, "Balloon Pop"],
    [3052, "Balloon Fall"],
    [3053, "Agility Pyramid Ledge On Left"],
    [3054, "Agility Pyramid Ledge Off Left"],
    [3055, "Agility Pyramid Ledge Fall Left"],
    [3056, "Agility Pyramid Ledge Fall Right"],
    [3057, "Agility Pyramid Ledge On Right"],
    [3058, "Agility Pyramid Ledge Off Right"],
    [3059, "Agility Pyramid Ledge Walk Left"],
    [3060, "Agility Pyramid Ledge Walk Right"],
    [3061, "Agility Pyramid Sidestep Fall"],
    [3062, "Agility Pyramid Sidestep Falll"],
    [3063, "Agility Pyramid Top Climb"],
    [3064, "Agility Pyramid Tilt Fall"],
    [3065, "Agility Pyramid Block Push 1"],
    [3066, "Agility Pyramid Block Push 2"],
    [3067, "Agility Pyramid Gap Jump"],
    [3068, "Agility Pyramid Gap Jump Fall"],
    [3069, "Agility Pyramid Logfall R"],
    [3070, "Agility Pyramid Tilting Floor"],
    [3071, "Human Dwarf Recieve"],
    [3072, "Dwarf Hand Over"],
    [3073, "Enakh Boneguard Ready"],
    [3074, "Enakh Boneguard Block"],
    [3075, "Enakh Boneguard Attack"],
    [3076, "Enakh Boneguard Death"],
    [3077, "Enakh Boneguard Large Death"],
    [3078, "Enakh Boneguard Walk"],
    [3079, "Snp Fire Boss Ready"],
    [3080, "Enakh Boneguard Glow Small Attack"],
    [3081, "Enakh Boneguard Glow Small Block"],
    [3082, "Snp Fire Boss Walk"],
    [3083, "Enakh Boneguard Glow Small Death"],
    [3084, "Enakh Boneguard Glow Large Ready"],
    [3085, "Enakh Boneguard Glow Large Attack"],
    [3086, "Enakh Boneguard Glow Large Block"],
    [3087, "Enakh Boneguard Glow Large Walk"],
    [3088, "Enakh Boneguard Glow Large Death"],
    [3089, "Enakh Enakhra Transform Spotanim"],
    [3090, "Enakhenakhra Transform Start"],
    [3091, "Enakhenakhra Transform Finish"],
    [3092, "Enakh Smoke Overlay"],
    [3093, "Enakh Film Overlay"],
    [3094, "Enakh Fall Hole"],
    [3095, "Enakh Magic Wall"],
    [3096, "Enakh Magic Wall Fade"],
    [3097, "Enakh Light Prison"],
    [3098, "Enakh Big Wall Fall"],
    [3099, "Enakh Floor Cracking"],
    [3100, "Enakh Floor Collapsing"],
    [3101, "Enakh Light Streaming"],
    [3102, "Enakh Player Chisel"],
    [3103, "Enakh Player Get Up"],
    [3104, "Burgh Furnace Smoke"],
    [3105, "Fire Effect"],
    [3106, "Burgh Furnace Lit"],
    [3107, "Candle Effect"],
    [3108, "Slayer Harpie Swarm"],
    [3109, "Slayer Harpie Dodge"],
    [3110, "Slayer Harpie Hit"],
    [3111, "Slayer Harpie Death"],
    [3112, "Slayer Harpie Nospin"],
    [3113, "Vampireslayer Coffin Open"],
    [3114, "Vampireslayer Arise"],
    [3115, "Vampireslayer Travel"],
    [3116, "Vampireslayer Give Beer"],
    [3117, "Treasure Magic Chest"],
    [3118, "Treasure Magic Openchest"],
    [3119, "Treasure Magic Openchest Ready"],
    [3120, "Treasure Magic Closechest"],
    [3121, "Poh Wardrobe Open"],
    [3122, "Poh Wardrobe Wooden Open"],
    [3123, "Fever Rope Swing"],
    [3124, "Cannon Blast Spotanim"],
    [3125, "Barrel Lit Spotanim"],
    [3126, "Fuse Lit Spotanim"],
    [3127, "Fever Explosion"],
    [3128, "Fever Player Rope Swing Start"],
    [3129, "Fever Player Rope Swing Base Anim"],
    [3130, "Fever Player Rope Swing Land Success"],
    [3131, "Fever Player Rope Swing Land Fail"],
    [3132, "Fever Rope Tie"],
    [3133, "Fever Load Cannon1 Cannister"],
    [3134, "Fever Load Cannon1"],
    [3135, "Fever Load Cannon2"],
    [3136, "Fever Prod Cannon1"],
    [3137, "Fever Nail Plank"],
    [3138, "Readbook Turnright"],
    [3139, "Readbook Turnleft"],
    [3140, "Human Readbook Turnright"],
    [3141, "Human Readbook Turnleft"],
    [3142, "Human Readbook Posh Turnright"],
    [3143, "Human Readbook Posh Turnleft"],
    [3144, "Chaoselemental Ready"],
    [3145, "Chaoselemental Walk"],
    [3146, "Chaoselemental Attack"],
    [3147, "Chaoselemental Death"],
    [3148, "Chaoselemental Discord"],
    [3149, "Chaoselemental Casting"],
    [3150, "Chaoselemental Madness Casting"],
    [3151, "Chaoselemental Madness Travel"],
    [3152, "Chaoselemental Madness Impact"],
    [3153, "Chaoselemental Confusion Travel"],
    [3154, "Chaoselemental Discord Casting"],
    [3155, "Chaoselemental Discord Travel"],
    [3156, "Chaoselemental Discord Impact"],
    [3157, "Dragon Two Handed Sword"],
    [3158, "Dragon Two Handed Sword Blast Spotanim"],
    [3159, "Killerwatt Ball Ready"],
    [3160, "Killerwatt Biped Ready"],
    [3161, "Killerwatt Biped Walk"],
    [3162, "Killerwatt Biped Death"],
    [3163, "Killerwatt Biped Attack"],
    [3164, "Killerwatt Biped Cast"],
    [3165, "Killerwatt Biped Block"],
    [3166, "Lightning Flash"],
    [3167, "Cloud Lightning Ready"],
    [3168, "Cloud Lightning Strike"],
    [3169, "Cloud Rain"],
    [3170, "Human Killerwatt Electricshock"],
    [3171, "Skeleton Killerwatt Electricshock"],
    [3172, "Draynor Machine Ready"],
    [3173, "Draynor Machine Active"],
    [3174, "Poh Portal"],
    [3175, "Human Chinchompa Ready"],
    [3176, "Human Chinchompa Defend"],
    [3177, "Human Chinchompa Walk"],
    [3178, "Human Chinchompa Run"],
    [3179, "Mud Pie Travel"],
    [3180, "Spit Anim"],
    [3181, "Spit Anim Player"],
    [3182, "Spit End Anim Player"],
    [3183, "Human Woodcrafting Axe Infernal"],
    [3184, "Brut Human Canoeing Carve Infernal Axe"],
    [3185, "Gasmask Application"],
    [3186, "Hangover Drink"],
    [3187, "Lift And Pull"],
    [3188, "Straight Rope Lift"],
    [3189, "Hanging Rope Lift"],
    [3190, "Pipe Grill"],
    [3191, "Rope Tie"],
    [3192, "Pull On Pipe"],
    [3193, "Emote Clap Loop"],
    [3194, "Bravek Ready"],
    [3195, "Plaguecity Human Doublepipesqueeze"],
    [3196, "Mcannon Interface Gun Idle"],
    [3197, "Mcannon Interface Gun Idle With Spring"],
    [3198, "Mcannon Interface Gun Safety Off With Spring"],
    [3199, "Mcannon Interface Gun Safety On With Spring"],
    [3200, "Mcannon Interface Gun Safety Off"],
    [3201, "Mcannon Interface Gun Safety On"],
    [3202, "Mcannon Interface Gun Attach Spring"],
    [3203, "Mcannon Interface Gun Unattach Spring"],
    [3204, "Mcannon Interface Gun Work Without Spring"],
    [3205, "Mcannon Interface Gun Work With Spring"],
    [3206, "Quest Mcannon Crate Shake"],
    [3207, "Fai Dwarf Walk Crate"],
    [3208, "Fai Dwarf Ready Crate"],
    [3209, "Fai Dwarf Working Cannon"],
    [3210, "Squirrel Walk"],
    [3211, "Squirrel Ready"],
    [3212, "Squirrel Ready2"],
    [3213, "Fai Racoon Ready"],
    [3214, "Fai Racoon Walk"],
    [3215, "Fai Racoon Turn"],
    [3216, "Fai Racoon Eating"],
    [3217, "Draynor Gallows Ghost"],
    [3218, "Draynor Poltergeist Chair"],
    [3219, "Draynor Poltergeist Painting"],
    [3220, "Draynor Possesed Chair"],
    [3221, "100 Vibrating Chair"],
    [3222, "Mcannon N Turn Back"],
    [3223, "Mcannon Ne Turn Back"],
    [3224, "Mcannon E Turn Back"],
    [3225, "Mcannon Se Turn Back"],
    [3226, "Mcannon S Turn Back"],
    [3227, "Mcannon Sw Turn Back"],
    [3228, "Mcannon W Turn Back"],
    [3229, "Mcannon Nw Turn Back"],
    [3230, "Ratwheel"],
    [3231, "Ratwheel Barberspole"],
    [3232, "Fai Falador Unicorn Walk"],
    [3233, "Fai Falador Unicorn Attack"],
    [3234, "Fai Falador Unicorn Block"],
    [3235, "Fai Falador Unicorn Ready"],
    [3236, "Fai Falador Unicorn Death"],
    [3237, "Fai Canary In Cage"],
    [3238, "Barbarian Unarmedblock"],
    [3239, "Barbarian Sword Block"],
    [3240, "Barbarian Blunt Block"],
    [3241, "Swan Walk"],
    [3242, "Swan Ready"],
    [3243, "Human Fai Furnace"],
    [3244, "Magictraining Ghost Broom Ready"],
    [3245, "Magictraining Ghost Broom Walk"],
    [3246, "Fairy Viles Lft"],
    [3247, "Fairy Viles Rht"],
    [3248, "Fairy Godfather Ready"],
    [3249, "Fairy Godfather Walk"],
    [3250, "Fairy Vanish"],
    [3251, "Fairy Appear"],
    [3252, "Fairy Greek Choir Ready"],
    [3253, "Fairy Greek Choir Walk"],
    [3254, "Fairy Greek Choir Vanish"],
    [3255, "Fairy Greek Choir Appear"],
    [3256, "Human Fairy Kneel And Offer"],
    [3257, "Human Fairy Take And Hold Up"],
    [3258, "Fairy Flower Enchant"],
    [3259, "Tanglefoot Ready"],
    [3260, "Tanglefoot Block"],
    [3261, "Tanglefoot Walk"],
    [3262, "Tanglefoot Attack"],
    [3263, "Tanglefoot Death"],
    [3264, "Chicken Shrine"],
    [3265, "Human Fairy Vanish"],
    [3266, "Human Fairy Appear"],
    [3267, "Fairy Cow Wheel"],
    [3268, "Human Speartrap Into Sidestep"],
    [3269, "Human Speartrap Into Sidestepl"],
    [3270, "Human Speartrap Walk Sidestep"],
    [3271, "Human Speartrap Ready Sidestep"],
    [3272, "Human Speartrap Walk Sidestepl"],
    [3273, "Human Speartrap Ready Sidestepl"],
    [3274, "Human Speartrap Outof Sidestep"],
    [3275, "Human Speartrap Outof Sidestepl"],
    [3276, "Human Speartrap Walk Sidestep Long L"],
    [3277, "Human Speartrap Walk Sidestep Long"],
    [3278, "Human Speartrap Walk Sidestep Caught L"],
    [3279, "Human Speartrap Walk Sidestep Caught"],
    [3280, "Human Dead"],
    [3281, "Romeo Juliet Pew Ready"],
    [3282, "Romeo Juliet Pew Ready2"],
    [3283, "Human Apothecary Create Potion"],
    [3284, "Human Drink From Vial Cadava"],
    [3285, "Human Canoeing Carve Rune Axe"],
    [3286, "Human Canoeing Carve Adamant Axe"],
    [3287, "Human Canoeing Carve Mithril Axe"],
    [3288, "Human Canoeing Carve Black Axe"],
    [3289, "Human Canoeing Carve Steel Axe"],
    [3290, "Human Canoeing Carve Iron Axe"],
    [3291, "Human Canoeing Carve Bronze Axe"],
    [3292, "Human Canoeing Carve Dragon Axe"],
    [3293, "Abyssal Bludgeon Walk"],
    [3294, "Abyssal Dagger Hack"],
    [3295, "Abyssal Dagger Block"],
    [3296, "Abyssal Dagger Idle"],
    [3297, "Abyssal Dagger Lunge"],
    [3298, "Abyssal Bludgeon Crush"],
    [3299, "Abyssal Bludgeon Special Attack"],
    [3300, "Abyssal Dagger Special"],
    [3301, "Canoeing Pushing Into Water"],
    [3302, "Canoeing Rowing"],
    [3303, "Canoeing Getting In"],
    [3304, "Canoeing Station Animations"],
    [3305, "Canoeing Sinking"],
    [3306, "Canoeing Bobbing Inwater"],
    [3307, "Canoeing Bobbing Inwater Interface"],
    [3308, "Canoeing Interface Water"],
    [3309, "Mole Ready"],
    [3310, "Mole Death"],
    [3311, "Mole Defend"],
    [3312, "Mole Attack"],
    [3313, "Mole Walk"],
    [3314, "Mole Burrow Down"],
    [3315, "Mole Burrow Up"],
    [3316, "Mole Mud Splat"],
    [3317, "Mole Mud Cloud"],
    [3318, "Mole Mud Hole"],
    [3319, "Mole Mud Hole Up"],
    [3320, "Mole Mud Splat Interface"],
    [3321, "Chat Human Sleep"],
    [3322, "Zygomite Adult Walk"],
    [3323, "Zygomite Adolescent Walk"],
    [3324, "Zygomite Ready"],
    [3325, "Zygomite Defend"],
    [3326, "Zygomite Attack"],
    [3327, "Zygomite Death"],
    [3328, "Zygomite Wiggle"],
    [3329, "Zygomite Fade Out"],
    [3330, "Zygomite Leap Out"],
    [3331, "Human Fungicide Pump Attack"],
    [3332, "Human Fungicide Pump Ready"],
    [3333, "Human Fungicide Pump Defend"],
    [3334, "Human Fungicide Pump Walk"],
    [3335, "Human Fungicide Pick Zygomite"],
    [3336, "Fungicide Spores Anim"],
    [3337, "Pruning All Fairy"],
    [3338, "Pruning Mid High Fairy"],
    [3339, "Pruning Mid Low Fairy"],
    [3340, "Pruning High Fairy"],
    [3341, "Pruning Mid Fairy"],
    [3342, "Pruning Low Fairy"],
    [3343, "Chickenquest Evil Chicken Nest"],
    [3344, "Fairy Dragon Chathead"],
    [3345, "Fairy Dragon Ready"],
    [3346, "Fairy Dragon Flame"],
    [3347, "Fairy Dragon Fire"],
    [3348, "Brulee Cooking"],
    [3349, "Bubble"],
    [3350, "Rings"],
    [3351, "Ringstart"],
    [3352, "Ringfroze"],
    [3353, "Book Chuck"],
    [3354, "Book Spin"],
    [3355, "Book Open"],
    [3356, "Big Final"],
    [3357, "Inflate"],
    [3358, "100 Osman Freeze"],
    [3359, "100 Osman Froze"],
    [3360, "100 Osman Unfreeze"],
    [3361, "100 Guide Freeze"],
    [3362, "100 Guide Froze"],
    [3363, "100 Guide Unfreeze"],
    [3364, "100 Cul Freeze"],
    [3365, "100 Cul Froze"],
    [3366, "100 Cul Unfreeze"],
    [3367, "100 Dave Freeze"],
    [3368, "100 Dave Froze"],
    [3369, "100 Dave Unfreeze"],
    [3370, "100 Sir Freeze"],
    [3371, "100 Sir Froze"],
    [3372, "100 Sir Unfreeze"],
    [3373, "100 Pirate Freeze"],
    [3374, "100 Pirate Froze"],
    [3375, "100 Pirate Unfreeze"],
    [3376, "100 Dwarf Freeze"],
    [3377, "100 Dwarf Froze"],
    [3378, "100 Dwarf Unfreeze"],
    [3379, "100 Dwarf Sit"],
    [3380, "100 Ogre Freeze"],
    [3381, "100 Ogre Froze"],
    [3382, "100 Ogre Unfreeze"],
    [3383, "100 Ogre Sit"],
    [3384, "100 Gob Freeze"],
    [3385, "100 Gob Froze"],
    [3386, "100 Gob Unfreeze"],
    [3387, "100 Gob Sit"],
    [3388, "100 Gobtwo Freeze"],
    [3389, "100 Gobtwo Froze"],
    [3390, "100 Gobtwo Unfreeze"],
    [3391, "100 Gobtwo Sit"],
    [3392, "100 Monkey Freeze"],
    [3393, "100 Monkey Froze"],
    [3394, "100 Monkey Unfreeze"],
    [3395, "100 Monkey Sit"],
    [3396, "100 Sit Ready Chair"],
    [3397, "100 Gypsy Freeze"],
    [3398, "Dwarf Mountain Dad Cooking"],
    [3399, "Hot Cake Juggle"],
    [3400, "100 Goblin Thrown Back"],
    [3401, "100 Goblin On Wall"],
    [3402, "100 Goblin Fall From Wall"],
    [3403, "100 Goblin Scrape And Eat"],
    [3404, "100 Goblin Cauldren Tumble"],
    [3405, "100 Goblin Cauldren Flames"],
    [3406, "100 Goblin Cauldren Shake"],
    [3407, "100 Goblin Cauldren Blast"],
    [3408, "100 Goblin Roof Blast"],
    [3409, "100 Goblin Roof Flames"],
    [3410, "Rockknocker Infernal"],
    [3411, "Cerberus Hellhound Pet Happy"],
    [3412, "Cerberus Hellhound Pet Angry"],
    [3413, "Human Play Wwf Lion"],
    [3414, "Human Play Wwf Tiger"],
    [3415, "Human Real Swimming"],
    [3416, "Human Real Swimming Into Ready"],
    [3417, "Human Ready Into Real Swimming"],
    [3418, "Human Real Swimming Ready"],
    [3419, "Human Real Swimming Death"],
    [3420, "Human Real Swimming Pickup Floor"],
    [3421, "Human Real Swimming Climb Anchor"],
    [3422, "Human Real Swimming Bombdive"],
    [3423, "Human Real Swimming Into Bombdive"],
    [3424, "Crab Ready"],
    [3425, "Crab Into Walk"],
    [3426, "Crab Walk"],
    [3427, "Crab Outof Walk"],
    [3428, "Crab Attack"],
    [3429, "Crab Block"],
    [3430, "Crab Death"],
    [3431, "Mudskipper Ready"],
    [3432, "Mudskipper Walk"],
    [3433, "Mudskipper Attack"],
    [3434, "Mudskipper Block"],
    [3435, "Mudskipper Death"],
    [3436, "Ogre Swim Ready"],
    [3437, "Ogre Swim"],
    [3438, "Kelp Ripple"],
    [3439, "100 Coral Flower"],
    [3440, "100 Pirate Bubbles"],
    [3441, "Fantail Fish Walk"],
    [3442, "Fantail Fish Ready"],
    [3443, "Shoal Walk"],
    [3444, "Shoal Ready"],
    [3445, "100guide Spotlight"],
    [3446, "100guide Egg Lift"],
    [3447, "100guide Egg Travel"],
    [3448, "100guide Egg Lift Back"],
    [3449, "100guide Egg Travel Back"],
    [3450, "Exit Egg Hero"],
    [3451, "Exit Egg Muscles"],
    [3452, "Exit Egg Backward"],
    [3453, "Guide If Question"],
    [3454, "Guide Egg Spin"],
    [3455, "Guide Milk Spin"],
    [3456, "Guide Flour Spin"],
    [3457, "Guide Interface Up"],
    [3458, "Guide Interface Down"],
    [3459, "100 Jubbly Tree Fall"],
    [3460, "100 Jubbly Ogre Bow"],
    [3461, "100 Ogre Arrow"],
    [3462, "100 Jubbly Ogre Kick"],
    [3463, "100 Jubbly Ready"],
    [3464, "100 Jubbly Walk"],
    [3465, "100 Jubbly Defend"],
    [3466, "100 Jubbly Death"],
    [3467, "Seagull Attack"],
    [3468, "Duck Rework Death"],
    [3469, "100 Jubbly Toad Balloon Ready"],
    [3470, "100 Jubbly Toad Balloon Inflate"],
    [3471, "100 Jubbly Toad Inflating"],
    [3472, "100 Jubbly Toad Balloon Deflate"],
    [3473, "100 Jubbly Treading Water"],
    [3474, "100 Jubbly Swimming"],
    [3475, "100 Jubbly Root Chopping"],
    [3476, "Ogre Boat Feldip To Tai"],
    [3477, "Ogre Boat Tai To Feldip"],
    [3478, "100 Ilm Banana Tree Pull Down"],
    [3479, "100 Ilm Gorilla Banana Tree Pull Down"],
    [3480, "100 Ilm Stepping Stone Jump"],
    [3481, "100 Ilm Stepping Stone Jump Test"],
    [3482, "100 Ilm Monkeybar Jump Up"],
    [3483, "100 Ilm Monkeybar Move"],
    [3484, "100 Ilm Monkeybar Jump Down"],
    [3485, "100 Ilm Climb Slope"],
    [3486, "100 Ilm Slope Fail Slide Back"],
    [3487, "100 Ilm Climb Tree"],
    [3488, "100 Ilm Vine Swing"],
    [3489, "100 Ilm Stepping Stone Fail"],
    [3490, "100 Ilm Monkey Swim Ready"],
    [3491, "100 Ilm Monkey Swim"],
    [3492, "100 Ilm Climb Tree Fail"],
    [3493, "100 Ilm Falling"],
    [3494, "100 Ilm Monkey Down Vine"],
    [3495, "100 Ilm Human Slicing Banana"],
    [3496, "100 Meat Tenderiser"],
    [3497, "100 Egg Whisk"],
    [3498, "Agrith Nana Ready"],
    [3499, "Agrith Nana Walk"],
    [3500, "Agrith Nana Block"],
    [3501, "Agrith Nana Attack"],
    [3502, "Agrith Nana Ranged Attack"],
    [3503, "Agrith Nana Death"],
    [3504, "Dessourt Ready"],
    [3505, "Dessourt Block"],
    [3506, "Dessourt Walk"],
    [3507, "Dessourt Tot Attack"],
    [3508, "Dessourt Melee Attack"],
    [3509, "Dessourt Death"],
    [3510, "Monkey Chathead Nodding Yes 1"],
    [3511, "Poh Grandfatherclock Tictoc"],
    [3512, "Monkey Chathead Nodding Yes 2"],
    [3513, "Monkey Chathead Nodding Yes 3"],
    [3514, "Monkey Chathead Nodding Yes 4"],
    [3515, "Monkey Chathead Shake No 1"],
    [3516, "Monkey Chathead Shake No 2"],
    [3517, "Monkey Chathead Shake No 3"],
    [3518, "Monkey Chathead Shake No 4"],
    [3519, "Hear No Evil Monkey Sleeping 1"],
    [3520, "Hear No Evil Monkey Sleeping 2"],
    [3521, "Hear No Evil Monkey Sleeping 3"],
    [3522, "Hear No Evil Monkey Sleeping 4"],
    [3523, "Hear No Evil Monkey Ready"],
    [3524, "Speak No Evil Monkey Ready"],
    [3525, "See No Evil Monkey Ready"],
    [3526, "Speak No Evil Wants To Talk"],
    [3527, "100 Ilm Snake Low Out Hole Constant"],
    [3528, "100 Ilm Snake Low Out Hole"],
    [3529, "100 Ilm Snake Mid Out Hole"],
    [3530, "100 Ilm Snake High Out Hole"],
    [3531, "100 Ilm Snake Ground Out Hole"],
    [3532, "100 Ilm Snake Out Then In Hole"],
    [3533, "100 Ilm Snake Hidden Out Of Sight"],
    [3534, "100 Ilm Snake Upperwall Out Hole"],
    [3535, "Royal Sea Snake Ready"],
    [3536, "Royal Sea Snake Walk"],
    [3537, "Royal Sea Snake Walk Baby"],
    [3538, "Royal Sea Snake Attack"],
    [3539, "Royal Sea Snake Defend"],
    [3540, "Royal Sea Snake Death"],
    [3541, "Human Play Wwf Snow Leopard"],
    [3542, "Lunar Dream Dream Light Shimmer"],
    [3543, "Zombie Dance"],
    [3544, "Zombie Walk Emote"],
    [3545, "Sarim Voidknight"],
    [3546, "Voidknight Sarim"],
    [3547, "Burgh Human Holding Cast"],
    [3548, "Burgh Holding Cast Spot"],
    [3549, "Burgh Hold Launch"],
    [3550, "Burgh Human Holding Capture Start"],
    [3551, "Burgh Human Holding Capture Loop"],
    [3552, "Burgh Human Holding Capture End"],
    [3553, "Burgh Human Capture Pour"],
    [3554, "Burgh Human Spirit Fade"],
    [3555, "Burgh Dust Human Start"],
    [3556, "Burgh Dust Spot Crumble"],
    [3557, "Rat Eat Ready"],
    [3558, "Burgh Bucket Drip"],
    [3559, "Burgh Map Route1 Pt1"],
    [3560, "Burgh Map Route1 Pt2"],
    [3561, "Burgh Map Route2 Pt1"],
    [3562, "Burgh Map Route2 Pt2"],
    [3563, "Burgh Gadderanks Fall Over"],
    [3564, "Burgh Pot Scoop"],
    [3565, "Burgh Gadderanks Stumble"],
    [3566, "Burgh Human Quest Enchanting Rod"],
    [3567, "Burgh Enchanting Rod Spot"],
    [3568, "The Thing Walk"],
    [3569, "The Thing Ready"],
    [3570, "The Thing Shear"],
    [3571, "Qip Cook Hopper Leaver"],
    [3572, "Qip Cook Hopper Grain"],
    [3573, "Torch Incense Smoke"],
    [3574, "Bell Pull Posh"],
    [3575, "Bell Pull Crude"],
    [3576, "Windchimes"],
    [3577, "Musical Bells"],
    [3578, "Small Globe Rotate"],
    [3579, "Large Globe Rotate"],
    [3580, "Crystalball Elemental Float"],
    [3581, "Crystalball Power Float"],
    [3582, "Elemental Orb Ready"],
    [3583, "Elemental Orb Opens"],
    [3584, "Elemental Orb Spins"],
    [3585, "Elemental Orb Closes"],
    [3586, "Magic Circle Zap"],
    [3587, "Poh Jester Hover"],
    [3588, "Poh Jester Elevate"],
    [3589, "Poh Jester Deelevate"],
    [3590, "Poh Jester Descend"],
    [3591, "Poh Jester Ascend"],
    [3592, "Jester Jumps Out"],
    [3593, "Jester Jumps In"],
    [3594, "Balance Beam Ready"],
    [3595, "Balance Beam Bash"],
    [3596, "Balance Beam Block"],
    [3597, "Balance Beam Falloff"],
    [3598, "Balance Beam Jumpoff"],
    [3599, "Balance Beam Getup"],
    [3600, "Balance Beam Walk"],
    [3601, "Hangman Hangs"],
    [3602, "Human Throw Hoop1"],
    [3603, "Human Throw Hoop2"],
    [3604, "Poh Hoop Projectile"],
    [3605, "Human Throw Dart1"],
    [3606, "Human Throw Dart2"],
    [3607, "Poh Dart Projectile"],
    [3608, "Human Throw Arrow1"],
    [3609, "Human Throw Arrow2"],
    [3610, "Poh Arrow Projectile"],
    [3611, "Human Pull Lever"],
    [3612, "Poh Lever Pull"],
    [3613, "Cage Throneroom Fall"],
    [3614, "Cage Throneroom Raise"],
    [3615, "Magic Cage Lesser"],
    [3616, "Magic Cage Greater"],
    [3617, "Tentacle Monster Ready"],
    [3618, "Tentacle Monster Attack"],
    [3619, "Tentacle Monster Block"],
    [3620, "Tentacle Monster Death"],
    [3621, "Reach Forward High"],
    [3622, "Human Sink Activate"],
    [3623, "Human Sink Stepback"],
    [3624, "Human Pump Sink"],
    [3625, "Human Pump Sink Kettle"],
    [3626, "Human Spike Trap Hit"],
    [3627, "Human Spike Trap Miss"],
    [3628, "Poh Spike Trap"],
    [3629, "Poh Man Trap"],
    [3630, "Human Man Trap Hit"],
    [3631, "Poh Plant Trap Start"],
    [3632, "Poh Plant Trap End"],
    [3633, "Poh Plant Trap Loop"],
    [3634, "Human Plant Trap Hit Start"],
    [3635, "Human Plant Trap Hit End"],
    [3636, "Human Plant Trap Hit Loop"],
    [3637, "Poh Marble Trap Start"],
    [3638, "Poh Marble Trap End"],
    [3639, "Human Marble Trap Hit"],
    [3640, "Human Fall From Sky"],
    [3641, "Human Fall From Sky Water"],
    [3642, "Poh Portal Shrink"],
    [3643, "Poh Portal Unshrink"],
    [3644, "Poh Scrying Pool"],
    [3645, "Human Use Scrying Pool"],
    [3646, "Poh Teleport Centrepiece"],
    [3647, "Poh Posh Garden Centrepiece4water"],
    [3648, "Poh Teleport Centrepiece Grand"],
    [3649, "Human Use Telescope"],
    [3650, "Poh Use Telescope"],
    [3651, "Human Use Crystalball"],
    [3652, "Staff Of Balance Special"],
    [3653, "Human Study Ready"],
    [3654, "Human Use Armour Repair Stand"],
    [3655, "Human Use Painting Stand"],
    [3656, "Human Use Banner Stand"],
    [3657, "Poh Human Whetstone"],
    [3658, "Poh Fireplace Light"],
    [3659, "Poh Larder Examine"],
    [3660, "Poh Barrel Use1"],
    [3661, "Poh Barrel Use2 Beer"],
    [3662, "Poh Barrel Use2 Asgarnian Ale"],
    [3663, "Poh Barrel Use2 Greenmans Ale"],
    [3664, "Poh Barrel Use2 Dragon Bitter"],
    [3665, "Poh Barrel Use2 Moonlight Mead"],
    [3666, "Poh Barrel Use2 Cider"],
    [3667, "Poh Bell Use Crude"],
    [3668, "Poh Bell Use Posh"],
    [3669, "Poh Shave At Stand"],
    [3670, "Poh Pose At Dresser"],
    [3671, "Poh Wardrobe Inspect"],
    [3672, "Poh Wardrobe Wooden Inspect"],
    [3673, "Poh Drawers Inspect"],
    [3674, "Human Use Windchimes"],
    [3675, "Human Use Chapel Organ"],
    [3676, "Human Poh Build"],
    [3677, "Human Boxing Ready"],
    [3678, "Human Boxing Jab"],
    [3679, "Human Boxing Block"],
    [3680, "Human Boxing Walk"],
    [3681, "Poh Drawers Open"],
    [3682, "Poh Summoning Anim"],
    [3683, "Human Poh Build Floor"],
    [3684, "Human Poh Build Wall"],
    [3685, "Human Throw Away"],
    [3686, "Human Sit Eat"],
    [3687, "Human Light Torch"],
    [3688, "Human Get Over Combatring Nogloves"],
    [3689, "Human Get Over Combatring Redgloves"],
    [3690, "Human Get Over Combatring Bluegloves"],
    [3691, "Human Picklock Chest"],
    [3692, "Human Picklock Cagedoor"],
    [3693, "Human Forcelock Cagedoor"],
    [3694, "Human Picklock Cagedoor Inwater"],
    [3695, "Human Forcelock Cagedoor Inwater"],
    [3696, "Human Use Pizzaoven"],
    [3697, "Human Use Toolrack"],
    [3698, "Sawmill Saw"],
    [3699, "Hammer Fall"],
    [3700, "Taxidermist Tube"],
    [3701, "Human Rub Fairy House"],
    [3702, "Human Drink From Teacup Clay"],
    [3703, "Human Drink From Teacup China"],
    [3704, "Human Drink From Teacup Giltchina"],
    [3705, "Human Bone Sacrifice"],
    [3706, "Bone Sacrifice Magic"],
    [3707, "Oub Monster1 Ready"],
    [3708, "Oub Monster1 Walk"],
    [3709, "Oub Monster1 Attack"],
    [3710, "Oub Monster1 Block"],
    [3711, "Oub Monster1 Death"],
    [3712, "Poh Toy Soldier Ready"],
    [3713, "Poh Toy Soldier Walk"],
    [3714, "Poh Toy Soldier Fallover"],
    [3715, "Poh Toy Soldier Fallover Ready"],
    [3716, "Poh Toy Doll Ready"],
    [3717, "Poh Toy Doll Walk"],
    [3718, "Poh Toy Mouse Walk"],
    [3719, "Chair Ready Herald"],
    [3720, "Water Effect"],
    [3721, "Templetrek Giant Snail Walk"],
    [3722, "Templetrek Giant Snail Ready"],
    [3723, "Templetrek Giant Snail Attack"],
    [3724, "Templetrek Giant Snail Slime Attack"],
    [3725, "Trek Giant Snail Slime Attack Spotanim"],
    [3726, "Templetrek Giant Snail Defend"],
    [3727, "Templetrek Giant Snail Death"],
    [3728, "Templetrek Tentacle Head Spawning"],
    [3729, "Templetrek Tentacle Spawning"],
    [3730, "Templetrek Tentacle Head Ready"],
    [3731, "Templetrek Tentacle Head Attack"],
    [3732, "Templetrek Tentacle Head Defend"],
    [3733, "Templetrek Tentacle Head Death"],
    [3734, "Templetrek Bog Prodding"],
    [3735, "Templetrek Sinking Anim"],
    [3736, "Templetrek Swamp Snake Attack"],
    [3737, "Templetrek Swamp Snake Death"],
    [3738, "Templetrek Swamp Snake Dead"],
    [3739, "Templetrek Rope Lasso"],
    [3740, "Templetrek Making Vine Rope"],
    [3741, "Human Trek Bridge Repair Axe"],
    [3742, "Templetrek Boat Bob"],
    [3743, "Templetrek Boat Ripples"],
    [3744, "Trek Tentacle Bubbles"],
    [3745, "Trek Healing Spell"],
    [3746, "Trek Snail Acid Hit"],
    [3747, "Human Knife Slash"],
    [3748, "Templetrek Trip Anim Initial Start"],
    [3749, "Templetrek Trip Anim Route All Trip 1"],
    [3750, "Templetrek Trip Anim Route 1 And 2 Trip 2"],
    [3751, "Templetrek Trip Anim Route 1 And 2 Trip 3"],
    [3752, "Templetrek Trip Anim Route 1 Trip 4"],
    [3753, "Templetrek Trip Anim Route 1 Trip 5"],
    [3754, "Templetrek Trip Anim Route 1 Trip 6"],
    [3755, "Templetrek Trip Anim Route 1 Trip 7"],
    [3756, "Templetrek Trip Anim Route 1 Trip 8"],
    [3757, "Templetrek Trip Anim Route 1 Trip 9"],
    [3758, "Templetrek Trip Anim Route 1 Trip 10"],
    [3759, "Templetrek Trip Anim Route 1 And 2 Trip 11"],
    [3760, "Templetrek Trip Anim Route 2 Trip 4"],
    [3761, "Templetrek Trip Anim Route 2 Trip 5"],
    [3762, "Templetrek Trip Anim Route 2 Trip 6"],
    [3763, "Templetrek Trip Anim Route 2 Trip 7"],
    [3764, "Templetrek Trip Anim Route 2 Trip 8"],
    [3765, "Templetrek Trip Anim Route 2 Trip 9"],
    [3766, "Templetrek Trip Anim Route 2 Trip 10"],
    [3767, "Templetrek Trip Anim Route 3 Trip 2"],
    [3768, "Templetrek Trip Anim Route 3 Trip 3"],
    [3769, "Templetrek Trip Anim Route 3 Trip 4"],
    [3770, "Templetrek Trip Anim Route 3 Trip 5"],
    [3771, "Templetrek Trip Anim Route 3 Trip 6"],
    [3772, "Templetrek Trip Anim Route 3 Trip 7"],
    [3773, "Templetrek Trip Anim Route 3 Trip 8"],
    [3774, "Templetrek Trip Anim Route 3 Trip 9"],
    [3775, "Templetrek Trip Anim Route 3 Trip 10"],
    [3776, "Templetrek Trip Anim Route 3 Trip 11"],
    [3777, "Templetrek Exclaimation Mark"],
    [3778, "Templetrek Trip All Start 2"],
    [3779, "Templetrek Trip Route 1 And 2 Start 3"],
    [3780, "Templetrek Trip Route 1 And 2 Start 4"],
    [3781, "Templetrek Trip Route 1 Start 5"],
    [3782, "Templetrek Trip Route 1 Start 6"],
    [3783, "Templetrek Trip Route 1 Start 7"],
    [3784, "Templetrek Trip Route 1 Start 8"],
    [3785, "Templetrek Trip Route 1 Start 9"],
    [3786, "Templetrek Trip Route 1 Start 10"],
    [3787, "Templetrek Trip Anim Route 1 And 2 Start 11"],
    [3788, "Templetrek Trip Route 2 Start 5"],
    [3789, "Templetrek Trip Route 2 Start 6"],
    [3790, "Templetrek Trip Route 2 Start 7"],
    [3791, "Templetrek Trip Route 2 Start 8"],
    [3792, "Templetrek Trip Route 2 Start 9"],
    [3793, "Templetrek Trip Route 2 Start 10"],
    [3794, "Templetrek Trip Route 3 Start 2"],
    [3795, "Templetrek Trip Route 3 Start 3"],
    [3796, "Templetrek Trip Route 3 Start 4"],
    [3797, "Templetrek Trip Route 3 Start 5"],
    [3798, "Templetrek Trip Route 3 Start 6"],
    [3799, "Templetrek Trip Route 3 Start 7"],
    [3800, "Templetrek Trip Route 3 Start 8"],
    [3801, "Templetrek Trip Route 3 Start 9"],
    [3802, "Templetrek Trip Route 3 Start 10"],
    [3803, "Emote Blow Kiss Loop"],
    [3804, "Anger Special Play"],
    [3805, "Anger Special Spot1"],
    [3806, "Player Jumphole"],
    [3807, "Wake Up"],
    [3808, "Anger Special Proj"],
    [3809, "Fear Walk"],
    [3810, "Fear Ready"],
    [3811, "Fear Parry"],
    [3812, "Fear Attack"],
    [3813, "Fear Death"],
    [3814, "Fear Cut"],
    [3815, "Confready"],
    [3816, "Confattack"],
    [3817, "Confpoisen"],
    [3818, "Confrange"],
    [3819, "Confwalk"],
    [3820, "Confparry"],
    [3821, "Confdeath"],
    [3822, "Lessready"],
    [3823, "Lessattack"],
    [3824, "Lesspoisen"],
    [3825, "Lesswalk"],
    [3826, "Lessparry"],
    [3827, "Lessdeath"],
    [3828, "Neckready"],
    [3829, "Neckattack"],
    [3830, "Neckpoisen"],
    [3831, "Neckrange"],
    [3832, "Neckparry"],
    [3833, "Neckdeath"],
    [3834, "Neckdeathfade"],
    [3835, "Hole Squeeze"],
    [3836, "Tolna Hole"],
    [3837, "Tolna Scared"],
    [3838, "Climb Down Soul"],
    [3839, "Human Play Wwf Amur Leopard"],
    [3840, "Talking Sack"],
    [3841, "Ram Head Defend"],
    [3842, "Ram Head Attack"],
    [3843, "Fishing Contest Banner"],
    [3844, "Railing Squeeze"],
    [3845, "Aide Fisherman Ready"],
    [3846, "Book Chuck Ready"],
    [3847, "Lore Dust Devil Attack"],
    [3848, "Lore Dust Devil Defend"],
    [3849, "Lore Dust Devil Death"],
    [3850, "Blast Furnace Npc Air Pump"],
    [3851, "Blast Furnace Npc Conveyer Cycle"],
    [3852, "Battleaxe Crush"],
    [3853, "Lore Dust Devil Player Dust Cloud"],
    [3854, "Rc Zmi Runner"],
    [3855, "Rc Zmi Lizard Attack"],
    [3856, "Rc Zmi Lizard Defend"],
    [3857, "Lore Dust Devil Npc Cloud Spotanim"],
    [3858, "Slayer Tots Charge Toxic"],
    [3859, "Easter07 Flapping Emote"],
    [3860, "Tentacle Monster Spawn"],
    [3861, "Swan Crush Loop"],
    [3862, "Easter 2006 Child Joy Jump"],
    [3863, "Easter Egg Rolling"],
    [3864, "Teleport Scroll Open"],
    [3865, "Arceuus Necromancy Anim"],
    [3866, "Human Mining Black Pickaxe Wall"],
    [3867, "Teleport Rune Human"],
    [3868, "Teleport Rune Spot"],
    [3869, "Teleport Cabbage Human"],
    [3870, "Teleport Cabbage Spotanim"],
    [3871, "Teleport Nardah Spotanim"],
    [3872, "Teleport Nardah Human"],
    [3873, "Human Mining Black Pickaxe"],
    [3874, "Teleport Slime Human"],
    [3875, "Teleport Slime Spotanim"],
    [3876, "Teleport Monastery Spot"],
    [3877, "Teleport Farm"],
    [3878, "Torcher Ready"],
    [3879, "Torcher Walk"],
    [3880, "Torcher Defend"],
    [3881, "Torcher Death"],
    [3882, "Torcher Attack"],
    [3883, "Torcher Fireball Launch"],
    [3884, "Torcher Fireball Travel"],
    [3885, "Torcher Fireball Impact"],
    [3886, "Splatter Ready"],
    [3887, "Splatter Walk"],
    [3888, "Splatter Death"],
    [3889, "Splatter Exploding"],
    [3890, "Splatter Defend"],
    [3891, "Splatter Attack"],
    [3892, "Brawler Walk"],
    [3893, "Brawler Ready"],
    [3894, "Brawler Death"],
    [3895, "Brawler Defend"],
    [3896, "Brawler Super Attack"],
    [3897, "Brawler Attack"],
    [3898, "Shifter Walk"],
    [3899, "Shifter Ready"],
    [3900, "Shifter Ready Two"],
    [3901, "Shifter Attack"],
    [3902, "Shifter Defend"],
    [3903, "Shifter Death"],
    [3904, "Pest Shifter Teleportattack"],
    [3905, "Pest Shifter Portal"],
    [3906, "Spinner Ready"],
    [3907, "Spinner Walk"],
    [3908, "Spinner Attack"],
    [3909, "Spinner Defend"],
    [3910, "Spinner Death"],
    [3911, "Pest Spinner Repairing"],
    [3912, "Pest Spinner Sparks"],
    [3913, "Ravager Ready"],
    [3914, "Ravager Walk"],
    [3915, "Ravager Attack"],
    [3916, "Ravager Defend"],
    [3917, "Ravager Death"],
    [3918, "Defiler Ready"],
    [3919, "Defiler Walk"],
    [3920, "Defiler Attack"],
    [3921, "Defiler Defend"],
    [3922, "Defiler Death"],
    [3923, "Defiler Spike Launch"],
    [3924, "Defiler Spike Impact"],
    [3925, "Pest Lander Boat Anim"],
    [3926, "Pest Void Knight Casting"],
    [3927, "Pest Flag Anim"],
    [3928, "Pest Portal On Anim"],
    [3929, "Pest Portal Shrinking Anim"],
    [3930, "Pest Portal Death"],
    [3931, "Pest Repair"],
    [3932, "Pest Void Knight Glow Anim"],
    [3933, "Pest Portal On Anim East"],
    [3934, "Pest Portal Shrinking Anim East"],
    [3935, "Pest Portal Death East"],
    [3936, "Pest Portal On Anim West"],
    [3937, "Pest Portal Shrinking Anim West"],
    [3938, "Pest Portal Death West"],
    [3939, "Pest Cauldron"],
    [3940, "Wild Banner"],
    [3941, "Wild Falloff Meteor Blast"],
    [3942, "Wild Falloff Meteor Flying"],
    [3943, "Lava Rock"],
    [3944, "Wilderness Portal Stone Glow"],
    [3945, "Human Wilderness Portal"],
    [3946, "Wilderness Portal Anim"],
    [3947, "Postie Pete Walk"],
    [3948, "Postie Pete Ready"],
    [3949, "Postie Pete Tele"],
    [3950, "Qip Cook Milkmaid"],
    [3951, "Qip Cook Chicken Lay Egg"],
    [3952, "Battle Tortoise Ready"],
    [3953, "Battle Tortoise Walk"],
    [3954, "Battle Tortoise Archer Attack"],
    [3955, "Battle Tortoise Mage Attack"],
    [3956, "Battle Tortoise Archer Mage Attack"],
    [3957, "Battle Tortoise Archer Mage Tortoise Attack"],
    [3958, "Battle Tortoise Archer Tortoise Attack"],
    [3959, "Battle Tortoise Mage Tortoise Attack"],
    [3960, "Battle Tortoise Attack"],
    [3961, "Battle Tortoise Defend"],
    [3962, "Battle Tortoise Death"],
    [3963, "Gnome Staff Walk"],
    [3964, "Gnome Staff Block"],
    [3965, "Gnome Staff Ready"],
    [3966, "Gnome Staff Attack"],
    [3967, "Gnome Staff Death"],
    [3968, "Gnome Mage Attack"],
    [3969, "Gnome Unarmed Attack"],
    [3970, "Swan Infinitedeath"],
    [3971, "Swan Hammer"],
    [3972, "Swan Pot Open"],
    [3973, "Swan Machine Use"],
    [3974, "Swan Stone Throw Launch"],
    [3975, "Swan Pot Spotanim"],
    [3976, "Swan Crush"],
    [3977, "Swan General Walk"],
    [3978, "Swan General Ready"],
    [3979, "Swan General Death"],
    [3980, "Swan General Attack"],
    [3981, "Swan General Defend"],
    [3982, "Swan General Shakefist"],
    [3983, "Swan Seatroll Water Rise"],
    [3984, "Swan Seatroll Walk"],
    [3985, "Swan Seatroll Attack"],
    [3986, "Swan Seatroll Block"],
    [3987, "Swan Seatroll Ready"],
    [3988, "Swan Seatroll Death"],
    [3989, "Swan Queen Ready"],
    [3990, "Swan Queen Defend"],
    [3991, "Swan Queen Attack"],
    [3992, "Swan Queen Spellcast"],
    [3993, "Swan Queen Death"],
    [3994, "Skeleton Mage Rise"],
    [3995, "Skeleton Mage Smoke"],
    [3996, "Elemental Equip Left Human Ready"],
    [3997, "Qip Cook Milkmaid Walk"],
    [3998, "Grab Evil Twin Claw"],
    [3999, "Grab Evil Twin In Claw Ready"],
    [4000, "Grab Evil Claw Grabbing"],
    [4001, "Grab Evil Twin Getting Grab"],
    [4002, "Grab Evil Twin Claw Drop"],
    [4003, "Grab Evil Twin Falling"],
    [4004, "Grab Evil Twin Reaching Control"],
    [4005, "Pinball Post"],
    [4006, "Pinball Post Inactive"],
    [4007, "Pinball Troll Lft"],
    [4008, "Pinball Troll Rht"],
    [4009, "Pinball Troll Ease Rht"],
    [4010, "Pinball Troll Ease Lft"],
    [4011, "Pinball Hammer Firing"],
    [4012, "Pinball Tunnel Entrance"],
    [4013, "Pinball Side Loop"],
    [4014, "Pinball Chicane"],
    [4015, "Pinball Ball Hit"],
    [4016, "Pinball Interface"],
    [4017, "Restless Skeleton Get Up"],
    [4018, "Restless Ghost Vanish"],
    [4019, "Restless Ghost Appear"],
    [4020, "Restless Ghost Travel"],
    [4021, "Royal Dwarf Mining"],
    [4022, "Royal Coal Engine Activated"],
    [4023, "Royal Human Platform Lift"],
    [4024, "Royal Human Platform Lift Reversed"],
    [4025, "Royal Spotanim Platform Lift"],
    [4026, "Royal Spotanim Platform Lift Reversed"],
    [4027, "Royal Steam Plume"],
    [4028, "Royal Human Steam Plume"],
    [4029, "Royal Human Slip Up"],
    [4030, "Royal Human Slip Fall"],
    [4031, "Royal Human Slip Up Only"],
    [4032, "Royal Rock Fall East"],
    [4033, "Royal Rock Fall South"],
    [4034, "Royal Rock Fall West"],
    [4035, "Royal Rock Fall North"],
    [4036, "Royal Show Diary"],
    [4037, "Royal Sea Snake Mother Ready"],
    [4038, "Royal Sea Snake Mother Defend"],
    [4039, "Royal Sea Snake Mother Death"],
    [4040, "Royal Sea Snake Mother Attack"],
    [4041, "Royal Sea Snake Mother Ranged Attack"],
    [4042, "Royal Sea Snake Mother Emerge"],
    [4043, "Human Use Staff With Crystalball1 Air"],
    [4044, "Human Use Staff With Crystalball2 Air"],
    [4045, "Human Use Staff With Crystalball1 Earth"],
    [4046, "Human Use Staff With Crystalball2 Earth"],
    [4047, "Human Use Staff With Crystalball1 Water"],
    [4048, "Human Use Staff With Crystalball2 Water"],
    [4049, "Human Use Staff With Crystalball1 Fire"],
    [4050, "Human Use Staff With Crystalball2 Fire"],
    [4051, "Human Use Staff With Crystalball1 Air Battlestaff"],
    [4052, "Human Use Staff With Crystalball2 Air Battlestaff"],
    [4053, "Human Use Staff With Crystalball1 Earth Battlestaff"],
    [4054, "Human Use Staff With Crystalball2 Earth Battlestaff"],
    [4055, "Human Use Staff With Crystalball1 Water Battlestaff"],
    [4056, "Human Use Staff With Crystalball2 Water Battlestaff"],
    [4057, "Human Use Staff With Crystalball1 Fire Battlestaff"],
    [4058, "Human Use Staff With Crystalball2 Fire Battlestaff"],
    [4059, "Human Use Staff With Crystalball1 Mystic Air Staff"],
    [4060, "Human Use Staff With Crystalball2 Mystic Air Staff"],
    [4061, "Human Use Staff With Crystalball1 Mystic Earth Staff"],
    [4062, "Human Use Staff With Crystalball2 Mystic Earth Staff"],
    [4063, "Human Use Staff With Crystalball1 Mystic Water Staff"],
    [4064, "Human Use Staff With Crystalball2 Mystic Water Staff"],
    [4065, "Human Use Staff With Crystalball1 Mystic Fire Staff"],
    [4066, "Human Use Staff With Crystalball2 Mystic Fire Staff"],
    [4067, "Poh Create Magic Tablet"],
    [4068, "Poh Create Magic Tablet Withstaff"],
    [4069, "Poh Smash Magic Tablet"],
    [4070, "Godwars Zamorak Walk"],
    [4071, "Poh Absorb Tablet Teleport"],
    [4072, "Poh Absorb Magic Spell"],
    [4073, "Chair Sit Ready Chair1"],
    [4074, "Chair Ready Diagonal Chair1"],
    [4075, "Chair Sit Ready Chair2"],
    [4076, "Chair Ready Diagonal Chair2"],
    [4077, "Chair Sit Ready Chair3"],
    [4078, "Chair Ready Diagonal Chair3"],
    [4079, "Chair Sit Ready Rocking Chair3"],
    [4080, "Chair Ready Diagonal Rocking Chair3"],
    [4081, "Chair Sit Ready Chair4"],
    [4082, "Chair Ready Diagonal Chair4"],
    [4083, "Chair Sit Ready Chair5"],
    [4084, "Chair Ready Diagonal Chair5"],
    [4085, "Chair Sit Ready Chair6"],
    [4086, "Chair Ready Diagonal Chair6"],
    [4087, "Chair Sit Ready Chair7"],
    [4088, "Chair Ready Diagonal Chair7"],
    [4089, "Chair Sit Ready Diningchairs 1"],
    [4090, "Chair Eat Diningchairs 1"],
    [4091, "Chair Sit Ready Diningchairs 2"],
    [4092, "Chair Eat Diningchairs 2"],
    [4093, "Chair Sit Ready Diningchairs 3"],
    [4094, "Chair Eat Diningchairs 3"],
    [4095, "Chair Sit Ready Diningchairs 4"],
    [4096, "Chair Eat Diningchairs 4"],
    [4097, "Chair Sit Ready Diningchairs 5"],
    [4098, "Chair Eat Diningchairs 5"],
    [4099, "Chair Sit Ready Diningchairs 6"],
    [4100, "Chair Eat Diningchairs 6"],
    [4101, "Chair Sit Ready Diningchairs 7"],
    [4102, "Chair Eat Diningchairs 7"],
    [4103, "Chair Sit"],
    [4104, "Chair Sit Diagonal Right"],
    [4105, "Chair Get Up"],
    [4106, "Chair Get Up Diagonal Right"],
    [4107, "Chair Sit Ready Stool 1"],
    [4108, "Chair Sit Ready Stool 2"],
    [4109, "Human Use Workbench Stool 1"],
    [4110, "Human Use Workbench Stool 2"],
    [4111, "Chair Sit Ready Throne 1"],
    [4112, "Chair Sit Ready Throne 2"],
    [4113, "Chair Sit Ready Throne 3"],
    [4114, "Chair Sit Ready Throne 4"],
    [4115, "Chair Sit Ready Throne 5"],
    [4116, "Chair Sit Ready Throne 6"],
    [4117, "Chair Sit Ready Throne 7"],
    [4118, "Treasure Magic Closechest End"],
    [4119, "Chathand1"],
    [4120, "Chathand2"],
    [4121, "Chathand3"],
    [4122, "Chathand4"],
    [4123, "Gas Vent"],
    [4124, "Fai Varrock Cookingpot Fire"],
    [4125, "Fai Varrock Oillamp Anim"],
    [4126, "Lunar Moonclan Flower Swing"],
    [4127, "Fai Varrock Lantern Anim"],
    [4128, "Fai Varrock Shop Sign"],
    [4129, "Fai Varrock Fortune Teller Shop Sign"],
    [4130, "Fai Varrock Hearth Fire"],
    [4131, "Fai Varrock Runeshop Sign"],
    [4132, "Fai Varrock Air Vent Smoke"],
    [4133, "Washing Line Pigeon"],
    [4134, "Pillory Flash"],
    [4135, "Pillory Flash First"],
    [4136, "Human Sit Eat Diag"],
    [4137, "Macaroni Penguin Walk"],
    [4138, "Macaroni Penguin Ready"],
    [4139, "Macaroni Penguin Ready Shooing"],
    [4140, "Macaroni Penguin Turn Ready"],
    [4141, "Chair Eat Chair1"],
    [4142, "Chair Eat Diagonal Chair1"],
    [4143, "Chair Eat Chair2"],
    [4144, "Chair Eat Diagonal Chair2"],
    [4145, "Chair Eat Chair3"],
    [4146, "Chair Eat Diagonal Chair3"],
    [4147, "Chair Eat Chair4"],
    [4148, "Chair Eat Diagonal Chair4"],
    [4149, "Chair Eat Chair5"],
    [4150, "Chair Eat Diagonal Chair5"],
    [4151, "Chair Eat Chair6"],
    [4152, "Chair Eat Diagonal Chair6"],
    [4153, "Chair Eat Chair7"],
    [4154, "Chair Eat Diagonal Chair7"],
    [4155, "Mcannon Interface Safety Off Attaching Spring"],
    [4156, "Mcannon Interface Safety Off Detaching Spring"],
    [4157, "Warguild Catapult Fire"],
    [4158, "Warguild Catapult Set"],
    [4159, "Warguild Catapult Set Arm"],
    [4160, "Warguild Catapult Set Fire"],
    [4161, "Warguild Arm Anim"],
    [4162, "Warguild Dummy Spring"],
    [4163, "Warguild Dummy Spring Up"],
    [4164, "Warguild Dummy Spring Down"],
    [4165, "Warguild Projspin"],
    [4166, "Warguild Animate"],
    [4167, "Warguild Animate Reverse"],
    [4168, "Warguild Blunt Def"],
    [4169, "Warguild Spike Def"],
    [4170, "Warguild Blade Def"],
    [4171, "Warguild Mage Def"],
    [4172, "Warguild Blunt Fail"],
    [4173, "Warguild Spike Fail"],
    [4174, "Warguild Blade Fail"],
    [4175, "Warguild Mage Fail"],
    [4176, "Warguild Sparks"],
    [4177, "Warguild Parry Defend"],
    [4178, "Balance Walk"],
    [4179, "Balance Ready"],
    [4180, "Balance Pickup"],
    [4181, "Standing Shot"],
    [4182, "Running Shot"],
    [4183, "Spinning Shot"],
    [4184, "Ref Duck"],
    [4185, "Dust Hands Play"],
    [4186, "Dust Hands Spot"],
    [4187, "Barrel Fall Spot"],
    [4188, "Barrel Fall Play"],
    [4189, "Mail Alert"],
    [4190, "Mcannon Hammer Anim"],
    [4191, "Quest Lunar Stand From Face Down"],
    [4192, "Dttd Player Through Crack"],
    [4193, "Dttd Carrying Crate Ready"],
    [4194, "Dttd Carrying Crate Walk"],
    [4195, "Dttd Bend To Listen At Door"],
    [4196, "Dttd Bent To Listen At Door Idle"],
    [4197, "Dttd Standing After Listen At Door"],
    [4198, "Dttd Player Stab Bone Dagger"],
    [4199, "Dttd Player Fire Bone Crossbow"],
    [4200, "Dttd Ham Cut Scene Death"],
    [4201, "Dttd Zanik Bend To Listen At Door"],
    [4202, "Dttd Zanik Bent To Listen At Door Idle"],
    [4203, "Dttd Zanik Stands After Listening At Door"],
    [4204, "Dttd Zanik Jump Into Box"],
    [4205, "Dttd Zanik Drunk Tog In Pain"],
    [4206, "Dttd Zanik Draw And Fire Crossbow"],
    [4207, "Dttd Ham Guard Pointing"],
    [4208, "Dttd Ham Meeting Ready"],
    [4209, "Dttd Ham Meeting Toasting"],
    [4210, "Dttd Bone Dealer Ready"],
    [4211, "Dttd Bone Dealer Opening Coat"],
    [4212, "Dttd Bone Dealer Coat Opening"],
    [4213, "Dttd Sigmund Vanishing"],
    [4214, "Dttd Bowl Dropping Magic"],
    [4215, "Dttd Arm Puts Lid On Box"],
    [4216, "Dttd Crossbow Drawn And Fired"],
    [4217, "Dttd Little Drip"],
    [4218, "Dttd Little Drips"],
    [4219, "Dttd Zanik Revival"],
    [4220, "Dttd Zanik Revival Static"],
    [4221, "Dttd Zanik Return To Life"],
    [4222, "Dttd Machine Smashing"],
    [4223, "Dttd Drill Machine Smashing Spot Anim Smoke"],
    [4224, "Dttd Drill Machine Broken Parts Projectile"],
    [4225, "Dttd Dagger Sp Attack"],
    [4226, "Xbows Human Walk F"],
    [4227, "Xbows Human Walk B"],
    [4228, "Xbows Human Run"],
    [4229, "Bone Crossbow Bolt Launch"],
    [4230, "Xbows Human Fire And Reload"],
    [4231, "Harmless Island Jungle Horror Ready"],
    [4232, "Harmless Island Jungle Horror Block"],
    [4233, "Harmless Island Jungle Horror Death"],
    [4234, "Harmless Island Jungle Horror Attack"],
    [4235, "Harmless Island Jungle Horror Attackb"],
    [4236, "Harmless Island Jungle Horror Walk"],
    [4237, "Harmless Island Cave Horror Howl"],
    [4238, "Brew Use Barley"],
    [4239, "Boiler Fire"],
    [4240, "Rum Bottle Smash"],
    [4241, "Rum Bottle"],
    [4242, "Steam Pump"],
    [4243, "Steam Pump Release"],
    [4244, "Brew Monkey Fight"],
    [4245, "Brew Monkey Ready"],
    [4246, "Brew Monkey Climb"],
    [4247, "Brew Monkey Throw"],
    [4248, "Brew Bitternut Thrown"],
    [4249, "Brew Bitternut Caught"],
    [4250, "Brew Bitternut Human Caught"],
    [4251, "Brew Steam Anim"],
    [4252, "Brew Monkey Climb Spotanim"],
    [4253, "Brew Bitternut Tree Climb"],
    [4254, "Brew Human Steam Pump"],
    [4255, "Brew Bucket Throw"],
    [4256, "Brew Jimmy Walk"],
    [4257, "Brew Jimmy Ready"],
    [4258, "Brew Fire Starter"],
    [4259, "Game Brew Helper Parrot Ready"],
    [4260, "Game Brew Bottle Machine Vibrate"],
    [4261, "Game Brew Bottle Steam"],
    [4262, "Game Brew Bottle Flash"],
    [4263, "Mino Walk"],
    [4264, "Mino Ready"],
    [4265, "Mino Death"],
    [4266, "Mino Attack"],
    [4267, "Mino Parry"],
    [4268, "Catpon Walk"],
    [4269, "Catpon Ready"],
    [4270, "Catpon Death"],
    [4271, "Catpon Attack"],
    [4272, "Catpon Attack Breath"],
    [4273, "Catpon Parry"],
    [4274, "Sos Wall Light"],
    [4275, "Emote Slap Head"],
    [4276, "Emote Lightbulb"],
    [4277, "Emote Lightbulb Spotanim"],
    [4278, "Emote Stampfeet"],
    [4279, "Emote Stampfeet Dust Spotanim"],
    [4280, "Emote Panic Flap"],
    [4281, "Door Chathead"],
    [4282, "Sos Security Door Drag"],
    [4283, "Sos Security Door Appear"],
    [4284, "Sos Security Door Glow"],
    [4285, "Qip Imp Catcher Wizard"],
    [4286, "Qip Imp Catcher Spell"],
    [4287, "Qip Imp Catcher Laugh"],
    [4288, "Qip Imp Catcher Chicken"],
    [4289, "Qip Imp Catcher Scratch"],
    [4290, "Mushroom Spin Q1"],
    [4291, "Mushroom Spin Q2"],
    [4292, "Mushroom Spin Q3"],
    [4293, "Mushroom Spin Q4"],
    [4294, "Mushroom Spin Q1 Anti"],
    [4295, "Mushroom Spin Q2 Anti"],
    [4296, "Mushroom Spin Q3 Anti"],
    [4297, "Mushroom Spin Q4 Anti"],
    [4298, "Gorak Walk"],
    [4299, "Gorak Ready"],
    [4300, "Gorak Attack"],
    [4301, "Gorak Defend"],
    [4302, "Gorak Death"],
    [4303, "Cosmic Entity Ready"],
    [4304, "Cosmic Entity Walk"],
    [4305, "Cosmic Entity Death"],
    [4306, "Cosmic Entity Defend"],
    [4307, "Cosmic Entity Attack"],
    [4308, "Gorak Cloud Lightning"],
    [4309, "Gorak Cloud Lightning Alt"],
    [4310, "Fairy2 Centaur Walk"],
    [4311, "Fairy2 Centaur Ready"],
    [4312, "Fairy2 Starflower Grow"],
    [4313, "Fairy2 Starflower Die"],
    [4314, "Fairy2 Starflower Seed"],
    [4315, "Fairy2 Starflower Fullgrown"],
    [4316, "Human Fairy2 Kneel And Pour"],
    [4317, "Fairy2 Queenwake"],
    [4318, "Ork Weapon Ready"],
    [4319, "Ork Weapon Walk"],
    [4320, "Ork Double Grip Attack"],
    [4321, "Ork Death"],
    [4322, "Ork Defend"],
    [4323, "Cosmic Entity Ball"],
    [4324, "Cosmic Entity Bubbles"],
    [4325, "Cosmic Crystal Moves"],
    [4326, "Cosmic Enity Beign Ready"],
    [4327, "Cosmic Enity Beign Walk"],
    [4328, "Fairy2 Secateur Enchant"],
    [4329, "Human Drink Red Rum"],
    [4330, "Human Drink Blue Rum"],
    [4331, "Templetrek Girl Unarmed Attack"],
    [4332, "Templetrek Girl Unarmed Defend"],
    [4333, "Sandstorm Update"],
    [4334, "Ntk Tele Spotanim"],
    [4335, "Ntk Urn Anim"],
    [4336, "Ntk Sarcophagi Anim"],
    [4337, "Ntk Sarcophagi Anim Ready"],
    [4338, "Ntk Tomb Door"],
    [4339, "Ntk Pyramid Door"],
    [4340, "Urn Search"],
    [4341, "Urn Search Bit"],
    [4342, "Urn Search Success"],
    [4343, "Ntk Tomb Search"],
    [4344, "Ntk Tomb Push Loop"],
    [4345, "Ntk Tomb Open"],
    [4346, "Curtain Open"],
    [4347, "Curtain Closing"],
    [4348, "Mixing Dyes Red+blue"],
    [4349, "Mixing Dyes Red+yellow"],
    [4350, "Mixing Dyes Blue+yellow"],
    [4351, "Dye Spotanim"],
    [4352, "Aggie Dye Making"],
    [4353, "100 Pirate Underwater Bubbles"],
    [4354, "Lunar Dream Plinth Hover"],
    [4355, "Lunar Dream Dream Tree Shimmer"],
    [4356, "Lunar Dream Numbers Spin"],
    [4357, "Lunar Dream Hurdles"],
    [4358, "Quest Lunar Ejector Platform Start"],
    [4359, "Quest Lunar Ejector Platform"],
    [4360, "Quest Lunar Dice Shake"],
    [4361, "Quest Lunar Dice Settle"],
    [4362, "Quest Lunar Puff Platform Ready"],
    [4363, "Quest Lunar Puff Platform Fall"],
    [4364, "Quest Lunar Puff Platform Return"],
    [4365, "Quest Lunar Ejector Thrown"],
    [4366, "Quest Lunar Falling On Platform"],
    [4367, "Quest Lunar Landing On Face"],
    [4368, "Quest Lunar Look High Lantern"],
    [4369, "Quest Lunar Look Low Lantern"],
    [4370, "Quest Lunar Floating Mirror Look"],
    [4371, "Quest Lunar Watering Plants"],
    [4372, "Quest Lunar Broom Sweep"],
    [4373, "Quest Lunar Bucket Empty Walk"],
    [4374, "Quest Lunar Bucket Full Walk"],
    [4375, "Quest Lunar Bucket Filling"],
    [4376, "Quest Lunar Bucket Pouring"],
    [4377, "Quest Lunar Moonclan Teaset Dance"],
    [4378, "Moonclan Staff Cast"],
    [4379, "Quest Luna Cast Magic"],
    [4380, "Quest Lunar Dreamland Jump Hurdle"],
    [4381, "Quest Lunar Dreamland Jump Hurdle Shock"],
    [4382, "Quest Lunar Dreamland Hurdle Shock Spotanimation"],
    [4383, "Suqka Walk"],
    [4384, "Suqka Defend"],
    [4385, "Suqka Defend Swords"],
    [4386, "Suqka Ready"],
    [4387, "Suqka Attack"],
    [4388, "Suqka Attack Swords"],
    [4389, "Suqka Death"],
    [4390, "Lunar Moonclan Baba Yaga Walk"],
    [4391, "Lunar Moonclan Baba Yaga Ready"],
    [4392, "Lunar Moonclan Hanging Light"],
    [4393, "Lunar Moonclan Hat Rack"],
    [4394, "Quest Lunar Bouncing Kettle"],
    [4395, "Quest Lunar Bouncing Clothes Rack"],
    [4396, "Quest Lunar Bouncing Stool"],
    [4397, "Quest Lunar Bouncing Table"],
    [4398, "Quest Lunar Bouncing Spoons"],
    [4399, "Hanging Body"],
    [4400, "Lunar Scratch"],
    [4401, "Lunar Telescope"],
    [4402, "Lunar Hand Hit"],
    [4403, "Quest Lunar Set Sail Wrong"],
    [4404, "Quest Lunar Set Sail Right"],
    [4405, "Quest Lunar Set Sail Return"],
    [4406, "Quest Lunar Staff Ruins"],
    [4407, "Lunar Fighting Me Tele"],
    [4408, "Quest Lunar Moonclan Brazier Flames"],
    [4409, "Quest Lunar Spell Cast Spell On Group"],
    [4410, "Hosdun Spider Boss Attack Ranged"],
    [4411, "Quest Lunar Pushing Magic Animation"],
    [4412, "Lunar Human Magic Summon1"],
    [4413, "Lunar Human Magic Summon2"],
    [4414, "Quest Lunar Spell Energy Exchange"],
    [4415, "Quest Lunar Spell Raining Cloud"],
    [4416, "Quest Lunar Spell Raining Fertile Soil"],
    [4417, "Quest Lunar Spell Skull Swoop"],
    [4418, "Quest Lunar Spell Energy Sparkle"],
    [4419, "Quest Lunar Pushing Magic Animation Spot"],
    [4420, "Quest Lunar Magic Spot1"],
    [4421, "Quest Lunar Magic Spot2"],
    [4422, "Quest Lunar Bakepie"],
    [4423, "Lunar Teleport"],
    [4424, "Human Moonclan Ready"],
    [4425, "Human Moonclan Turnonspot"],
    [4426, "Human Moonclan Walk F"],
    [4427, "Human Moonclan Walk B"],
    [4428, "Human Moonclan Walk L"],
    [4429, "Human Moonclan Walk R"],
    [4430, "Human Moonclan Run"],
    [4431, "Slow Hammock Swinging"],
    [4432, "Quest Lunar Cure Plant"],
    [4433, "Human Ogre Fletching"],
    [4434, "Area Harmless Ear Cover"],
    [4435, "Human Climbing Loop"],
    [4436, "Xbows Fletching Wood Bronze"],
    [4437, "Xbows Fletching Oak Blurite"],
    [4438, "Xbows Fletching Willow Iron"],
    [4439, "Xbows Fletching Teak Steel"],
    [4440, "Xbows Fletching Maple Mithril"],
    [4441, "Xbows Fletching Mahogany Adamantite"],
    [4442, "Xbows Fletching Yew Runite"],
    [4443, "Xbows Lucky Lightening Strike"],
    [4444, "Xbows Sea Curse Waterfall"],
    [4445, "Xbows Clear Mind Glow"],
    [4446, "Xbows Magical Poison"],
    [4447, "Xbows Life Leach"],
    [4448, "Xbows Blood Sacrifice"],
    [4449, "Xbows Earths Fury"],
    [4450, "Xbows Dragons Breath"],
    [4451, "Xbows Down To Earth"],
    [4452, "Xbows Diamond Tip"],
    [4453, "Xbows Fire And Climbed Grapple"],
    [4454, "Xbows Fire And Climbed Grapple Yanille"],
    [4455, "Xbows Human Fire And Climb Grapple"],
    [4456, "Xbows Human Climb Grapple Uphill"],
    [4457, "Xbows Human Climb Grapple Downhill"],
    [4458, "Xbows Human Hook Grapple To Rock Part1"],
    [4459, "Xbows Human Hook Grapple To Rock Part2"],
    [4460, "Xbows Human Shoot Grapple Up Cliff"],
    [4461, "Xbows Draw Grapple Toshoot Up Cliff"],
    [4462, "Human Xbow Enchant Arrowtip"],
    [4463, "Xbows Enchanting Tips Spot"],
    [4464, "Xbows Karamja North Swimming Anim"],
    [4465, "Xbows Karamja South Swimming Anim"],
    [4466, "Xbows Lumbridge East Swimming Anim"],
    [4467, "Xbows Lumbridge West Swimming Anim"],
    [4468, "Xbows Water Obelisk Swimming Anim"],
    [4469, "Xbows Karamja Swimming Spotanim"],
    [4470, "Xbows Fletching Pearl"],
    [4471, "Quest Ahoy Human Filling Bucket"],
    [4472, "Eyeglo Fluffie Ready"],
    [4473, "Eyeglo Fluffie Walking"],
    [4474, "Eyeglo Fluffie Attack"],
    [4475, "Eyeglo Fluffie Defend"],
    [4476, "Eyeglo Fluffie Death"],
    [4477, "Eyeglo Fluffy Reveal"],
    [4478, "Eyeglo Fluffy Reveal Magic"],
    [4479, "Cerberus Hellhound Pet Neutral"],
    [4480, "Sang Mining Wall Infernal Pickaxe"],
    [4481, "Human Mining Infernal Pickaxe Wall"],
    [4482, "Human Mining Infernal Pickaxe"],
    [4483, "Human Mining Infernal Pickaxe Noreachforward"],
    [4484, "Cerberus Idle"],
    [4485, "Cerberus Idle Sitting"],
    [4486, "Cerberus Idle To Stand"],
    [4487, "Cerberus Stand To Sit"],
    [4488, "Cerberus Walk"],
    [4489, "Cerberus Defend"],
    [4490, "Cerberus Attack Range"],
    [4491, "Cerberus Bite"],
    [4492, "Cerberus Fire Breath"],
    [4493, "Cerberus Special Attack Spray"],
    [4494, "Cerberus Howl"],
    [4495, "Cerberus Death"],
    [4496, "Hh Hellfire Mage Absorb"],
    [4497, "Hh Hellfire Burst"],
    [4498, "Hh Hellfire Hit"],
    [4499, "Hh Bone Ball Burst"],
    [4500, "Hh Bone Ball Spin"],
    [4501, "Cerberus Special Attack Flame"],
    [4502, "Fire Liquid"],
    [4503, "Human Inquisitors Mace Crush"],
    [4504, "Human Nightmare Staff Ready"],
    [4505, "Human Nightmare Staff Crush"],
    [4506, "Human Turn Iron Winch"],
    [4507, "Fire Liquid Wall"],
    [4508, "Smoulderstone Charge Axe Spotanim"],
    [4509, "Smoulderstone Charge Pickaxe Spotanim"],
    [4510, "Smoulderstone Create Tools"],
    [4511, "Smouderstone Charge Axe"],
    [4512, "Smouderstone Recharge Axe"],
    [4513, "Smouderstone Charge Pickaxe"],
    [4514, "Smouderstone Recharge Pickaxe"],
    [4515, "Hellhound Torch"],
    [4516, "Soul Wave Anim"],
    [4517, "Soul Skull Active"],
    [4518, "Soul Skull Open"],
    [4519, "Keykeeper"],
    [4520, "Abyssal Dagger Special Spotanim"],
    [4521, "Abyssal Spawn Death"],
    [4522, "Abyssal Spawn Attack"],
    [4523, "Abyssal Spawn Defend"],
    [4524, "Abyssal Spawn Idle"],
    [4525, "Abyssal Spawn Walk"],
    [4526, "Abyssal Spawn Projanim"],
    [4527, "Sire Sleeping"],
    [4528, "Sire Waking"],
    [4529, "Sire Idle One"],
    [4530, "Sire Attack Spawns"],
    [4531, "Sire Attack Miasma"],
    [4532, "Sire Mobilising"],
    [4533, "Sire Idle Two"],
    [4534, "Sire Walk"],
    [4535, "Aluft Gnome Phone Ringing"],
    [4536, "Aluft Gnome Talking On Phone"],
    [4537, "Aluft Gnome Sitting Facing West"],
    [4538, "Aluft Gnome Sitting Facing South"],
    [4539, "Duck Rework Land Ready"],
    [4540, "Aluft Player Handing Over"],
    [4541, "Aluft Delivery Box"],
    [4542, "Aluft Gnome Delivery Package"],
    [4543, "Aluft Plant Teleport"],
    [4544, "Aluft Human Plant Teleport"],
    [4545, "Aluft Plant Teleport Revers"],
    [4546, "Aluft Human Plant Teleport Revers"],
    [4547, "Aluft Human Activate Seed Pod"],
    [4548, "Aluft Seed Pod Release"],
    [4549, "Reading Dossier"],
    [4550, "Dossier Explosion"],
    [4551, "Exploding Dossier"],
    [4552, "Bkf Bent To Listen At Door Idle"],
    [4553, "Bkf Throw Cabbage"],
    [4554, "Bkf Cabbage Proj Thrown"],
    [4555, "Bkf Cabbage Tumble"],
    [4556, "Bkf Cabbage Cauldron Bubbles"],
    [4557, "Eyeglo Table Deco"],
    [4558, "Eyeglo Singing Bowl Human"],
    [4559, "Eyeglo Plant Anim"],
    [4560, "Eyeglo Gnome Machine 01"],
    [4561, "Eyeglo Gnome Machine 02"],
    [4562, "Eyeglo Gnome Machine 03"],
    [4563, "Eyeglo Gnome Machine Cogs"],
    [4564, "Goblin Crowd"],
    [4565, "Gnome Crowd"],
    [4566, "Goblin Crowd2"],
    [4567, "Gnome Crowd2"],
    [4568, "Goblin Crowd3"],
    [4569, "Gnome Crowd3"],
    [4570, "Eyeglo Spirit Tree Ready"],
    [4571, "Spirit Tree Shadow"],
    [4572, "Eyeglo Spirit Tree Look Down"],
    [4573, "Eyeglo Shadow Overlay"],
    [4574, "Eyeglo Map Anim"],
    [4575, "Eyeglo Lightning Strike"],
    [4576, "Eyeglo Spirit Tree Stump Reveal"],
    [4577, "Eyeglo Battle Tortoise Reveal"],
    [4578, "Eyeglo Goblin Scared Run"],
    [4579, "Eyeglo Machine Sabortage"],
    [4580, "Eyeglo Eyeglow Oaknock Hammering Machine"],
    [4581, "Eyeglo Reaching For Machine Controls"],
    [4582, "Eyeglo Glouphrie Expulsion"],
    [4583, "Eyeglo Glouphrie Summon"],
    [4584, "Eyeglo Hazelmere Mind Meld Spot Anim"],
    [4585, "Eyeglo Hazelmere Mind Meld"],
    [4586, "Eyeglo Mind Meld Player"],
    [4587, "Eyeglo Mind Meld Chathead 1"],
    [4588, "Eyeglo Mind Meld Chathead 2"],
    [4589, "Eyeglo Mind Meld Chathead 3"],
    [4590, "Eyeglo Mind Meld Chathead 4"],
    [4591, "Xbows Human Ready"],
    [4592, "Qip Digisite Rockpick Anim"],
    [4593, "Qip Digsite Panning 01"],
    [4594, "Qip Digsite Panning 02"],
    [4595, "Fai Varrock Swing Lantern"],
    [4596, "Qip Ds Silverlight Case Open"],
    [4597, "Demon Silverlight Open"],
    [4598, "Demon Silverlight Take"],
    [4599, "Qip Ds Wardrobe Appear"],
    [4600, "Qip Ds Wardrobe Disappear"],
    [4601, "Qip Ds Bone Magic"],
    [4602, "Qip Ds Bones Wizard Anim"],
    [4603, "Qip Ds Wally Cutscene"],
    [4604, "Qip Ds Recieving Silverlight"],
    [4605, "Qip Ds Recieving Silverlight Spotanim"],
    [4606, "Qip Ds Presenting Silverlight Start"],
    [4607, "Qip Ds Presenting Sword Middle"],
    [4608, "Qip Ds Presenting Sword End"],
    [4609, "Qip Ds Crystalball Leave"],
    [4610, "Qip Ds Crystalball Return"],
    [4611, "Qip Ds Attaining Crystalball Spotanim"],
    [4612, "Qip Ds Returning Crystalball Spotanim"],
    [4613, "Qip Ds Reading Crystalball Spotanim"],
    [4614, "Qip Ds Attaining Crystalball"],
    [4615, "Qip Ds Returning Crystalball"],
    [4616, "Qip Ds Reading Crystalball"],
    [4617, "Qip Ds Dark Wizard Chanting"],
    [4618, "Qip Ds Delrith Struck Down"],
    [4619, "Qip Ds Delrith Weakened Portal"],
    [4620, "Qip Ds Delrith Portal Failed"],
    [4621, "Qip Ds Table Explosion Firstframe"],
    [4622, "Qip Ds Table Explosion"],
    [4623, "Qip Ds Delrith Summoned"],
    [4624, "Qip Ds Delrith Banished"],
    [4625, "Qip Ds Rock Fly"],
    [4626, "Qip Ds Sneaky Walk"],
    [4627, "Fai Varrock Crystalball Anim"],
    [4628, "Fai Varrock Candle Anim"],
    [4629, "Demon Swipe"],
    [4630, "Demon Fireball Cast"],
    [4631, "Demon Fireball Spotanim"],
    [4632, "Monkey Sheep Dismount"],
    [4633, "Dragon Turnleft"],
    [4634, "Dragon Turnright"],
    [4635, "Dragon Walk Kbd"],
    [4636, "Monkey Unicorn Idle"],
    [4637, "Monkey Unicorn Walk"],
    [4638, "Dragon Block Kbd"],
    [4639, "Monkey Unicorn Mount"],
    [4640, "Monkey Unicorn Dismount"],
    [4641, "Monkey Human Mount"],
    [4642, "Dragon Death Elvarg"],
    [4643, "Monkey Human Dismount"],
    [4644, "Demon Attack Greater"],
    [4645, "Harpoonfish Projectile"],
    [4646, "Human Ape Idle"],
    [4647, "Ghost Summon"],
    [4648, "Imp Caught"],
    [4649, "Giant Basic Walk"],
    [4650, "Giant Basic Ready"],
    [4651, "Giant Basic Defend"],
    [4652, "Giant Basic Attack"],
    [4653, "Giant Basic Death"],
    [4654, "Giant Moss Walk"],
    [4655, "Giant Moss Lg Club Walk"],
    [4656, "Giant Moss Ready"],
    [4657, "Giant Moss Defend"],
    [4658, "Giant Moss Attack"],
    [4659, "Giant Moss Death"],
    [4660, "Giant Fire Walk"],
    [4661, "Giant Fire Sword Walk"],
    [4662, "Giant Fire Ready"],
    [4663, "Giant Fire Sword Ready"],
    [4664, "Giant Fire Defend"],
    [4665, "Giant Fire Sword Defend"],
    [4666, "Giant Fire Attack"],
    [4667, "Giant Fire Sword Attack"],
    [4668, "Giant Fire Death"],
    [4669, "Giant Ice Walk"],
    [4670, "Giant Ice Ready"],
    [4671, "Giant Ice Defend"],
    [4672, "Giant Ice Attack"],
    [4673, "Giant Ice Death"],
    [4674, "Demon Walk"],
    [4675, "Demon Ready"],
    [4676, "Demon Defend"],
    [4677, "Demon Death"],
    [4678, "Demon Attack"],
    [4679, "Demon Attack Greater"],
    [4680, "Demon Attack Lesser"],
    [4681, "Demon Appear"],
    [4682, "Human Ape Walk F"],
    [4683, "Myq3 Vampire Flying"],
    [4684, "Myq3 Vampire Flying Head"],
    [4685, "Myq3 Vampire Flying Stab Attack"],
    [4686, "Myq3 Vampire Flying Stab Attack Head"],
    [4687, "Myq3 Vampire Flying Swoop Attack"],
    [4688, "Myq3 Vampire Flying Swoop Attack Head"],
    [4689, "Myq3 Vampire Flying Ready"],
    [4690, "Myq3 Vampire Flying Ready Head"],
    [4691, "Myq3 Vampire Flying Defend"],
    [4692, "Myq3 Vampire Flying Defend Head"],
    [4693, "Myq3 Vampire Flying Defend Variation"],
    [4694, "Myq3 Vampire Flying Defend Variation Head"],
    [4695, "Myq3 Vampire Flying Landing"],
    [4696, "Myq3 Vampire Flying Landing Head"],
    [4697, "Myq3 Vampire Flying Death"],
    [4698, "Myq3 Vampire Flying Death Head"],
    [4699, "Myq3 Vampire Grounded Walk"],
    [4700, "Myq3 Vampire Grounded Female Walk"],
    [4701, "Myq3 Vampire Grounded Attack"],
    [4702, "Myq3 Vampire Grounded Ready Male"],
    [4703, "Myq3 Vampire Grounded Ready Female"],
    [4704, "Myq3 Vampire Grounded Defend Female"],
    [4705, "Myq3 Vampire Grounded Defend Male"],
    [4706, "Myq3 Vampire Grounded Takeoff"],
    [4707, "Myq3 Vampire Head Takeoff"],
    [4708, "Myq3 Vampire Grounded Death"],
    [4709, "Myq3 Mining Wall"],
    [4710, "Myq3 Mining Ready"],
    [4711, "Myq3 Male Juvinate Pouchtray Ready"],
    [4712, "Myq3 Citizen Huddled"],
    [4713, "Myq3 Citizen Look Out"],
    [4714, "Myq3 Vanstrom Klause Punch Kicks"],
    [4715, "Myq3 Vanstrom Klause Kick"],
    [4716, "Myq3 Vanstrom Klause Punches"],
    [4717, "Myq3 Vanstrom Klause Special Punch"],
    [4718, "Myq3 Vanstrom Klause Special Punch Player Knockout"],
    [4719, "Myq3 Vanstrom Klause Player Regaining Conciousness"],
    [4720, "Myq3 Area Sanguine Outer Wall Climb"],
    [4721, "Myq3 Double Square Jump"],
    [4722, "Myq3 Shelf Climb"],
    [4723, "Myq3 Breached Wall Crossing First"],
    [4724, "Myq3 Breached Wall Crossing Second"],
    [4725, "Myq3 Blood Tithe Pouch Eating"],
    [4726, "Myq3 Ready To Crawl Crawl Crawl To Ready"],
    [4727, "Myq3 Outcrop Wall Climb"],
    [4728, "Myq3 Outcrop Wall Slide Down"],
    [4729, "Myq3 Vampire Teleport Spell Casting"],
    [4730, "Myq3 Vampire Teleport Projectile Anim"],
    [4731, "Myq3 Player Teleport Spell"],
    [4732, "Myq3 Vanstrom Klaus Defend From Player"],
    [4733, "Myq3 Human To Vampire Transform Pt1"],
    [4734, "Myq3 Human To Vampire Transform Pt2"],
    [4735, "Myq3 Vanstrom Klaus Defend Shield"],
    [4736, "Myq3 Teleport Spell Casting"],
    [4737, "Myq3 Human To Vampire Transform"],
    [4738, "Myq3 Werewolf Ready"],
    [4739, "Myq3 Werewolf Unconcious Human Ready"],
    [4740, "Myq3 Werewolf Walk"],
    [4741, "Myq3 Werewolf Unconcious Human Walk"],
    [4742, "Myq3 Werewolf Attack"],
    [4743, "Myq3 Ghetto Wall Button Anim"],
    [4744, "Myq3 Agil Pushwall Anim"],
    [4745, "Myq3 Agil Pushwall Flat Anim"],
    [4746, "Myq3 Castle Waste Pipes 1b"],
    [4747, "Myq3 Castle Waste Pipes 2b"],
    [4748, "Myq3 Boat Map 01"],
    [4749, "Myq3 Boat Map 02"],
    [4750, "Myq3 Stamp"],
    [4751, "Emote Air Guitar"],
    [4752, "Air Guitar Spotanim"],
    [4753, "Myq3 Leaves Ready"],
    [4754, "Myq3 Leaves Walk"],
    [4755, "Myq3 Boat Ready"],
    [4756, "Myq3 Boat Walk"],
    [4757, "Sang Repair Boat"],
    [4758, "Sang Crawling Ready"],
    [4759, "Sang Crawling"],
    [4760, "Sang Mining Wall Rune Pickaxe"],
    [4761, "Sang Mining Wall Bronze Pickaxe"],
    [4762, "Sang Mining Wall Iron Pickaxe"],
    [4763, "Sang Mining Wall Steel Pickaxe"],
    [4764, "Sang Mining Wall Adamant Pickaxe"],
    [4765, "Sang Mining Wall Mithril Pickaxe"],
    [4766, "Sang Mining Wall Dragon Pickaxe"],
    [4767, "Myq3 Juvinate Juvenile Holding Capture Start"],
    [4768, "Myq3 Juvinate Juvenile Holding Capture Loop"],
    [4769, "Myq3 Juvinate Juvenile Dust Start"],
    [4770, "Myq3 Neck Bite"],
    [4771, "Myq3 Human Neck Bitten"],
    [4772, "Myq3 Human Tightrope"],
    [4773, "Straydog Walk"],
    [4774, "Straydog Defend"],
    [4775, "Straydog Death"],
    [4776, "Straydog Attack"],
    [4777, "Straydog Ready"],
    [4778, "Varrock Washing Line"],
    [4779, "Slug2 Walk Stage One"],
    [4780, "Slug2 Human Rocking"],
    [4781, "Slug2 Bobbing"],
    [4782, "Slug2 Church Light Anim"],
    [4783, "Slug2 Cave Torch Flame"],
    [4784, "Hobgoblin Spear Attack"],
    [4785, "Seaslug Falling"],
    [4786, "Seaslug Boat Repair"],
    [4787, "Seaslug Water In"],
    [4788, "Seaslug Water Ready"],
    [4789, "Seaslug Ken Leap"],
    [4790, "Seaslug Water Out"],
    [4791, "Seaslug Torch Possessed"],
    [4792, "Seaslug Torch Possessed Spotanim"],
    [4793, "Seaslug Torch Slug"],
    [4794, "Seaslug Torch Slug Spotanim"],
    [4795, "Seaslug Controls Right"],
    [4796, "Seaslug Crane Right"],
    [4797, "Seaslug Controls Left"],
    [4798, "Seaslug Crane Left"],
    [4799, "Seaslug Fishing Platform To Witchaven"],
    [4800, "Seaslug Fishing Platform To Island"],
    [4801, "Seaslug Island To Fishing Platform"],
    [4802, "Seaslug Witchaven To Fishing Platform"],
    [4803, "Seaslug Witchhaven To Isle"],
    [4804, "Seaslug Human Kick"],
    [4805, "Seaslug Ready To Crawl Crawl Crawl To Ready"],
    [4806, "Seaslug Human Waving"],
    [4807, "Seaslug Grab N Destroy"],
    [4808, "Seaslug Squashed Spotanim"],
    [4809, "Seaslug Player Drying Sticks"],
    [4810, "Seaslug Twigs N Glass"],
    [4811, "Slug2 Page North"],
    [4812, "Slug2 Page East"],
    [4813, "Slug2 Page South"],
    [4814, "Slug2 Page West"],
    [4815, "Slug2 Page North Fliped"],
    [4816, "Slug2 Page East Fliped"],
    [4817, "Slug2 Page South Fliped"],
    [4818, "Slug2 Page West Fliped"],
    [4819, "Slug2 Queen Ready"],
    [4820, "Slug2 Slug Queen Walk"],
    [4821, "Slug2 Prince Walking"],
    [4822, "Slug2 Cave Door Open"],
    [4823, "Slug2 Cave Door Close"],
    [4824, "Slug2 Walk Stage Two"],
    [4825, "Slug2 Ready Stage One"],
    [4826, "Slug2 Human Blob Stuck"],
    [4827, "Slug2 Blob Spot"],
    [4828, "Slug2 Prince Ready"],
    [4829, "Slug2 Prince Attack"],
    [4830, "Slug2 Prince Death"],
    [4831, "Slug2 Prince Defend"],
    [4832, "Slug2 Prince Blow"],
    [4833, "Slug2 Goop Travel"],
    [4834, "Slug2 Human Handing Over"],
    [4835, "Slug2 Human Stumble Back"],
    [4836, "Slug2 Smoke Anim"],
    [4837, "Slug2 Door Fx"],
    [4838, "Slug2 Sir Tiffy Drink Tea"],
    [4839, "Slug2 Crystal Ball Scan"],
    [4840, "Slug2 Crystal Ball Scan Spot"],
    [4841, "Slug2 Death Blow"],
    [4842, "Slug2 Queen Ready 2 Attack"],
    [4843, "Lore Lizard Chat Happy"],
    [4844, "Lore Lizard Chat Sad"],
    [4845, "Lore Lizard Chat Quizzical"],
    [4846, "Lore Lizard Chat Idle"],
    [4847, "Aide Drawing Chalk Circle"],
    [4848, "Aide Chalk Circle"],
    [4849, "Aide Chalk Circle 2"],
    [4850, "Aide Sitting Down Crosslegged"],
    [4851, "Aide Sitting Crosslegged Ready"],
    [4852, "Aide Standing Up"],
    [4853, "Aide Player Getting Book"],
    [4854, "Aide Player Book Get"],
    [4855, "Aide Reciting Incantation"],
    [4856, "Aide Player Book Portal"],
    [4857, "Aide Player Teleporting"],
    [4858, "Aide Player Portal"],
    [4859, "Glassblowing Ready"],
    [4860, "Elem1 Qip Furnace Glow"],
    [4861, "Elem1 Qip Turn Valve"],
    [4862, "Elem1 Qip Fill Bowl"],
    [4863, "Elem1 Qip Bellow Repair"],
    [4864, "Earth Elemental Rework Ready Rock"],
    [4865, "Earth Elemental Rework Emerge"],
    [4866, "Earth Elemental Rework Ready"],
    [4867, "Earth Elemental Rework Walk"],
    [4868, "Earth Elemental Rework Attack"],
    [4869, "Earth Elemental Rework Defend"],
    [4870, "Earth Elemental Rework Death"],
    [4871, "Elem Waterwall Door Opening No Cart Top"],
    [4872, "Elem Waterwall Door Closing No Cart Top"],
    [4873, "Elem Waterwall Loading Arms Emerging No Cart Top"],
    [4874, "Elem Waterwall Loading Arms Retreating No Cart Top"],
    [4875, "Elem Waterwall Door Opening Cart Top"],
    [4876, "Elem Waterwall Door Closing Cart Top"],
    [4877, "Elem Waterwall Cart Top Emerging Cart Top"],
    [4878, "Elem Waterwall Cart Top Retreating Cart Top"],
    [4879, "Elem2 Door Open Hold Frame"],
    [4880, "Elem2 Door Open Extended Hold Frame"],
    [4881, "Elem2 Door Closed Retreated Frame"],
    [4882, "Elem2 Extractor Hat Lever Pull Onto Head"],
    [4883, "Elem2 Extractor Hat Ready"],
    [4884, "Elem2 Extractor Chair Whole Anim"],
    [4885, "Elem2 Extractor Chair Player Electrocution"],
    [4886, "Elem2 Extractor Chair Skeleton Electrocution"],
    [4887, "Elem2 Up To Down Overtrack"],
    [4888, "Elem2 Down To Up Overtrack"],
    [4889, "Elem2 Up To Down Overlava"],
    [4890, "Elem2 Down To Up Overlava"],
    [4891, "Elem2 Rotate From Overlava To Overtrack"],
    [4892, "Elem2 Rotate From Overtrack To Overlava"],
    [4893, "Elem2 Elem Helm Equip Spot"],
    [4894, "Elem Presssupport"],
    [4895, "Elem2 Watertank Ready"],
    [4896, "Elem2 Wind Cogs"],
    [4897, "Elem Extractor Gun"],
    [4898, "Elem Windtunnel Fanblade Reverse"],
    [4899, "Elem Extractor Base"],
    [4900, "Elem Extractor Gun Ready"],
    [4901, "Elem Windtunnel Dial Wall"],
    [4902, "Elem2 Watertank Fill"],
    [4903, "Elem2 Watertank Empty"],
    [4904, "Elem2 Lever 3way Right"],
    [4905, "Human Elem2 Corkscrew"],
    [4906, "Elem2 Wind Cogs Reverse"],
    [4907, "Elem2 Wind Cogs Stop"],
    [4908, "Elem Press Hammer"],
    [4909, "Human Elem2 Lever 3way Right"],
    [4910, "Elem2 Lever 3way Left"],
    [4911, "Human Elem2 Lever 3way Left"],
    [4912, "Elem2 Corkscrew"],
    [4913, "Bat Rework Flying"],
    [4914, "Bat Rework Ready"],
    [4915, "Bat Rework Attack"],
    [4916, "Bat Rework Defend"],
    [4917, "Bat Rework Death"],
    [4918, "Bat Rework Death Small"],
    [4919, "Bear Rework Ready"],
    [4920, "Bear Rework Cub Ready"],
    [4921, "Bear Rework Ready Grizzly"],
    [4922, "Bear Rework Ready Cub Grizzly"],
    [4923, "Bear Rework Walk"],
    [4924, "Bear Rework Cub Walk"],
    [4925, "Bear Rework Attack"],
    [4926, "Bear Rework Cub Attack"],
    [4927, "Bear Rework Defend"],
    [4928, "Bear Rework Cub Defend"],
    [4929, "Bear Rework Death"],
    [4930, "Bear Rework Cub Death"],
    [4931, "Giant Rat Walk"],
    [4932, "Giant Rat Ready"],
    [4933, "Giant Rat Attack"],
    [4934, "Giant Rat Defend"],
    [4935, "Giant Rat Death"],
    [4936, "Desert Goat Attack"],
    [4937, "Skillcapes Player Fletching Bow"],
    [4938, "Skillcapes Fletching Bow Spotanim"],
    [4939, "Skillcapes Player Magic"],
    [4940, "Skillcapes Magic Spotanim"],
    [4941, "Skillcapes Player Mining"],
    [4942, "Skillcapes Mining Spotanim"],
    [4943, "Skillcapes Player Smithing"],
    [4944, "Skillcapes Smithing Spotanim"],
    [4945, "Skillcapes Player Quest Cape"],
    [4946, "Skillcapes Quest Cape Spotanim"],
    [4947, "Skillcapes Player Runecrafting"],
    [4948, "Skillcapes Runecrafting Spotanim"],
    [4949, "Skillcapes Crafting Player Anim"],
    [4950, "Skillcapes Crafting Spotanim"],
    [4951, "Skillcapes Fishing Player Anim"],
    [4952, "Skillcapes Fishing Spotanim"],
    [4953, "Skillcapes Construction Player Anim"],
    [4954, "Skillcapes Construction Spotanim"],
    [4955, "Skillcapes Cooking Player Anim"],
    [4956, "Skillcapes Cooking Spotanim"],
    [4957, "Skillcapes Woodcutting Player Anim"],
    [4958, "Skillcapes Woodcutting Spotanim"],
    [4959, "Skill Cape Attack"],
    [4960, "Skill Cape Attack Spotanim"],
    [4961, "Skill Cape Defend"],
    [4962, "Skillcape Defend Spotanim"],
    [4963, "Skillcape Farming"],
    [4964, "Skillcape Farming Spotanim"],
    [4965, "Skill Cape Thieving"],
    [4966, "Skill Cape Thieving Spotanim"],
    [4967, "Skill Cape Slayer"],
    [4968, "Skill Cape Slayer Spotanim"],
    [4969, "Skillcapes Human Herblore"],
    [4970, "Skillcapes Spot Herblore"],
    [4971, "Skillcapes Human Hitpoints"],
    [4972, "Skillcapes Spot Hitpoints"],
    [4973, "Skillcapes Human Range"],
    [4974, "Skillcapes Spot Range"],
    [4975, "Skillcapes Human Firemaking"],
    [4976, "Skillcapes Spot Firemaking"],
    [4977, "Skillcapes Human Agility"],
    [4978, "Skillcapes Spot Agility"],
    [4979, "Skillcapes Human Prayer"],
    [4980, "Skillcapes Spot Prayer"],
    [4981, "Skillcapes Human Strength"],
    [4982, "Skillcapes Spot Strength"],
    [4983, "Myarm Troll Cry"],
    [4984, "Myarm Tears"],
    [4985, "Myarm Troll Eating"],
    [4986, "Myarm Troll Ready"],
    [4987, "Myarm Troll Attack"],
    [4988, "Myarm Troll Defend"],
    [4989, "Myarm Troll Death"],
    [4990, "Myarm Troll Running"],
    [4991, "Myarm Troll Jumping"],
    [4992, "Myarm Troll Picking Herbs"],
    [4993, "Myarm Troll Planting Seeds"],
    [4994, "Myarm Troll Pouring Bucket"],
    [4995, "Myarm Troll Receiving Vile"],
    [4996, "Myarm Troll Pouring Vile"],
    [4997, "Myarm Vile Returning"],
    [4998, "Myarm Troll Breaking Rake"],
    [4999, "Myarm Troll Give Rake"],
    [5000, "Myarm Troll Poking Farming Patch"],
    [5001, "Myarm Troll Raking"],
    [5002, "Myarm Sunbather Sipping Ready"],
    [5003, "Myarm Rake End"],
    [5004, "Myarm Compost"],
    [5005, "Myarm Players Vile"],
    [5006, "Myarm Human Players Vile"],
    [5007, "Myarm Troll Vile"],
    [5008, "Myarm Vile Pouring"],
    [5009, "Myarm Vile Return Spot"],
    [5010, "Myarm Rake Break Spot"],
    [5011, "Myarm Rake Return"],
    [5012, "Myarm Dolphin Jump"],
    [5013, "Myarm Bush Shake"],
    [5014, "Myarm Bucket"],
    [5015, "Myarm Human Bucket"],
    [5016, "Myarm Rock Throw01"],
    [5017, "Myarm Rock Launch01"],
    [5018, "Myarm Leprechaun Scared01"],
    [5019, "Myarm Dwarfgethit01"],
    [5020, "Myarm Dwarfroll01"],
    [5021, "Myarm Roc Ready"],
    [5022, "Myarm Roc Walk"],
    [5023, "Myarm Roc Flap Attack"],
    [5024, "Myarm Roc Peck Attack"],
    [5025, "Myarm Roc Rock Attack"],
    [5026, "Myarm Roc Defend"],
    [5027, "Myarm Roc Death"],
    [5028, "Myarm Roc Entrance"],
    [5029, "Myarm Roc Baby Ready"],
    [5030, "Myarm Roc Baby Walk"],
    [5031, "Myarm Roc Baby Attack"],
    [5032, "Myarm Baby Roc Defend"],
    [5033, "Myarm Roc Baby Death"],
    [5034, "Myarm Rock Break Spot"],
    [5035, "Myarm Rock Travel"],
    [5036, "Myarm Roc Rock Lift"],
    [5037, "Tourtrap Qip Bend Bars"],
    [5038, "Tourtrap Qip Escape Through Bars"],
    [5039, "Tourtrap Qip Climb Cliff Pt1"],
    [5040, "Tourtrap Qip Cliff Drop Pt1"],
    [5041, "Tourtrap Qip Scrabble Success"],
    [5042, "Tourtrap Qip Scrabble Fail Part1"],
    [5043, "Tourtrap Qip Climb Cliff Fail Pt1"],
    [5044, "Tourtrap Qip Camel Ready"],
    [5045, "Tourtrap Qip Camel Graze"],
    [5046, "Tourtrap Qip Cart Failure A"],
    [5047, "Tourtrap Qip Cart Failure B"],
    [5048, "Tourtrap Qip Cart Failure C"],
    [5049, "Tourtrap Qip Cart Success"],
    [5050, "Tourtrap Qip Loading Barrel A"],
    [5051, "Tourtrap Qip Loading Barrel B"],
    [5052, "Tourtrap Qip Loading Barrel C"],
    [5053, "Tourtrap Qip Winching Machine"],
    [5054, "Tourtrap Qip Human Winching"],
    [5055, "Quest Tourtrap Qip Cactus Animation"],
    [5056, "Tourtrap Qip Get Up Dust Off"],
    [5057, "Shove 1h"],
    [5058, "Gub Tree Sparkle"],
    [5059, "Gub Reindeer Emote"],
    [5060, "Gub Nose Glow Anim"],
    [5061, "Snakeboss Blowpipe Attack"],
    [5062, "Gub Snow Fall"],
    [5063, "Gub Xmas Human Snowball Throw"],
    [5064, "Gub Xmas Human Snowball Throw Spot"],
    [5065, "Gub Xmas Human Snowball Throw Projectile Anim"],
    [5066, "Gub Xmas Human Snowball Impact"],
    [5067, "Gub Xmas Human Snowball Making"],
    [5068, "Snakeboss Attack Acidx3"],
    [5069, "Snakeboss Attack Acidx1"],
    [5070, "Snakeboss Idle"],
    [5071, "Snakeboss Spawn"],
    [5072, "Snakeboss Sinkfast"],
    [5073, "Snakeboss Emergefast"],
    [5074, "Barbassault Turret Top Ready"],
    [5075, "Barbassault Turret Top Attack"],
    [5076, "Barbassault Trap Attack"],
    [5077, "Barbassault Trapdoor"],
    [5078, "Barbassault Trapdoor Winch"],
    [5079, "Barbassault Turret Interact"],
    [5080, "Barbassault Stomp Egg"],
    [5081, "Barbassault Turret Ready"],
    [5082, "Barbassault Penance Queen Ready"],
    [5083, "Barbassault Penance Queen Defend"],
    [5084, "Barbassault Penance Queen Attack"],
    [5085, "Barbassault Penance Queen Rangeattack"],
    [5086, "Barbassault Penance Queen Walk"],
    [5087, "Barbassault Penance Queen Death"],
    [5088, "Barbassault Penance Queen Trapdoor"],
    [5089, "Barbassault Penance Queen Spawn Walk"],
    [5090, "Barbassault Penance Queen Spawn Ready"],
    [5091, "Barbassault Penance Queen Spawn Defend"],
    [5092, "Barbassault Penance Queen Spawn Attack"],
    [5093, "Barbassault Penance Queen Spawn Death"],
    [5094, "Barbassault Penance Fighter Ready"],
    [5095, "Barbassault Penance Fighter Walk"],
    [5096, "Barbassault Penance Fighter Defend"],
    [5097, "Barbassault Penance Fighter Attack"],
    [5098, "Barbassault Penance Fighter Death"],
    [5099, "Barbassault Penance Runner Ready"],
    [5100, "Barbassault Penance Runner Walk"],
    [5101, "Barbassault Penance Runner Defend"],
    [5102, "Barbassault Penance Runner Death"],
    [5103, "Barbassault Penance Runner Eating"],
    [5104, "Barbassault Penance Healer Ready"],
    [5105, "Barbassault Penance Healer Defend"],
    [5106, "Barbassault Penance Healer Death"],
    [5107, "Barbassault Penance Healer Walk"],
    [5108, "Human Harpoon Barbed"],
    [5109, "Zep Basket Crashed"],
    [5110, "Zep Balloon Journey Entrana Taverley"],
    [5111, "Zep Balloon Journey Taverley Entrana"],
    [5112, "Zep Balloon Journey Entrana Crafting"],
    [5113, "Zep Balloon Journey Crafting Entrana"],
    [5114, "Zep Balloon Journey Entrana Varrock"],
    [5115, "Zep Balloon Journey Varrock Entrana"],
    [5116, "Zep Balloon Journey Entrana Grandtree"],
    [5117, "Zep Balloon Journey Grandtree Entrana"],
    [5118, "Zep Balloon Journey Entrana Castlewars"],
    [5119, "Zep Balloon Journey Castlewars Entrana"],
    [5120, "Zep Balloon Journey Varrock Crafting"],
    [5121, "Zep Balloon Journey Crafting Varrock"],
    [5122, "Zep Balloon Journey Varrock Taverley"],
    [5123, "Zep Balloon Journey Taverley Varrock"],
    [5124, "Zep Balloon Journey Taverley Crafting"],
    [5125, "Zep Balloon Journey Crafting Taverley"],
    [5126, "Zep Balloon Journey Taverley Castlewars"],
    [5127, "Zep Balloon Journey Castlewars Taverley"],
    [5128, "Zep Balloon Journey Crafting Castlewars"],
    [5129, "Zep Balloon Journey Castlewars Crafting"],
    [5130, "Zep Balloon Journey Varrock Castlewars"],
    [5131, "Zep Balloon Journey Castlewars Varrock"],
    [5132, "Zep Balloon Journey Grandtree Castlewars"],
    [5133, "Zep Balloon Journey Castlewars Grandtree"],
    [5134, "Zep Balloon Journey Grandtree Crafting"],
    [5135, "Zep Balloon Journey Crafting Grandtree"],
    [5136, "Zep Balloon Journey Taverley Grandtree"],
    [5137, "Zep Balloon Journey Grandtree Taverley"],
    [5138, "Zep Balloon Journey Varrock Grandtree"],
    [5139, "Zep Balloon Journey Grandtree Varrock"],
    [5140, "Zep Making Balloon"],
    [5141, "Zep Balloon Ready"],
    [5142, "Zep Set Off Balloon"],
    [5143, "Zep Test Balloon Setoff"],
    [5144, "Zep Test Balloon Projectile"],
    [5145, "Zep Test Balloon On Fire"],
    [5146, "Zep Peasant Ready1"],
    [5147, "Zep Peasant Ready2"],
    [5148, "Zep Peasant Ready3"],
    [5149, "Zep Peasant Ready4"],
    [5150, "Zep Peasant Walk1"],
    [5151, "Zep Peasant Walk2"],
    [5152, "Zep Peasant Walk3"],
    [5153, "Zep Peasant Walk4"],
    [5154, "Zep Shark Attack"],
    [5155, "Zep Fill Sandbag"],
    [5156, "Zep 2nd Test Balloon On Fire"],
    [5157, "Zep Waterfall"],
    [5158, "Skillcapes Human Hunting"],
    [5159, "Skillcapes Spot Hunting"],
    [5160, "Human Falconer Ready"],
    [5161, "Human Falconer Turnonspot"],
    [5162, "Human Falconer Attack"],
    [5163, "Human Falconer Defend"],
    [5164, "Human Falconer Walk F"],
    [5165, "Human Falconer Walk B"],
    [5166, "Human Falconer Walk L"],
    [5167, "Human Falconer Walk R"],
    [5168, "Human Falconer Run"],
    [5169, "Hunting Ojibway Fail"],
    [5170, "Hunting Ojibway Failed"],
    [5171, "Bird Landontrap"],
    [5172, "Bird Leavetrap"],
    [5173, "Bird Caughtintrap"],
    [5174, "Bird Caughtintrap Ready"],
    [5175, "Boxtrap Catching"],
    [5176, "Boxtrap Catching East"],
    [5177, "Boxtrap Catching South"],
    [5178, "Boxtrap Catching West"],
    [5179, "Boxtrap Ready"],
    [5180, "Boxtrap Failed"],
    [5181, "Hunting Chinchompa Walking"],
    [5182, "Hunting Chinchompa Ready"],
    [5183, "Hunting Chinchompa Death"],
    [5184, "Hunting Chinchompa Approaching"],
    [5185, "Hunting Chinchompa Backoff"],
    [5186, "Chinchompa Flailing Death"],
    [5187, "Ferret Walk"],
    [5188, "Ferret Ready"],
    [5189, "Ferret Attack"],
    [5190, "Ferret Death"],
    [5191, "Hunting Ferret Approaching"],
    [5192, "Hunting Ferret Backoff"],
    [5193, "Deadfall Empty"],
    [5194, "Deadfall Failing"],
    [5195, "Deadfall Catching"],
    [5196, "Deadfall Catching South"],
    [5197, "Deadfall Full"],
    [5198, "Falcon Launch"],
    [5199, "Falcon Travel"],
    [5200, "Falcon Hit"],
    [5201, "Falcon Hit Post"],
    [5202, "Falcon On Prey"],
    [5203, "Falcon Ready"],
    [5204, "Hunting Speedybeast Invisible"],
    [5205, "Small Smokecloud"],
    [5206, "Human Priority Stumble Back"],
    [5207, "Human Hunting Dismantle Net"],
    [5208, "Human Laytrap"],
    [5209, "Human Butterflynet Swing"],
    [5210, "Swing Lasso"],
    [5211, "Hang On Lasso"],
    [5212, "Hunting Setting Trap Small"],
    [5213, "Hunting Opening Butterfly Jar"],
    [5214, "Hunting Butterfly Out Jar"],
    [5215, "Hunting Setting Sapling Trap"],
    [5216, "Hunting Searching Bushes"],
    [5217, "Hunting Baiting Small Traps"],
    [5218, "Hunting Imp Caught"],
    [5219, "Hunting Imp Static"],
    [5220, "Hunting Imp Waiting To Trap"],
    [5221, "Hunting Imp Caught In Trap"],
    [5222, "Hunting Imp Trapped"],
    [5223, "Hunting Pitfall Collapse"],
    [5224, "Hunting Pitfall Collapsed"],
    [5225, "Hunter Big Cat Ready"],
    [5226, "Hunter Big Cat Walk"],
    [5227, "Hunter Big Cat Defend"],
    [5228, "Hunter Big Cat Bite"],
    [5229, "Hunter Big Cat Butt"],
    [5230, "Hunter Big Cat Death"],
    [5231, "Hunter Bigcat Leap Npc"],
    [5232, "Hunter Bigcat Leap Proj1"],
    [5233, "Hunter Bigcat Leap Proj2"],
    [5234, "Hunter Bigcat Fall In Pit"],
    [5235, "Hunter Bigcat Dead"],
    [5236, "Hunting Teasing Animal"],
    [5237, "Hunting Snare Falls"],
    [5238, "Rabbit Caughtintrap"],
    [5239, "Rabbit Caughtintrap Ready"],
    [5240, "Hunting Snare Capture Rabbit0"],
    [5241, "Hunting Snare Capture Rabbit1"],
    [5242, "Hunting Snare Capture Rabbit2"],
    [5243, "Human Crafting Spikedvambraces"],
    [5244, "Human Fletching Huntingbolts"],
    [5245, "Human Walkforward Salamander"],
    [5246, "Human Ready Salamander"],
    [5247, "Human Attack Salamander"],
    [5248, "Human Walkother Salamander"],
    [5249, "Human Salamander Tar Grind"],
    [5250, "Hunting Noose Walk F"],
    [5251, "Hunting Noose Walk B"],
    [5252, "Hunting Noose Turnonspot"],
    [5253, "Hunting Noose Run"],
    [5254, "Hunting Noose Ready"],
    [5255, "Hunting Noose Catch"],
    [5256, "Hunting Noose Polar"],
    [5257, "Hunting Noose Desert"],
    [5258, "Hunting Noose Jungle"],
    [5259, "Hunting Noose Wood"],
    [5260, "Hunting Footprints Fade In"],
    [5261, "Hunting Footprints Fade Away"],
    [5262, "Salamander Walk"],
    [5263, "Salamander Ready"],
    [5264, "Firebreath"],
    [5265, "Explode"],
    [5266, "Hunting Sapling Setting"],
    [5267, "Hunting Sapling Set"],
    [5268, "Hunting Sapling Catching"],
    [5269, "Hunting Sapling Full"],
    [5270, "Hunting Sapling Failing"],
    [5271, "Hunting Sapling Failed"],
    [5272, "Huntingbeast Walk"],
    [5273, "Huntingbeast Ready"],
    [5274, "Huntingbeast Proj"],
    [5275, "Huntingbeast Approach"],
    [5276, "Huntingbeast Missingloc"],
    [5277, "Huntingbeast Backoff"],
    [5278, "Iceberg Moves"],
    [5279, "Giant Eagle Walk"],
    [5280, "Giant Eagle Ready"],
    [5281, "Giant Eagle Attack"],
    [5282, "Giant Eagle Death"],
    [5283, "Dragon Claws"],
    [5284, "Cockatiel Walk"],
    [5285, "Imp Champion Attack"],
    [5286, "Hunter Xbow Launch"],
    [5287, "Eaglepeak Mechbird Start"],
    [5288, "Eaglepeak Mechbird Travel"],
    [5289, "Eaglepeak Mecheagle Displaced Ne"],
    [5290, "Eaglepeak Mecheagle Displaced Sw"],
    [5291, "Eaglepeak Mecheagle Displaced Ne180"],
    [5292, "Eaglepeak Mecheagle Displaced Sw180"],
    [5293, "Eaglepeak Stumbleback"],
    [5294, "Uber Kebbit Ready Spotanim"],
    [5295, "Eaglepeak Net Trap"],
    [5296, "Eaglepeak Net Trap Trigger"],
    [5297, "Eaglepeak Net Trap Drop"],
    [5298, "Eaglepeak Stumble Fall"],
    [5299, "Eaglepeak Winch"],
    [5300, "Eaglepeak Feeder"],
    [5301, "Uber Kebbit Walk"],
    [5302, "Uber Kebbit Ready"],
    [5303, "Uber Kebbit Death"],
    [5304, "Uber Kebbit Attack"],
    [5305, "Uber Kebbit Defend"],
    [5306, "Birdfeeder Full"],
    [5307, "Birdfeeder Emptying"],
    [5308, "Birdfeeder Empty"],
    [5309, "Eaglepeak Desert Boulder Roll"],
    [5310, "Eaglepeak Desert Boulder Ready"],
    [5311, "Eaglepeak Desert Boulder Push"],
    [5312, "Trail Bow Emote"],
    [5313, "Trail Yawn Emote"],
    [5314, "Trail Yawn Emote Spotanim"],
    [5315, "Trail Angry Emote"],
    [5316, "Trail Dance Emote"],
    [5317, "Spider Walk Large"],
    [5318, "Spider Ready Large"],
    [5319, "Spider Attack Large"],
    [5320, "Spider Defend Large"],
    [5321, "Spider Death Large"],
    [5322, "Spider Casting Large"],
    [5323, "Spider Teleport Large"],
    [5324, "Spider Teleport Large Reverse"],
    [5325, "Spider Walk"],
    [5326, "Spider Ready"],
    [5327, "Spider Attack"],
    [5328, "Spider Defend"],
    [5329, "Spider Death"],
    [5330, "Spider Casting"],
    [5331, "Spider Teleport"],
    [5332, "Spider Teleport Reverse"],
    [5333, "Spider Tbw Bush Attack"],
    [5334, "Sheep Walk"],
    [5335, "Sheep Ready"],
    [5336, "Sheep Death"],
    [5337, "Sheep Defend"],
    [5338, "Sheep Attack"],
    [5339, "Goat Ready"],
    [5340, "Goat Walk"],
    [5341, "Goat Attack"],
    [5342, "Goat Defend"],
    [5343, "Goat Death"],
    [5344, "Sheep Shaggy Walk"],
    [5345, "Sheep Shaggy Ready"],
    [5346, "Sheep Shaggy Defend"],
    [5347, "Golem Ranged Attack"],
    [5348, "Golem Rock Projectile Spotanim"],
    [5349, "Hunting Noose Razorback"],
    [5350, "Qip Watchtower Crystal Glow"],
    [5351, "Qip Watchtower Machine Ready"],
    [5352, "Qip Watchtower Wizard Relic"],
    [5353, "Qip Watchtower Wizard Relic Spotanim"],
    [5354, "Qip Watchtower Read Scroll"],
    [5355, "Qip Watchtower Double Square Jump"],
    [5356, "Qip Watchtower Skavid Hit By Ogre"],
    [5357, "Qip Watchtower Ogre Spellcasting"],
    [5358, "Qip Watchtower Ogre Spell Travel"],
    [5359, "Qip Watchtower Ogre Spell Impact"],
    [5360, "Qip Watchtower Shaman Melting"],
    [5361, "Qip Watchtower Pour Vial"],
    [5362, "Qip Watchtower Getup"],
    [5363, "Anma Human Ready Sack"],
    [5364, "Anma Human Walk Sack"],
    [5365, "Anma Hammer Iron"],
    [5366, "Sire Right Hook"],
    [5367, "Sire Attack Miasma Two"],
    [5368, "Sire Attack Teleport Player"],
    [5369, "Sire Attack Right Whip"],
    [5370, "Anma Ghost Ready"],
    [5371, "Anma Ghost Ready Sack Empty"],
    [5372, "Anma Ghost Walk"],
    [5373, "Anma Ghost Walk Sack Empty"],
    [5374, "Anma Ghost Ready Sack Full"],
    [5375, "Anma Ghost Walk Sack Full"],
    [5376, "Anma Ghost Grab Chicken"],
    [5377, "Anma Ghost Chase Chicken"],
    [5378, "Anma Ghost Confused"],
    [5379, "Anma Wear Amulet"],
    [5380, "Anma Chicken Evade"],
    [5381, "Anma Chicken Grab Spotanim"],
    [5382, "Anma Wear Amulet Spotanim"],
    [5383, "Human Woodcutting Blessed Axe"],
    [5384, "Human Woodcutting Blessed Axe Miss"],
    [5385, "Lore Chicken Walk"],
    [5386, "Lore Chicken Ready"],
    [5387, "Lore Chicken Attack"],
    [5388, "Lore Chicken Defend"],
    [5389, "Lore Chicken Death"],
    [5390, "Barbassault Penance Healer Poision"],
    [5391, "Barbassault Penance Healer Heal"],
    [5392, "Barbassault Penance Healer Cloud"],
    [5393, "Barbassault Penance Ranger Ready"],
    [5394, "Barbassault Penance Ranger Walk"],
    [5395, "Barbassault Penance Ranger Defend"],
    [5396, "Barbassault Penance Ranger Attack"],
    [5397, "Barbassault Penance Ranger Death"],
    [5398, "Barbassault Penance Ranger Attack Spotanim Travel"],
    [5399, "Barbassault Penance Ranger Attack Spotanim Impact"],
    [5400, "Barbassault Vial Scoop"],
    [5401, "Barbassault Egg Poision"],
    [5402, "Barbassault Egg Stun"],
    [5403, "Barbassault Penance Queen Range Attack Casting"],
    [5404, "Barbassault Penance Queen Range Attack Travel"],
    [5405, "Barbassault Penance Queen Range Attack Impact"],
    [5406, "Barbassault Egg Stomp Splat"],
    [5407, "Barbassault Drink From Spring"],
    [5408, "Barbassault Penance Queen New Defend"],
    [5409, "Barbassault Penance Queen New Walk"],
    [5410, "Barbassault Penacne Queen New Ready"],
    [5411, "Barbassault Penacne Queen New Attack"],
    [5412, "Barbassault Penacne Queen New Death"],
    [5413, "Barbassault Penacne Queen New Attack Ranged"],
    [5414, "Barbassault Queen New Trapdoor"],
    [5415, "Barbassault Crater Bubbles"],
    [5416, "Barbassault Trap Door Build"],
    [5417, "Barbassault Cave Barricade Build"],
    [5418, "Barbassault Cave Barricade Smash"],
    [5419, "Barbassault Player Vending Arm Pull"],
    [5420, "Barbassault Loc Vending Arm Pull"],
    [5421, "Barbassault Healer Interface Medic Flash"],
    [5422, "Barbassault Explosive Egg Blast"],
    [5423, "Barbassault Horn"],
    [5424, "Barbassault Egg Cannon Ready"],
    [5425, "Barbassault Egg Cannon Ready N"],
    [5426, "Barbassault Egg Cannon Fire"],
    [5427, "Barbassault Egg Cannon Fire N"],
    [5428, "Barbassault Egg Cannon Human Fire"],
    [5429, "Barbassault Egg Base Ready"],
    [5430, "Barbassault Egg Base Ready N"],
    [5431, "Barbassault Egg Box Ready"],
    [5432, "Barbassault Egg Box Ready N"],
    [5433, "Barbassault Atomic Blast"],
    [5434, "Barbassault Atomic Spike"],
    [5435, "Barbassault Egg Projectile"],
    [5436, "Barbassault Human Use Horn"],
    [5437, "Barbassault Stunned Anim"],
    [5438, "Anma Human Walk Sack B"],
    [5439, "Anma Human Sack Attack"],
    [5440, "Anma Human Sack Kick"],
    [5441, "Anma Human Sack Block"],
    [5442, "Contact Extinguish Light"],
    [5443, "Contact Offensive Spell"],
    [5444, "Contact Summon Swarm"],
    [5445, "Contact Locust Spawn Fade"],
    [5446, "Contact Locust Walk"],
    [5447, "Contact Locust Ready"],
    [5448, "Contact Locust Defend"],
    [5449, "Contact Locust Death"],
    [5450, "Contact Locust Lance Attack"],
    [5451, "Contact Locust Bow Attack"],
    [5452, "Contact Boss Spawn"],
    [5453, "Contact Boss Spawn Rev"],
    [5454, "Contact Boss Walk"],
    [5455, "Contact Boss Ready"],
    [5456, "Contact Boss Death"],
    [5457, "Contact Boss Attack"],
    [5458, "Contact Boss Defend"],
    [5459, "Contact Darkning"],
    [5460, "Contact Offensive"],
    [5461, "Contact Offensive Impact"],
    [5462, "Contact Offensive Travel"],
    [5463, "Contact Summon"],
    [5464, "Scarab Spiral Rev"],
    [5465, "Contact Spawn Front"],
    [5466, "Contact Spawn Front Rev"],
    [5467, "Contact Spawn Centre"],
    [5468, "Contact Spawn Centre Rev"],
    [5469, "Contact Spawn Rear"],
    [5470, "Contact Spawn Rear Rev"],
    [5471, "Osman Limp Forward"],
    [5472, "Osman Limp Backward"],
    [5473, "Osman Limp Left"],
    [5474, "Osman Limp Right"],
    [5475, "Osman Ready Limp"],
    [5476, "Contact Fall"],
    [5477, "Barrows Repeating Crossbow Fire Spot"],
    [5478, "Ghost Summon2"],
    [5479, "Skeleton Walk"],
    [5480, "Skeleton Walk Transparent"],
    [5481, "Skeleton Walk Shield"],
    [5482, "Skeleton Walk Shield Transparent"],
    [5483, "Skeleton Ready"],
    [5484, "Skeleton Ready Transparent"],
    [5485, "Skeleton Attack Weapon"],
    [5486, "Skeleton Attack Weapon Transparent"],
    [5487, "Skeleton Attack Sword"],
    [5488, "Skeleton Attack Sword Transparent"],
    [5489, "Skeleton Defend"],
    [5490, "Skeleton Defend Transparent"],
    [5491, "Skeleton Death"],
    [5492, "Skeleton Death Transparent"],
    [5493, "Skeleton Giant Ready"],
    [5494, "Skeleton Giant Ready Transparent"],
    [5495, "Skeleton Giant Vary2 Ready"],
    [5496, "Skeleton Giant Vary2 Ready Transparent"],
    [5497, "Skeleton Giant Walk"],
    [5498, "Skeleton Giant Walk Transparent"],
    [5499, "Skeleton Giant Attack"],
    [5500, "Skeleton Giant Attack Transparent"],
    [5501, "Skeleton Giant Defend"],
    [5502, "Skeleton Giant Defend Transparent"],
    [5503, "Skeleton Giant Death"],
    [5504, "Skeleton Giant Death Transparent"],
    [5505, "Skeleton Giant Vary3 Ready"],
    [5506, "Skeleton Giant Vary3 Walk"],
    [5507, "Skeleton Giant Vary3 Attack"],
    [5508, "Skeleton Giant Vary3 Defend"],
    [5509, "Skeleton Giant Vary3 Death"],
    [5510, "Skeleton Champion Ready"],
    [5511, "Skeleton Champion Walk"],
    [5512, "Skeleton Champion Attack"],
    [5513, "Skeleton Champion Defend"],
    [5514, "Skeleton Champion Death"],
    [5515, "Skeleton Champ Spotanim"],
    [5516, "Skeleton Champ Projectile"],
    [5517, "Skeleton Gorilla Ready"],
    [5518, "Skeleton Gorilla Walk"],
    [5519, "Skeleton Gorilla Attack"],
    [5520, "Skeleton Gorilla Defend"],
    [5521, "Skeleton Gorilla Death"],
    [5522, "Skeleton Mage Rise Summon"],
    [5523, "Skeleton Mage Casting"],
    [5524, "Skeleton Human Become Skeleton"],
    [5525, "Skeleton Skeleton Become Skeleton"],
    [5526, "Skeleton Strike Casting"],
    [5527, "Skeleton Despawn"],
    [5528, "Skeleton Mage Casting Swansong"],
    [5529, "Skeleton Weaken Casting Spotanim"],
    [5530, "Ghost Normal Ready"],
    [5531, "Ghost Normal Walk"],
    [5532, "Ghost Normal Attack"],
    [5533, "Ghost Normal Defend"],
    [5534, "Ghost Normal Death"],
    [5535, "Ghost Nazastarool Attack"],
    [5536, "Ghost Nazastarool Defend"],
    [5537, "Ghost Nazastarool Death"],
    [5538, "Ghost Tendrill Ready"],
    [5539, "Ghost Tendrill Walk"],
    [5540, "Ghost Tendrill Attack"],
    [5541, "Ghost Tendrill Defend"],
    [5542, "Ghost Tendrill Death"],
    [5543, "Ghost Mine Boss Run"],
    [5544, "Ghost Normal Summoning"],
    [5545, "Ghost Tendrill Summoning"],
    [5546, "Ghost Normal Despawn"],
    [5547, "Ghost Tendrill Despawn"],
    [5548, "Mummy Civillian Ready"],
    [5549, "Mummy Civillian Attack"],
    [5550, "Mummy Civillian Defend"],
    [5551, "Mummy Soldier Ready"],
    [5552, "Mummy Walk"],
    [5553, "Mummy Sword Walk"],
    [5554, "Mummy Sword Attack"],
    [5555, "Mummy Death"],
    [5556, "Mummy Defend"],
    [5557, "Mummy Guardian Walk"],
    [5558, "Mummy Guardian Ready"],
    [5559, "Mummy Emerge North"],
    [5560, "Mummy Emerge South"],
    [5561, "Mummy Emerge East"],
    [5562, "Mummy Emerge West"],
    [5563, "Mummy Turn To Ash"],
    [5564, "Mummy Ash Breakup"],
    [5565, "Zombie Ready Normal"],
    [5566, "Zombie Walk Normal"],
    [5567, "Zombie Defend Normal"],
    [5568, "Zombie Attack Normal"],
    [5569, "Zombie Death Normal"],
    [5570, "Zombie Walk Weapon"],
    [5571, "Zombie Attack Weapon"],
    [5572, "Zombie Ready Weapon"],
    [5573, "Zombie Ready Arm Champion"],
    [5574, "Zombie Defend Weapon"],
    [5575, "Zombie Death Weapon"],
    [5576, "Zombie Ready Dragging"],
    [5577, "Zombie Walk Dragging"],
    [5578, "Zombie Attack Dragging"],
    [5579, "Zombie Defend Dragging"],
    [5580, "Zombie Death Dragging"],
    [5581, "Zombie Attack Champion"],
    [5582, "Zombie Walk Champion"],
    [5583, "Zombie Sign Walk"],
    [5584, "Zombie Sign Ready"],
    [5585, "Half Wood Luke Walk"],
    [5586, "Half Wood Luke Ready"],
    [5587, "Zombie Despawn"],
    [5588, "Lotr Log Swing"],
    [5589, "Lotr Pickaxe Ready"],
    [5590, "Lotr Pickaxe Defend"],
    [5591, "Lotr Pickaxe Attack"],
    [5592, "Lotr Pickaxe Death"],
    [5593, "Lotr Pickaxe Walk"],
    [5594, "Lotr Spade Ready"],
    [5595, "Lotr Spade Walk"],
    [5596, "Lotr Spade Death"],
    [5597, "Lotr Spade Attack"],
    [5598, "Lotr Ruins Flickering Flame"],
    [5599, "Lotr Cage Door Opening"],
    [5600, "Lotr Cage Door Closing"],
    [5601, "Lotr Cage Door Open"],
    [5602, "Lotr Human Walk F"],
    [5603, "Lotr Possesed Armour Reform"],
    [5604, "Lotr Possesed Miner Reform"],
    [5605, "Lotr Waterfall Head"],
    [5606, "Hallowed Telepad Ready"],
    [5607, "Deserttreasure Pitfall Initial"],
    [5608, "Lotr Tarn Razorlor Human Summon Spell"],
    [5609, "Lotr Tarn Razorlor Change To Mutant Part1"],
    [5610, "Lotr Tarn Razorlor Change To Mutant Spot Part1"],
    [5611, "Lotr Tarn Razorlor Change To Mutant Part2"],
    [5612, "Lotr Tarn Razorlor Change To Mutant Spot Part2"],
    [5613, "Lotr Tarn Mutant Summon Spell"],
    [5614, "Lotr Tarn Mutant Summon Spell Spot"],
    [5615, "Lotr Tarn Razorlor Mutant Walk"],
    [5616, "Lotr Tarn Razorlor Mutant Ready"],
    [5617, "Lotr Tarn Razorlor Mutant Attack"],
    [5618, "Lotr Tarn Razorlor Mutant Defend"],
    [5619, "Lotr Tarn Razorlor Mutant Death"],
    [5620, "Lotr Tarn Human Mutant To Ghost Transform"],
    [5621, "Lotr Terror Dog Walk"],
    [5622, "Lotr Terror Dog Look Walk"],
    [5623, "Lotr Terror Dog Look Ready"],
    [5624, "Lotr Terror Dog Attack"],
    [5625, "Lotr Terror Dog Attack Large"],
    [5626, "Lotr Terror Dog Defend"],
    [5627, "Lotr Terror Dog Death"],
    [5628, "Lotr Terror Dog Death Large"],
    [5629, "Lotr Terror Dog Burst Green"],
    [5630, "Lotr Terror Dog Burst Spot"],
    [5631, "Lotr Wall Push"],
    [5632, "Lotr Floor Spike Activate"],
    [5633, "Surok Zaff Spell Casting"],
    [5634, "Surok Zaff Spell Casting Spot"],
    [5635, "Surok Zaff Spell Casting Proj"],
    [5636, "Surok Zaff Spell Casting Impact"],
    [5637, "Lotr Enchant Amulet Player Anim"],
    [5638, "Surok Surok Spell Casting Spot"],
    [5639, "Surok Surok Spell Casting Proj"],
    [5640, "Surok Surok Spell Casting Impact"],
    [5641, "Brain Sawbones Ready"],
    [5642, "Brain Sawbones Walk"],
    [5643, "Brain Sawbones Attack"],
    [5644, "Brain Sawbones Defend"],
    [5645, "Brain Zombie Pirate Wanderers Walk"],
    [5646, "Brain Zombie Pirate Wanderers Ready"],
    [5647, "Brain Zombie Pirate Wanderers Attack"],
    [5648, "Brain Zombie Pirate Wanderers Defend"],
    [5649, "Brain Zombie Pirate Wanderers Death"],
    [5650, "Brain Zombie Pirate Drag Feet Ready"],
    [5651, "Brain Zombie Pirate Drag Feet Attack"],
    [5652, "Brain Zombie Pirate Drag Feet Walk"],
    [5653, "Brain Zombie Pirate Drag Feet Defend"],
    [5654, "Brain Zombie Pirate Drag Feet Death"],
    [5655, "Brain Zombie Pirate Captain Walk"],
    [5656, "Brain Zombie Pirate Captain Ready"],
    [5657, "Brain Zombie Pirate Captain Attack"],
    [5658, "Brain Zombie Pirate Captain Death"],
    [5659, "Lotr Enchant Spell Spot"],
    [5660, "Lotr Tarn Mutant Proj Spot"],
    [5661, "Peng Chat Idle"],
    [5662, "Peng Chat Quizzical"],
    [5663, "Peng Chat Happy"],
    [5664, "Peng Chat Happy Fast"],
    [5665, "Peng Chat Sad"],
    [5666, "Peng Gentoo Walk"],
    [5667, "Peng Geentoo Run"],
    [5668, "Peng Gentoo Ready"],
    [5669, "Peng Gentoo Attack"],
    [5670, "Peng Gentoo Defend"],
    [5671, "Peng Gentoo Death"],
    [5672, "Peng Penguin Fallover"],
    [5673, "Peng Cowbell Ready"],
    [5674, "Peng Player Bongo"],
    [5675, "Peng Bongo Ready"],
    [5676, "Peng General Walk"],
    [5677, "Peng General Ready"],
    [5678, "Peng Gentoo Starjump"],
    [5679, "Peng Gentoo Starjump West"],
    [5680, "Peng Gentoo Starjump East"],
    [5681, "Peng Gentoo Situps"],
    [5682, "Peng Gentoo Situps North"],
    [5683, "Peng Gentoo Situps West"],
    [5684, "Peng Gentoo Situps East"],
    [5685, "Peng Gentoo Pushups"],
    [5686, "Peng Gentoo Pushups West"],
    [5687, "Peng Gentoo Pushups East"],
    [5688, "Peng Swim Ready"],
    [5689, "Peng Swim Walk"],
    [5690, "Peng Swim Walk Backward"],
    [5691, "Peng Jump"],
    [5692, "Peng Jump Fail"],
    [5693, "Peng Emote Bow"],
    [5694, "Peng Emote Spin"],
    [5695, "Peng Emote Wave"],
    [5696, "Peng Emote Cheer"],
    [5697, "Peng Emote Shiver"],
    [5698, "Peng Emote Clap"],
    [5699, "Peng Emote Flap"],
    [5700, "Peng Emote Preen"],
    [5701, "Peng Icicle Walk"],
    [5702, "Peng Icicle Walk Fail"],
    [5703, "Peng Slippery Walk"],
    [5704, "Peng Slippery Walk Fail"],
    [5705, "Peng Slide Ready"],
    [5706, "Peng Slide Walk"],
    [5707, "Peng Slide Run"],
    [5708, "Peng Jump A"],
    [5709, "Peng Jump B"],
    [5710, "Peng Jump C"],
    [5711, "Peng Slide Jump Fail"],
    [5712, "Peng Icicle Fall"],
    [5713, "Peng Icicle Fall Fail"],
    [5714, "Peng Human Transmogrify"],
    [5715, "Peng Transmogrify"],
    [5716, "Peng Human Detransmogrify"],
    [5717, "Peng Detransmogrify"],
    [5718, "Peng Larry Hide"],
    [5719, "Peng Polar Bear Walk"],
    [5720, "Peng Polar Bear Ready"],
    [5721, "Peng Icelord Walk"],
    [5722, "Peng Icelord Ready"],
    [5723, "Peng Icelord Defend"],
    [5724, "Peng Icelord Attack"],
    [5725, "Peng Icelord Ranged Attack"],
    [5726, "Peng Icelord Death"],
    [5727, "Peng Icelord Icicle Proj"],
    [5728, "Peng Cannon Platform"],
    [5729, "Peng Balloon Platform"],
    [5730, "Peng Jump Platform"],
    [5731, "Peng Blast Doors Open"],
    [5732, "Peng Blast Doors Opened"],
    [5733, "Peng Blast Doors Close"],
    [5734, "Peng Agility Glitter01"],
    [5735, "Peng Map Interface Outward"],
    [5736, "Peng Map Interface Return"],
    [5737, "Peng Steam Generator01"],
    [5738, "Peng Spinning Light01"],
    [5739, "Peng Flagpole Flap01"],
    [5740, "Peng Interogation Chair01"],
    [5741, "Peng Finnishline01"],
    [5742, "Peng War Table Light01"],
    [5743, "Fai Varrock Smith Drill"],
    [5744, "Fai Varrock Lathe"],
    [5745, "Dorgesh Wire Chimney Smoke"],
    [5746, "Peng Human Shovel Snow"],
    [5747, "Peng Snow Shovel"],
    [5748, "Peng Snow Impact"],
    [5749, "Dragon Claws Spot"],
    [5750, "Myq3 Black To Grey"],
    [5751, "Sire Attack Double Hook"],
    [5752, "Wake Up Ready"],
    [5753, "Barb Assault Egg Place"],
    [5754, "Human Woodcrafting Hammer"],
    [5755, "Sire Attack Double Whips"],
    [5756, "Human Woodcrafting Knife"],
    [5757, "Fris Pie"],
    [5758, "Fris Juggling"],
    [5759, "Human Juggling"],
    [5760, "Fris Human Jig"],
    [5761, "Human Fris Skip"],
    [5762, "Human Fris Talk"],
    [5763, "Fris Human Pie"],
    [5764, "Shipjourney Rellekka To Iznot"],
    [5765, "Shipjourney Iznot To Rellekka"],
    [5766, "Shipjourney Rellekka To Izso"],
    [5767, "Shipjourney Izso To Rellekka"],
    [5768, "Fris Banner"],
    [5769, "Fris Boat Bob"],
    [5770, "Fris Iceberg Moves"],
    [5771, "Fris Geyser"],
    [5772, "Fris Geyser Small"],
    [5773, "Fris Pine Sway"],
    [5774, "Fris Pine Attack"],
    [5775, "Fris Troll King Death"],
    [5776, "Fris Human Dead King Reach"],
    [5777, "Fris Human Dead King Hold Aloft"],
    [5778, "Fris Human Dead King Hold Aloft Short"],
    [5779, "Fris Trollking Throw Left Arm"],
    [5780, "Fris Trollking Ice Ball"],
    [5781, "Yak Walk"],
    [5782, "Yak Attack"],
    [5783, "Yak Defend"],
    [5784, "Yak Death"],
    [5785, "Yak Just Ready Update"],
    [5786, "Yak Ready"],
    [5787, "Yak Graze"],
    [5788, "Zombie Walk Left Normal"],
    [5789, "Zombie Walk Right Normal"],
    [5790, "Zombie Walkbackwards Weapon"],
    [5791, "Zombie Walk Right Dragging"],
    [5792, "Zombie Walk Left Dragging"],
    [5793, "Zombie Walkbackwards Dragging"],
    [5794, "Ghost Fade Out Normal"],
    [5795, "Ghost Fade In Normal"],
    [5796, "100 Osman Fountain Drink"],
    [5797, "Quest Hundred 100 Osman Fountain Water"],
    [5798, "S Fireplace"],
    [5799, "Fai Varrock Brooming"],
    [5800, "Fai Varrock Broom Ready"],
    [5801, "100 Osman Seasons Elemental Ready"],
    [5802, "100 Osman Seasons Elemental Walk"],
    [5803, "100 Osman Seasons Elemental Point"],
    [5804, "Snakeboss Death"],
    [5805, "Jad Boss Pet Walk"],
    [5806, "Snakeboss Attack Tail Left"],
    [5807, "Snakeboss Attack Tail Right"],
    [5808, "Snakeboss Defend"],
    [5809, "Shadow Maj Seer Walk"],
    [5810, "Shadow Maj Seer Ready"],
    [5811, "Shadow Maj Severed Leg Spot"],
    [5812, "Shadow Maj Severed Leg Human Throw"],
    [5813, "Tol Interface Leak"],
    [5814, "Tol Lazy Builder01"],
    [5815, "Tol Lazy Builder02"],
    [5816, "Tol Lazy Builder03"],
    [5817, "Tol Lazy Builder03 North"],
    [5818, "Tol Lazy Builder04"],
    [5819, "Tol Player Rummage01"],
    [5820, "Tol Player Rummage02"],
    [5821, "Tol Player Whistle01"],
    [5822, "Tol Mage Walk01"],
    [5823, "Tol Mage Ready01"],
    [5824, "Tol Magic Table01"],
    [5825, "Tol Magic Pipe01"],
    [5826, "Tol Swordchick Walk01"],
    [5827, "Tol Player Drink Tea01"],
    [5828, "Tol Water Flow"],
    [5829, "Tol Water Bubbles"],
    [5830, "Tol Cage Surround Anim"],
    [5831, "Tol Homonculus Ready"],
    [5832, "Tol Homonculus Walk"],
    [5833, "Tol Homonculus Summon"],
    [5834, "Tol Homonculus Magic"],
    [5835, "Tol Homonculus Magic Spotanim"],
    [5836, "Tol Homonculus Talking"],
    [5837, "Tol Homonculus Angry"],
    [5838, "Tol Homonculus Quizical"],
    [5839, "Tol Frogeel Ready"],
    [5840, "Tol Frogeel Walk"],
    [5841, "Tol Frogeel Death"],
    [5842, "Tol Frogeel Attack"],
    [5843, "Tol Frogeel Defend"],
    [5844, "Tol Lifesymbol Glow"],
    [5845, "Tol Player Whistle Beckon"],
    [5846, "Tol Player Fix Machine"],
    [5847, "Tol Swinging Cage Small"],
    [5848, "Cow Walk"],
    [5849, "Cow Attack"],
    [5850, "Cow Defend"],
    [5851, "Cow Death"],
    [5852, "Cow Just Ready Update"],
    [5853, "Cow Ready"],
    [5854, "Cow Graze"],
    [5855, "Cow Dairy"],
    [5856, "Calf Walk"],
    [5857, "Brain Mill Sail Rotate"],
    [5858, "Brain Mi Gor Walk"],
    [5859, "Brain Mi Gor Ready"],
    [5860, "Brain Robbery Player Pull Statue"],
    [5861, "Great Brain Robbery Statue Pulling"],
    [5862, "Brain Player Gas Death"],
    [5863, "Brain Player Blow Whistle"],
    [5864, "Brain Player Pray"],
    [5865, "Brain Player Anchor Attack"],
    [5866, "Brain Player Anchor Defend"],
    [5867, "Brain Player Anchor Walk"],
    [5868, "Brain Player Anchor Run"],
    [5869, "Brain Player Anchor Ready"],
    [5870, "Brain Player Anchor Special Attack"],
    [5871, "Brain Spot Anchor Special Attack"],
    [5872, "Brain Puffin Walk"],
    [5873, "Brain Puffin Ready"],
    [5874, "Brain Searock Tide"],
    [5875, "Brain Brother Tranquility Shifty Ready"],
    [5876, "Brain Human Brain Monk Walk"],
    [5877, "Brain Human Brain Monk Ready"],
    [5878, "Brain Zombie Pirate Limpers Walk"],
    [5879, "Brain Zombie Pirate Limpers Ready"],
    [5880, "Brain Zombie Pirate Limpers Attack"],
    [5881, "Brain Zombie Pirate Limpers Defend"],
    [5882, "Brain Zombie Pirate Boney Walk"],
    [5883, "Brain Zombie Pirate Boney Ready"],
    [5884, "Brain Zombie Pirate Boney Attack"],
    [5885, "Brain Zombie Pirate Boney Defend"],
    [5886, "Brain Zombie Pirate Boney Death"],
    [5887, "Brain Zombie Pirate Cutters Walk"],
    [5888, "Brain Zombie Pirate Cutters Ready"],
    [5889, "Brain Zombie Pirate Cutters Attack"],
    [5890, "Brain Zombie Pirate Cutters Defend"],
    [5891, "Brain Zombie Pirate Cutters Death"],
    [5892, "Brain Barrelchest Walk"],
    [5893, "Brain Barrelchest Ready"],
    [5894, "Brain Barrelchest Normal Attack"],
    [5895, "Brain Barrelchest Special Attack"],
    [5896, "Brain Barrelchest Wall Breaker Attack"],
    [5897, "Brain Barrelchest Defend"],
    [5898, "Brain Barrelchest Death"],
    [5899, "Brain Door Explosion"],
    [5900, "Brain Wall Collapse 1"],
    [5901, "Brain Wall Collapse 2"],
    [5902, "Brain Door Collapse"],
    [5903, "Brain Secret Wall Breakup Mid"],
    [5904, "Brain Secret Wall Breakup Side"],
    [5905, "Brain Mon Locs Anims"],
    [5906, "Brain Mon Locs Ready Anims"],
    [5907, "Brain Stairs Fix"],
    [5908, "Brain Cat And Ball Anim"],
    [5909, "Brain Fuse Burning"],
    [5910, "Ramble Trip Anim Initial Start"],
    [5911, "Ramble Trip Route 1 Start 2"],
    [5912, "Ramble Trip Route 1 Start 3"],
    [5913, "Ramble Trip Route 1 Start 4"],
    [5914, "Ramble Trip Route 1 Start 5"],
    [5915, "Ramble Trip Route 1 Start 6"],
    [5916, "Ramble Trip Route 1 Start 7"],
    [5917, "Ramble Trip Route 1 Start 8"],
    [5918, "Ramble Trip Route 1 And 2 Start 9"],
    [5919, "Ramble Trip Route 1 And 2 Start 10"],
    [5920, "Ramble Trip Route All Start 11"],
    [5921, "Ramble Trip Route 2 Start 2"],
    [5922, "Ramble Trip Route 2 Start 3"],
    [5923, "Ramble Trip Route 2 Start 4"],
    [5924, "Ramble Trip Route 2 Start 5"],
    [5925, "Ramble Trip Route 2 Start 6"],
    [5926, "Ramble Trip Route 2 Start 7"],
    [5927, "Ramble Trip Route 2 Start 8"],
    [5928, "Ramble Trip Route 3 Start 2"],
    [5929, "Ramble Trip Route 3 Start 3"],
    [5930, "Ramble Trip Route 3 Start 4"],
    [5931, "Ramble Trip Route 3 Start 5"],
    [5932, "Ramble Trip Route 3 Start 6"],
    [5933, "Ramble Trip Route 3 Start 7"],
    [5934, "Ramble Trip Route 3 Start 8"],
    [5935, "Ramble Trip Route 3 Start 9"],
    [5936, "Ramble Trip Route 3 Start 10"],
    [5937, "Ramble Anim Route 1 And 2 Trip 1"],
    [5938, "Ramble Anim Route 1 Trip 2"],
    [5939, "Ramble Anim Route 1 Trip 3"],
    [5940, "Ramble Anim Route 1 Trip 4"],
    [5941, "Ramble Anim Route 1 Trip 5"],
    [5942, "Ramble Anim Route 1 Trip 6"],
    [5943, "Ramble Anim Route 1 Trip 7"],
    [5944, "Ramble Anim Route 1 Trip 8"],
    [5945, "Ramble Anim Route 1 And 2 Trip 9"],
    [5946, "Ramble Anim Route 1 And 2 Trip 10"],
    [5947, "Ramble Anim Route All Trip 11"],
    [5948, "Ramble Anim Route 2 Trip 2"],
    [5949, "Ramble Anim Route 2 Trip 3"],
    [5950, "Ramble Anim Route 2 Trip 4"],
    [5951, "Ramble Anim Route 2 Trip 5"],
    [5952, "Ramble Anim Route 2 Trip 6"],
    [5953, "Ramble Anim Route 2 Trip 7"],
    [5954, "Ramble Anim Route 2 Trip 8"],
    [5955, "Ramble Anim Route 3 Trip 1"],
    [5956, "Ramble Anim Route 3 Trip 2"],
    [5957, "Ramble Anim Route 3 Trip 3"],
    [5958, "Ramble Anim Route 3 Trip 4"],
    [5959, "Ramble Anim Route 3 Trip 5"],
    [5960, "Ramble Anim Route 3 Trip 6"],
    [5961, "Ramble Anim Route 3 Trip 7"],
    [5962, "Ramble Anim Route 3 Trip 8"],
    [5963, "Ramble Anim Route 3 Trip 9"],
    [5964, "Ramble Anim Route 3 Trip 10"],
    [5965, "Ramble Zombie Emerge Head"],
    [5966, "Ramble Zombie Emerge Torso"],
    [5967, "Ramble Zombie Emerge Thighs"],
    [5968, "Ramble Zombie Emerge Feet"],
    [5969, "Ramble Zombie Walk Land"],
    [5970, "Ramble Zombie Attack"],
    [5971, "Ramble Zombie Defend"],
    [5972, "Ramble Zombie Death"],
    [5973, "Ramble Zombie Ready"],
    [5974, "Ramble Sick Folk Healthy Ready"],
    [5975, "Ramble Sick Folk Stage 1 Ready"],
    [5976, "Ramble Sick Folk Stage 2 Ready"],
    [5977, "Ramble Sick Folk Stage 3 Ready"],
    [5978, "Ramble Sick Folk Stage Healthy Eating"],
    [5979, "Ramble Sick Folk Stage 1 Eating"],
    [5980, "Ramble Sick Folk Stage 2 Eating"],
    [5981, "Ramble Sick Folk Stage 3 Eating"],
    [5982, "Ramble Transformation Into Ghast"],
    [5983, "Ramble 2nd Stage To Healthy"],
    [5984, "Ramble 3rd Stage To Healthy"],
    [5985, "Ramble 4th Stage To Healthy"],
    [5986, "Trek Nailbeast Ready"],
    [5987, "Trek Nailbeast Walk"],
    [5988, "Trek Nailbeast Defend"],
    [5989, "Trek Nailbeast Attack"],
    [5990, "Trek Nailbeast Death"],
    [5991, "Dttd Zanik Laugh"],
    [5992, "Dttd Zanik Point"],
    [5993, "Dttd Zanik Turnonspot"],
    [5994, "Dttd Zanik Tog Ready"],
    [5995, "Dttd Zanik Tog Walk"],
    [5996, "Dttd Zanik Drink Togbowl"],
    [5997, "Dttd Zanik Open Cell"],
    [5998, "Dttd Zanik Firing Crossbow"],
    [5999, "Dttd Zanik Dance Spin"],
    [6000, "Dttd Zanik Bow"],
    [6001, "Dorgesh Goblin Unarmed Attack"],
    [6002, "Dorgesh Goblin Unarmed Defend"],
    [6003, "Dorgesh Goblin Death"],
    [6004, "Dorgesh Goblin Ready Mining"],
    [6005, "Dorgesh Goblin Walk Spear"],
    [6006, "Dorgesh Goblin Ready Spear"],
    [6007, "Dorgesh Goblin Club Attack"],
    [6008, "Dorgesh Goblin Spear Block"],
    [6009, "Monalisk Giant Cave Bug Explode"],
    [6010, "Monalisk Creature Ready"],
    [6011, "Monalisk Creature Walk"],
    [6012, "Monalisk Creature Attack"],
    [6013, "Monalisk Creature Defend"],
    [6014, "Monalisk Creature Death"],
    [6015, "Molanisk Creature On Wall Look East"],
    [6016, "Molanisk Creature On Wall Look West"],
    [6017, "Molanisk Creature On Wall Look North"],
    [6018, "Molanisk Creature On Wall Look South"],
    [6019, "Molanisk Creature On Wall Jump East"],
    [6020, "Molanisk Creature On Wall Jump West"],
    [6021, "Molanisk Creature On Wall Jump North"],
    [6022, "Molanisk Creature On Wall Jump South"],
    [6023, "Dorgesh Fountain"],
    [6024, "Dorgesh Back Water"],
    [6025, "Dorgesh Feature Base"],
    [6026, "Dorgesh Banners"],
    [6027, "Dorgesh Conductor Coil"],
    [6028, "Dorgesh Plasma Ball"],
    [6029, "Dorgesh Light Glow"],
    [6030, "Dorgesh Light Off"],
    [6031, "Dorgesh Light Close Off"],
    [6032, "Dorgesh Light Open"],
    [6033, "Dorgesh Zapper Light"],
    [6034, "Dorgesh Zapper Moth Death"],
    [6035, "Dorgesh Zapper Dormant"],
    [6036, "Dorgesh Moths"],
    [6037, "Dorgesh Sink"],
    [6038, "Dorgesh Wire Machine"],
    [6039, "Dorgesh Frogspit Rotate"],
    [6040, "Dorgesh Goblin Ready"],
    [6041, "Dorgesh Goblin Walk"],
    [6042, "Dorgesh Goblin Child Walk"],
    [6043, "Dorgesh Goblin Ready Crate"],
    [6044, "Dorgesh Goblin Walk Crate"],
    [6045, "Dorgesh Goblin Ready Scribe"],
    [6046, "Dorgesh Goblin Walk Scribe"],
    [6047, "Dorgesh Goblin Chat Talker"],
    [6048, "Dorgesh Goblin Chat Listener"],
    [6049, "Dorgesh Goblin Engineer Operate"],
    [6050, "Dorgesh Goblin Child Pat"],
    [6051, "Dorgesh Goblin Child Pat Back"],
    [6052, "Dorgesh Goblin Child Ball Ready"],
    [6053, "Dorgesh Goblin Child Ball Kick"],
    [6054, "Dorgesh Goblin Child Ball Kick To"],
    [6055, "Dorgesh Goblin Child Ball Receive"],
    [6056, "Dorgesh Ball Spotanim"],
    [6057, "Dorgesh Baby Crawl"],
    [6058, "Dorgesh Baby Ready"],
    [6059, "Dorgesh Baby Sit Ready"],
    [6060, "Dorgesh Goblin Frogspit Rotate"],
    [6061, "Dorgesh Goblin Fish Walk"],
    [6062, "Dorgesh Goblin Fish Ready"],
    [6063, "Dorgesh Light Change Human"],
    [6064, "Dorgesh Artifact Spell Human"],
    [6065, "Dorgesh Artifact Spell Spot"],
    [6066, "Dorgesh Xbow Launch"],
    [6067, "Dorgesh Xbow Swing"],
    [6068, "Dorgesh Xbow Swing Fail"],
    [6069, "Dorgesh Grapple Dormant"],
    [6070, "Dorgesh Grapple Swing"],
    [6071, "Dorgesh Grapple Swing Fail"],
    [6072, "Dorgesh Grapple Swing Reverse"],
    [6073, "Dorgesh Grapple Swing Fail Reverse"],
    [6074, "Dorgesh Grapple Spot"],
    [6075, "Dorgesh Magic Scan Ready"],
    [6076, "Dorgesh Magic Scan Walk"],
    [6077, "Monalisk Cave Bug Walk"],
    [6078, "Monalisk Cave Bug Ready"],
    [6079, "Monalisk Cave Bug Attack"],
    [6080, "Monalisk Cave Bug Defend"],
    [6081, "Monalisk Giant Cave Bug Death"],
    [6082, "Monalisk Mini Cave Bug Death"],
    [6083, "Molanisk Player Ring Bell"],
    [6084, "Slice Zanik Teleport Sphere Breaking"],
    [6085, "Tbw Cleanup Player Hack Opal"],
    [6086, "Tbw Cleanup Player Hack Jade"],
    [6087, "Tbw Cleanup Player Hack Redtopaz"],
    [6088, "Rabbit Walk"],
    [6089, "Rabbit Ready"],
    [6090, "Rabbit Attack"],
    [6091, "Rabbit Defend"],
    [6092, "Rabbit Death"],
    [6093, "Rabbit Walk Projanim"],
    [6094, "Quest Fairy Cow Wheel Walk"],
    [6095, "Stab Wolbanedagger"],
    [6096, "Surok Surok Document Burning"],
    [6097, "Surok Surok Document Burning Spot"],
    [6098, "Surok King Roald Collapse"],
    [6099, "Surok King Roald New Collapse"],
    [6100, "Surok King Roald Impact"],
    [6101, "Surok King Roald Attack"],
    [6102, "Surok Player Pickaxe Swing"],
    [6103, "Surok Player Climbing Into Tunnel"],
    [6104, "Surok Player Rune Combine"],
    [6105, "Surok Rune Combine Spot"],
    [6106, "Fai Varrock Bench Sit"],
    [6107, "Dttd Zanik Stepping Stone Jump"],
    [6108, "Human Mining Black Pickaxe Noreachforward"],
    [6109, "Sang Mining Wall Black Pickaxe"],
    [6110, "Clanwars Barrier Sink"],
    [6111, "Rabbit Emote"],
    [6112, "Olaf2 Undead Walk"],
    [6113, "Olaf2 Undead Ready"],
    [6114, "Olaf2 Brine Rat Walk"],
    [6115, "Olaf2 Brine Rat Death"],
    [6116, "Olaf2 Brine Rat Defend"],
    [6117, "Olaf2 Brine Rat Attack"],
    [6118, "Olaf2 Brine Sabre Special"],
    [6119, "Olaf2 Brine Sabre Special Spot"],
    [6120, "Olaf2 Cave Boulder Roll"],
    [6121, "Olaf2 Trap Wall Hit Head"],
    [6122, "Olaf2 Head Hit"],
    [6123, "Olaf2 Trap Barrel Spin"],
    [6124, "Olaf2 Fall Off Barrel"],
    [6125, "Olaf2 Skull Lever"],
    [6126, "Olaf2 Ulfric Rise"],
    [6127, "Olaf2 Brine Rat Ready"],
    [6128, "Olaf2 Undead Sword Lunge"],
    [6129, "Olaf2 Undead Sword Def"],
    [6130, "Olaf2 Human Boulder Push Side"],
    [6131, "Olaf2 Human Boulder Push"],
    [6132, "Wild Ditch Jump"],
    [6133, "Goblin Casting Spotanim"],
    [6134, "Goblin Champion Casting"],
    [6135, "Goblin Champion Drain"],
    [6136, "Surface Goblin Bow"],
    [6137, "Surface Goblin Dance"],
    [6138, "Surface Goblin Banner Walk"],
    [6139, "Surface Goblin Banner Ready"],
    [6140, "Surface Goblin Eyeglo Crazy Scared"],
    [6141, "Surface Goblin Eyeglo Scared Run"],
    [6142, "Slice Arrow Hit Spot"],
    [6143, "Slice Ham Agent Arrow Launch"],
    [6144, "Slice Ham Agent Arrow Launch Spot"],
    [6145, "Slice Ham Agent Arrow Launch Proj"],
    [6146, "Slice Player Thrown Out Anim"],
    [6147, "Slice Player Mace Special Attack"],
    [6148, "Slice Player Mace Special Attack Spot"],
    [6149, "Slice Zanik Public Address"],
    [6150, "Slice Hostage Walk"],
    [6151, "Slice Hostage Ready"],
    [6152, "Slice Surface Goblin Sergent Walk"],
    [6153, "Slice Surface Goblin Sergent Ready"],
    [6154, "Slice Surface Goblin Sergent Attack"],
    [6155, "Slice Surface Goblin Sergent Defend"],
    [6156, "Slice Surface Goblin Sergent Death"],
    [6157, "Slice Surface Goblin Sergent Hide"],
    [6158, "Slice Surface Goblin Sergent Stand Up"],
    [6159, "Slice Dorgesh Urtaq Arguing"],
    [6160, "Slice Dwarf Alvijar Arguing"],
    [6161, "Slice Zanik Address Goblin Crowd"],
    [6162, "Slice Zanik Address Goblin Crowd Var"],
    [6163, "Slice Zanik Address Goblin Crowd Calm"],
    [6164, "Slice Dwarf Crowd Cheering Var 1"],
    [6165, "Slice Dwarf Crowd Cheering Var 2"],
    [6166, "Slice Dwarf Crowd Cheering Var 3"],
    [6167, "Slice Cave Goblins Crowd Cheering Var 1"],
    [6168, "Slice Cave Goblins Crowd Cheering Var 2"],
    [6169, "Slice Flash"],
    [6170, "Slice Dwarf Train Ready"],
    [6171, "Slice Train Anim 01"],
    [6172, "Slice Train Anim 02"],
    [6173, "Slice Train Anim 03"],
    [6174, "Slice Train Anim 04"],
    [6175, "Slice Train Anim 05"],
    [6176, "Slice Train Anim 06"],
    [6177, "Slice Train Anim 07"],
    [6178, "Slice Train Anim 08"],
    [6179, "Slice Train Anim 09"],
    [6180, "Slice Surface Goblin Squat Walk"],
    [6181, "Slice Surface Goblin Squat Ready"],
    [6182, "Slice Surface Goblin Death"],
    [6183, "Slice Surface Goblin Defend"],
    [6184, "Slice Surface Goblin Squat Unarmed Attack"],
    [6185, "Slice Surface Goblin Armed Attack"],
    [6186, "Slice Surface Goblin Squat Ready Spear"],
    [6187, "Slice Surface Goblin Squat Walk Spear"],
    [6188, "Slice Surface Goblin Squat Attack Spear"],
    [6189, "Slice Surface Goblin Defend Spear"],
    [6190, "Slice Surface Goblin Death Spear"],
    [6191, "Slice Arrow Death"],
    [6192, "Slice Surface Goblin Death By Arrow"],
    [6193, "Slice Surface Goblin Running Scared"],
    [6194, "Slice Goblin Excavate"],
    [6195, "Slice Surface Goblin Death By Firebolt"],
    [6196, "Slice Goblin Cleaning"],
    [6197, "Light Beam Butterfly Old"],
    [6198, "Slice Player Hide Stand"],
    [6199, "Slice Surface Goblin Squat Spear Attack Shield"],
    [6200, "Slice Surface Goblin Squat Shield Spear Ready"],
    [6201, "Slice Surface Goblin Squat Walk Shield Armed"],
    [6202, "Slice Surface Goblin Squat Generals Walk"],
    [6203, "Slice Surface Goblin Squat Generals Ready"],
    [6204, "Surface Goblin Wormbrain Death"],
    [6205, "Slice Dwarf 1 Ready"],
    [6206, "Slice Dwarf 2 Ready"],
    [6207, "Slice Dwarf 3 Ready"],
    [6208, "Slice Dwarf 4 Ready"],
    [6209, "Slice Player Untie Zanik"],
    [6210, "Slice Zanik Train Blast Past"],
    [6211, "Slice Zanik Train Track Struggle"],
    [6212, "Slice Zanik Train Track Get Up"],
    [6213, "Slice Player Train Blast Past"],
    [6214, "Slice Zanik Jump From Track North"],
    [6215, "Slice Zanik Jump From Track South"],
    [6216, "Vm Specimen Brush Dust Spotanim"],
    [6217, "Vm Player Use Specimen Brush"],
    [6218, "Kalphite Ready"],
    [6219, "Kalphite Lord Ready"],
    [6220, "Kalphite Walk"],
    [6221, "Kalphite Larvae Walk"],
    [6222, "Kalphite Lord Walk"],
    [6223, "Kalphite Jaws Attack"],
    [6224, "Kalphite Larvae Jaws Attack"],
    [6225, "Kalphite Claw Attack"],
    [6226, "Kalphite Claw Lord Attack"],
    [6227, "Kalphite Defend"],
    [6228, "Kalphite Death"],
    [6229, "Kalphite Larvae Death"],
    [6230, "Kalphite Lord Death"],
    [6231, "Kalphite Ranged Attack"],
    [6232, "Kalphite Queen Defend"],
    [6233, "Kalphite Flying Queen Death"],
    [6234, "Kalphite Flying Queen Ranged Attack"],
    [6235, "Kalphite Flying Queen Stinger Attack"],
    [6236, "Kalphite Flying Queen Ready Walk"],
    [6237, "Kalphite Flying Queen Defend"],
    [6238, "Kalphite Queen Walk"],
    [6239, "Kalphite Queen Ready"],
    [6240, "Kalphite Queen Ranged Attack"],
    [6241, "Kalphite Queen Jaws Attack"],
    [6242, "Kalphite Queen Death"],
    [6243, "Kalphite Queen Angry"],
    [6244, "Kalphite Queen Laugh"],
    [6245, "Kalphite Queen Happy"],
    [6246, "Kalphite Queen Idle"],
    [6247, "Small Spider Ready"],
    [6248, "Small Spider Walk"],
    [6249, "Small Spider Attack"],
    [6250, "Small Spider Defend"],
    [6251, "Small Spider Death"],
    [6252, "Scorpion Ready"],
    [6253, "Scorpion Walk"],
    [6254, "Scorpion Attack Tail"],
    [6255, "Scorpion Defend"],
    [6256, "Scorpion Death"],
    [6257, "Small Scorpion Walk"],
    [6258, "Small Scorpion Ready"],
    [6259, "Small Scorpion Defend"],
    [6260, "Small Scorpion Death"],
    [6261, "Small Scorpion Attack"],
    [6262, "Scorpion Fight Arena Walk"],
    [6263, "Lobster Ready"],
    [6264, "Lobster Walk"],
    [6265, "Lobster Attack"],
    [6266, "Lobster Defend"],
    [6267, "Lobster Death"],
    [6268, "Human Ape Walk L"],
    [6269, "Kalphite Flying Queen Emerge Spotanim"],
    [6270, "Kalphite Flying Queen Emerging"],
    [6271, "Kalphite Lightening Projectile"],
    [6272, "Kaphite Egg Explosion Update"],
    [6273, "Kaphite Egg Regeneration Update"],
    [6274, "Kaphite Egg Pulsing Wall Update"],
    [6275, "Human Ape Walk R"],
    [6276, "Human Ape Walk B"],
    [6277, "Human Ape Run"],
    [6278, "Human Ape Attack"],
    [6279, "Human Ape Defend"],
    [6280, "Dream Cyrisus Unconscious"],
    [6281, "Dream Cyrisus Barely Conscious Transition"],
    [6282, "Dream Cyrisus Barely Conscious"],
    [6283, "Dream Cyrisus Sit Up Transition"],
    [6284, "Dream Cyrisus Sitting Up"],
    [6285, "Dream Player Help Cyrisus Stand Up"],
    [6286, "Dream Cyrisus Stand Up Transition"],
    [6287, "Dream Cyrisus Admire Himself"],
    [6288, "Dream Cyrisus Recieve Food Sitting"],
    [6289, "Dream Player Feed Cyrisus Sitting"],
    [6290, "Dream Player Feed Cyrisus Lying"],
    [6291, "Dream Player Feed Cyrisus Standing"],
    [6292, "Dream Cyrisus Recieve Food Standing"],
    [6293, "Dream Player Monsterexam Statspy"],
    [6294, "Dream Player Humidify Spell"],
    [6295, "Human Amethystcutting"],
    [6296, "Dream Player Dream Spell Ready"],
    [6297, "Human Ready Fan"],
    [6298, "Dream Player Make Plank Spell"],
    [6299, "Dream Player Spellbook Swap"],
    [6300, "Dream Crouch"],
    [6301, "Dream Cyrisus Stomp"],
    [6302, "Dream Zeds"],
    [6303, "Dream Player Hunter Box Spell"],
    [6304, "Dream Reverse Teleport"],
    [6305, "Dream Player Points"],
    [6306, "Dream Spell Monsterexam Statspy Spotanim"],
    [6307, "Dream Humidify Spell Spotanim"],
    [6308, "Dream Plank Make Spell Spotanim"],
    [6309, "Dream Spellbook Spotanim"],
    [6310, "Dream Razorbeast Attack"],
    [6311, "Dream Razorbeast Ready"],
    [6312, "Dream Razorbeast Walk"],
    [6313, "Dream Razorbeast Defend"],
    [6314, "Dream Razorbeast Spawn"],
    [6315, "Dream Razorbeast Death"],
    [6316, "Dream Razor Beast Spawn Spotanim"],
    [6317, "Dream Inadequacy Ready"],
    [6318, "Dream Inadequacy Attack Front"],
    [6319, "Dream Inadequacy Attack Back"],
    [6320, "Dream Inadequacy Attack Left"],
    [6321, "Dream Inadequacy Attack Right"],
    [6322, "Dream Inadequacy Death"],
    [6323, "Dream Inadequacy Transform Spotanim"],
    [6324, "Dream Inadequacy Defend"],
    [6325, "Dream Inadequacy Ranged Attack"],
    [6326, "Dream Inadequacy Mouth Spotanim"],
    [6327, "Dream Razor Beast Spawn Projanim"],
    [6328, "Dream Untouchable Ready Walk"],
    [6329, "Dream Untouchable Attack"],
    [6330, "Dream Untouchable Defend"],
    [6331, "Dream Untouchable Death"],
    [6332, "Dream Untouchable Spawn"],
    [6333, "Dream Untouchable Spawn Spotanim"],
    [6334, "Dream Untouchable Transform Spotanim"],
    [6335, "Dream Everlasting Spawn Spotanim"],
    [6336, "Dream Everlasting Transform Spotanim"],
    [6337, "Dream Illusive Spawn Spotanim"],
    [6338, "Dream Illusive Ready"],
    [6339, "Dream Illusive Walk"],
    [6340, "Dream Illusive Defend P1"],
    [6341, "Dream Illusive Defend P2"],
    [6342, "Dream Illusive Attack"],
    [6343, "Dream Everlasting Ready"],
    [6344, "Dream Everlasting Walk"],
    [6345, "Dream Everlasting Attack"],
    [6346, "Dream Everlasting Defend"],
    [6347, "Dream Everlasting Death"],
    [6348, "Dream Illusive Spawn"],
    [6349, "Dream Illusive Death"],
    [6350, "Dream Illusive Death Ready"],
    [6351, "Dream Illusive Death Stomped"],
    [6352, "Dream Illusive Stomp Spotanim"],
    [6353, "Dream Hunter Spell Spotanim"],
    [6354, "Dream Inadequacy Spawn"],
    [6355, "Dream Inadequacy Spawn Spotanim"],
    [6356, "Dream Everlasting Spawn"],
    [6357, "Dream Illusive Digging Out Spotanim"],
    [6358, "Dream Illusive Digging Back Spotanim"],
    [6359, "Dorgesh Zanik Pipesqueeze"],
    [6360, "Dorgesh Zanik Pipeunsqueeze"],
    [6361, "Human Woodcrafting Axe Rune"],
    [6362, "Human Woodcrafting Axe Adamant"],
    [6363, "Human Woodcrafting Axe Mithril"],
    [6364, "Human Woodcrafting Axe Black"],
    [6365, "Human Woodcrafting Axe Steel"],
    [6366, "Human Woodcrafting Axe Iron"],
    [6367, "Human Woodcrafting Axe Dragon"],
    [6368, "Giant Champion Attack"],
    [6369, "Giant Champion Death"],
    [6370, "Giant Champion Defend"],
    [6371, "Giant Champion Ready"],
    [6372, "Giant Champion Walk"],
    [6373, "Unicorn Rework Walk"],
    [6374, "Unicorn Rework Ready"],
    [6375, "Unicorn Rework Defend"],
    [6376, "Unicorn Rework Attack"],
    [6377, "Unicorn Rework Death"],
    [6378, "Fai Varrock Drunk Walk"],
    [6379, "Fai Varrock Drunk Ready"],
    [6380, "Vm Quiz Ready"],
    [6381, "Vm Quiz Lost Disappointment"],
    [6382, "Vm Quiz Celebration"],
    [6383, "Vm Display Case Ponder"],
    [6384, "Vm Painting Ponder"],
    [6385, "Vm Painting Ponder Var 1"],
    [6386, "Vm Painting Ponder Var 2"],
    [6387, "Vm Human Display Case Item Place"],
    [6388, "Vm Art Critic Walk"],
    [6389, "Vm Art Critic Ready"],
    [6390, "Vm Museum Guard Ready"],
    [6391, "Vm Museum Guard Gate"],
    [6392, "Vm Museum Guard Gate Mirrored"],
    [6393, "Vm Natural Historian Ready"],
    [6394, "Vm Natural Historian Ready Var"],
    [6395, "Vm Natural Historian Walk"],
    [6396, "Vm Natural Historian Dragon Flap"],
    [6397, "Vm Natural Historian Penguin Waddle"],
    [6398, "Vm Natural Historian Snail Antenna"],
    [6399, "Vm Natural Historian Lizard Hop"],
    [6400, "Vm Natural Historian Monkey Hop"],
    [6401, "Vm Natural Historian Snake Twist"],
    [6402, "Vm Natural Historian Mole Tunnel"],
    [6403, "Vm Natural Historian Camel Hump"],
    [6404, "Vm Natural Historian Wyvern"],
    [6405, "Vm Natural Historian Leech Twist"],
    [6406, "Vm Natural Historian Seaslug Twist"],
    [6407, "Vm Natural Historian Kalphite Queen Pincers"],
    [6408, "Vm Natural Historian Battle Tortoise"],
    [6409, "Vm Natural Historian Terror Bird"],
    [6410, "Vm School Teacher Male Walk"],
    [6411, "Vm School Teacher Male Ready"],
    [6412, "Vm Female Teacher Child Girl Walk Multi"],
    [6413, "Vm Female Teacher Child Girl Ready Multi"],
    [6414, "Vm Patrol Route Workmen Walk"],
    [6415, "Vm Patrol Route Workmen Ready"],
    [6416, "Vm Patrol Route Workmen Plank Drop"],
    [6417, "Vm Patrol Route Workmen Plank Pickup"],
    [6418, "Vm Patrol Route Workmen No Plank Walk"],
    [6419, "Vm Patrol Route Workmen Wheelbarrow Walk"],
    [6420, "Vm Patrol Route Workmen Wheelbarrow Empty Walk"],
    [6421, "Vm Patrol Wheelbarrow Dumping Rocks"],
    [6422, "Vm Patrol Route Workmen Wheelbarrow Ready"],
    [6423, "Vm Patrol Route Workmen Wheelbarrow Empty Ready"],
    [6424, "Vm Wheelbarrow Loader"],
    [6425, "Vm Wheelbarrow Loader Ready"],
    [6426, "Vm Pillar Flag Motion"],
    [6427, "Vm Display Case Cogs"],
    [6428, "Vm Natural History Display Case Leech"],
    [6429, "Vm Natural History Display Case Leech Fixed"],
    [6430, "Vm Natural History Display Case Snail"],
    [6431, "Vm Natural History Display Case Snail Fixed"],
    [6432, "Vm Natural History Display Case Seaslug"],
    [6433, "Vm Natural History Display Case Seaslug Fixed"],
    [6434, "Vm Natural History Display Case Monkey"],
    [6435, "Vm Natural History Display Case Monkey Fixed"],
    [6436, "Vm Natural History Display Case Lizard"],
    [6437, "Vm Natural History Display Case Lizard Fixed"],
    [6438, "Vm Natural History Display Case Penguin"],
    [6439, "Vm Natural History Display Case Penguin Fixed"],
    [6440, "Vm Natural History Display Case Camel"],
    [6441, "Vm Natural History Display Case Camel Fixed"],
    [6442, "Vm Natural History Display Case Terror Bird"],
    [6443, "Vm Natural History Display Case Terror Bird Fixed"],
    [6444, "Vm Natural History Display Case Wyvern"],
    [6445, "Vm Natural History Display Case Wyvern Fixed"],
    [6446, "Vm Natural History Display Case Dragon"],
    [6447, "Vm Natural History Display Case Dragon Fixed"],
    [6448, "Vm Natural History Display Case Battle Tortoise"],
    [6449, "Vm Natural History Display Case Battle Tortoise Fixed"],
    [6450, "Vm Natural History Display Case Mole"],
    [6451, "Vm Natural History Display Case Mole Fixed"],
    [6452, "Vm Natural History Display Case Snake"],
    [6453, "Vm Natural History Display Case Snake Fixed"],
    [6454, "Vm Canal Barge Workman Kneeling Hammering"],
    [6455, "Vm Canal Barge Workman Sawing"],
    [6456, "Vm Canal Barge Workman Sledgehammering"],
    [6457, "Vm Canal Barge Workman Painting Tar"],
    [6458, "Vm Canal Barge Foremen Talking"],
    [6459, "Vm Player Use Rockpick"],
    [6460, "Vm Rockpick Dust Spotanim"],
    [6461, "Vm Archaeoligist Cleaning Table"],
    [6462, "Vm Player Button Push"],
    [6463, "Vm Botton Loc Push"],
    [6464, "Vm Outside Gate Guard Ready"],
    [6465, "Vm Outside Gate Guard Shaking Head"],
    [6466, "Fai Varrock Child Swings"],
    [6467, "Fai Varrock Whirly Washing Line"],
    [6468, "Fai Varrock Limp Walk"],
    [6469, "Fai Varrock Ikov Lucien Ready"],
    [6470, "Fai Varrock Wheat Sway"],
    [6471, "Vm School Girl Skip"],
    [6472, "Vm School Girl Ready"],
    [6473, "Vm School Girl Ready Var1"],
    [6474, "Vm School Girl Ready Var2"],
    [6475, "Vm School Girl Ready Var3"],
    [6476, "Vm Natural History Display Case Kalphite Queen"],
    [6477, "Vm Natural History Display Case Kalphite Queen Fixed"],
    [6478, "Varrock Granny Rocking"],
    [6479, "Varrock Tramp Walk"],
    [6480, "Varrock Tramp Ready"],
    [6481, "Varrock Heavybag Ready"],
    [6482, "Varrock Heavybag Defend"],
    [6483, "Varrock Heavybag Attack"],
    [6484, "Fai Varrock Child Ready"],
    [6485, "Fai Varrock Child Ready Offset"],
    [6486, "Fai Varrock Guard Walk"],
    [6487, "Fai Varrock Guard Ready"],
    [6488, "Fai Varrock Guard Defend"],
    [6489, "Fai Varrock Guard Attack"],
    [6490, "Fai Varrock Guard Death"],
    [6491, "Fai Varrock 2 Npc Table"],
    [6492, "Fai Varrock Central Square"],
    [6493, "Fai Varrock Mill Engine2"],
    [6494, "Fai Varrock Mill Stone"],
    [6495, "Fai Varrock Millsail"],
    [6496, "Dragon Ready Poh Fix"],
    [6497, "Grim Beanstalk 3x3 Growing"],
    [6498, "Grim Beanstalk 1x1 Growing Spot"],
    [6499, "Grim Beanstalk 3x3 Shrinking"],
    [6500, "Grim 1x1 Beanstalk Collapsing"],
    [6501, "Grim Giant Attack"],
    [6502, "Grim Giant Death"],
    [6503, "Grim Giant Defend"],
    [6504, "Grim Giant Ready"],
    [6505, "Grim Giant Walk"],
    [6506, "Grim Grimnash Asleep Ready"],
    [6507, "Grim Grimnash Ready"],
    [6508, "Grim Grimnash Warning Attack"],
    [6509, "Grim Dwarf Tower Ready"],
    [6510, "Grim Experiment No2 Walk"],
    [6511, "Grim Experiment No2 Ready"],
    [6512, "Grim Experiment No2 Death"],
    [6513, "Grim Experiment No2 Attack"],
    [6514, "Grim Experiment No2 Proj Attack"],
    [6515, "Grim Experiment No2 Defend"],
    [6516, "Grim Experiment No2 Head Proj"],
    [6517, "Grim Giant Mouse Walk"],
    [6518, "Grim Giant Mouse Ready"],
    [6519, "Grim Giant Mouse Attack"],
    [6520, "Grim Giant Mouse Defend"],
    [6521, "Grim Giant Mouse Death"],
    [6522, "Grim Gramaphone Multi Anim"],
    [6523, "Grim Magic Circle Glow"],
    [6524, "Grim Giant Taunt"],
    [6525, "Grim Spitting"],
    [6526, "Grim Story Telling"],
    [6527, "Grim Player Gramaphone Windup"],
    [6528, "Grim Player Kicking Gramaphone"],
    [6529, "Grim Player Shrinking"],
    [6530, "Grim Player Growing"],
    [6531, "Grim Woman Long Skirt Walk"],
    [6532, "Grim Woman Long Skirt Walk Backwards"],
    [6533, "Grim Gnome Ready1"],
    [6534, "Grim Gnome Ready2"],
    [6535, "Grim Gnome Ready3"],
    [6536, "Werewolf Attack"],
    [6537, "Werewolf Death"],
    [6538, "Werewolf Defend"],
    [6539, "Werewolf Ready"],
    [6540, "Werewolf Ready Extra"],
    [6541, "Werewolf Walk"],
    [6542, "Werewolf On Throne"],
    [6543, "Werewolf Transform Werewolf"],
    [6544, "Werewolf Walk With Human"],
    [6545, "Werewolf Ready With Human"],
    [6546, "Werewolf Ready With Stick"],
    [6547, "Werewolf Throw Stick"],
    [6548, "Werewolf Walk With Stick"],
    [6549, "Werewolf Ready Trainer Extra"],
    [6550, "Werewolf Angry Chathead"],
    [6551, "Lore Wolf Chathead Idle"],
    [6552, "Lore Wolf Chathead Sad"],
    [6553, "Lore Wolf Chathead Quizzical"],
    [6554, "Werewolf Transform Human"],
    [6555, "Lore Wolf Chathead Happy"],
    [6556, "Dog Wolf Walk"],
    [6557, "Dog Wolf Defend"],
    [6558, "Dog Wolf Death"],
    [6559, "Dog Wolf Attack"],
    [6560, "Dog Walk"],
    [6561, "Dog Small Dog Ready"],
    [6562, "Dog Small Dog Attack"],
    [6563, "Dog Medium Dog Defend"],
    [6564, "Dog Medium Dog Death"],
    [6565, "Dog Medium Dog Attack"],
    [6566, "Dog Jackal Defend"],
    [6567, "Dog Jackal Death"],
    [6568, "Dog Jackal Attack"],
    [6569, "Dog Fox Defend"],
    [6570, "Dog Fox Death"],
    [6571, "Dog Medium Dog Walk"],
    [6572, "Dog Fight Arena Attack"],
    [6573, "Dog Fight Arena Defend"],
    [6574, "Dog Godwars Defend"],
    [6575, "Human Spellcast Arceuus Teleport"],
    [6576, "Dog Hellhound Godwars Death"],
    [6577, "Dog Skeleton Hellhound Walk"],
    [6578, "Dog Skeleton Hellhound Defend"],
    [6579, "Dog Skeleton Hellhound Attack"],
    [6580, "Dog Wolf Ready"],
    [6581, "Dog Hellhound Godwars Attack"],
    [6582, "Dog Hellhound Godwars Walk"],
    [6583, "Dog Hellhound Walk"],
    [6584, "Grim Farming Seed Dibbing"],
    [6585, "Darkbow Dragon Head Projanim"],
    [6586, "Darkbow Dragon Head Impact"],
    [6587, "Darkbow Smoke Arrow Flight"],
    [6588, "Darkbow Darkbow Smoke Arrow Impact"],
    [6589, "Dark Bow Broad Arrow Smoke Projanim"],
    [6590, "Dark Bow Generic Arrow Smoke Projanim"],
    [6591, "Ii Jar Maker Spotanim"],
    [6592, "Ii Player Use Jar Maker"],
    [6593, "Ii Human Walk Thru Wheat Fast"],
    [6594, "Ii Human Walk Thru Wheat Mid Speed"],
    [6595, "Ii Human Walk Thru Wheat Slowly"],
    [6596, "Ii Wheat Grow"],
    [6597, "Ii Wheat Grow Frame1"],
    [6598, "Ii Wheat Wilt Frame1"],
    [6599, "Ii Wheat Wilt"],
    [6600, "Ii Human Dart Throw"],
    [6601, "Ii Human Teleport"],
    [6602, "Ii Portal Spotanim"],
    [6603, "Ii Human Net Run"],
    [6604, "Ii Human Net Ready"],
    [6605, "Ii Human Net Throw"],
    [6606, "Ii Human Net Throw Oldnet"],
    [6607, "Ii Human Net Walkforward"],
    [6608, "Ii Human Net Walkbackwards"],
    [6609, "Ii Human Net Walkright"],
    [6610, "Ii Human Net Walkleft"],
    [6611, "Ii Human Net Turnonspot"],
    [6612, "Ii Smokepuff Anim"],
    [6613, "Ii Impling Ready"],
    [6614, "Ii Impling Walk"],
    [6615, "Ii Impling Caught"],
    [6616, "Ii Impling Dodge"],
    [6617, "Ii Impling Escape Anim"],
    [6618, "Ii Impling Noise"],
    [6619, "Ii Impling Release Kicked"],
    [6620, "Ii Impling Release Travel"],
    [6621, "Ii Impling Release Escape Spotanim"],
    [6622, "Ii Flaming Projectile"],
    [6623, "Ii Magic Wheat Bl"],
    [6624, "Ii Magic Wheat Bm"],
    [6625, "Ii Magic Wheat Br"],
    [6626, "Ii Magic Wheat Mr"],
    [6627, "Ii Magic Wheat M"],
    [6628, "Ii Imp Pickpocket"],
    [6629, "Ii Imp Pickpocket Fail"],
    [6630, "Ii Imp Release"],
    [6631, "Dragon Slayer Qip Death1"],
    [6632, "Dragon Slayer Qip Death2"],
    [6633, "Dragon Slayer Qip Death3"],
    [6634, "Dragon Slayer Qip Skel Death"],
    [6635, "Dragon Slayer Qip Magic Door Ready"],
    [6636, "Dragon Slayer Qip Magic Door Open"],
    [6637, "Dragon Slayer Qip Magic Door Closing"],
    [6638, "Dragon Slayer Qip Candle Fire"],
    [6639, "Dragon Slayer Qip Vine Ready"],
    [6640, "Dragon Slayer Qip Cr Journey"],
    [6641, "Dragon Slayer Qip Elvarg Fly"],
    [6642, "Dragonslayer Elvarg Fire"],
    [6643, "Dragonslayer Elvarg Fire2"],
    [6644, "Dragon Slayer Qip Cloud"],
    [6645, "Dragon Slayer Qip Fire"],
    [6646, "Dragon Slayer Qip Fire1x1"],
    [6647, "Dragon Slayer Qip Fire Impact"],
    [6648, "Dragon Slayer Qip Fireball"],
    [6649, "Dragon Slayer Qip Jen Scared"],
    [6650, "Dragon Slayer Qip Melzar1"],
    [6651, "Dragon Slayer Qip Melzar2"],
    [6652, "Dragon Slayer Qip Jenkins Jump"],
    [6653, "Dragon Slayer Qip Flames Anim"],
    [6654, "Dragon Slayer Qip Remove Head Part1"],
    [6655, "Dragon Slayer Qip Remove Head Part2"],
    [6656, "Dragon Slayer Qip Oracle Flapping Flag"],
    [6657, "Petrock Human Ready"],
    [6658, "Petrock Human Walk"],
    [6659, "Petrock Human Walk B"],
    [6660, "Petrock Human Running"],
    [6661, "Petrock Human Turnonspot"],
    [6662, "Petrock Human Walk L"],
    [6663, "Petrock Human Walk R"],
    [6664, "Petrock Human Stay"],
    [6665, "Petrock Human Stick"],
    [6666, "Dragon Slayer Child Death"],
    [6667, "Petrock Spotanim Stay"],
    [6668, "Petrock Spotanim Stick"],
    [6669, "Petrock Projanim Stick"],
    [6670, "Petrock Spotanim Stick Land"],
    [6671, "Xbows Stringing Crossbow Bronze"],
    [6672, "Xbows Stringing Crossbow Blurite"],
    [6673, "Xbows Stringing Crossbow Iron"],
    [6674, "Xbows Stringing Crossbow Steel"],
    [6675, "Xbows Stringing Crossbow Mithril"],
    [6676, "Xbows Stringing Crossbow Adamantite"],
    [6677, "Xbows Stringing Crossbow Runite"],
    [6678, "Stringing Shortbow"],
    [6679, "Stringing Oak Shortbow"],
    [6680, "Stringing Willow Shortbow"],
    [6681, "Stringing Maple Shortbow"],
    [6682, "Stringing Yew Shortbow"],
    [6683, "Stringing Magic Shortbow"],
    [6684, "Stringing Longbow"],
    [6685, "Stringing Oak Longbow"],
    [6686, "Stringing Willow Longbow"],
    [6687, "Stringing Maple Longbow"],
    [6688, "Stringing Yew Longbow"],
    [6689, "Stringing Magic Longbow"],
    [6690, "Qip Dragon Slayer Shield Charge One"],
    [6691, "Qip Dragon Slayer Shield Charge Two"],
    [6692, "Qip Dragon Slayer Shield Charge Three"],
    [6693, "Qip Dragon Slayer Shield Charge Four"],
    [6694, "Qip Dragon Slayer Shield Charge Five"],
    [6695, "Qip Dragon Slayer Player Absorbing Fire"],
    [6696, "Qip Dragon Slayer Player Unleashing Fire"],
    [6697, "Qip Dragon Slayer Shield Attack Spotanim"],
    [6698, "Qip Dragon Slayer Player Projanim"],
    [6699, "Qip Dragon Slayer Player Impact"],
    [6700, "Qip Dragon Slayer Player Releasing Charge"],
    [6701, "Qip Dragon Slayer Release Charge Spotanim"],
    [6702, "Brut Human Knifeuse"],
    [6703, "Brut Player Hand Fishing Start"],
    [6704, "Brut Player Hand Fishing Ready"],
    [6705, "Brut Player Hand Fishing End Shark 2"],
    [6706, "Brut Player Hand Fishing End Shark 1"],
    [6707, "Brut Player Hand Fishing End Swordfish 1"],
    [6708, "Brut Player Hand Fishing End Swordfish 2"],
    [6709, "Brut Player Hand Fishing End Blank"],
    [6710, "Brut Player Hand Fishing End Tuna 1"],
    [6711, "Brut Player Hand Fishing End Tuna 2"],
    [6712, "Brut Human Smithing"],
    [6713, "Brut Player Firemaking Aide Shortbow"],
    [6714, "Brut Player Firemaking Shortbow"],
    [6715, "Brut Player Firemaking Oak Shortbow"],
    [6716, "Brut Player Firemaking Willow Shortbow"],
    [6717, "Brut Player Firemaking Maple Shortbow"],
    [6718, "Brut Player Firemaking Yew Shortbow"],
    [6719, "Brut Player Firemaking Magic Shortbow"],
    [6720, "Brut Player Firemaking Daganoth Bow"],
    [6721, "Brut Bow Firemaking Spotanim"],
    [6722, "Brut Dragon Casting"],
    [6723, "Brut Player Jump Whirlpool"],
    [6724, "Brut Ascending Spirit"],
    [6725, "Brut Angry Spirit Appear"],
    [6726, "Brut Angry Spirit Attack"],
    [6727, "Brut Angry Spirit Death"],
    [6728, "Brut Angry Spirit Defend"],
    [6729, "Brut Angry Spirit Ready"],
    [6730, "Brut Angry Spirit Walk"],
    [6731, "Brut Waterfall Anim"],
    [6732, "Brut Waterfall Anim Tall"],
    [6733, "Brut Pyre Boat Fire"],
    [6734, "Brut Pyre Boat Launch"],
    [6735, "Brut Pyre Boat Ready"],
    [6736, "Brut Pyre Boat Sink"],
    [6737, "Skill Brut Whirlpool Anim"],
    [6738, "Brut Human Canoeing Carve Rune Axe"],
    [6739, "Brut Human Canoeing Carve Adamant Axe"],
    [6740, "Brut Human Canoeing Carve Mithril Axe"],
    [6741, "Brut Human Canoeing Carve Black Axe"],
    [6742, "Brut Human Canoeing Carve Steel Axe"],
    [6743, "Brut Human Canoeing Carve Iron Axe"],
    [6744, "Brut Human Canoeing Carve Bronze Axe"],
    [6745, "Brut Human Canoeing Carve Dragon Axe"],
    [6746, "Human Mining Rune Pickaxe Noreachforward"],
    [6747, "Human Mining Bronze Pickaxe Noreachforward"],
    [6748, "Human Mining Iron Pickaxe Noreachforward"],
    [6749, "Human Mining Steel Pickaxe Noreachforward"],
    [6750, "Human Mining Adamant Pickaxe Noreachforward"],
    [6751, "Human Mining Mithril Pickaxe Noreachforward"],
    [6752, "Human Mining Rune Pickaxe Wall"],
    [6753, "Human Mining Bronze Pickaxe Wall"],
    [6754, "Human Mining Iron Pickaxe Wall"],
    [6755, "Human Mining Steel Pickaxe Wall"],
    [6756, "Human Mining Adamant Pickaxe Wall"],
    [6757, "Human Mining Mithril Pickaxe Wall"],
    [6758, "Human Mining Dragon Pickaxe Wall"],
    [6759, "Mounted Terrorbird Gnome Hands Over Food"],
    [6760, "Terrorchick Food Delivery"],
    [6761, "Chompy Attack"],
    [6762, "Chompy Death"],
    [6763, "Chompy Defend"],
    [6764, "Chompy Ready And Extra"],
    [6765, "Chompy Walk"],
    [6766, "Chompy Fly Down"],
    [6767, "Chompy Fly Up"],
    [6768, "Chompy Permadeath"],
    [6769, "Animatronic Terrorbird"],
    [6770, "Animatronic Terrorbird Ready"],
    [6771, "Bird Flying Ready And Extra"],
    [6772, "Bird Flying Ready And Extra Toucan And Cormarant"],
    [6773, "Bird Flying Ready"],
    [6774, "Bird Flying Ready Toucan And Cormarant"],
    [6775, "Bird Flying Attack"],
    [6776, "Bird Flying Defend"],
    [6777, "Bird Flying Death"],
    [6778, "Bird Flying Death Large Bird"],
    [6779, "Bird Flying Death Medium Bird"],
    [6780, "Bird Lands On Trap"],
    [6781, "Bird Gets Caught In Trap"],
    [6782, "Bird Caught In Trap Ready"],
    [6783, "Bird Lands On Trap And Flies Off"],
    [6784, "Crow Fly"],
    [6785, "Crow Ready"],
    [6786, "Crow Ready 2"],
    [6787, "Crow Ready 3"],
    [6788, "Seagull Ready And Fly Test"],
    [6789, "Terror Bird Ready Extra"],
    [6790, "Mounted Terrorbird Attack"],
    [6791, "Mounted Terrorbird Death"],
    [6792, "Mounted Terrorbird Defend"],
    [6793, "Mounted Terrorbird Ready"],
    [6794, "Mounted Terrorbird Ready Extra"],
    [6795, "Mounted Terrorbird Ready Timer"],
    [6796, "Mounted Terrorbird Walk"],
    [6797, "Mounted Terrorbird Ready Timer 1x1"],
    [6798, "Mounted Terrorbird Ready 1x1"],
    [6799, "Mounted Terrorbird Walk 1x1"],
    [6800, "Jubbly Attack"],
    [6801, "Jubbly Death"],
    [6802, "Jubbly Defend"],
    [6803, "Jubbly Ready And Extra"],
    [6804, "Jubbly Walk"],
    [6805, "Jubbly Fly Down"],
    [6806, "Jubbly Fly Up"],
    [6807, "Jubbly Permadeath"],
    [6808, "Firebird Fly"],
    [6809, "Firebird Ready"],
    [6810, "Firebird Defend"],
    [6811, "Firebird Attack"],
    [6812, "Firebird Death"],
    [6813, "Duck Rework Land Ready Extra"],
    [6814, "Duck Rework Ready"],
    [6815, "Duck Rework Land Ready And Extra"],
    [6816, "Duck Rework Ready Extra"],
    [6817, "Duck Rework Swim"],
    [6818, "Duck Rework Underwater Ready And Extra"],
    [6819, "Duck Rework Walk"],
    [6820, "Duckling Rework Swim"],
    [6821, "Ducklings Rework Ready"],
    [6822, "Ducklings Rework Swim"],
    [6823, "Jubster Death"],
    [6824, "Lore Bird Chathead Sad"],
    [6825, "Pattern Dragon Teacher Ready"],
    [6826, "Pattern Imp On Stool Ready"],
    [6827, "Qip Observatory Goblin Wake Up"],
    [6828, "Qip Observatory Goblin Sleeping"],
    [6829, "Qip Observatory Goblin Drunk Ready And Extra"],
    [6830, "Qip Observatory Goblin Drunk Ready Timer"],
    [6831, "Qip Observatory Cooking Goblin Ready And Extra"],
    [6832, "Qip Observatory Cooking Goblin Ready Timer"],
    [6833, "Qip Observatory Setting A Fire Ready And Extra"],
    [6834, "Qip Observatory Goblin Chatter One"],
    [6835, "Qip Observatory Goblin Chatter Two"],
    [6836, "Qip Observatory Huck Fin Goblin Ready And Extra"],
    [6837, "Qip Observatory Huck Fin Goblin Ready Timer"],
    [6838, "Human Kicks Chest Open"],
    [6839, "Qip Observatory Human Wakes Up Goblin"],
    [6840, "Generic Look And Search"],
    [6841, "Astronomers Assistant Works At Desk"],
    [6842, "Human Wakes Up Goblin"],
    [6843, "Walk Up Stairs Static"],
    [6844, "Professor Fixing Scope Scratch Head"],
    [6845, "Professor Fixing Scope Screw Driver"],
    [6846, "Professor Fixing Scope Pull Lever"],
    [6847, "Professor Fixing Scope Hammer Time"],
    [6848, "Professor Fitting Lens"],
    [6849, "Look Through Scope"],
    [6850, "Chest Closes"],
    [6851, "Chest Kicked Open"],
    [6852, "Camp Fire Burst"],
    [6853, "Camp Fire"],
    [6854, "Pattern Rocking Horse Anim"],
    [6855, "Pattern Zombie At Desk Ready"],
    [6856, "Pattern Mummy At Desk Ready"],
    [6857, "Pattern Giant At Desk Ready"],
    [6858, "Pattern Goblin1 At Desk Ready"],
    [6859, "Pattern Goblin2 At Desk Ready"],
    [6860, "Twinkling Stars"],
    [6861, "Bubbling Beans"],
    [6862, "Spider Falls From Ceiling"],
    [6863, "Town Crier Scratch Head"],
    [6864, "Town Crier Ready"],
    [6865, "Town Crier Bell Ring"],
    [6866, "Town Crier Show Book"],
    [6867, "Town Crier Walk"],
    [6868, "Torcher Teleport"],
    [6869, "Splatter Teleport"],
    [6870, "Brawler Teleport"],
    [6871, "Ravager Teleport"],
    [6872, "Defiler Teleport"],
    [6873, "Pest Skill Banner Flap"],
    [6874, "Pest Skill Banner Billowing"],
    [6875, "Pest Skill Banner Flapq"],
    [6876, "Pest Spinner Explode"],
    [6877, "Pest Spinner Explode Spot"],
    [6878, "Pest Portal Shield Ready"],
    [6879, "Pest Portal Shield Ready East"],
    [6880, "Pest Portal Shield Ready West"],
    [6881, "Pest Portal Shield Defend"],
    [6882, "Pest Portal Shield Defend East"],
    [6883, "Pest Portal Shield Defend West"],
    [6884, "Pest Portal Shield Death"],
    [6885, "Pest Portal Shield Death East"],
    [6886, "Pest Portal Shield Death West"],
    [6887, "Pest Magic Attack"],
    [6888, "Spiral Attack Human"],
    [6889, "Spiral Attack"],
    [6890, "Kr Court Audience Singles One"],
    [6891, "Kr Court Audience Singles Two"],
    [6892, "Kr Court Audience Singles Three"],
    [6893, "Kr Court Audience Singles Four"],
    [6894, "Kr Court Audience Singles Five"],
    [6895, "Kr Court Audience Singles Six"],
    [6896, "Kr Npc Coshing Player"],
    [6897, "Kr Player Ko"],
    [6898, "Kr Judge Ready"],
    [6899, "Kr Judge Hammering Order"],
    [6900, "Kr Jury Ready Group A"],
    [6901, "Kr Jury Ready Group B"],
    [6902, "Kr Jury Ready Group C"],
    [6903, "Kr Jury Ready Group D"],
    [6904, "Kr Jury Nodding Group A"],
    [6905, "Kr Jury Nodding Group B"],
    [6906, "Kr Jury Nodding Group C"],
    [6907, "Kr Jury Nodding Group D"],
    [6908, "Kr Jury Shaking Group A"],
    [6909, "Kr Jury Shaking Group B"],
    [6910, "Kr Jury Shaking Group C"],
    [6911, "Kr Jury Shaking Group D"],
    [6912, "Kr Cam Knights Jail Ready Lucan"],
    [6913, "Kr Cam Knights Jail Ready Palomedes"],
    [6914, "Kr Cam Knights Jail Ready Lancelot"],
    [6915, "Kr Cam Knights Jail Ready Bedivere"],
    [6916, "Kr Cam Knights Tristram Jailed"],
    [6917, "Kr Sleeping Wizard"],
    [6918, "Kr Keep Knight Posing"],
    [6919, "Kr Sincalir Family Pacing"],
    [6920, "Kr Cam Knights Pyramid Climb"],
    [6921, "Kr King Arthur Reveal"],
    [6922, "Kr Player Pulling Statue Arm"],
    [6923, "Kr Human Smashing Glass"],
    [6924, "Kr Broken Glass Spotanim"],
    [6925, "Kr Cam Knights Tristram Jailed Tweaked"],
    [6926, "Kr Sinclair Family Pacing Male Tweaked"],
    [6927, "Kr Keep Le Faye Guard Ready"],
    [6928, "Kr Keep Le Faye Guard Walk"],
    [6929, "Kr Keep Le Faye Guard Defend"],
    [6930, "Kr Smoke Puff Player"],
    [6931, "Fly Paper Ready"],
    [6932, "Human Fishing Casting Pearl Oily"],
    [6933, "Falador Partyroom Wall Lever"],
    [6934, "Falador Party Room Lever"],
    [6935, "Godwars Zamorak Ready"],
    [6936, "Carpet Flying"],
    [6937, "Castlewars Pray Start"],
    [6938, "Castlewars Pray End"],
    [6939, "Nzone Nazasterool Skeleton Arise"],
    [6940, "Nzone Nazasterool Ghost Arise"],
    [6941, "Nzone Barrel Use1"],
    [6942, "Nzone Barrel Use2 Nzone4dose2rangerspotion"],
    [6943, "Nzone Barrel Use2 Nzone4dose2magicpotion"],
    [6944, "Nzone Barrel Use2 Nzone4doseoverloadpotion"],
    [6945, "Nzone Barrel Use2 Nzone4doseabsorptionpotion"],
    [6946, "Shayzien Lizard Boss Land"],
    [6947, "Godwars Zamorak Defend"],
    [6948, "Godwars Zamorak Attack"],
    [6949, "Godwars Zamorak Death"],
    [6950, "Godwars Zamorak Magic Attack"],
    [6951, "Godwars Zamorak Magic Attack Spotanim"],
    [6952, "Godwars Armadyl Ready"],
    [6953, "Godwars Armadyl Walk"],
    [6954, "Wildy Hub Entrance Glow"],
    [6955, "Godwars Armadyl Cannon Attack"],
    [6956, "Godwars Armadyl Spear Attack"],
    [6957, "Godwars Armadyl Sword Attack"],
    [6958, "Godwars Armadyl Defend"],
    [6959, "Godwars Armadyl Death"],
    [6960, "Godwars Armadyl Spear Travel Spotanim"],
    [6961, "Godwars Armadyl Axe Travel Spotanim"],
    [6962, "Godwars Armadyl Bolt Attack Spotanim"],
    [6963, "Godwars Armadyl Bolt Attack Projanim"],
    [6964, "Godwars Armadyl Bolt Hit Spotanim"],
    [6965, "Godwars Saradomin Walk"],
    [6966, "Godwars Saradomin Ready"],
    [6967, "Godwars Saradomin Attack"],
    [6968, "Godwars Saradomin Death"],
    [6969, "Godwars Saradomin Defend"],
    [6970, "Godwars Saradomin Magic Attack"],
    [6971, "Godwars Saradomin Magic Attack Spotanim"],
    [6972, "Godwars Spiritual Ork Ranger Ranged Attack"],
    [6973, "Godwars Spiritual Ork Ranger Ranged Attack Spotanim"],
    [6974, "Godwars Spiritual Armadyl Warrior Magic Spotanim"],
    [6975, "Godwars Spiritual Armadyl Warrior Magic"],
    [6976, "Godwars Armadyl Avatar Ready"],
    [6977, "Godwars Armadyl Avatar Walk"],
    [6978, "Godwars Armadyl Avatar Defend"],
    [6979, "Godwars Armadyl Avatar Death"],
    [6980, "Godwars Armadyl Avatar Wind Attack"],
    [6981, "Godwars Armadyl Avatar Claw Attack"],
    [6982, "Godwars Spiritual Ork Mage Magic Attack"],
    [6983, "Godwars Ea Player Move Boulder"],
    [6984, "Godwars Ea Player Move Boulder South"],
    [6985, "Godwars Ea Boulder Move Up"],
    [6986, "Godwars Ea Boulder Move Down"],
    [6987, "Godwars Big Hole Light"],
    [6988, "Godwars Ripple Anim"],
    [6989, "Godwars Goblin Ready"],
    [6990, "Godwars Goblin Banner Walking"],
    [6991, "Godwars Imp Magi Attack"],
    [6992, "Godwars Imp Magi Attack Spotanim"],
    [6993, "Godwars Human Swim Double"],
    [6994, "Godwars Surface Swim"],
    [6995, "Godwars Swim Forward"],
    [6996, "Godwars Swim Ready"],
    [6997, "Godwars Swim Attack"],
    [6998, "Godwars Swim Defend"],
    [6999, "Godwars Swim Death"],
    [7000, "Godwars Snowing Anim"],
    [7001, "Godwars Small Snowdrops"],
    [7002, "Superior Hydra Idle"],
    [7003, "Godwars Saradomin Sword Attack Spot"],
    [7004, "Godwars Godsword Zamorak Player"],
    [7005, "Godwars Godsword Zamorak Spot"],
    [7006, "Superior Hydra Walk"],
    [7007, "Godwars Godsword Armadyl Spot"],
    [7008, "Superior Hydra Attack Ranged"],
    [7009, "Godwars Godsword Saradomin Spot"],
    [7010, "Superior Hydra Attack Magic"],
    [7011, "Godwars Godsword Bandos Spot"],
    [7012, "100 Dave Spectate"],
    [7013, "Godwars Dying Paladin Ready"],
    [7014, "Godwars Dying Paladin Death"],
    [7015, "Godwars Dying Paladin Dead"],
    [7016, "Godwars Bandos Walk"],
    [7017, "Godwars Bandos Ready"],
    [7018, "Godwars Bandos Attack"],
    [7019, "Godwars Bandos Defend"],
    [7020, "Godwars Bandos Death"],
    [7021, "Godwars Bandos Ranged"],
    [7022, "Godwars Bandos Proj"],
    [7023, "Godwars Bandos Spot"],
    [7024, "Godwars Waterfall"],
    [7025, "Godwars Waterfall Slow"],
    [7026, "Godwars Centaur Attack Ranged"],
    [7027, "Godwars Centaur Defend"],
    [7028, "Godwars Centaur Death"],
    [7029, "Godwars Centaur Arrow Launch"],
    [7030, "Godwars Centaur Arrow Proj"],
    [7031, "Godwars Ancient Ork Death"],
    [7032, "Godwars Lion Ready"],
    [7033, "Godwars Lion Walk"],
    [7034, "Godwars Lion Death"],
    [7035, "Godwars Lion Defend"],
    [7036, "Godwars Lion Attack"],
    [7037, "Godwars Lion Magic Attack"],
    [7038, "Godwars Lion Magic Spot"],
    [7039, "Godwars Lion Magic Proj"],
    [7040, "Godwars Lion Magic Impact"],
    [7041, "Godwars Human Crawling"],
    [7042, "Godwars Goblin Banner Death"],
    [7043, "Dh Sword Run"],
    [7044, "Dh Sword Turnonspot"],
    [7045, "Dh Sword Slash"],
    [7046, "Dh Sword Chop"],
    [7047, "Dh Sword Walk Right"],
    [7048, "Dh Sword Walk Left"],
    [7049, "Human Poh Build Dwh"],
    [7050, "Dh Sword Saradomin Special Spotanim"],
    [7051, "Dh Sword Zamorak Special Spotanim"],
    [7052, "Dh Sword Walk"],
    [7053, "Dh Sword Ready"],
    [7054, "Dh Sword Smash"],
    [7055, "Dh Sword Block"],
    [7056, "Dh Sword Defend"],
    [7057, "Birdhouse Make"],
    [7058, "Zeah Chathead Nod"],
    [7059, "Chair Eat Stool 1"],
    [7060, "Zeah Chathead Quiz"],
    [7061, "Zeah Chathead Sad"],
    [7062, "Dh Sword Armadyl Special Spotanim"],
    [7063, "Dh Sword Saradomin God Special Spotanim"],
    [7064, "Dh Sword Bandos Special Spotanim"],
    [7065, "Dh Sword Dragon Spotanim"],
    [7066, "Dh Sword Dragon Special Player"],
    [7067, "Godwars Uwater Severed Arm"],
    [7068, "Godwars Uwater Deadguy"],
    [7069, "Godwars Goblin2 Sonic Attk Proj"],
    [7070, "Godwars Goblin2 Sonic Attk Spot"],
    [7071, "Godwars Sergeant Goblin2 Sonic"],
    [7072, "Godwars Goblin2 Sonic Impact"],
    [7073, "Godwars Sergeant Goblin3 Ranged"],
    [7074, "Godwars Goblin3 Handaxe Proj"],
    [7075, "Godwars Saradomin Light Attk Spot"],
    [7076, "Godwars Zamarok Bdygrd Ranged Spot"],
    [7077, "Godwars Zamorak Bdygrd Ranged"],
    [7078, "Godwars Zamorak Bdygrd Ranged Proj"],
    [7079, "Godwars Zamorak Magic Attack Spot"],
    [7080, "Godwars Zamorak Magic Attack Proj"],
    [7081, "Godwars Black Demon Fireball Spot"],
    [7082, "Godwars Black Demon Fireball Proj"],
    [7083, "Sotd Special"],
    [7084, "Sotd Special Start"],
    [7085, "Sotd Special Extra"],
    [7086, "Aluft Gnome Sitting Facing East"],
    [7087, "Chair Eat Stool 2"],
    [7088, "Chair Eat Throne 1"],
    [7089, "Chair Eat Throne 2"],
    [7090, "Chair Eat Throne 3"],
    [7091, "Chair Eat Throne 4"],
    [7092, "Chair Eat Throne 5"],
    [7093, "Chair Eat Throne 6"],
    [7094, "Chair Eat Throne 7"],
    [7095, "Sire Attack Spawns Two"],
    [7096, "Sire Panic Mode"],
    [7097, "Sire Idle Three"],
    [7098, "Sire Apocalypse"],
    [7099, "Sire Idle Four"],
    [7100, "Sire Death"],
    [7101, "Nexus Floor Beat 1"],
    [7102, "Nexus Lung Death"],
    [7103, "Nexus Lung Death Loop"],
    [7104, "Nexus Floor Beat 2"],
    [7105, "Nexus Lung Wheezing"],
    [7106, "Abyssal Tentacle Idle"],
    [7107, "Abyssal Tentacle Sleeping"],
    [7108, "Abyssal Tentacle Waking"],
    [7109, "Abyssal Tentacle Attack"],
    [7110, "Abyssal Tentacle Sleeping Reversed"],
    [7111, "Abyssal Tentacle Waking Reversed"],
    [7112, "Abyssal Tentacle Stunned"],
    [7113, "Abyssal Tentacle Stunned Loop"],
    [7114, "Abyssal Tentacle Unstunned"],
    [7115, "Abyssal Miasma Spotanim"],
    [7116, "Overseer Idle"],
    [7117, "Overseer Talk 1"],
    [7118, "Lunar Human Magic Geomancy"],
    [7119, "Quest Lunar Spellbook Geomancy"],
    [7120, "Max Cape Spotanim"],
    [7121, "Max Cape Player Anim"],
    [7122, "Max Get Up"],
    [7123, "Abyssal Scion Spawn"],
    [7124, "Abyssal Scion Walk"],
    [7125, "Abyssal Scion Idle"],
    [7126, "Abyssal Scion Attack Melee"],
    [7127, "Abyssal Scion Attack Ranged"],
    [7128, "Abyssal Scion Defend"],
    [7129, "Abyssal Scion Death"],
    [7130, "Abyssal Scion Chathead Talk"],
    [7131, "Ash Emote"],
    [7132, "Rooftops Pole Vault"],
    [7133, "Agility Shortcut Wall Jumpdown Noreachforward"],
    [7134, "Human Walk Logbalance Loop"],
    [7135, "Slayer Kraken Arise"],
    [7136, "Wounded Dead"],
    [7137, "Slayer Tots Charge"],
    [7138, "Rockknocker"],
    [7139, "Human Mining Dragon Pickaxe"],
    [7140, "Human Mining Dragon Pickaxe Noreachforward"],
    [7141, "Surok Rune Combine Loop"],
    [7142, "Human Ledge Walk Right Looped"],
    [7143, "Kastori Harvester Walk F"],
    [7144, "Kastori Harvester Ready"],
    [7147, "Lore Polar Bear Arc Blast Spot"],
    [7148, "Lore Polar Bear Arc Blast Proj"],
    [7149, "Lore Polar Bear Arc Blast Impact"],
    [7150, "Lore Polar Bear Clout Impact"],
    [7151, "Snakeboss Sliceeel"],
    [7152, "Shayzien Lizard Boss Jump"],
    [7153, "Horror Preach Bandos"],
    [7154, "Horror Preach Armadyl"],
    [7155, "Horror Preach Zaros"],
    [7156, "Pollbooth"],
    [7157, "Shayzien Lizard Boss Minion Summon"],
    [7158, "Shayzien Lizard Boss Tail Swipe"],
    [7159, "Shayzien Lizard Boss Hands To Head"],
    [7160, "Shayzien Lizard Boss Rise"],
    [7161, "Teleport Scroll Blue Stars Spotanim"],
    [7162, "Necro Swirl Spell"],
    [7163, "Res Necromancy Plant Spell"],
    [7164, "Res Necromancy Float Mud"],
    [7165, "Teleport Reverse"],
    [7166, "Godwars Armadyl Pet Ready"],
    [7167, "Godwars Armadyl Pet Walk"],
    [7168, "Zeah Chathead Talk"],
    [7169, "Zeah Chathead Laugh"],
    [7170, "Zeah Chathead Shake Head"],
    [7171, "Hunting Impling Catch"],
    [7172, "Xbows Fletching Blank"],
    [7173, "Giant Basic Spell"],
    [7174, "Wint Light Brazier Bruma"],
    [7175, "Chathypnobunny4 2006"],
    [7176, "Giant Basic Spell Loop"],
    [7177, "Lore Beaver Ready"],
    [7178, "Lore Beaver Walk"],
    [7179, "Rock Golem Chathead Idle"],
    [7180, "Rock Golem Idle"],
    [7181, "Rock Golem Walk"],
    [7182, "Chinchompa Chathead Idle"],
    [7183, "Giant Basic Stamp"],
    [7184, "Giant Basic Inject Grow"],
    [7185, "Human Zenytecutting"],
    [7186, "Chair Eat Stool 1 Delayoffset"],
    [7187, "Dream Cyrisus Sit Up Transition Reverse"],
    [7188, "Starjump Short"],
    [7189, "Pushup Short"],
    [7190, "Situp Short"],
    [7191, "Shay Lizard Warrior Ready"],
    [7192, "Shay Lizard Warrior Attack Melee"],
    [7193, "Shay Lizard Warrior Attack Ranged"],
    [7194, "Shay Lizard Warrior Defend"],
    [7195, "Shay Lizard Warrior Walk"],
    [7196, "Shay Lizard Warrior Death"],
    [7197, "Hosidius Plough Fix"],
    [7198, "Arceuus Necromancy Playeranim"],
    [7199, "Pisc Repair Hammer"],
    [7200, "Wild Cave Chainmace Defend"],
    [7201, "Arceuus Chisel Essence"],
    [7202, "Arceuus Chisel Essenceblock"],
    [7203, "Human Fish Onspot Pearl Oily"],
    [7204, "Blast Mining Dynamite"],
    [7205, "Dwarf Bendover"],
    [7206, "Dwarf Deposit"],
    [7207, "Mm2 Glough Death"],
    [7208, "Human Levitate"],
    [7209, "Eoc Pick Strength Success"],
    [7210, "Human Knockdown"],
    [7211, "Human Knockdown Loop"],
    [7212, "Human Rockfall Merge"],
    [7213, "Mm2 Cave Boss Boulder Breaking"],
    [7214, "Godwars Hammer Gong Hammer"],
    [7215, "Godwars Hammer Gong Dwh"],
    [7216, "Mm2 Cave Floor Tile Breaking"],
    [7217, "Ballista Splinter"],
    [7218, "Ballista Attack"],
    [7219, "Ballista Defend"],
    [7220, "Ballista Ready"],
    [7221, "Ballista Run"],
    [7222, "Ballista Special Attack"],
    [7223, "Ballista Walk"],
    [7224, "Demonic Gorilla Defend"],
    [7225, "Demonic Gorilla Magic"],
    [7226, "Demonic Gorilla Punch"],
    [7227, "Demonic Gorilla Range"],
    [7228, "Demonic Gorilla Smash Chest"],
    [7229, "Demonic Gorilla Death"],
    [7230, "Demonic Gorilla Idle"],
    [7231, "Demonic Gorilla Jump Up"],
    [7232, "Demonic Gorilla Land Down"],
    [7233, "Demonic Gorilla Walk"],
    [7234, "Kruk Tortured Ape Walk"],
    [7235, "Kruk Tortured Ape Idle"],
    [7236, "Kruk Tortured Ape Defend"],
    [7237, "Kruk Tortured Ape Death"],
    [7238, "Kruk Tortured Ape Magic"],
    [7239, "Kruk Tortured Ape Punch"],
    [7240, "Kruk Tortured Ape Range"],
    [7241, "Kruk Tortured Ape Smash Chest"],
    [7242, "Glidermap Longflight"],
    [7243, "Glidermap Shortflight"],
    [7244, "Glough Inject"],
    [7245, "Human Blown End"],
    [7246, "Mm2 Hunter Maniacal Monkey Walk"],
    [7247, "Mm2 Hunter Maniacal Monkey Eat"],
    [7248, "Mm2 Hunter Maniacal Monkey Panic"],
    [7249, "Mm2 Hunter Maniacal Monkey Eat And Panic"],
    [7250, "Mm2 Hunter Maniacal Monkey Projanim"],
    [7251, "Mm2 Hunter Maniacal Monkey Invisible"],
    [7252, "Mm2 Deadfall Drop Staticstart"],
    [7253, "Mm2 Deadfall Drop"],
    [7254, "Mm2 Deadfall Lift Staticstart"],
    [7255, "Mm2 Deadfall Lift"],
    [7256, "Mm2 Deadfall Lift Reverse Staticstart"],
    [7257, "Mm2 Deadfall Lift Reverse"],
    [7258, "Mm2 Deadfall Lift Check"],
    [7259, "Kruk Tortured Ape Deadfall"],
    [7260, "Kruk Tortured Ape Deadfall Reverse"],
    [7261, "Kruk Tortured Ape Deadfall Check"],
    [7262, "Anma Chopping Failed 3a Axe"],
    [7263, "Human Canoeing Carve 3a Axe"],
    [7264, "Human Woodcutting 3a Axe"],
    [7265, "Human Woodcrafting Axe 3a"],
    [7266, "Brut Human Canoeing Carve 3a Axe"],
    [7267, "Rockknocker 3a"],
    [7268, "Player Town Crier Bell Ring"],
    [7269, "Lore Dog Ready"],
    [7270, "Lore Wolf Readyextra"],
    [7271, "Ready Clue Scroll"],
    [7272, "Walk Forward Clue Scroll"],
    [7273, "Running Clue Scroll"],
    [7274, "Running Casket"],
    [7275, "Attacking Casket"],
    [7276, "Blocking Casket"],
    [7277, "Briefcase Open"],
    [7278, "Emote Uri Briefcase"],
    [7279, "Emote Uri Invisible"],
    [7280, "Bloodhound Walk"],
    [7281, "Sang Mining Wall 3a Pickaxe"],
    [7282, "Human Mining 3a Pickaxe Wall"],
    [7283, "Human Mining 3a Pickaxe"],
    [7284, "Human Mining 3a Pickaxe Noreachforward"],
    [7285, "Chair Sit Ready Garden Bench Teak Left"],
    [7286, "Chair Eat Garden Bench Teak Left"],
    [7287, "Chair Sit Ready Garden Bench Teak Right"],
    [7288, "Chair Eat Garden Bench Teak Right"],
    [7289, "Chair Sit Ready Garden Bench Gnome Left"],
    [7290, "Chair Eat Garden Bench Gnome Left"],
    [7291, "Chair Sit Ready Garden Bench Gnome Right"],
    [7292, "Chair Eat Garden Bench Gnome Right"],
    [7293, "Chair Sit Ready Garden Bench Marble Left"],
    [7294, "Chair Eat Garden Bench Marble Left"],
    [7295, "Chair Sit Ready Garden Bench Marble Right"],
    [7296, "Chair Eat Garden Bench Marble Right"],
    [7297, "Chair Sit Ready Garden Bench Obsidian Left"],
    [7298, "Chair Eat Garden Bench Obsidian Left"],
    [7299, "Chair Sit Ready Garden Bench Obsidian Right"],
    [7300, "Chair Eat Garden Bench Obsidian Right"],
    [7301, "Poh Portal Loop"],
    [7302, "Poh Altar Lunar Idle"],
    [7303, "Poh Altar Occult Idle"],
    [7304, "Poh Pool Idle"],
    [7305, "Poh Pool Drink"],
    [7306, "Rift Guardian Walk"],
    [7307, "Rift Guardian Idle"],
    [7308, "Rift Guardian Attack"],
    [7309, "Squirrel Idle"],
    [7310, "Squirrel Hop"],
    [7311, "Squirrel Attack"],
    [7312, "Tangleroot Idle"],
    [7313, "Tangleroot Walk"],
    [7314, "Tangleroot Attack"],
    [7315, "Raccoon Idle"],
    [7316, "Raccoon Walk"],
    [7317, "Raccoon Run"],
    [7318, "Raccoon Attack"],
    [7319, "Human Herbing Grind Npc"],
    [7320, "Winter Fire"],
    [7321, "Wint Brazier Lit"],
    [7322, "Wintertodt Idle B"],
    [7323, "Wintertodt Resting"],
    [7324, "Rc Zmi Lizard Ready"],
    [7325, "Rc Zmi Lizard Walk"],
    [7326, "Rc Zmi Lizzard Death"],
    [7327, "Hween16 Knife Walk"],
    [7328, "Hween16 Slash"],
    [7329, "Hween16 Hostage"],
    [7330, "Human Death Reverse"],
    [7331, "Hween16 Remove Mask"],
    [7332, "Human Ready Sheathed"],
    [7333, "Royal Sea Snake Mother Emergeandstrike"],
    [7334, "Olm Head Initial"],
    [7335, "Olm Head Spawn"],
    [7336, "Olm Head Idle Front"],
    [7337, "Olm Head Idle Right"],
    [7338, "Olm Head Idle Left"],
    [7339, "Olm Head Turn Right"],
    [7340, "Olm Head Turn Right Reverse"],
    [7341, "Olm Head Turn Left"],
    [7342, "Olm Head Turn Left Reverse"],
    [7343, "Olm Head Turn Left Right"],
    [7344, "Olm Head Turn Right Left"],
    [7345, "Olm Head Attack Acid Front"],
    [7346, "Olm Head Attack Acid Right"],
    [7347, "Olm Head Attack Acid Left"],
    [7348, "Olm Head Death Front"],
    [7349, "Olm Hand Right Initial"],
    [7350, "Olm Hand Right Spawn"],
    [7351, "Olm Hand Right Idle"],
    [7352, "Olm Hand Right Death"],
    [7353, "Olm Hand Left Initial"],
    [7354, "Olm Hand Left Spawn"],
    [7355, "Olm Hand Left Idle"],
    [7356, "Olm Hand Left Cast Stun"],
    [7357, "Olm Hand Left Cast Heal"],
    [7358, "Olm Hand Left Cast Earthshock"],
    [7359, "Olm Hand Left Cast Earthquake"],
    [7360, "Olm Hand Left Stunned"],
    [7361, "Olm Hand Left Stunned Idle"],
    [7362, "Olm Hand Left Unstunned"],
    [7363, "Olm Hand Left Gripping Spawn1"],
    [7364, "Olm Hand Left Gripping Spawn2"],
    [7365, "Olm Hand Left Gripping Idle"],
    [7366, "Olm Hand Left Gripping Attack Stun"],
    [7367, "Olm Hand Left Gripping Attack Heal"],
    [7368, "Olm Hand Left Gripping Attack Earthshock"],
    [7369, "Olm Hand Left Gripping Attack Earthquake"],
    [7370, "Olm Hand Left Death"],
    [7371, "Olm Head Attack Front Enraged"],
    [7372, "Olm Head Attack Left Enraged"],
    [7373, "Olm Head Attack Right Enraged"],
    [7374, "Olm Head Idle Front Enraged"],
    [7375, "Olm Head Idle Left Enraged"],
    [7376, "Olm Head Idle Right Enraged"],
    [7377, "Olm Head Rotate Left Enraged"],
    [7378, "Olm Head Rotate Left Reversed Enraged"],
    [7379, "Olm Head Rotate Left Right Enraged"],
    [7380, "Olm Head Rotate Right Left Enraged"],
    [7381, "Olm Head Rotate Right Enraged"],
    [7382, "Olm Head Rotate Right Reversed Enraged"],
    [7383, "Olm Head Spawn Enraged"],
    [7384, "Rock Bash"],
    [7385, "Sandtimer 10secs Looped"],
    [7386, "Human Shield Crafting Leather"],
    [7387, "Human Shield Crafting Snakeskin"],
    [7388, "Xmas16 Snowglobe Shake"],
    [7389, "Xmas16 Snowglobe Snowstorm"],
    [7390, "Heal Casting Loop"],
    [7391, "Human Rockhammer Hit"],
    [7392, "Human Rockpick Hit"],
    [7393, "Fishstabber"],
    [7394, "Fishstabber Infernal"],
    [7395, "Olm Pet Walk"],
    [7396, "Olm Pet Idle"],
    [7397, "Olm Pet Defend"],
    [7398, "Olm Pet Attack"],
    [7399, "Olm Pet Chathead Idle"],
    [7400, "Olm Pet Chathead Idle Variation Roar"],
    [7401, "Human Harpoon Dragon"],
    [7402, "Human Harpoon Infernal"],
    [7403, "Qip Watchtower Read Scroll And Stop"],
    [7404, "Smoulderstone Charge Harpoon"],
    [7405, "Smouderstone Charge Harpoon"],
    [7406, "Smouderstone Recharge Harpoon"],
    [7407, "Vasa Dormant"],
    [7408, "Vasa Spawn"],
    [7409, "Vasa Stun Spawn"],
    [7410, "Vasa Attack"],
    [7411, "Vasa Walk"],
    [7412, "Vasa Heal Spawn"],
    [7413, "Vasa Heal Idle"],
    [7414, "Vasa Healed"],
    [7415, "Vasa Death"],
    [7416, "Vasa Idle"],
    [7417, "Dohgadyle Idle"],
    [7418, "Dohgadyle Defend"],
    [7419, "Dohgadyle Walk"],
    [7420, "Dohgadyle Bite"],
    [7421, "Dohgadyle Bark"],
    [7422, "Dohgadyle Lazor"],
    [7423, "Dohgadyle Emerge"],
    [7424, "Dohgadyle Slam"],
    [7425, "Dohgadyle Idle Water"],
    [7426, "Dohgadyle Death"],
    [7427, "Vanguard Dormant"],
    [7428, "Vanguard Spawn"],
    [7429, "Vanguard Walk"],
    [7430, "Vanguard Idle Basic"],
    [7431, "Vanguard Heal"],
    [7432, "Vanguard Death"],
    [7433, "Vanguard Idle Basic Idle Magic Transition"],
    [7434, "Vanguard Idle Magic"],
    [7435, "Vanguard Defend Magic"],
    [7436, "Vanguard Attack Magic"],
    [7437, "Vanguard Idle Magic Idle Basic Transition"],
    [7438, "Vanguard Idle Basic Idle Melee Transition"],
    [7439, "Vanguard Idle Melee"],
    [7440, "Vanguard Defend Melee"],
    [7441, "Vanguard Attack Melee"],
    [7442, "Vanguard Idle Melee Idle Basic Transition"],
    [7443, "Vanguard Idle Basic Idle Ranged Transition"],
    [7444, "Vanguard Idle Ranged"],
    [7445, "Vanguard Defend Ranged"],
    [7446, "Vanguard Attack Ranged"],
    [7447, "Vanguard Idle Ranged Idle Basic Transition"],
    [7448, "Vespula Walk"],
    [7449, "Vespula Idle"],
    [7450, "Vespula Attack Ranged"],
    [7451, "Vespula Defend"],
    [7452, "Vespula Takeoff"],
    [7453, "Vespula Flying"],
    [7454, "Vespula Attack Melee Flying"],
    [7455, "Vespula Attack Ranged Flying"],
    [7456, "Vespula Defend Flying"],
    [7457, "Vespula Landing"],
    [7458, "Vespula Death Walking"],
    [7459, "Vespula Death Flying"],
    [7460, "Vespine Hatch"],
    [7461, "Vespine Walk"],
    [7462, "Vespine Explode"],
    [7463, "Luxgrub Idle Healthy"],
    [7464, "Luxgrub Idle Sickly"],
    [7465, "Luxgrub Idle Infected"],
    [7466, "Luxgrub Death"],
    [7467, "Luxgrub Vespine Hatch Spotanim"],
    [7468, "Luxgrub Dead"],
    [7469, "Olm Hand Left Transition From Grip"],
    [7470, "Olm Shattering Crystal"],
    [7471, "Olm Shockwave"],
    [7472, "Olm Crystal Explode"],
    [7473, "Tekton Spawn"],
    [7474, "Tekton Avil Transition To Idle"],
    [7475, "Tekton Idle Transition To Anvil"],
    [7476, "Tekton Idle"],
    [7477, "Tekton Walk"],
    [7478, "Tekton Idle Transition To Ready"],
    [7479, "Tekton Ready Transition To Idle"],
    [7480, "Tekton Ready"],
    [7481, "Tekton Ready Defend"],
    [7482, "Tekton Attack Stab"],
    [7483, "Tekton Slash"],
    [7484, "Tekton Hammer Crush"],
    [7485, "Tekton Idle Enraged"],
    [7486, "Tekton Walk Enraged"],
    [7487, "Tekton Avil Transition To Idle Enraged"],
    [7488, "Tekton Idle Transition To Ready Enraged"],
    [7489, "Tekton Ready Transition To Idle Enraged"],
    [7490, "Tekton Ready Enraged"],
    [7491, "Tekton Ready Defend Enraged"],
    [7492, "Tekton Hammer Crush Enraged"],
    [7493, "Tekton Attack Stab Enraged"],
    [7494, "Tekton Slash Enraged"],
    [7495, "Tekton Death"],
    [7496, "Raids Thievingchests Eat"],
    [7497, "Raids Thievingchests Tired"],
    [7498, "Raids Thievingchests Sleeping"],
    [7499, "Raids Vespular Portal Active"],
    [7500, "Raids Vespular Portal Closing"],
    [7501, "Raids Vespular Portal Closed"],
    [7502, "Raids Central Crystal Shatter"],
    [7503, "Raids Olms Lair Entrance"],
    [7504, "Olm Generic Range Proj"],
    [7505, "Olm Burnwithme Travel"],
    [7506, "Raids Crystal Smashing"],
    [7507, "Human Dinhs Bulwark Crush"],
    [7508, "Human Dinhs Bulwark Ready"],
    [7509, "Human Dinhs Bulwark Run"],
    [7510, "Human Dinhs Bulwark Walk"],
    [7511, "Human Dinhs Bulwark Bash"],
    [7512, "Human Dinhs Bulwark Block"],
    [7513, "Spot Dclaws Spec"],
    [7514, "Human Dragon Claws Spec"],
    [7515, "Human Dragon Sword Spec"],
    [7516, "Human Elder Maul Attack"],
    [7517, "Human Elder Maul Block"],
    [7518, "Human Elder Maul Ready"],
    [7519, "Human Elder Maul Run"],
    [7520, "Human Elder Maul Walk"],
    [7521, "Human Dragon Taxe Spec"],
    [7522, "Spot Dinhs Bulwark Idle"],
    [7523, "Spot Dinhs Bulwark Block"],
    [7524, "Dragon Taxe Launch Spec"],
    [7525, "Specialattack Disembowel"],
    [7526, "Human Staffready Statue"],
    [7527, "Dclaws Human Attack"],
    [7528, "Raids Barehanded Batcatch"],
    [7529, "Human Make Wine"],
    [7530, "Spot Make Wine"],
    [7531, "Human Battlestaff Crafting"],
    [7532, "Spot Battlestaff Create"],
    [7533, "Bday17 Bling"],
    [7534, "Bday17 Chacha"],
    [7535, "Bday17 Phone"],
    [7536, "Bday17 Style"],
    [7537, "Bday17 Lasso"],
    [7538, "Bday17 Balloon Idle"],
    [7539, "Bday17 Balloon Walk"],
    [7540, "Bday17 Balloon Run"],
    [7541, "Bday17 Balloon Attack"],
    [7542, "Bday17 Lute Play"],
    [7543, "Bday17 Party Balloons"],
    [7544, "Osb4 Walk Cheer"],
    [7545, "Screaming Banshee Ready"],
    [7546, "Screaming Banshee Defend"],
    [7547, "Screaming Banshee Attack"],
    [7548, "Screaming Banshee Death"],
    [7549, "Bring Dead Nechryarch"],
    [7550, "Abhorrent Spectre Attack"],
    [7551, "Qip Watchtower Stop Reading Scroll"],
    [7552, "Xbows Human Fire And Reload Pvn"],
    [7553, "Infernaleel Break"],
    [7554, "Ii Human Dart Throw Pvn"],
    [7555, "Ballista Attack Pvn"],
    [7556, "Ballista Special Attack Pvn"],
    [7557, "Dttd Player Fire Bone Crossbow Pvn"],
    [7558, "Thzarr Ring Chuck Pvn"],
    [7559, "Inferno Collapsing Wall Side Right"],
    [7560, "Inferno Collapsing Wall Side Left"],
    [7561, "Safe Spot Distructible Pillar Collapse"],
    [7562, "Zuk Death"],
    [7563, "Zuk Spawn"],
    [7564, "Zuk Idle"],
    [7565, "Zuk Defend"],
    [7566, "Zuk Attack"],
    [7567, "Moving Safe Spot Ready"],
    [7568, "Moving Safe Spot Hit"],
    [7569, "Moving Safe Spot Death"],
    [7570, "Inferno Exit"],
    [7571, "Zuk Proj"],
    [7572, "Jalnib Walk"],
    [7573, "Jalnib Ready"],
    [7574, "Jalnib Attack"],
    [7575, "Jalnib Defend"],
    [7576, "Jalnib Death"],
    [7577, "Jalmejrah Ready"],
    [7578, "Jalmejrah Attack"],
    [7579, "Jalmejrah Defend"],
    [7580, "Jalmejrah Death"],
    [7581, "Jalak Attack Magic"],
    [7582, "Jalak Attack Melee"],
    [7583, "Jalak Attack Ranged"],
    [7584, "Jalak Death"],
    [7585, "Jalak Defend"],
    [7586, "Jalak Ready"],
    [7587, "Jalak Walk"],
    [7588, "Jaltokjad Walk"],
    [7589, "Jaltokjad Ready"],
    [7590, "Jaltokjad Attack Melee"],
    [7591, "Jaltokjad Defend"],
    [7592, "Jaltokjad Attack Magic"],
    [7593, "Jaltokjad Attack Ranged"],
    [7594, "Jaltokjad Death"],
    [7595, "Jalimkot Ready"],
    [7596, "Jalimkot Walk"],
    [7597, "Jalimkot Attack"],
    [7598, "Jalimkot Defend"],
    [7599, "Jalimkot Death"],
    [7600, "Jalimkot Digdown"],
    [7601, "Jalimkot Digup"],
    [7602, "Jalxil Ready"],
    [7603, "Jalxil Walk"],
    [7604, "Jalxil Attack Melee"],
    [7605, "Jalxil Attack Ranged"],
    [7606, "Jalxil Death"],
    [7607, "Jalxil Defend"],
    [7608, "Jalakxil Walk"],
    [7609, "Jalakxil Ready"],
    [7610, "Jalakxil Attack Magic"],
    [7611, "Jalakxil Resurrect"],
    [7612, "Jalakxil Attack Melee"],
    [7613, "Jalakxil Death"],
    [7614, "Inferno Basic Projectile"],
    [7615, "Inferno Basic Projectile 02"],
    [7616, "Inferno Splitter Proj"],
    [7617, "Human Stake2 Pvn"],
    [7618, "Human Chinchompa Attack Pvn"],
    [7619, "Godwars Hammer Gong Bronzewarhammer"],
    [7620, "Godwars Hammer Gong Ironwarhammer"],
    [7621, "Godwars Hammer Gong Steelwarhammer"],
    [7622, "Godwars Hammer Gong Blackwarhammer"],
    [7623, "Godwars Hammer Gong Whitewarhammer"],
    [7624, "Godwars Hammer Gong Mithrilwarhammer"],
    [7625, "Godwars Hammer Gong Adamantwarhammer"],
    [7626, "Godwars Hammer Gong Runewarhammer"],
    [7627, "Dream Spell Start"],
    [7628, "Dream Spell End"],
    [7629, "Human Walk F Fan"],
    [7630, "Human Walk B Fan"],
    [7631, "Human Walk L Fan"],
    [7632, "Human Walk R Fan"],
    [7633, "Human Running Fan"],
    [7634, "Minnow Fishing Spot Location"],
    [7635, "Minnow Fishing Flyingfish"],
    [7636, "Levelup 99 Skill"],
    [7637, "Levelup Max"],
    [7638, "Zgs Special Player"],
    [7639, "Zgs Special Ornate Player"],
    [7640, "Sgs Special Player"],
    [7641, "Sgs Special Ornate Player"],
    [7642, "Bgs Special Player"],
    [7643, "Bgs Special Ornate Player"],
    [7644, "Ags Special Player"],
    [7645, "Ags Special Ornate Player"],
    [7646, "Zeah Chathead Shifty"],
    [7647, "Fossil Npc Merfolk Idle"],
    [7648, "Fossil Npc Leprechaun Bound Pot"],
    [7649, "Fossil Npc Lep Swim Ready"],
    [7650, "Fossil Npc Wyvern Flight Idle"],
    [7651, "Fossil Npc Wyvern Flight Claw"],
    [7652, "Fossil Npc Wyvern Flight Death"],
    [7653, "Fossil Npc Wyvern Flight Breath"],
    [7654, "Fossil Npc Wyvern Flight Tail"],
    [7655, "Fossil Npc Wyvern Cyclone Loop"],
    [7656, "Fossil Npc Wyvern Cyclone Spawn"],
    [7657, "Fossil Npc Wyvern Flight Fire"],
    [7658, "Fossil Npc Wyvern Flight Bite"],
    [7659, "Fossil Npc Wyvern Flight Defend"],
    [7660, "Fossil Npc Puffer Puff"],
    [7661, "Fossil Npc Puffer Idle"],
    [7662, "Fossil Npc Puffer Swim"],
    [7663, "Fossil Npc Puffer Idle Puffed"],
    [7664, "Fossil Npc Puffer Swim Puffed"],
    [7665, "Fossil Loc Net Empty Idle"],
    [7666, "Fossil Loc Uplant Wave"],
    [7667, "Fossil Loc Uplant Current"],
    [7668, "Fossil Loc Current Stream"],
    [7669, "Fossil Npc Merfolk Throne Idle"],
    [7670, "Fossil Loc Air Pocket"],
    [7671, "Fossil Loc Clam Idle"],
    [7672, "Fossil Loc Clam Idle Shut"],
    [7673, "Fossil Loc Clam Shut"],
    [7674, "Fossil Loc Clam Open"],
    [7675, "Fossil Npc Lavabeast Spawn"],
    [7676, "Fossil Npc Lavabeast Despawn"],
    [7677, "Fossil Npc Lavabeast Idle"],
    [7678, "Fossil Npc Lavabeast Attack"],
    [7679, "Fossil Npc Lavabeast Defend"],
    [7680, "Fossil Spot Lavabeast Bomb"],
    [7681, "Fossil Lava Heat"],
    [7682, "Fossil Npc Hoopsnake Idle"],
    [7683, "Fossil Npc Hoopsnake Walk"],
    [7684, "Fossil Projectile Hoopsnake"],
    [7685, "Fossil Npc Hoopsnake Attack"],
    [7686, "Fossil Npc Hoopsnake Defend"],
    [7687, "Fossil Npc Herbiboar Appear"],
    [7688, "Fossil Npc Herbiboar Stunned"],
    [7689, "Fossil Npc Herbiboar Wake"],
    [7690, "Fossil Npc Herbiboar Burrow"],
    [7691, "Fossil Loc Jumpshroom Idle"],
    [7692, "Fossil Loc Jumpshroom Jump"],
    [7693, "Fossil Loc Jumpshroom Squash"],
    [7694, "Fossil Npc Herbiboar Idle"],
    [7695, "Fossil Npc Herbiboar Walk"],
    [7696, "Fossil Npc Herbiboar Attack"],
    [7697, "Fossil Npc Fetal"],
    [7698, "Fossil Npc Tarbeast Splat Spot"],
    [7699, "Ultracompost Make"],
    [7700, "Fossil Wyvern Shield Release Charge"],
    [7701, "Human Inhale Pufferfish"],
    [7702, "Human Swim Cavewall"],
    [7703, "Human Swim Fast"],
    [7704, "Human Swim Shipwall"],
    [7705, "Human Swim Hole Enter"],
    [7706, "Human Swim Hole Leave"],
    [7707, "Human Swim Steal"],
    [7708, "Human Swim Steal Fail"],
    [7709, "Human Swim Steal Success"],
    [7710, "Human Swim Steal Fail End"],
    [7711, "Vmi Mining Falling Stalactite"],
    [7712, "Vmi Mining Boulder Float"],
    [7713, "Vmi Mining Boulder Giant Breakoff"],
    [7714, "Vmi Mining Boulder Giant Destroy"],
    [7715, "Vmi Mining Boulder Large Destroy"],
    [7716, "Vmi Mining Boulder Medium Destroy"],
    [7717, "Vmi Mining Boulder Small Destroy"],
    [7718, "Vmi Mining Boulder Tiny Destroy"],
    [7719, "Vmi Lavabomb Glow"],
    [7720, "Vmi Lava Whirlpool"],
    [7721, "Fi Bone Pool Idle"],
    [7722, "Vmi Chamber Blocked"],
    [7723, "Vmi Chamber Idle"],
    [7724, "Fi Bone Sluice Closed"],
    [7725, "Fi Bone Sluice Open"],
    [7726, "Fi Bone Shroom Idle"],
    [7727, "Fi Bone Fossil Appear"],
    [7728, "Fi Bone Fossil Idle"],
    [7729, "Fi Bone Fossil Disappear"],
    [7730, "Fi Dkl Bone Machine Active"],
    [7731, "Fi Dkl Bone Machine Inactive"],
    [7732, "Fi Dkl Pendant Machine Active"],
    [7733, "Fi Dkl Pendant Machine Inactive"],
    [7734, "Fi Dkl Shield Machine Active"],
    [7735, "Fi Dkl Shield Machine Inactive"],
    [7736, "Spinetree Attack"],
    [7737, "Spinetree Ready"],
    [7738, "Human Fling Water"],
    [7739, "Human Fail Pufferfish"],
    [7740, "Fossil Tablet Volcano"],
    [7741, "Human Fossil Volcano Teleport"],
    [7742, "Fossil Mine Jump Idle"],
    [7743, "Fossil Mine Jump Geyser"],
    [7744, "Fossil Bellshroom Swallow"],
    [7745, "Human Fossil Drink Stump"],
    [7746, "Human Fossil Sleep Stool"],
    [7747, "Human Fossil Volcano Land"],
    [7748, "Gg Bell Swinging"],
    [7749, "Deadman Banner Flutter"],
    [7750, "Deadman Skeleton On Wall Cheer"],
    [7751, "Premier Club Emote"],
    [7752, "Premier Club Emote Spotanim"],
    [7753, "Zaros Vertical Casting Priority"],
    [7754, "Human Casting Tele Block Staff Priority"],
    [7755, "Gg Projectile Lightning 01"],
    [7756, "Gg Projectile Lightning 02"],
    [7757, "Gg Projectile Lightning 03"],
    [7758, "Gg Projectile Lightning 04"],
    [7759, "Gg Projectile Lightning 05"],
    [7760, "Gg Projectile Lightning 06"],
    [7761, "Gg Projectile Lightning 07"],
    [7762, "Gg Projectile Lightning 08"],
    [7763, "Gg Dawn Lightning Death"],
    [7764, "Gg Dusk Lightning Dawn Death"],
    [7765, "Gg Projectile Lightning Enraged"],
    [7766, "Gg Dawn Spawn"],
    [7767, "Gg Dawn Spawn Fly"],
    [7768, "Gg Dawn Fly"],
    [7769, "Gg Dawn Attack Slash"],
    [7770, "Gg Dawn Attack Ranged"],
    [7771, "Gg Dawn Attack Stun"],
    [7772, "Gg Dawn Attack Special"],
    [7773, "Gg Dawn Fly Up"],
    [7774, "Gg Dawn Fly Down"],
    [7775, "Gg Dawn Defend"],
    [7776, "Gg Dawn Death"],
    [7777, "Gg Dawn Death Smash"],
    [7778, "Gg Dusk Spawn"],
    [7779, "Gg Dusk Idle"],
    [7780, "Gg Dusk Walk"],
    [7781, "Gg Dusk Idle Defensive"],
    [7782, "Gg Dusk Walk Defensive"],
    [7783, "Gg Dusk Retract Wing"],
    [7784, "Gg Dusk Extend Wing"],
    [7785, "Gg Dusk Attack Slash Defensive"],
    [7786, "Gg Dusk Attack Slash"],
    [7787, "Gg Dusk Attack Sweep Defensive"],
    [7788, "Gg Dusk Attack Sweep"],
    [7789, "Gg Dusk Spawn Jump"],
    [7790, "Gg Dusk Fly Up"],
    [7791, "Gg Dusk Fly"],
    [7792, "Gg Dusk Attack Special"],
    [7793, "Gg Dusk Fall Down"],
    [7794, "Gg Dusk Defend"],
    [7795, "Gg Dusk Enrage"],
    [7796, "Gg Dusk Enrage Spawn"],
    [7797, "Gg Dusk Enrage Idle"],
    [7798, "Gg Dusk Enrage Walk"],
    [7799, "Gg Dusk Enrage Attack Special"],
    [7800, "Gg Dusk Enrage Attack Slash"],
    [7801, "Gg Dusk Enrage Attack Ranged"],
    [7802, "Gg Dusk Attack Forcefield"],
    [7803, "Gg Dusk Death"],
    [7804, "Gg Pet Chathead Laugh"],
    [7805, "Gg Pet Chathead Talk Basic"],
    [7806, "Gg Dusk Pet Walk"],
    [7807, "Gg Dusk Pet Idle"],
    [7808, "Gg Dusk Pet Attack"],
    [7809, "Gg Dusk Death Smash"],
    [7810, "Gargoyle Marble Walk"],
    [7811, "Gargoyle Marble Attack"],
    [7812, "Gargoyle Marble Death"],
    [7813, "Gargoyle Marble Death Smash"],
    [7814, "Gargoyle Marble Defend"],
    [7815, "Gargoyle Marble Attack Ranged"],
    [7816, "Gg Debris Shadow 90"],
    [7817, "Gg Debris Shadow 120"],
    [7818, "Gg Debris Shadow 150"],
    [7819, "Gg Debris Shadow 180"],
    [7820, "Pyrefiend Casting"],
    [7821, "Revenant Magic Travel"],
    [7822, "Revenant Magic Impact"],
    [7823, "Dmm Supply Chest Spawn"],
    [7824, "Dmm Supply Chest Idle"],
    [7825, "Human Use Wom Telecope Start"],
    [7826, "Human Use Wom Telecope Middle"],
    [7827, "Human Use Wom Telecope End"],
    [7828, "Ds2 Sconce Idle"],
    [7829, "Ogre Ready New"],
    [7830, "Ogre Walk New"],
    [7831, "Human Shield Crafting Green Dhide"],
    [7832, "Human Shield Crafting Blue Dhide"],
    [7833, "Human Shield Crafting Red Dhide"],
    [7834, "Human Shield Crafting Black Dhide"],
    [7835, "Magictraining Pizazz Eyepop"],
    [7836, "Slayer Tots I Charge Toxic"],
    [7837, "Zamorak Demon Boss Idle"],
    [7838, "Zamorak Demon Boss Defend"],
    [7839, "Zamorak Demon Boss Walk"],
    [7840, "Zamorak Demon Boss Attack Melee"],
    [7841, "Zamorak Demon Boss Attack Magic"],
    [7842, "Zamorak Demon Boss Spawn"],
    [7843, "Zamorak Demon Boss Death"],
    [7844, "Ent Boss Spawn"],
    [7845, "Ent Boss Idle"],
    [7846, "Ent Boss Defend"],
    [7847, "Ent Boss Walk"],
    [7848, "Ent Boss Attack Melee"],
    [7849, "Ent Boss Attack Magic"],
    [7850, "Ent Boss Attack Death"],
    [7851, "Wild Zealot Idle"],
    [7852, "Wild Zealot Walk"],
    [7853, "Wild Zealot Slash"],
    [7854, "Wild Zealot Death"],
    [7855, "Human Cast Surge"],
    [7856, "Surge Travel"],
    [7857, "Surge Casting"],
    [7858, "Dog Small Dog Ready Simple"],
    [7859, "Wave Impact Galvek"],
    [7860, "Xbows Fletching Yew Dragon"],
    [7861, "Dwarf Crossbow Idle"],
    [7862, "Dwarf Crossbow Walk"],
    [7863, "Dwarf Crossbow Attack"],
    [7864, "Dragonkin Attack Mage"],
    [7865, "Dragonkin Attack Melee"],
    [7866, "Dragonkin Flinch"],
    [7867, "Dragonkin Death"],
    [7868, "Dragonkin Chathead Talk"],
    [7869, "Dragonkin Death Fire"],
    [7870, "Dragon Flight Idle"],
    [7871, "Dragon Flight Firebreath"],
    [7872, "Dragon Flight Appear"],
    [7873, "Dragonfire Ward Releasing Charge"],
    [7874, "Ds2 Robert Spec 1"],
    [7875, "Ds2 Robert Spec 2"],
    [7876, "Ds2 Robert Spec 3"],
    [7877, "Ds2 Tidal Proj"],
    [7878, "Ds2 Tidal Spawn"],
    [7879, "Ds2 Tidal Despawn"],
    [7880, "Ds2 Entomb Impact"],
    [7881, "Ds2 Galvek Proj Travel"],
    [7882, "Ds2 Galvek Prox Idle"],
    [7883, "Ds2 Galvek Water Launched"],
    [7884, "Ds2 Vorkath Fireball"],
    [7885, "Ds2 Vorkath Bone Ball Burst"],
    [7886, "Ds2 Robert Special"],
    [7887, "Ds2 Spawn Walk"],
    [7888, "Ds2 Spawn Ready"],
    [7889, "Ds2 Spawn Defend"],
    [7890, "Ds2 Spawn Attack"],
    [7891, "Ds2 Spawn Death"],
    [7892, "Ds2 Spawn Egg"],
    [7893, "Ds2 Robert Bow Charge"],
    [7894, "Lithkren Torch Small"],
    [7895, "Lithkren Brazier"],
    [7896, "Ds2 Dragon Head Lit"],
    [7897, "Ds2 Dragon Orb Fire"],
    [7898, "Ds2 Lithkren Generator Wheel"],
    [7899, "Ds2 Lithkren Vault Lazor"],
    [7900, "Galvek Grounded Slash"],
    [7901, "Galvek Grounded Breath"],
    [7902, "Galvek Grounded Ready"],
    [7903, "Galvek Flight Ready"],
    [7904, "Galvek Flight Breath"],
    [7905, "Galvek Flight Crunch"],
    [7906, "Galvek Flight Disappear"],
    [7907, "Galvek Flight Reappear"],
    [7908, "Galvek Grounded Land"],
    [7909, "Galvek Grounded Disappear"],
    [7910, "Galvek Grounded Launch Special"],
    [7911, "Galvek Flight Launch Special"],
    [7912, "Galvek Grounded Stomp"],
    [7913, "Galvek Sleepy"],
    [7914, "Galvek Spit"],
    [7915, "Galvek Death"],
    [7916, "Galvek Death Loop"],
    [7917, "Ds2 Karamja Walltrap Idle"],
    [7918, "Ds2 Karamja Walltrap Fail"],
    [7919, "Ds2 Karamja Floortrap Fail"],
    [7920, "Ds2 Karamja Floortrap Idle"],
    [7921, "Ds2 Karamja Plinth Teleport"],
    [7922, "Ds2 Stone Guardian Ready"],
    [7923, "Ds2 Stone Guardian Attack"],
    [7924, "Ds2 Stone Guardian Death"],
    [7925, "Ds2 Stone Guardian Defend"],
    [7926, "Ds2 Stone Guardian Walk"],
    [7927, "Ds2 Stone Guardian Melee"],
    [7928, "Ds2 Debris Bobbing"],
    [7929, "Ds2 Lithkren Barrier Glow"],
    [7930, "Ds2 Fremmy Boatman Hurt"],
    [7931, "Ds2 Fremmy Boatman Row"],
    [7932, "Ds2 Fremmy Boatman Hurt O"],
    [7933, "Ds2 Fremmy Boatman Row O"],
    [7934, "Human Bobrun"],
    [7935, "Ds2 Sarcophagus Closing"],
    [7936, "Ds2 Sarcophagus Opening"],
    [7937, "Ds2 Sarcophagus Open"],
    [7938, "Ds2 Leak"],
    [7939, "Ds2 Fountain Idle"],
    [7940, "Ds2 Fremmy Boatman Drum"],
    [7941, "Ds2 Dead Pose 1"],
    [7942, "Ds2 Dead Pose 2"],
    [7943, "Ds2 Dead Pose 3"],
    [7944, "Ds2 Dead Pose 4"],
    [7945, "Ds2 Dead Pose 5"],
    [7946, "Ds2 Vorkath Sleeping"],
    [7947, "Ds2 Vorkath Walk"],
    [7948, "Ds2 Vorkath Idle"],
    [7949, "Ds2 Vorkath Death"],
    [7950, "Ds2 Vorkath Spawn"],
    [7951, "Ds2 Vorkath Attack Melee"],
    [7952, "Ds2 Vorkath Ranged"],
    [7953, "Ds2 Vorkath Stomp"],
    [7954, "Ds2 Vorkath Defend Up"],
    [7955, "Ds2 Vorkath Defend Idle"],
    [7956, "Ds2 Vorkath Defend Down"],
    [7957, "Ds2 Vorkath Acid"],
    [7958, "Ds2 Vorkath Chathead Talk"],
    [7959, "Ds2 Vorkath Pet Walk"],
    [7960, "Ds2 Vorkath Ranged Up"],
    [7961, "Xbows Stringing Crossbow Dragon"],
    [7962, "Wild Zealot Magic"],
    [7963, "Wild Zealot Magic2"],
    [7964, "Wild Zealot Spawn"],
    [7965, "Wild Zealot Defend"],
    [7966, "Wild Zealot Projectile"],
    [7967, "Staff Of Light Special"],
    [7968, "Osb5 Human 5 Slash"],
    [7969, "Osb5 Spot 5 Slash"],
    [7970, "Shayzien Boulder Roll"],
    [7971, "Shayzien Orb Glow"],
    [7972, "Osb5 Human Rs Slash"],
    [7973, "Osb5 Spot Rs Slash"],
    [7974, "Corpbeast Walk Improved"],
    [7975, "Zukrek Idle"],
    [7976, "Zukrek Defend"],
    [7977, "Zukrek Walk"],
    [7978, "Zukrek Attack"],
    [7979, "Zukrek Chathead Talk"],
    [7980, "Darkcore Idle Pet"],
    [7981, "Nature Staff Make"],
    [7982, "Dogadile Pet Walk"],
    [7983, "Tekton Pet Walk"],
    [7984, "Vanguard Pet Walk"],
    [7985, "Vasa Pet Walk"],
    [7986, "Vespula Pet Walk"],
    [7987, "Top Spider Magic Walk"],
    [7988, "Top Spider Magic Idle"],
    [7989, "Top Spider Magic Attack"],
    [7990, "Top Spider Magic Meleeattack"],
    [7991, "Top Spider Magic Death"],
    [7992, "Top Spider Magic Death Detonate"],
    [7993, "Top Spider Ranged Idle"],
    [7994, "Human Throw Egg Sara"],
    [7995, "Human Throw Egg Guthix"],
    [7996, "Human Throw Egg Zam"],
    [7997, "Top Spider Ranged Walk"],
    [7998, "Top Spider Ranged Death"],
    [7999, "Top Spider Ranged Attack"],
    [8000, "Top Spider Ranged Death Detonate"],
    [8001, "Top Spider Ranged Meleeattack"],
    [8002, "Top Spider Melee Idle"],
    [8003, "Top Spider Melee Walk"],
    [8004, "Top Spider Melee Attack"],
    [8005, "Top Spider Melee Death"],
    [8006, "Top Spider Melee Death Detonate"],
    [8007, "Druidicspirit Human Bloom Emerald"],
    [8008, "Druidicspirit Human Bloom Flail"],
    [8009, "Ivandis Flail Ready"],
    [8010, "Ivandis Flail Attack"],
    [8011, "Ivandis Flail Walk F"],
    [8012, "Ivandis Flail Walk B"],
    [8013, "Ivandis Flail Walk L"],
    [8014, "Ivandis Flail Walk R"],
    [8015, "Ivandis Flail Turnonspot"],
    [8016, "Ivandis Flail Run"],
    [8017, "Ivandis Flail Defend"],
    [8018, "Myq4 Steam Vent Activate"],
    [8019, "Myq4 Steam Vent Broken"],
    [8020, "Myq4 Steam Vent Activate West"],
    [8021, "Myq4 Steam Vent Activate East"],
    [8022, "Myq4 Abomination Idle"],
    [8023, "Myq4 Abomination Walk"],
    [8024, "Myq4 Abomination Death"],
    [8025, "Myq4 Abomination Melee"],
    [8026, "Myq4 Abomination Range"],
    [8027, "Myq4 Abomination Defend"],
    [8028, "Myq4 Abomination Crawl"],
    [8029, "Myq4 Abomination Weaken"],
    [8030, "Myq4 Abomination Projectile Travel"],
    [8031, "Myq4 Vampire Ready"],
    [8032, "Myq4 Vampire Walk"],
    [8033, "Myq4 Vampyre Death"],
    [8034, "Myq4 Vampire Claw"],
    [8035, "Myq4 Vampire Charge"],
    [8036, "Myq4 Vampire Release"],
    [8037, "Myq4 Vampire Land"],
    [8038, "Myq4 Vampire Takeoff"],
    [8039, "Myq4 Vampire Grounded Attack"],
    [8040, "Myq4 Vampire Flying Magic"],
    [8041, "Myq4 Vampire Barrage"],
    [8042, "Myq4 Knockback"],
    [8043, "Myq4 Stunned Transition"],
    [8044, "Myq4 Safalaan Trance"],
    [8045, "Myq4 Safalaan Rest"],
    [8046, "Myq4 Safalaan Glow"],
    [8047, "Myq4 Safalaan Boom"],
    [8048, "Slepe Chair Slouch"],
    [8049, "Slepe Sleeping"],
    [8050, "Human Ready Loop"],
    [8051, "Verzik Human Idle"],
    [8052, "Verzik Pillar Collapse"],
    [8053, "Verzik Throne Transform Initial"],
    [8054, "Verzik Chathead Talk"],
    [8055, "Verzik Chathead Laugh"],
    [8056, "Scythe Of Vitur Attack"],
    [8057, "Scythe Of Vitur Ready"],
    [8058, "Tob Xarpus Idle"],
    [8059, "Tob Xarpus Attack Ranged"],
    [8060, "Tob Xarpus Absorb"],
    [8061, "Tob Xarpus Fly Up"],
    [8062, "Tob Xarpus Death A"],
    [8063, "Tob Xarpus Death B"],
    [8064, "Tob Xarpus Exhumed Start"],
    [8065, "Tob Xarpus Exhumed Loop"],
    [8066, "Tob Xarpus Exhumed End"],
    [8067, "Tob Xarpus Acid Splat Start"],
    [8068, "Tob Xarpus Acid Splat Loop"],
    [8069, "Tob Xarpus Acid Splat End"],
    [8070, "Tob Purgatory Stance"],
    [8071, "Sanguinesti Staff Travel"],
    [8072, "Sanguinesti Staff Heal"],
    [8073, "Nylocas Pillar Precollapse"],
    [8074, "Nylocas Pillar Collapse"],
    [8075, "Top Spider Melee Spawn"],
    [8076, "Tob Spider Tank Idle"],
    [8077, "Tob Spider Tank Walk"],
    [8078, "Tob Spider Tank Death"],
    [8079, "Tob Spider Tank Spawn"],
    [8080, "Tob Bloat Ready"],
    [8081, "Tob Bloat Walk"],
    [8082, "Tob Bloat Sleep"],
    [8083, "Tob Bloat Flies Large"],
    [8084, "Tob Bloat Flies Small"],
    [8085, "Tob Bloat Death"],
    [8086, "Tob Bloat Chamber Idle"],
    [8087, "Tob Bloat Swinging Chain"],
    [8088, "Tob Bloat Falling Flesh"],
    [8089, "Tob Bloat Stunned Short"],
    [8090, "Maiden Idle"],
    [8091, "Maiden Attack Blood"],
    [8092, "Maiden Attack Special"],
    [8093, "Maiden Death A"],
    [8094, "Maiden Death B"],
    [8095, "Elemental Walk"],
    [8096, "Elemental Idle"],
    [8097, "Elemental Death"],
    [8098, "Elemental Spawn"],
    [8099, "Tob Blood Splat"],
    [8100, "Tob Shadow Projectile"],
    [8101, "Tob Blood Spawn Walk"],
    [8102, "Tob Blood Spawn Idle"],
    [8103, "Tob Blood Spawn Death"],
    [8104, "Verzik Pillar Fade"],
    [8105, "Tob Treasure Room Teleport Crystal"],
    [8106, "Tob Throne Room Arrow Float"],
    [8107, "Verzik Phase1 Idle"],
    [8108, "Verzik Throne Transform"],
    [8109, "Verzik Phase1 Attack Magic"],
    [8110, "Verzik Phase1 Defend"],
    [8111, "Verzik Phase1 Death"],
    [8112, "Verzik Phase2 Spawn"],
    [8113, "Verzik Phase2 Idle"],
    [8114, "Verzik Phase2 Attack Magic"],
    [8115, "Verzik Phase2 Lightning Spot"],
    [8116, "Verzik Phase2 Attack Melee"],
    [8117, "Verzik Phase2 Heal"],
    [8118, "Verzik Phase2 Death"],
    [8119, "Verzik Phase3 Spawn"],
    [8120, "Verzik Phase3 Idle"],
    [8121, "Verzik Phase3 Walk"],
    [8122, "Verzik Phase3 Walk Pet"],
    [8123, "Verzik Phase3 Attack Melee"],
    [8124, "Verzik Phase3 Attack Magic"],
    [8125, "Verzik Phase3 Attack Ranged"],
    [8126, "Verzik Phase3 Attack Powerblast"],
    [8127, "Verzik Phase3 Attack Webspin"],
    [8128, "Verzik Phase3 Death A"],
    [8129, "Verzik Phase3 Death B"],
    [8130, "Verzik Webspin"],
    [8131, "Verzik Ranged Vile"],
    [8132, "Verzik Lightning Impact"],
    [8133, "Verzik Blood Projectile"],
    [8134, "Verzik Blood Impact"],
    [8135, "Verzik Pet Chathead Talk"],
    [8136, "Tob Sotetseg Walk"],
    [8137, "Tob Sotetseg Idle"],
    [8138, "Tob Sotetseg Attack Melee"],
    [8139, "Tob Sotetseg Attack Ranged"],
    [8140, "Tob Sotetseg Death"],
    [8141, "Tob Sotetseg Wall Float"],
    [8142, "Tob Sotetseg Shadow Portal"],
    [8143, "Tob Sotetseg Tile Glow"],
    [8144, "Tob Sotetseg Shared Projectile"],
    [8145, "Ghrazi Rapier Attack"],
    [8146, "Deadman Hanging Banner Idle"],
    [8147, "Hosdun Spider Boss Attack Melee"],
    [8148, "Pvpa Dungeon Portal Idle"],
    [8149, "Human Drink From Vial Cadava Spotanim"],
    [8150, "My2arm Troll Walking 2x2"],
    [8151, "My2arm Troll Walking 1x1"],
    [8152, "My2arm Troll Walking Staff 2x2"],
    [8153, "My2arm Troll Walking Knuckledrag 2x2"],
    [8154, "My2arm Troll Idle"],
    [8155, "My2arm Troll Idle Staff"],
    [8156, "My2arm Troll Idle Knuckledrag"],
    [8157, "My2arm Troll Sitting Idle"],
    [8158, "My2arm Troll Attack Melee"],
    [8159, "My2arm Troll Attack Ranged"],
    [8160, "My2arm Troll Death"],
    [8161, "My2arm Injured Falling Staff"],
    [8162, "My2arm Injured Idle Staff"],
    [8163, "My2arm Death Staff"],
    [8164, "My2arm Troll Stunned"],
    [8165, "My2arm Troll Stunned Idle"],
    [8166, "My2arm Troll Chathead Talk Basic"],
    [8167, "My2arm Troll Chathead Mute"],
    [8168, "My2arm Troll Chathead Cry"],
    [8169, "My2arm Troll Chathead Talk Sad"],
    [8170, "My2arm Fire Idle"],
    [8171, "My2arm Fire Teleport"],
    [8172, "My2arm Fire Teleport Human"],
    [8173, "My2arm Map Interface Outward"],
    [8174, "My2arm Map Interface Returning"],
    [8175, "My2arm Map Interface Out 0 1"],
    [8176, "My2arm Map Interface Out 1 2"],
    [8177, "My2arm Map Interface Out 2 3"],
    [8178, "My2arm Map Interface Out 3 1"],
    [8179, "My2arm Map Interface Out 3 4"],
    [8180, "My2arm Map Interface Out 4 5"],
    [8181, "Human Swim Get In"],
    [8182, "Human Swim Get Out"],
    [8183, "Javelin Launch"],
    [8184, "Human Spear Wall Spec"],
    [8185, "Spot Spear Wall Spec"],
    [8186, "D Tknife Launch"],
    [8187, "Dragon Slayer Qip Fire1x1 Long"],
    [8188, "Human Fishing Casting Pearl"],
    [8189, "Human Fishing Casting Pearl Fly"],
    [8190, "Human Fishing Casting Pearl Brut"],
    [8191, "Human Fish Onspot Pearl"],
    [8192, "Human Fish Onspot Pearl Fly"],
    [8193, "Human Fish Onspot Pearl Brut"],
    [8194, "Human Dragon Knife"],
    [8195, "Human Dragon Knife P"],
    [8196, "Stoneglow Long"],
    [8197, "Farming Pour Water Bottomlessbucket"],
    [8198, "Shayzien Lizard Boss Sit"],
    [8199, "Shayzien Lizard Boss Pray"],
    [8200, "Shayzien Lizard Boss Chant"],
    [8201, "Arceuus Elder Ready"],
    [8202, "Arceuus Lord Ready"],
    [8203, "Arceuus Lord Trance"],
    [8204, "Aerial Fishing Pool"],
    [8205, "Aerial Fishing Launch"],
    [8206, "Aerial Fishing Travel"],
    [8207, "Aerial Fishing Splash Medium"],
    [8208, "Golden Tench Ready"],
    [8209, "Golden Tench Attack"],
    [8210, "Kahlith Ready"],
    [8211, "Kahlith Walk"],
    [8212, "Kahlith Ready Stick"],
    [8213, "Kahlith Walk Stick"],
    [8214, "Kahlith Chat Basic"],
    [8215, "Kahlith Chat Disapproving"],
    [8216, "Kahlith Chat Chanting"],
    [8217, "Kahlith Chat Mute"],
    [8218, "Konar Walk"],
    [8219, "Konar Ready"],
    [8220, "Konar Chathead Talk"],
    [8221, "Hespori Spawn"],
    [8222, "Hespori Ready"],
    [8223, "Hespori Attack Special"],
    [8224, "Hespori Attack Ranged"],
    [8225, "Hespori Death"],
    [8226, "Hespori Vine Impact"],
    [8227, "Hespori Healer Ready"],
    [8228, "Hespori Healer Alive To Dead"],
    [8229, "Hespori Healer Dead To Alive"],
    [8230, "Hespori Healer Dead"],
    [8231, "Gazebo Cat Breathing"],
    [8232, "Hydra Stage 1 Walk"],
    [8233, "Hydra Stage 1 Ready"],
    [8234, "Hydra Stage 1 Attack Special"],
    [8235, "Hydra Stage 1 Attack Ranged"],
    [8236, "Hydra Stage 1 Attack Magic"],
    [8237, "Hydra Stage 1 Death"],
    [8238, "Hydra Stage 2 Spawn"],
    [8239, "Hydra Stage 2 Walk"],
    [8240, "Hydra Stage 2 Ready"],
    [8241, "Hydra Stage 2 Attack Special"],
    [8242, "Hydra Stage 2 Attack Ranged"],
    [8243, "Hydra Stage 2 Attack Magic"],
    [8244, "Hydra Stage 2 Death"],
    [8245, "Hydra Stage 3 Spawn"],
    [8246, "Hydra Stage 3 Walk"],
    [8247, "Hydra Stage 3 Ready"],
    [8248, "Hydra Stage 3 Attack Special"],
    [8249, "Hydra Stage 3 Attack Ranged"],
    [8250, "Hydra Stage 3 Attack Magic"],
    [8251, "Hydra Stage 3 Death"],
    [8252, "Hydra Stage 4 Spawn"],
    [8253, "Hydra Stage 4 Walk"],
    [8254, "Hydra Stage 4 Ready"],
    [8255, "Hydra Stage 4 Attack Magic"],
    [8256, "Hydra Stage 4 Attack Ranged"],
    [8257, "Hydra Stage 4 Death"],
    [8258, "Hydra Death"],
    [8259, "Hydra Lesser Walk"],
    [8260, "Hydra Lesser Ready"],
    [8261, "Hydra Lesser Attack Ranged"],
    [8262, "Hydra Lesser Attack Magic"],
    [8263, "Hydra Lesser Attack Special"],
    [8264, "Hydra Lesser Death"],
    [8265, "Hydra Chathead Talk"],
    [8266, "Wyrm Walk"],
    [8267, "Wyrm Ready"],
    [8268, "Wyrm Transition Up"],
    [8269, "Wyrm Transition Down"],
    [8270, "Wyrm Attack Melee"],
    [8271, "Wyrm Attack Magic"],
    [8272, "Wyrm Death"],
    [8273, "Drake Walk"],
    [8274, "Drake Ready"],
    [8275, "Drake Melee"],
    [8276, "Drake Ranged"],
    [8277, "Drake Death 01"],
    [8278, "Drake Death 02"],
    [8279, "Hydra Geyser"],
    [8280, "Hydra Geyser Off"],
    [8281, "Sulphur Lizard Walk"],
    [8282, "Sulphur Lizard Ready"],
    [8283, "Sulphur Lizard Melee"],
    [8284, "Sulphur Lizard Death"],
    [8285, "Tassa Kaal Seated Ready"],
    [8286, "Tasa Kaal Chathead Ready"],
    [8287, "Hydraboss Pool Landed"],
    [8288, "Human Dhunter Lance Attack"],
    [8289, "Human Dhunter Lance Slash"],
    [8290, "Human Dhunter Lance Crush"],
    [8291, "Human Dragon Tknives Spec"],
    [8292, "Human Dragon Tknives Spec Poison"],
    [8293, "Dragon Tknives Spec"],
    [8294, "Dream Humidify Spell Projanim"],
    [8295, "Osb6 Display Mobile Idle"],
    [8296, "Hydra Stage 1 Walk Silent"],
    [8297, "Hydra Stage 2 Walk Silent"],
    [8298, "Hydra Stage 2 Ready Silent"],
    [8299, "Hydra Stage 3 Walk Silent"],
    [8300, "Hydra Stage 4 Walk Silent"],
    [8301, "Anma Chopping Failed Gilded Axe"],
    [8302, "Human Canoeing Carve Gilded Axe"],
    [8303, "Human Woodcutting Gilded Axe"],
    [8304, "Human Woodcrafting Axe Gilded"],
    [8305, "Brut Human Canoeing Carve Gilded Axe"],
    [8306, "Mimic Walk"],
    [8307, "Mimic Ready"],
    [8308, "Mimic Melee"],
    [8309, "Mimic Charge Ranged"],
    [8310, "Mimic Death"],
    [8311, "Sang Mining Wall Gilded Pickaxe"],
    [8312, "Human Mining Gilded Pickaxe Wall"],
    [8313, "Human Mining Gilded Pickaxe"],
    [8314, "Human Mining Gilded Pickaxe Noreachforward"],
    [8315, "Viking Lyre Enchant"],
    [8316, "Vengeance Spell Anim Nostalling"],
    [8317, "Vengeance Spell Anim Stalling"],
    [8318, "Hosdun Spider Boss Death"],
    [8319, "Hodsun Spider Boss Walk"],
    [8320, "Hosdun Spider Boss Idle"],
    [8321, "Human Sun Prayer"],
    [8322, "Anma Chopping Failed Crystal Axe"],
    [8323, "Human Canoeing Carve Crystal Axe"],
    [8324, "Human Woodcutting Crystal Axe"],
    [8325, "Human Woodcutting Gauntlet Axe Hm"],
    [8326, "Human Woodcrafting Axe Crystal"],
    [8327, "Brut Human Canoeing Carve Crystal Axe"],
    [8328, "Human Getup Priority 10"],
    [8329, "Rockknocker Crystal"],
    [8330, "Rockknocker Zalcano"],
    [8331, "Easter19 Egg Emote"],
    [8332, "Easter19 Egg Emote Human"],
    [8333, "Fishstabber Crystal"],
    [8334, "Giant Rat Death Fast"],
    [8335, "Dog Wolf Death Quick"],
    [8336, "Human Harpoon Crystal"],
    [8337, "Human Harpoon Gauntlet Hm"],
    [8338, "Sote Gauntlet Spider Death"],
    [8339, "Sote Gauntlet Spider Attack Melee"],
    [8340, "Sote Gauntlet Spider Idle"],
    [8341, "Sote Gauntlet Spider Walk"],
    [8342, "Sang Mining Wall Zalcano Pickaxe"],
    [8343, "Sang Mining Wall Crystal Pickaxe"],
    [8344, "Human Mining Zalcano Pickaxe Wall"],
    [8345, "Human Mining Crystal Pickaxe Wall"],
    [8346, "Human Mining Zalcano Pickaxe"],
    [8347, "Human Mining Crystal Pickaxe"],
    [8348, "Human Mining Gauntlet Pickaxe Hm"],
    [8349, "Human Mining Zalcano Pickaxe Noreachforward"],
    [8350, "Human Mining Crystal Pickaxe Noreachforward"],
    [8351, "Human Mining Zalcano Bronze Pickaxe"],
    [8352, "Human Mining Zalcano Iron Pickaxe"],
    [8353, "Human Mining Zalcano Black Pickaxe"],
    [8354, "Human Mining Zalcano Steel Pickaxe"],
    [8355, "Human Mining Zalcano Mithril Pickaxe"],
    [8356, "Human Mining Zalcano Adamant Pickaxe"],
    [8357, "Human Mining Zalcano Rune Pickaxe"],
    [8358, "Human Mining Zalcano Gilded Pickaxe"],
    [8359, "Human Mining Zalcano Dragon Pickaxe"],
    [8360, "Human Mining Zalcano Dragon Pickaxe Pretty"],
    [8361, "Human Mining Zalcano Zalcano Pickaxe"],
    [8362, "Human Mining Zalcano Infernal Pickaxe"],
    [8363, "Human Mining Zalcano 3a Pickaxe"],
    [8364, "Human Mining Zalcano Crystal Pickaxe"],
    [8365, "Sote Flying Book Idle"],
    [8366, "Sote Book Tornado 2x2"],
    [8367, "Sote Book Tornado 3x3"],
    [8368, "Sote Seal Breaking"],
    [8369, "Sote Seal Broken"],
    [8370, "Dark Lord Trapped"],
    [8371, "Dark Lord Freed"],
    [8372, "Dark Lord Ready"],
    [8373, "Dark Lord Teleport Despawn"],
    [8374, "Dark Lord Teleport Spawn"],
    [8375, "Dark Lord Attack Ranged"],
    [8376, "Dark Lord Attack Ranged Single"],
    [8377, "Dark Lord Attack Ranged Multiple"],
    [8378, "Dark Lord Attack Healer"],
    [8379, "Dark Lord Attack Melee"],
    [8380, "Dark Lord Attack Powerblast"],
    [8381, "Dark Lord Ranged Proj 01"],
    [8382, "Dark Lord Ranged Proj 02"],
    [8383, "Dark Lord Powerblast Proj"],
    [8384, "Dark Lord Death"],
    [8385, "Seren Chat Idle"],
    [8386, "Seren Chat Talk 1"],
    [8387, "Seren Chat Talk 2"],
    [8388, "Seren Chat Talk 3"],
    [8389, "Seren Chat Talk 4"],
    [8390, "Dark Lord Chat Idle"],
    [8391, "Dark Lord Chat Talk 1"],
    [8392, "Dark Lord Chat Talk 2"],
    [8393, "Dark Lord Chat Talk 3"],
    [8394, "Dark Lord Chat Talk 4"],
    [8395, "Sote Baxtorian Statue Stone"],
    [8396, "Sote Baxtorian Statue Awaken"],
    [8397, "Sote Baxtorian Statue Ready"],
    [8398, "Sote Human Stabbed"],
    [8399, "Sote Ithell Symbol Glowing"],
    [8400, "Sote Raise Orb"],
    [8401, "Sote Raise Orb Injured"],
    [8402, "Sote Raise Orb Dying"],
    [8403, "Sote Raise Orb Dead"],
    [8404, "Sote Dead Elf Pose A"],
    [8405, "Sote Dead Elf Pose B"],
    [8406, "Sote Dead Elf Pose C"],
    [8407, "Sote Dead Elf Pose D"],
    [8408, "Sote Dead Elf Pose E"],
    [8409, "Sote Elena Sitting Up"],
    [8410, "Ds2 Stone Guardian Attack Move"],
    [8411, "Gauntlet Tool Storage Idle"],
    [8412, "Gauntlet Fishing Spot Idle"],
    [8413, "Gauntlet Singing Bowl Idle"],
    [8414, "Gauntlet Barrier Idle"],
    [8415, "Gauntlet Tap Idle"],
    [8416, "Hunllef Walk"],
    [8417, "Hunllef Ready"],
    [8418, "Hunllef Attack Special"],
    [8419, "Hunllef Attack Ranged"],
    [8420, "Hunllef Attack Melee"],
    [8421, "Hunllef Death Part A"],
    [8422, "Hunllef Death Part B"],
    [8423, "Hunllef Tornado Proj"],
    [8424, "Hunllef Tornado Proj Short"],
    [8425, "Crystal Spider Attack"],
    [8426, "Crystal Spider Death"],
    [8427, "Hunllef Pet Chat Talk"],
    [8428, "Hunllef Pet Walk"],
    [8429, "Zalcano Idle"],
    [8430, "Zalcano Walk"],
    [8431, "Zalcano Attack Melee"],
    [8432, "Zalcano Attack Ranged"],
    [8433, "Zalcano Attack Magic"],
    [8434, "Zalcano Attack Golem"],
    [8435, "Zalcano Attack Rock Fall"],
    [8436, "Zalcano Defend"],
    [8437, "Zalcano Fall Down"],
    [8438, "Zalcano Fallen Idle"],
    [8439, "Zalcano Stand Up"],
    [8440, "Zalcano Death"],
    [8441, "Zalcano Flyback"],
    [8442, "Zalcano Pentagram"],
    [8443, "Zalcano Furnace"],
    [8444, "Zalcano Runecraft"],
    [8445, "Zalcano Chat Idle"],
    [8446, "Zalcano Chat Talk"],
    [8447, "Zalcano Pet Walk"],
    [8448, "Zalcano Rock Idle"],
    [8449, "Zalcano Rock Shatter"],
    [8450, "Zalcano Rock Fall"],
    [8451, "Zalcano Enchanted Rock Proj"],
    [8452, "Zalcano Enchanted Rock Impact"],
    [8453, "Prif Portal Shrink"],
    [8454, "Prif Crystal Spire Light Idle"],
    [8455, "Clan Tower Teleporter Idle"],
    [8456, "Prif Agility Shortcut Portal Idle"],
    [8457, "Prif Crystal Boi Idle"],
    [8458, "Prif Crystal Boi Walk"],
    [8459, "Prif Crystal Singing"],
    [8460, "Curse Eye Twitch"],
    [8461, "Crab Rave"],
    [8462, "Human Walk B Long"],
    [8463, "Human Fletching Add Bolt Feathers Bronze"],
    [8464, "Human Fletching Add Bolt Feathers Iron"],
    [8465, "Human Fletching Add Bolt Feathers Silver"],
    [8466, "Human Fletching Add Bolt Feathers Blurite"],
    [8467, "Human Fletching Add Bolt Feathers Steel"],
    [8468, "Human Fletching Add Bolt Feathers Mithril"],
    [8469, "Human Fletching Add Bolt Feathers Adamant"],
    [8470, "Human Fletching Add Bolt Feathers Rune"],
    [8471, "Human Fletching Add Bolt Feathers Dragon"],
    [8472, "Human Fletching Add Bolt Tips Bronze"],
    [8473, "Human Fletching Add Bolt Tips Iron"],
    [8474, "Human Fletching Add Bolt Tips Blurite"],
    [8475, "Human Fletching Add Bolt Tips Steel"],
    [8476, "Human Fletching Add Bolt Tips Mithril"],
    [8477, "Human Fletching Add Bolt Tips Adamant"],
    [8478, "Human Fletching Add Bolt Tips Rune"],
    [8479, "Human Fletching Add Bolt Tips Dragon"],
    [8480, "Human Fletching Add Arrow Tips"],
    [8481, "Human Fletching Add Feather"],
    [8482, "Human Fletching Add Dart Feathers Bronze"],
    [8483, "Human Fletching Add Dart Feathers Iron"],
    [8484, "Human Fletching Add Dart Feathers Steel"],
    [8485, "Human Fletching Add Dart Feathers Mithril"],
    [8486, "Human Fletching Add Dart Feathers Adamant"],
    [8487, "Human Fletching Add Dart Feathers Rune"],
    [8488, "Human Fletching Add Dart Feathers Dragon"],
    [8489, "Aide Resting On Sword"],
    [8490, "Oge Banner Flutter"],
    [8491, "Human Use Lectern"],
    [8492, "Hw19 Spooky Walk"],
    [8493, "Basilisk Dead"],
    [8494, "Jormungand Entomb Impact"],
    [8495, "Jormungand Entomb Hold"],
    [8496, "Jormungand Entomb Break"],
    [8497, "Basilisk Knight Ready"],
    [8498, "Basilisk Knight Walk"],
    [8499, "Basilisk Knight Melee"],
    [8500, "Basilisk Knight Magic"],
    [8501, "Basilisk Knight Death"],
    [8502, "Basilisk Knight Chathead"],
    [8503, "Human Jormungand Stun"],
    [8504, "Human Jormungand Stunned 01"],
    [8505, "Human Jormungand Stunned 02"],
    [8506, "Human Jormungand Stunned 03"],
    [8507, "Human Jormungand Freed"],
    [8508, "Human Jormungand Freed Spotanim"],
    [8509, "Jormungand Ready"],
    [8510, "Jormungand Melee"],
    [8511, "Jormungand Magic"],
    [8512, "Jormungand Sleep"],
    [8513, "Jormungand Awakening"],
    [8514, "Jormungand Stun"],
    [8515, "Jormungand Gaze"],
    [8516, "Jormungand Death Part 1"],
    [8517, "Jormungand Death Part 2"],
    [8518, "Jormungand Dead"],
    [8519, "Jormungand Stun Projectile"],
    [8520, "Jormungand Chathead"],
    [8521, "Hw19 Spooky Idle"],
    [8522, "Hw19 Costume Crafting"],
    [8523, "League Relic Unlock"],
    [8524, "Human Relic Unlock"],
    [8525, "League Twisted Drawing Chalk Circle"],
    [8526, "Spectre Ghost Ready"],
    [8527, "Spectre Ghost Fly"],
    [8528, "Spectre Ghost Melee Attack"],
    [8529, "Spectre Ghost Mage Attack"],
    [8530, "Spectre Ghost Range Attack"],
    [8531, "Spectre Ghost Defend"],
    [8532, "Nightmare Staff Special"],
    [8533, "Peng Icelord Ice Barrage"],
    [8534, "Sleepwalker Walk"],
    [8535, "League Twisted Scroll Read"],
    [8536, "League Trophy Emote Small"],
    [8537, "League Trophy Emote Large"],
    [8538, "League Trophy Glint Spot"],
    [8539, "League Trophy Glint Long Spot"],
    [8540, "League Trophy Dragon Firebreath"],
    [8541, "Emote Explore"],
    [8542, "Evillaugh 1"],
    [8543, "Evillaugh 2"],
    [8544, "Evilidle 3"],
    [8545, "Nightmare Staff Volatile Hit"],
    [8546, "Nightmare Staff Volatile Cast"],
    [8547, "Nightmare Staff Eldritch Hit"],
    [8548, "Nightmare Staff Eldritch Player Cast"],
    [8549, "Human Biped Template 1x1"],
    [8550, "Human Biped Template 2x2"],
    [8551, "Shura Ready"],
    [8552, "Shura Walk"],
    [8553, "Nightmare Parasite Idle"],
    [8554, "Nightmare Parasite Attack Ranged"],
    [8555, "Nightmare Parasite Attack Magic"],
    [8556, "Nightmare Parasite Impregnate Player"],
    [8557, "Nightmare Parasite Vomit"],
    [8558, "Nightmare Parasite Vomit Spotanim"],
    [8559, "Nightmare Parasite Death"],
    [8560, "Nightmare Parasite Spawn"],
    [8561, "Nightmare Parasite Strong"],
    [8562, "Husk Idle"],
    [8563, "Husk Walk"],
    [8564, "Husk Ranged Attack"],
    [8565, "Husk Magic Attack"],
    [8566, "Husk Death"],
    [8567, "Husk Spawn"],
    [8568, "Sleepwalker Idle"],
    [8569, "Sleepwalker Ready"],
    [8570, "Sleepwalker Death"],
    [8571, "Sleepwalker Absorb"],
    [8572, "Sleepwalker Spawn"],
    [8573, "Nightmare Sanctuary Inactive To Preparing"],
    [8574, "Nightmare Sanctuary Preparing Idle"],
    [8575, "Nightmare Sanctuary Preparing To Active"],
    [8576, "Nightmare Sanctuary Active To Preparing"],
    [8577, "Nightmare Sanctuary Active Idle Phase 01"],
    [8578, "Nightmare Sanctuary Active Idle Phase 02"],
    [8579, "Nightmare Sanctuary Active Idle Phase 03"],
    [8580, "Nightmare Sanctuary Preparing To Inactive"],
    [8581, "Nightmare Sanctuary To Inactive"],
    [8582, "Nightmare Sanctuary Death Loop"],
    [8583, "Human Nightmare Wake"],
    [8584, "Human Nightmare Sleep"],
    [8585, "Nightmare Garden Walkway Mid Float"],
    [8586, "Nightmare Garden Walkway Side Float"],
    [8587, "Nightmare Garden Totem Spell"],
    [8588, "Nightmare Garden Totem Spell Impact"],
    [8589, "Nightmare Totem Fully Charged"],
    [8590, "Nightmare Garden Island Floating"],
    [8591, "Nightmare Head Loc"],
    [8592, "Nightmare Walk"],
    [8593, "Nightmare Idle"],
    [8594, "Nightmare Attack Melee"],
    [8595, "Nightmare Attack Magic"],
    [8596, "Nightmare Attack Ranged"],
    [8597, "Nightmare Attack Surge"],
    [8598, "Nightmare Attack Rift"],
    [8599, "Nightmare Attack Confusion"],
    [8600, "Nightmare Attack Infection"],
    [8601, "Nightmare Attack Segment"],
    [8602, "Nightmare Attack Summon"],
    [8603, "Nightmare Attack Charge"],
    [8604, "Nightmare Attack Blast"],
    [8605, "Nightmare Attack Trance"],
    [8606, "Nightmare Attack Parasite"],
    [8607, "Nightmare Despawn"],
    [8608, "Nightmare Attack Blast Despawn"],
    [8609, "Nightmare Respawn"],
    [8610, "Nightmare Attack Blast Respawn"],
    [8611, "Nightmare Spawn Initial"],
    [8612, "Nightmare Death"],
    [8613, "Nightmare Dead Loop"],
    [8614, "Nightmare Projectile Ranged"],
    [8615, "Nightmare Projectile Rift"],
    [8616, "Nightmare Separate Spotanim Petals Inactive Initial"],
    [8617, "Nightmare Separate Spotanim Petals Inactive Spawn"],
    [8618, "Nightmare Separate Spotanim Petals Inactive Idle"],
    [8619, "Nightmare Separate Spotanim Petals Active Spawn"],
    [8620, "Nightmare Separate Spotanim Petals Active Idle"],
    [8621, "Nightmare Separate Spotanim Petals Active Despawn"],
    [8622, "Nightmare Separate Spotanim Berry Inactive Initial"],
    [8623, "Nightmare Separate Spotanim Berry Inactive Spawn"],
    [8624, "Nightmare Separate Spotanim Berry Inactive Idle"],
    [8625, "Nightmare Separate Spotanim Berry Active Spawn"],
    [8626, "Nightmare Separate Spotanim Berry Active Idle"],
    [8627, "Nightmare Separate Spotanim Berry Active Despawn"],
    [8628, "Nightmare Flies Projectile"],
    [8629, "Nightmare Infection Spotanim Initial"],
    [8630, "Nightmare Infection Spotanim Spawn"],
    [8631, "Nightmare Infection Spotanim Idle"],
    [8632, "Nightmare Infection Spotanim Despawn"],
    [8633, "Nightmare Impact Blast Spotanim"],
    [8634, "Nightmare Pet Walk"],
    [8635, "Nightmare Pet Chat Idle"],
    [8636, "Nightmare Pet Chat Talk"],
    [8637, "Tekton Enraged Pet Walk"],
    [8638, "Human Sword Slash Withdagger"],
    [8639, "Vespula Pet Fly"],
    [8640, "Human Carrot Sword Attack"],
    [8641, "Raids Boss 1 Swirl"],
    [8642, "Human Carrot Sword Ready"],
    [8643, "Raids Boss Swirl 1 Fast"],
    [8644, "Drakan Incinerate Death"],
    [8645, "Myq5 Knockback"],
    [8646, "Myq4 Steam Vent Activate Missing"],
    [8647, "Druidicspirit Human Bloom Ruby"],
    [8648, "Druidicspirit Human Bloom Blisterwood Sickle"],
    [8649, "Druidicspirit Human Bloom Blisterwood Flail"],
    [8650, "Bloodveld Walk Pet"],
    [8651, "Bloodveld Attack Move"],
    [8652, "Specter Goo Travel Loop"],
    [8653, "Hallowed Hammer Swing"],
    [8654, "Hallowed Teleport Activate"],
    [8655, "Hallowed Statue Fire Idle"],
    [8656, "Hallowed Statue Fire Ready"],
    [8657, "Hallowed Statue Fire Start Attack"],
    [8658, "Hallowed Statue Fire Attack"],
    [8659, "Hallowed Statue Fire Finish Attack"],
    [8660, "Hallowed Statue Ready Fire Blast"],
    [8661, "Hallowed Statue Start Fire Blast"],
    [8662, "Hallowed Statue Fire Blast"],
    [8663, "Hallowed Statue End Fire Blast"],
    [8664, "Hallowed Statue Idle Fire Blast"],
    [8665, "Hallowed Statue Sword Idle"],
    [8666, "Hallowed Statue Sword Ready"],
    [8667, "Hallowed Statue Sword Start Attack"],
    [8668, "Hallowed Statue Sword Attack"],
    [8669, "Hallowed Statue Sword Finish Attack"],
    [8670, "Hallowed Statue Sword Catch"],
    [8671, "Hallowed Statue Sword Spin"],
    [8672, "Hallowed Statue Lightning Idle"],
    [8673, "Hallowed Statue Lightning Start Attack"],
    [8674, "Hallowed Statue Lightning Attack"],
    [8675, "Hallowed Statue Lightning Finish Attack"],
    [8676, "Hallowed Statue Lightning Strike Idle"],
    [8677, "Hallowed Statue Lightning Start Strike"],
    [8678, "Hallowed Statue Lightning Start Strike Long"],
    [8679, "Hallowed Statue Lightning Strike"],
    [8680, "Hallowed Statue Lightning End Strike"],
    [8681, "Hallowed Statue Projectile Idle"],
    [8682, "Hallowed Statue Projectile Ready"],
    [8683, "Hallowed Statue Projectile Start Attack"],
    [8684, "Hallowed Statue Projectile Attack"],
    [8685, "Hallowed Statue Projectile Finish Attack"],
    [8686, "Hallowed Statue Idle Bolt"],
    [8687, "Hallowed Statue Bolt"],
    [8688, "Hallowed Telepad Idle"],
    [8689, "Hallowed Telepad Activate"],
    [8690, "Hallowed Telepad Activate Rev"],
    [8691, "Hallowed Coffin Open"],
    [8692, "Hallowed Human Running"],
    [8693, "Hs Fish Swim"],
    [8694, "Hs Magic Portal"],
    [8695, "Hs Prayer Barrier"],
    [8696, "Hallowed Human Smithing"],
    [8697, "Darkm Lamp Flicker"],
    [8698, "Darkm Prisoner Shackled Wall"],
    [8699, "Darkm Prisoner Caged"],
    [8700, "Vyrelady Walk"],
    [8701, "Vyrelady Ready"],
    [8702, "Vyrelord Walk"],
    [8703, "Vyrelord Ready"],
    [8704, "Vyrelord Barrage"],
    [8705, "Vyrelord Claw"],
    [8706, "Vyrelord Feeding Time"],
    [8707, "Vyrelord Fixed Neck Bite"],
    [8708, "Vyrelord Ground Defend Female"],
    [8709, "Vyrelord Ground Defend Male"],
    [8710, "Vyrelord Grounded Death"],
    [8711, "Vyrelord Head Vamp Spell"],
    [8712, "Vyrelord Human To Vampire Fade"],
    [8713, "Vyrelord Juvenile Juvinate Dust Start"],
    [8714, "Vyrelord Juvenile Juvinate Hold Capture"],
    [8715, "Vyrelord Juvinate Tithe Puch Ready"],
    [8716, "Vyrelord Magic"],
    [8717, "Vyrelord New Ground Attack"],
    [8718, "Vyrelord Orb To Human Fade"],
    [8719, "Vyrelord Vanstrom Klaus Defend"],
    [8720, "Vyrelord Vanstrom Klause Double Punch Kick"],
    [8721, "Vyrelord Vanstrom Klause Dragon"],
    [8722, "Vyrelord Summon"],
    [8723, "Vyrelord Disintegrate"],
    [8724, "Vyrelord Disintegrate Spotanim"],
    [8725, "Vyrelord Drakan Walk"],
    [8726, "Vyrelord Drakan Ready"],
    [8727, "Vyrelord Drakan Walk Dramatic"],
    [8728, "Vyrelord Drakan Walk Dramatic Loop"],
    [8729, "Vyrelord Drakan Spawn"],
    [8730, "Vyrelord Drakan Spawn Spotanim"],
    [8731, "Vyrelord Drakan Despawn"],
    [8732, "Vyrelord Drakan Despawn Spotanim"],
    [8733, "Vyrelord Reachforladder"],
    [8734, "Vyrelord Drakan Imprison"],
    [8735, "Vyrelord Trapped"],
    [8736, "Vyrelord Drakan Imprison Spotanim"],
    [8737, "Vyrelord Trapped Idle"],
    [8738, "Vyrelord Trapped Spotanim"],
    [8739, "Vyrelord Drakan Obliterate"],
    [8740, "Vyrelord Drakan Incinerate"],
    [8741, "Vyrelord Obliterate Death"],
    [8742, "Vyrelord Vanescula Despawn"],
    [8743, "Vyrelord Trapped Despawn"],
    [8744, "Vyrelord Transform Pt1"],
    [8745, "Vyrelord Transform Pt2"],
    [8746, "Drakan Incinerate Death Spotanim"],
    [8747, "Poh Portal Shrinkunshrinkloop"],
    [8748, "Grim Reaper Ready"],
    [8749, "Death Office Muncher"],
    [8750, "Death Office Portal Exit"],
    [8751, "Death Office Torch"],
    [8752, "Death Office Desk"],
    [8753, "Hunllef Spawn"],
    [8754, "Hunllef Attack Transition Magic"],
    [8755, "Hunllef Attack Transition Ranged"],
    [8756, "Hunllef Projectile Ranged"],
    [8757, "Hunllef Projectile Magic"],
    [8758, "Gg Dusk Fall Down And Defend"],
    [8759, "Superior Hydra Attack Special"],
    [8760, "Superior Hydra Death"],
    [8761, "Superior Wyrm Transition Up"],
    [8762, "Superior Drake Melee Special"],
    [8763, "Lotr Banker Walk"],
    [8764, "Lotr Banker Ready"],
    [8765, "Godwars Bandos Attack Loop"],
    [8766, "Zalcano Attack Loop"],
    [8767, "Sourhog Idle"],
    [8768, "Sourhog Walk"],
    [8769, "Sourhog Attack Melee"],
    [8770, "Sourhog Attack Ranged"],
    [8771, "Sourhog Death"],
    [8772, "Sourhog Death Slayer Npc"],
    [8773, "Sourhog Dead"],
    [8774, "Sourhog Dead Fadeaway"],
    [8775, "Hw20 Poh Pumpkin Idle"],
    [8776, "Anma Chopping Failed League Trailblazer Axe"],
    [8777, "Human Canoeing Carve League Trailblazer Axe"],
    [8778, "Human Openheavychest"],
    [8779, "Human Woodcrafting Axe League Trailblazer"],
    [8780, "Brut Human Canoeing Carve League Trailblazer Axe"],
    [8781, "Rockknocker League Trailblazer"],
    [8782, "Fishstabber League Trailblazer"],
    [8783, "Human Harpoon Trailblazer"],
    [8784, "Human Harpoon League Trailblazer"],
    [8785, "Sang Mining Wall League Trailblazer Pickaxe"],
    [8786, "Human Mining League Trailblazer Pickaxe Wall"],
    [8787, "Human Mining League Trailblazer Pickaxe"],
    [8788, "Human Mining League Trailblazer Pickaxe Noreachforward"],
    [8789, "Human Mining Zalcano League Trailblazer Pickaxe"],
    [8790, "League Trailblazer Archway"],
    [8791, "League Trailblazer Waystone"],
    [8792, "Trailblazer League Area Unlock Emote"],
    [8793, "Trailblazer League Area Unlock Emote Spotanim"],
    [8794, "Trailblazer League Last Recall Teleport Disappear"],
    [8795, "Trailblazer League Last Recall Teleport Disappear Spotanim"],
    [8796, "Trailblazer League Last Recall Teleport Reappear"],
    [8797, "Trailblazer League Last Recall Teleport Reappear Spotanim"],
    [8798, "League Trailblazer Home Teleport Human 1"],
    [8799, "League Trailblazer Home Teleport Human 2"],
    [8800, "League Trailblazer Home Teleport Spotanim 2"],
    [8801, "League Trailblazer Home Teleport Human 3"],
    [8802, "League Trailblazer Home Teleport Spotanim 3"],
    [8803, "League Trailblazer Home Teleport Human 4"],
    [8804, "League Trailblazer Home Teleport Spotanim 4"],
    [8805, "League Trailblazer Home Teleport Human 5"],
    [8806, "League Trailblazer Home Teleport Spotanim 5"],
    [8807, "League Trailblazer Home Teleport Human 6"],
    [8808, "League Trailblazer Home Teleport Spotanim 6"],
    [8809, "League Trailblazer Home Teleport Human Complete"],
    [8810, "League Trailblazer Home Teleport Spotanim Complete"],
    [8811, "Home Teleport Human Fire 1"],
    [8812, "Home Teleport Human Fire 2"],
    [8813, "Home Teleport Human Fire 3"],
    [8814, "Home Teleport Spotanim Fire 3"],
    [8815, "Home Teleport Human Fire 4"],
    [8816, "Home Teleport Spotanim Fire 4"],
    [8817, "Home Teleport Human Fire 5"],
    [8818, "Home Teleport Spotanim Fire 5"],
    [8819, "Antisanta Chat"],
    [8820, "Hahaha"],
    [8821, "Leagues Teleport Spotanim Fire"],
    [8822, "Leagues Teleport Spotanim Fire Scale"],
    [8823, "Leagues Teleport Spotanim Fire Scale Randomised"],
    [8824, "Leagues Teleport Spotanim Fire Local Rotate Z"],
    [8825, "Leagues Teleport Spotanim Fire Local Rotate X"],
    [8826, "Leagues Teleport Spotanim Fire Rotate X Z"],
    [8827, "Leagues Teleport Spotanim Fire Rotate Z X"],
    [8828, "Leagues Teleport Spotanim Fire Rotate X Z X"],
    [8829, "Leagues Teleport Spotanim Fire Rotate Z X Z"],
    [8830, "Leagues Teleport Spotanim Fire Rotate Mixed Centre"],
    [8831, "Leagues Teleport Spotanim Fire Rotate Mixed Oscillate"],
    [8832, "Leagues Teleport Spotanim Fire Rotate Mix A"],
    [8833, "Human Cutting"],
    [8834, "Bear Headless Beast Defend"],
    [8835, "Bear Headless Beast Stomp"],
    [8836, "Ga Beast Rock Fall"],
    [8837, "Human Pour Pot"],
    [8838, "Human Sculpt Clay"],
    [8839, "Human Clay Stitching"],
    [8840, "Snp Fire Boss Attack"],
    [8841, "Snp Fire Boss Death"],
    [8842, "Snp Nature Boss Ready"],
    [8843, "Snp Nature Boss Walk"],
    [8844, "Snp Nature Boss Attack"],
    [8845, "Snp Nature Boss Death"],
    [8846, "Snp Nature Boss Pet Walk"],
    [8847, "Snp Fire Boss Pet Walk"],
    [8848, "Snp Fire Boss Chathead"],
    [8849, "Snp Nature Boss Chathead"],
    [8850, "Fire Burning"],
    [8851, "Snp Obelisk"],
    [8852, "Human Lockedchest Moving"],
    [8853, "Trollromance Toboggan Flying With Sound"],
    [8854, "Trollromance Toboggan Walking With Sound"],
    [8855, "Osb8 Skillcape Banana Emote"],
    [8856, "Osb8 Skillcape Banana Spotanim Sequence"],
    [8857, "Jaltokjad Walk Pet"],
    [8858, "Jaltokjad Chathead Pet"],
    [8859, "Tzhaar Ket Rak Seated Ready"],
    [8860, "Tzhaar Ket Rak Chathead"],
    [8861, "Game Star Meteor Impact"],
    [8862, "Game Star Meteor"],
    [8863, "Star Meteor Rock Change"],
    [8864, "Game Star Bulbo Star Sprite Ready"],
    [8865, "Game Star Meteor Despawn"],
    [8866, "Game Star Star Sprite Despawn"],
    [8867, "Fsb Pool Idle"],
    [8868, "Tempoross Tether"],
    [8869, "Tempoross Tether Loop"],
    [8870, "Tempoross Untether"],
    [8871, "Tempoross Cannon Firing"],
    [8872, "Tempoross Cannon Firing Mirror"],
    [8873, "Fsb Pool Whirligig"],
    [8874, "Tempoross Storm Cloud Lightning Spotanim"],
    [8875, "Tempoross Lightning Cloud Idle"],
    [8876, "Tempoross Lightning Cloud Growing"],
    [8877, "Tempoross Lightning Cloud Charging Idle"],
    [8878, "Tempoross Lightning Cloud Attack"],
    [8879, "Tempoross Lightning Cloud Shrinking"],
    [8880, "Tempoross Lightning Cloud Shadow"],
    [8881, "Tempoross Lightning Cloud Shadow Short"],
    [8882, "Tempoross Torrent"],
    [8883, "Tempoross Cannon Disabled"],
    [8884, "Tempoross Cannon Disabled Mirrored"],
    [8885, "Sang Mining Wall Trailblazer Pickaxe No Infernal"],
    [8886, "Human Mining Trailblazer Pickaxe No Infernal Wall"],
    [8887, "Human Mining Trailblazer Pickaxe No Infernal"],
    [8888, "Human Mining Trailblazer Pickaxe No Infernal Noreachforward"],
    [8889, "Human Mining Zalcano Trailblazer Pickaxe No Infernal"],
    [8890, "League Trailblazer Scroll Read"],
    [8891, "Ii Human Walk Thru Wheat Mid Speed Affinity"],
    [8892, "Ii Human Walk Thru Wheat Slowly Affinity"],
    [8893, "Tempoross Torrent Cast"],
    [8894, "Human Smithing Noreplace"],
    [8895, "Fsb Ready"],
    [8896, "Fsb Unengaged"],
    [8897, "Fsb Spawn"],
    [8898, "Slayer Lizard Walk Fast"],
    [8899, "Fsb Whirlpool"],
    [8900, "Fsb Ready To Whirl"],
    [8901, "Fsb Whirl To Ready"],
    [8902, "Fsb Tidal Wave"],
    [8903, "Fsb Torrent Cast"],
    [8904, "Fsb Death"],
    [8905, "Fsb Lightening Cast"],
    [8906, "Fsb Enraged Transition"],
    [8907, "Fsb Pet Chathead"],
    [8908, "Fsb Enraged Spawn"],
    [8909, "Tentacle Trawler Monster Attack"],
    [8910, "Tentacle Trawler Monster Recoil"],
    [8911, "Human Smithing Imcando Hammer"],
    [8912, "Human Poh Build Imcando Hammer"],
    [8913, "Human Poh Build Floor Imcando Hammer"],
    [8914, "Human Poh Build Wall Imcando Hammer"],
    [8915, "Human Hammer Hit Imcando Hammer"],
    [8916, "Birdhouse Make Imcando Hammer"],
    [8917, "Emote Flex"],
    [8918, "Pest Repair Imcando Hammer"],
    [8919, "Barbassault Trap Door Build Imcando Hammer"],
    [8920, "Barbassault Cave Barricade Build Imcando Hammer"],
    [8921, "Dwarf Rps"],
    [8922, "Mcannon Hammer Anim Imcando Hammer"],
    [8923, "Tol Player Fix Machine Imcando Hammer"],
    [8924, "Sang Repair Boat Imcando Hammer"],
    [8925, "Anma Hammer Iron Imcando Hammer"],
    [8926, "Human Woodcrafting Imcando Hammer"],
    [8927, "Fever Nail Plank Imcando Hammer"],
    [8928, "Rps Human"],
    [8929, "Dwarf Eat"],
    [8930, "Bim Pushups"],
    [8931, "Bim Pushups Stand"],
    [8932, "Flickering Flame Calm"],
    [8933, "Imcando Sacred Forge"],
    [8934, "Gateway Imcando Vault01 Glow"],
    [8935, "Bim Human Ready"],
    [8936, "Fx Fog Ground01 Loop"],
    [8937, "Fx Fog Ground04 Loop"],
    [8938, "Bim Sandwich Make"],
    [8939, "Ancient Guardian Walking 2x2"],
    [8940, "Ancient Guardian Walking 1x1"],
    [8941, "Ancient Guardian Idle"],
    [8942, "Ancient Guardian Attack Melee"],
    [8943, "Ancient Guardian Death"],
    [8944, "Ancient Guardian Awaken"],
    [8945, "Ancient Guardian Inactive"],
    [8946, "Ancient Guardian Attack Melee Variation"],
    [8947, "Swan Hammer Imcando Hammer"],
    [8948, "Brut Human Smithing Imcando Hammer"],
    [8949, "Godwars Hammer Gong Imcando Hammer"],
    [8950, "Hosidius Plough Fix Imcando Hammer"],
    [8951, "Pisc Repair Imcando Hammer"],
    [8952, "Tentacle Trawler Monster Sweep"],
    [8953, "Tentacle Trawler Monster Hold"],
    [8954, "Human Trawler Hack Axe Bronze"],
    [8955, "Human Trawler Hack Axe Iron"],
    [8956, "Human Trawler Hack Axe Steel"],
    [8957, "Human Trawler Hack Axe Black"],
    [8958, "Human Trawler Hack Axe Mithril"],
    [8959, "Human Trawler Hack Axe Adamant"],
    [8960, "Human Trawler Hack Axe Rune"],
    [8961, "Human Trawler Hack Axe Gilded"],
    [8962, "Human Trawler Hack Axe Dragon"],
    [8963, "Human Trawler Hack Axe Infernal"],
    [8964, "Human Trawler Hack Axe 3a"],
    [8965, "Human Trawler Hack Axe Crystal"],
    [8966, "Human Trawler Hack Axe League Trailblazer"],
    [8967, "Human Trawler Hack Axe Trailblazer No Infernal"],
    [8968, "Tentacle Trawler Monster Invisible"],
    [8969, "Infernaleel Break Imcando"],
    [8970, "Human Cast Selfimbue"],
    [8971, "Nightmare Attack Rift Fast"],
    [8972, "Human Spellcast Grasp"],
    [8973, "Human Spellcast Resurrect"],
    [8974, "Human Cast Vicious Strike"],
    [8975, "Human Cast Offering"],
    [8976, "Human Prepare Offering"],
    [8977, "Human Spellcast Demonbane"],
    [8978, "Human Cast Vilevigour"],
    [8979, "Human Spellcast Shadowveil"],
    [8980, "Human Spellcast Degrime"],
    [8981, "Human Prepare Degrime"],
    [8982, "Self Imbue"],
    [8983, "Death Charge"],
    [8984, "Death Charge Npc Hit"],
    [8985, "Mark Of Darkness"],
    [8986, "Mark Of Darkness Hit"],
    [8987, "Fx Spellcast Grasp"],
    [8988, "Fx Spellimpact Grasp"],
    [8989, "Fx Spellcast Resurrect"],
    [8990, "Fx Spellcast Resurrect03"],
    [8991, "Fx Spellcast Offeringsinister"],
    [8992, "Fx Spellcast Offeringdemonic"],
    [8993, "Fx Spellcast Demonbane"],
    [8994, "Fx Spellimpact Demonbane"],
    [8995, "Fx Spellcast Vilevigour"],
    [8996, "Fx Spellcast Corruption01"],
    [8997, "Fx Spellimpact Corruption01"],
    [8998, "Fx Spellcast Shadowveil"],
    [8999, "Fx Spellcast Darklure"],
    [9000, "Fx Spellproj Darklure"],
    [9001, "Fx Spellimpact Darklure"],
    [9002, "Fx Spellcast Degrime"],
    [9003, "Flamewall Extended"],
    [9004, "Tob Shadow Projectile Spawn"],
    [9005, "Tob Shadow Projectile Despawn"],
    [9006, "Ntk Tomb Door Opened"],
    [9007, "Zombie Raise Dragging"],
    [9008, "Human Sittingdown Ready Gz"],
    [9009, "Human Sittingdown Scratch Gz"],
    [9010, "Human Sittingdown Think Gz"],
    [9011, "Human Sittingdown Move Gz"],
    [9012, "Human Sittingdown Ready Gz Blue"],
    [9013, "Human Sittingdown Scratch Gz Blue"],
    [9014, "Human Sittingdown Think Gz Blue"],
    [9015, "Human Sittingdown Move Gz Blue"],
    [9016, "Portal Radial Spin"],
    [9017, "Dh Vex Walk"],
    [9018, "Dh Vex Ready"],
    [9019, "Dh Vex Run"],
    [9020, "Dh Vex Walk Right"],
    [9021, "Dh Vex Walk Left"],
    [9022, "Clan Medieval Diningchair Sitting"],
    [9023, "Clan Medieval Diningchair Eating"],
    [9024, "Clan Medieval Barstool Sitting"],
    [9025, "Clan Medieval Barstool Eating"],
    [9026, "Gg Debris Shadow 210"],
    [9027, "Gg Debris Shadow 240"],
    [9028, "Sanguinesti Staff Travel Justiciar"],
    [9029, "Sanguinesti Staff Heal Justiciar"],
    [9030, "Top Spider Melee Spawn Noloop"],
    [9031, "Tob Bloat Walk Pet"],
    [9032, "Tob Sotetseg Walk Pet"],
    [9033, "Tob Xarpus Pet Idle"],
    [9034, "Fx Spellcast Grasp Xamphur"],
    [9035, "Fx Spellimpact Resurrect01"],
    [9036, "Fx Spellcast Demonbane Xamphur"],
    [9037, "Loc Spelltrigger Darkmark Idle"],
    [9038, "Loc Spelltrigger Darkmark Spawn"],
    [9039, "Loc Spelltrigger Darkmark Despawn"],
    [9040, "Loc Spelltrigger Darkmark Spawn And Idle"],
    [9041, "Fx Spellhit Darkmark01"],
    [9042, "Judgeofyama Death"],
    [9043, "Judgeofyama Attack"],
    [9044, "Dwarf Ready Loop"],
    [9045, "Dwarf Ready Woman Loop"],
    [9046, "Zombie Thrawl Spawn"],
    [9047, "Ghost Thrall Spawn"],
    [9048, "Skeleton Thrall Spawn"],
    [9049, "Akd Dark Piscarilius Hand Grasp"],
    [9050, "Human Zyanyi Idle"],
    [9051, "Human Zyanyi Walk"],
    [9052, "Human Zyanyi Walk L"],
    [9053, "Human Zyanyi Walk R"],
    [9054, "Human Zyanyi Walk B"],
    [9055, "Human Zyanyi Turn"],
    [9056, "Human Unconscious Loop"],
    [9057, "Human Unconscious Transition"],
    [9058, "Proj Dagger Kualti"],
    [9059, "Npc Xamphur Default Idle"],
    [9060, "Npc Xamphur Transition A"],
    [9061, "Npc Xamphur Transition A Loop"],
    [9062, "Npc Xamphur Combat Transition B"],
    [9063, "Npc Xamphur Combat Idle"],
    [9064, "Npc Xamphur Combat Attack Grasp"],
    [9065, "Npc Xamphur Summon A"],
    [9066, "Npc Xamphur Summon B"],
    [9067, "Npc Xamphur Dismiss"],
    [9068, "Npc Xamphur Combat Pursuing Hands"],
    [9069, "Npc Xamphur Demonbane"],
    [9070, "Npc Hand Right Pursuing"],
    [9071, "Npc Hand Left Pursuing"],
    [9072, "Npc Hand Left Idle"],
    [9073, "Npc Hand Right Idle"],
    [9074, "Npc Hand Right Walk"],
    [9075, "Npc Hand Left Walk"],
    [9076, "Npc Hand Left Attack"],
    [9077, "Npc Hand Right Attack"],
    [9078, "Npc Hand Left Death"],
    [9079, "Npc Hand Right Death"],
    [9080, "Chathead Xamphur Default"],
    [9081, "Chathead Xamphur Default Tilt"],
    [9082, "Chathead Xamphur Default Negative"],
    [9083, "Chathead Xamphur Default Affirmative"],
    [9084, "Chathead Xamphur Default Extroverted"],
    [9085, "Chathead Xamphur Default Introverted"],
    [9086, "Fx Light Streaming Slower"],
    [9087, "Shayzien Lantern01 Sway01"],
    [9088, "Shayzien Lantern01 Sway02"],
    [9089, "Shayzien Lantern01 Idle01"],
    [9090, "Npc Lynx Combat Walk"],
    [9091, "Npc Lynx Combat Idle"],
    [9092, "Npc Lynx Combat Melee"],
    [9093, "Npc Lynx Combat Death"],
    [9094, "Npc Lynx Combat Spawn"],
    [9095, "Npc Boar Combat Idle"],
    [9096, "Npc Boar Combat Walk"],
    [9097, "Npc Boar Combat Melee"],
    [9098, "Npc Boar Combat Death"],
    [9099, "Npc Boar Combat Spawn"],
    [9100, "Arceuus Elder Ready Loop"],
    [9101, "Human Death Loop"],
    [9102, "Nightmare Attack Rift Phase 04 Start"],
    [9103, "Nightmare Attack Rift Phase 04 Idle"],
    [9104, "Nightmare Attack Rift Phase 04 Finish"],
    [9105, "Nightmare Projectile Rift Phase 04 Start"],
    [9106, "Nightmare Projectile Rift Phase 04 Idle"],
    [9107, "Nightmare Projectile Rift Phase 04 End"],
    [9108, "Human Fletching Add Dart Feathers Amethyst"],
    [9109, "Gg Debris Shadow 270"],
    [9110, "Gg Debris Shadow 300"],
    [9111, "Hydra Stage 1 Switch Attack"],
    [9112, "Hydra Stage 2 Switch Attack"],
    [9113, "Hydra Stage 3 Switch Attack"],
    [9114, "Hydra Stage 4 Switch Attack"],
    [9115, "Gg Combined Ui Pose1"],
    [9116, "Combat Achievements Teleport Player Tier 1"],
    [9117, "Combat Achievements Teleport Woman Tier 1"],
    [9118, "Combat Achievements Teleport Reappear Player Tier 1"],
    [9119, "Combat Achievements Teleport Player Tier 2"],
    [9120, "Combat Achievements Teleport Woman Tier 2"],
    [9121, "Combat Achievements Teleport Reappear Player Tier 2"],
    [9122, "Combat Achievements Teleport Player Tier 3"],
    [9123, "Combat Achievements Teleport Woman Tier 3"],
    [9124, "Combat Achievements Teleport Reappear Player Tier 3"],
    [9125, "Combat Achievements Teleport Player Tier 4"],
    [9126, "Combat Achievements Teleport Woman Tier 4"],
    [9127, "Combat Achievements Teleport Reappear Player Tier 4"],
    [9128, "Combat Achievements Teleport Player Tier 5"],
    [9129, "Combat Achievements Teleport Woman Tier 5"],
    [9130, "Combat Achievements Teleport Reappear Player Tier 5"],
    [9131, "Combat Achievements Teleport Player Tier 6"],
    [9132, "Combat Achievements Teleport Woman Tier 6"],
    [9133, "Combat Achievements Teleport Reappear Player Tier 6"],
    [9134, "Combat Achievements Teleport Spotanim"],
    [9135, "Combat Achievements Teleport Reappear Spotanim"],
    [9136, "Hodsun Spider Boss Walk Small"],
    [9137, "Npc Araxyte01 Idle"],
    [9138, "Npc Araxyte01 Walk"],
    [9139, "Npc Araxyte01 Walk Fast"],
    [9140, "Npc Araxyte01 Attack"],
    [9141, "Npc Araxyte01 Death"],
    [9142, "Verzik Young Idle"],
    [9143, "Verzik Young Walk"],
    [9144, "Human Caststrike Walkmerge"],
    [9145, "Human Cast Surge Walkmerge"],
    [9146, "Deadman Grim Reaper Ready"],
    [9147, "Dmm Last Recall Teleport Disappear"],
    [9148, "Dmm Last Recall Teleport Disappear Spotanim"],
    [9149, "Dmm Last Recall Teleport Reappear"],
    [9150, "Dmm Last Recall Teleport Reappear Spotanim"],
    [9151, "Fx Spellcast Dmm"],
    [9152, "Fx Spellcast Dmm Guardian"],
    [9153, "Fx Dmm Rampage01"],
    [9154, "Fx Dmm Rampage02"],
    [9155, "Fx Dmm Rampage03"],
    [9156, "Fx Dmm Rampage04"],
    [9157, "Fx Dmm Rampage05"],
    [9158, "Human Spellcast Dmm"],
    [9159, "Human Guardian Dmm"],
    [9160, "Human Trophy League03 Block"],
    [9161, "Human Xbows League03 Idle"],
    [9162, "Hw12 Human Shake Bottle"],
    [9163, "Hw21 Spotanim Shake Bottle"],
    [9164, "Human Xbows League03 Walk F"],
    [9165, "Human Xbows League03 Walk B"],
    [9166, "Zcb Attack"],
    [9167, "Grim Reaper Walk"],
    [9168, "Zcb Attack Pvn"],
    [9169, "Grim Reaper Idle"],
    [9170, "Nex Warrior Special"],
    [9171, "Ngs Special Player"],
    [9172, "Ngs Special Spotanim"],
    [9173, "Ngs Special Player Iteration"],
    [9174, "Ngs Special Spotanim Iteration"],
    [9175, "Nex Run"],
    [9176, "Nex Pet Run"],
    [9177, "Nex Ready"],
    [9178, "Nex Dash Attack"],
    [9179, "Nex Turmoil"],
    [9180, "Nex Attack"],
    [9181, "Nex Pet Attack"],
    [9182, "Nex Blast Away"],
    [9183, "Nex Blood Siphon"],
    [9184, "Nex Death"],
    [9185, "Nex Defend"],
    [9186, "Nex Smash Attack"],
    [9187, "Nex Spin Out"],
    [9188, "Nex Alternate Cast Attack"],
    [9189, "Nex Cast Attack"],
    [9190, "Nex Blood Siphon Spotanim"],
    [9191, "Nex Turmoil Spotanim"],
    [9192, "Blood Reaver Death"],
    [9193, "Blood Reaver Walk"],
    [9194, "Blood Reaver Attack"],
    [9195, "Blood Reaver Ready"],
    [9196, "Blood Reaver Defend"],
    [9197, "Nex Spot Soulsplit Proj"],
    [9198, "Nex Spot Leech Proj"],
    [9199, "Nex Spot Leech Impact"],
    [9200, "Nex Mushroom Cloud Projanim"],
    [9201, "Nex Mushroom Cloud Spotanim"],
    [9202, "Nex Summon"],
    [9203, "Nex Prison Barrier"],
    [9204, "Human Xbows League03 Run"],
    [9205, "Human Xbows League03 Attack"],
    [9206, "Human Xbows League03 Attack Pvn"],
    [9207, "League03 Area Unlock Emote Spotanim"],
    [9208, "League03 Area Unlock Emote Player"],
    [9209, "League03 Home Teleport Human 1"],
    [9210, "League03 Home Teleport Human 2"],
    [9211, "League03 Home Teleport Human 3"],
    [9212, "League03 Home Teleport Human 4"],
    [9213, "League03 Home Teleport Human 5"],
    [9214, "League03 Home Teleport Human 6"],
    [9215, "League03 Home Teleport Spotanim 1"],
    [9216, "League03 Home Teleport Spotanim 2"],
    [9217, "League03 Home Teleport Spotanim 3"],
    [9218, "League03 Home Teleport Spotanim 4"],
    [9219, "League03 Home Teleport Spotanim 5"],
    [9220, "League03 Home Teleport Spotanim 6"],
    [9221, "Leagues03 Cutscene01 Fadein01"],
    [9222, "Leagues03 Cutscene01 Fadeout01"],
    [9223, "Kronis Chains Idle"],
    [9224, "Kronis Chains Idle Typeq"],
    [9225, "Kronis Chains Unlock"],
    [9226, "Kronis Chains Unlock Typeq"],
    [9227, "League3 Fog Idle"],
    [9228, "League3 Rocks01 Idle"],
    [9229, "Cannon League03 Active"],
    [9230, "Cannon League03 Fire N"],
    [9231, "Cannon League03 Fire Ne"],
    [9232, "Cannon League03 Fire E"],
    [9233, "Cannon League03 Fire Se"],
    [9234, "Cannon League03 Fire S"],
    [9235, "Cannon League03 Fire Sw"],
    [9236, "Cannon League03 Fire W"],
    [9237, "Cannon League03 Fire Nw"],
    [9238, "Cannon League03 Aim"],
    [9239, "Cannon League03 Aim N"],
    [9240, "Cannon League03 Aim Ne"],
    [9241, "Cannon League03 Aim E"],
    [9242, "Cannon League03 Aim Se"],
    [9243, "Cannon League03 Aim S"],
    [9244, "Cannon League03 Aim Sw"],
    [9245, "Cannon League03 Aim W"],
    [9246, "Cannon League03 Aim Nw"],
    [9247, "League 3 Home Teleport Scroll"],
    [9248, "Leagues03 Cutscene01 Frame01"],
    [9249, "Leagues03 Cutscene01 Frame02"],
    [9250, "Leagues03 Cutscene01 Frame03"],
    [9251, "Leagues03 Cutscene01 Frame04"],
    [9252, "Leagues03 Cutscene01 Frame05"],
    [9253, "Leagues03 Cutscene01 Frame06"],
    [9254, "Leagues03 Cutscene01 Frame07"],
    [9255, "Cannon League03 Idle"],
    [9256, "League3 Area Teleport Spotanim"],
    [9257, "League3 Area Teleport Spotanim Reverse"],
    [9258, "Sage Idle 01"],
    [9259, "Sage Idle 02"],
    [9260, "Fx Beam Idle"],
    [9261, "Human Trophy League03 Run"],
    [9262, "Human Trophy League03 Attack"],
    [9263, "Human Banner League03 Idle"],
    [9264, "Human Banner League03 Walk F"],
    [9265, "Human Banner League03 Walk B"],
    [9266, "Human Banner League03 Walk L"],
    [9267, "Human Banner League03 Walk R"],
    [9268, "Human Banner League03 Turn"],
    [9269, "Human Banner League03 Run"],
    [9270, "Human Banner League03 Attack"],
    [9271, "Human Banner League03 Block"],
    [9272, "Human Trophy League03 Idle"],
    [9273, "Human Trophy League03 Walk"],
    [9274, "Human Relic Unlock Female"],
    [9275, "Npc Revenant Superior Walk"],
    [9276, "Npc Revenant Superior Idle"],
    [9277, "Npc Revenant Superior Attack Melee"],
    [9278, "Npc Revenant Superior Attack Stun"],
    [9279, "Npc Revenant Superior Attack Heal"],
    [9280, "Npc Revenant Superior Death"],
    [9281, "Npc Revenant Superior Spawn"],
    [9282, "Npc Revenant Superior Attack Dot"],
    [9283, "Lotg Player Shields Eyes Start"],
    [9284, "Lotg Player Shields Eyes End"],
    [9285, "Lotg Goblin To Player Player Anim"],
    [9286, "Lotg Player To Goblin Player Anim"],
    [9287, "Lotg Goblin To Player Goblin Anim"],
    [9288, "Lotg Player To Goblin Goblin Anim"],
    [9289, "Lotg Player Invokes High Priest"],
    [9290, "Lotg Goblin Invokes High Priest"],
    [9291, "Lotg Goblin Pickpocket"],
    [9292, "Lotg Goblin Praying At Altar"],
    [9293, "Lotg Goblin Searches Crates"],
    [9294, "Lotg Zanik Lifted Up In Light Vortex Part One"],
    [9295, "Lotg Zanik Lifted Up In Light Vortex Part Two"],
    [9296, "Lotg Zanik Light Vortex One"],
    [9297, "Lotg Zanik Light Vortex Two"],
    [9298, "Lotg Preacher Gesticulating"],
    [9299, "Lotg Bone Shard Attack"],
    [9300, "Lotg Skeletal Claw"],
    [9301, "Lotg Magic Spell Double Coil"],
    [9302, "Lotg Double Coil Spotanim"],
    [9303, "Magic Spell Double Coil Impact Spotanim"],
    [9304, "Lotg Magic Spell Raise Undead"],
    [9305, "Lotg Raise Undead Spotanim"],
    [9306, "Lotg Magic Spell Light Bow"],
    [9307, "Lotg Light Bow Spotanim"],
    [9308, "Lotg Light Bow Projectile"],
    [9309, "Lotg Player Pushing Sarcophagus"],
    [9310, "Lotg Zanik Pushing Sarcophagus"],
    [9311, "Lotg Clawing Out Of The Ground"],
    [9312, "Lotg High Priest Giving Up"],
    [9313, "Lotg High Priest Giving Up Ready"],
    [9314, "High Priest Finally Dying"],
    [9315, "Lotg Sneak Under Crypt Door"],
    [9316, "Lotg Hopespear Walk"],
    [9317, "Lotg Hopespear Ready"],
    [9318, "Lotg Oldak Activating Hacking Machine"],
    [9319, "Lotg Oldak Looking At Hacking Machine"],
    [9320, "Lotg Goblins Mixing Dyes"],
    [9321, "Lotg Unlocking The Crypt Door"],
    [9322, "Lotg Swamp Bubbles"],
    [9323, "Lotg Oozing Rock"],
    [9324, "Lotg Bone Shards Projectile"],
    [9325, "Lotg Sarcophagus Closed"],
    [9326, "Lotg Sarcophagus Opening"],
    [9327, "Lotg Sarcophagus Open"],
    [9328, "Lotg Claw Out Of Ground Dust Spotanim"],
    [9329, "Lotg Door Closed"],
    [9330, "Lotg Door Opening"],
    [9331, "Fairy Ring Inner Ring Blows Out"],
    [9332, "Fairy Ring Mid Ring Blows Out"],
    [9333, "Fairy Ring Outer Ring Blows Out"],
    [9334, "Fairy Ring Portal Opening"],
    [9335, "Fairy Ring Ready"],
    [9336, "Lotg Hacking Machine Flashing Lights"],
    [9337, "Lotg Vials Spotanim"],
    [9338, "Lotg Portal In Flux"],
    [9339, "Lotg Player Dust Walk"],
    [9340, "Slice Surface Goblin Squat Run"],
    [9341, "Human Ski Idle"],
    [9342, "Human Ski Walk"],
    [9343, "Human Ski Walk Left"],
    [9344, "Human Ski Walk Right"],
    [9345, "Human Ski Walk Backwards"],
    [9346, "Human Ski Run"],
    [9347, "Human Ski Attack"],
    [9348, "Human Ski Defend"],
    [9349, "Human Fishing Casting Brut"],
    [9350, "Human Fishing Onspot Brut"],
    [9351, "Human Poh Build Dwh Ornament"],
    [9352, "Godwars Hammer Gong Dwh Ornament"],
    [9353, "Picking Low Shorter"],
    [9354, "Death Office Portal Round"],
    [9355, "Death Office Portal Round Gotr"],
    [9356, "Death Office Portal Death"],
    [9357, "Death Office Portal Death Loop"],
    [9358, "Death Office Portal Spawn"],
    [9359, "Death Office Portal Flicker"],
    [9360, "Death Office Portal Flicker Gotr"],
    [9361, "Human Runecraft Walkmerge"],
    [9362, "Statue Runestone01 Inactive"],
    [9363, "Statue Runestone01 Active"],
    [9364, "Gotr Light Lantern"],
    [9365, "Gotr Chisel Essence"],
    [9366, "Barrier Saradomin01 Idle"],
    [9367, "Fx Beam Burst"],
    [9368, "Fx Beam Strike"],
    [9369, "Portal Guardian Walk"],
    [9370, "Portal Guardian Idle"],
    [9371, "Portal Guardian Surge"],
    [9372, "Portal Guardian Siphon"],
    [9373, "Portal Guardian Sleep"],
    [9374, "Portal Guardian Sleep Loop"],
    [9375, "Portal Guardian Wakeup"],
    [9376, "Portal Guardian Spawn"],
    [9377, "Rift Guardian Walk Large"],
    [9378, "Rift Guardian Walk Small"],
    [9379, "Rift Guardian Ready"],
    [9380, "Rift Guardian Spawn"],
    [9381, "Rift Guardian Death"],
    [9382, "Rift Guardian Attack Ranged"],
    [9383, "Rift Guardian Attack Melee"],
    [9384, "Rift Guardian Defend Melee"],
    [9385, "Rift Guardian Defend Ranged"],
    [9386, "Rift Guardian Inactive"],
    [9387, "Gotr Abyssal Leech Attack"],
    [9388, "Gotr Abyssal Leech Defend"],
    [9389, "Gotr Abyssal Leech Death"],
    [9390, "Gotr Abyssal Walker Attack"],
    [9391, "Gotr Abyssal Walker Defend"],
    [9392, "Gotr Abyssal Walker Death"],
    [9393, "Gotr Abyssal Pyramid Ranged Attack"],
    [9394, "Gotr Abyssal Pyramid Attack"],
    [9395, "Gotr Abyssal Pyramid Defend"],
    [9396, "Gotr Abyssal Pyramid Death"],
    [9397, "Rift Guardian Sit"],
    [9398, "Tote Flyback"],
    [9399, "Arceuus Chisel Essence Priority"],
    [9400, "Nightmare Projectile Rift Idle"],
    [9401, "Human Pickuptable Walkmerge"],
    [9402, "Human Leverdown Walkmerge"],
    [9403, "League 3 Horror Preach Saradomin"],
    [9404, "League 3 Horror Preach Zamorak"],
    [9405, "League 3 Horror Preach Guthix"],
    [9406, "Human Crate Squat"],
    [9407, "Easter22 Crate Spawn"],
    [9408, "Easter22 Crate Exclaim"],
    [9409, "Easter22 Crate Question"],
    [9410, "Easter22 Crate Idle"],
    [9411, "Easter22 Crate Shake"],
    [9412, "Easter22 Crate Survey"],
    [9413, "Human Crate Survey"],
    [9414, "League 3 Horror Preach Bandos"],
    [9415, "Human Prepare Offering Loop"],
    [9416, "Spell Shadow Barrage Impact Fast"],
    [9417, "Picking Mid Short"],
    [9418, "Poh Smash Magic Tablet Walkmerge"],
    [9419, "Npc Kephri Walk01"],
    [9420, "Npc Wardens Idle06"],
    [9421, "Npc Akkha Walk 03 Spear"],
    [9422, "M Zombie Attack Move"],
    [9423, "Human Walk Appear"],
    [9424, "Human Walk Appear Slow"],
    [9425, "Human Walk Appear Long"],
    [9426, "Bcs Charge Attack Loop"],
    [9427, "Bcs Scabarite Champion Attack Slash"],
    [9428, "Bcs Scabarite Champion Attack Spell"],
    [9429, "Bcs Rift Appear"],
    [9430, "Bcs Rift Idle"],
    [9431, "Bcs Rift Disappear"],
    [9433, "Human Unconscious Transition Barely Conscious"],
    [9434, "Human Unconscious Transition Barely Conscious Loop"],
    [9435, "Human Barely Conscious"],
    [9436, "Icthalarins Door Closed"],
    [9437, "Gas Short"],
    [9438, "Human Dead Loop"],
    [9439, "Ics Stumble Back"],
    [9440, "League 3 Horror Preach Armadyl"],
    [9441, "League 3 Horror Preach Zaros"],
    [9442, "Sg Grindstone Repair"],
    [9443, "Giants Foundry Work Preform"],
    [9444, "Giants Foundry Work Preform Loop"],
    [9445, "Giants Foundry Polishing Wheel Spin"],
    [9446, "Giants Foundry Hammer01"],
    [9447, "Giants Foundry Crucible Pour01"],
    [9448, "Giants Foundry Crucible Stop01"],
    [9449, "Giants Foundry Idle"],
    [9450, "Waterwheel Chute"],
    [9451, "Human Preform Lift"],
    [9452, "Human Preform Lift Start"],
    [9453, "Human Preform Lift Start02"],
    [9454, "Human Preform Lift Loop"],
    [9455, "Human Preform Lift Loop02"],
    [9456, "Human Preform Lift End"],
    [9457, "Giants Foundry Finish Sword"],
    [9458, "Human Push Priority"],
    [9459, "Human Weapon Giant01 Run"],
    [9460, "Human Weapon Giant01 Ready"],
    [9461, "Human Weapon Giant01 Walk"],
    [9462, "Gotr Chisel Guardian"],
    [9463, "Ballista02 Defend"],
    [9464, "Ballista02 Ready"],
    [9465, "Ballista02 Attack"],
    [9466, "Ballista02 Attack Pvn"],
    [9467, "Ballista02 Special Attack"],
    [9468, "Ballista02 Special Attack Pvn"],
    [9469, "Spell Shadow Barrage Impact Med"],
    [9470, "Gg Debris Shadow 60"],
    [9471, "Human Osmumtens Fang"],
    [9472, "Tumekans Light Cast"],
    [9473, "Human Mining Het Bronze Pickaxe"],
    [9474, "Human Mining Het Iron Pickaxe"],
    [9475, "Human Mining Het Black Pickaxe"],
    [9476, "Human Mining Het Steel Pickaxe"],
    [9477, "Human Mining Het Mithril Pickaxe"],
    [9478, "Human Mining Het Adamant Pickaxe"],
    [9479, "Human Mining Het Rune Pickaxe"],
    [9480, "Human Mining Het Gilded Pickaxe"],
    [9481, "Human Mining Het Dragon Pickaxe"],
    [9482, "Human Mining Het Dragon Pickaxe Pretty"],
    [9483, "Human Mining Het Zalcano Pickaxe"],
    [9484, "Human Mining Het Infernal Pickaxe"],
    [9485, "Human Mining Het 3a Pickaxe"],
    [9486, "Human Mining Het Crystal Pickaxe"],
    [9487, "Human Mining Het League Trailblazer Pickaxe"],
    [9488, "Human Mining Het Trailblazer Pickaxe No Infernal"],
    [9489, "Human Crafting Armadylean"],
    [9490, "Toa Flip Tile"],
    [9491, "Toa Sot Idle"],
    [9492, "Toa Sot Cast A"],
    [9493, "Toa Sot Cast B"],
    [9494, "Toa Sot Ready"],
    [9495, "Gateway Tomb01 Barrier01 Idle01"],
    [9496, "Toa Tile Glow Idle"],
    [9497, "Wallkit Tomb Monkey01 Blink01"],
    [9498, "Toa Dust Falling"],
    [9499, "Pottery Tomb Bobbing01"],
    [9500, "Wallkit Tomb Crocodile01 Idle01"],
    [9501, "Toa Teleporter Idle"],
    [9502, "Toa Pillar Shake"],
    [9503, "Toa Pillar Idle"],
    [9504, "Toa Osmumten Chest Closed"],
    [9505, "Toa Osmumten Chest Reveal"],
    [9506, "Toa Osmumten Chest Open"],
    [9507, "Fx Cycle"],
    [9508, "Fx Cycle Ring"],
    [9509, "Fx Cycle Masori Head"],
    [9510, "Fx Cycle Masori Top"],
    [9511, "Fx Cycle Masori Legs"],
    [9512, "Fx Cycle Sword"],
    [9513, "Fx Cycle Ward"],
    [9514, "Fx Cycle Staff"],
    [9515, "Toa Obelisk01 Glow"],
    [9516, "Toa Wall Raising"],
    [9517, "Toa Wall Static"],
    [9518, "Toa Boulder Rolling"],
    [9519, "Toa Dung Drop"],
    [9520, "Toa Life Leach"],
    [9521, "Fx Cycle Glow"],
    [9522, "Fx Cycle Glow Loop"],
    [9523, "Fx Cycle Shrink"],
    [9524, "Toa Wardens01 Pyramid Attack"],
    [9525, "Toa Wardens01 Pyarmid Appear"],
    [9526, "Toa Wardens01 Pyarmid Leave"],
    [9527, "Toa Wardens01 Pyramid Load"],
    [9528, "Toa Wardens01 Pyramid Invisible"],
    [9529, "Npc Scabaras Idle01"],
    [9530, "Npc Scabaras Walk01"],
    [9531, "Npc Scabaras Trapped01"],
    [9532, "Npc Crondis Idle01"],
    [9533, "Npc Crondis Walk01"],
    [9534, "Npc Crondis Trapped01"],
    [9535, "Npc Apmeken Idle01"],
    [9536, "Npc Apmeken Walk01"],
    [9537, "Npc Apmeken Trapped01"],
    [9538, "Npc Het Idle01"],
    [9539, "Npc Het Walk01"],
    [9540, "Npc Het Trapped01"],
    [9541, "Vfx Pantheon Trapped01"],
    [9542, "Toa Het Orb Walk01"],
    [9543, "Toa Spell Tumeken01 Cast01"],
    [9544, "Toa Keris Partisan Special01"],
    [9545, "Toa Keris Partisan Special01 Fx"],
    [9546, "Toa Tumekans Light Cast01"],
    [9547, "Crondis Column Trap Anim"],
    [9548, "Crondis Poison Tile Idle"],
    [9549, "Crondis Poison Tile Activate 01"],
    [9550, "Crondis Poison Tile Activate 02"],
    [9551, "Crondis Poison Tile Activate 03"],
    [9552, "Crondis Poison Tile Activate 04"],
    [9553, "Crondis Poison Tile Activate 05"],
    [9554, "Crondis Poison Tile Activate 06"],
    [9555, "Crondis Poison Tile Activate 07"],
    [9556, "Crondis Poison Tile Activate 08"],
    [9557, "Crondis Poison Tile Activate 09"],
    [9558, "Crondis Poison Tile Activate 10"],
    [9559, "Crondis Poison Spotanim"],
    [9560, "Crondis Poison Spotanim 2"],
    [9561, "Crondis Poison Spotanim 3"],
    [9562, "Crondis Spear Trap Idle"],
    [9563, "Crondis Spear Trap Activate"],
    [9564, "Crondis Spear Trap Spear"],
    [9565, "Crondis Spear Trap Spear02"],
    [9566, "Fx Apmeken Sight"],
    [9567, "Fx Apmeken Sight Long"],
    [9568, "Fx Apmeken Floor"],
    [9569, "Fx Apmeken Floor Long"],
    [9570, "Fx Apmeken Blind"],
    [9571, "Fx Apmeken Gain"],
    [9572, "Npc Kephri Idle"],
    [9573, "Npc Kephri Turn Left"],
    [9574, "Npc Kephri Turn Right"],
    [9575, "Npc Kephri Attack Ranged"],
    [9576, "Npc Kephri Attack Ranged Radial"],
    [9577, "Npc Kephri Attack Magic Radial"],
    [9578, "Npc Kephri Attack Special Eggs"],
    [9579, "Npc Kephri Stunned"],
    [9580, "Npc Kephri Stunned Idle"],
    [9581, "Npc Kephri Stunned Wakeup"],
    [9582, "Npc Kephri Death"],
    [9583, "Npc Kephri Dead"],
    [9584, "Npc Scarab Walk"],
    [9585, "Npc Scarab Walk Backwards"],
    [9586, "Npc Scarab Idle"],
    [9587, "Npc Scarab Attack"],
    [9588, "Npc Scarab Ranged Attack"],
    [9589, "Npc Scarab Spawn"],
    [9590, "Npc Scarab Death"],
    [9591, "Npc Scarab Flying Takeoff"],
    [9592, "Npc Scarab Flying Idle"],
    [9593, "Npc Scarab Flying Idle02"],
    [9594, "Npc Scarab Flying Attack"],
    [9595, "Npc Scarab Flying Landing"],
    [9596, "Npc Scarab Flying Spawn"],
    [9597, "Npc Scarab Flying Death"],
    [9598, "Npc Scarab Flying Death02"],
    [9599, "Npc Scarab Flying Death03"],
    [9600, "Npc Scarab Flying Explode01"],
    [9601, "Vfx Scarab Shield01 Alive"],
    [9602, "Vfx Scarab Shield01 Dead"],
    [9603, "Vfx Scarab Shield01 Death"],
    [9604, "Vfx Scarab Shield01 Reform"],
    [9605, "Npc Swarm01 Scarab01 Spawn01"],
    [9606, "Npc Swarm01 Scarab01 Idle01"],
    [9607, "Npc Swarm01 Scarab01 Integrate01"],
    [9608, "Npc Swarm01 Scarab01 Death01"],
    [9609, "Spotanim Dungball Explosion01"],
    [9610, "Vfx Scarab Explosion01"],
    [9611, "Vfx Scarab Explosion02"],
    [9612, "Vfx Scarab Explosion03"],
    [9613, "Vfx Scarab Explosion04"],
    [9614, "Vfx Scarab Explosion05"],
    [9615, "Vfx Scarab Explosion06"],
    [9616, "Vfx Scarab Explosion07"],
    [9617, "Vfx Scarab Explosion08"],
    [9618, "Npc Zebak01 Idle"],
    [9619, "Npc Zebak02 Idle"],
    [9620, "Npc Zebak01 Attack Melee"],
    [9621, "Npc Zebak02 Attack Melee"],
    [9622, "Npc Zebak01 Attack Melee Enraged"],
    [9623, "Npc Zebak02 Attack Melee Enraged"],
    [9624, "Npc Zebak01 Attack Ranged"],
    [9625, "Npc Zebak02 Attack Ranged"],
    [9626, "Npc Zebak01 Attack Ranged Enraged"],
    [9627, "Npc Zebak02 Attack Ranged Enraged"],
    [9628, "Npc Zebak01 Attack Roar"],
    [9629, "Npc Zebak02 Attack Roar"],
    [9630, "Npc Zebak01 Attack Tail"],
    [9631, "Npc Zebak02 Attack Tail"],
    [9632, "Npc Zebak01 Attack Special"],
    [9633, "Npc Zebak02 Attack Special"],
    [9634, "Npc Zebak01 Death"],
    [9635, "Npc Zebak02 Death"],
    [9636, "Npc Zebak01 Dead"],
    [9637, "Npc Zebak02 Dead"],
    [9638, "Spotanim Zebak Magic01"],
    [9639, "Projectile Zebak Ranged01"],
    [9640, "Projectile Zebak Ranged01 Enraged"],
    [9641, "Spotanim Zebak Ranged01"],
    [9642, "Projectile Zebak Pitcher01"],
    [9643, "Projectile Zebak Pitcher01 Enraged"],
    [9644, "Spotanim Zebak Pitcher01"],
    [9645, "Projectile Zebak Shield01"],
    [9646, "Spotanim Zebak Shield01"],
    [9647, "Spotanim Zebak Attack Roar"],
    [9648, "Toa Wardens Buff Spotanim"],
    [9649, "Npc Wardens Walk01"],
    [9650, "Npc Wardens Walk02"],
    [9651, "Npc Wardens Walk03"],
    [9652, "Npc Wardens Walk04"],
    [9653, "Npc Wardens Idle01"],
    [9654, "Npc Wardens Idle02"],
    [9655, "Npc Wardens Idle03"],
    [9656, "Npc Wardens Idle04"],
    [9657, "Npc Wardens Idle05"],
    [9658, "Npc Wardens Stomp01"],
    [9659, "Npc Wardens Melee01"],
    [9660, "Npc Wardens Ranged01"],
    [9661, "Npc Wardens Magic01"],
    [9662, "Npc Wardens Death01"],
    [9663, "Npc Wardens Wake01"],
    [9664, "Npc Wardens Wake02"],
    [9665, "Npc Wardens Dormant01"],
    [9666, "Npc Wardens Special01"],
    [9667, "Npc Wardens Impact01"],
    [9668, "Npc Wardens Launch01"],
    [9669, "Npc Wardens Explosion01"],
    [9670, "Npc Wardens Kneel01"],
    [9671, "Npc Wardens Kneeling01"],
    [9672, "Npc Wardens Standup01"],
    [9673, "Npc Wardens Headless01"],
    [9674, "Npc Wardens Attackleft01"],
    [9675, "Npc Wardens Attackleft02"],
    [9676, "Npc Wardens Attackright01"],
    [9677, "Npc Wardens Attackright02"],
    [9678, "Npc Wardens Attackcenter01"],
    [9679, "Npc Wardens Attackcenter02"],
    [9680, "Npc Wardens Stagger01"],
    [9681, "Npc Wardens Release01"],
    [9682, "Npc Wardens Charge01"],
    [9683, "Npc Wardens Charging01"],
    [9684, "Npc Wardens Enraging01"],
    [9685, "Npc Wardens Enraged01"],
    [9686, "Spotanim Wardens01 Magic01 Activate01"],
    [9687, "Spotanim Wardens01 Explosion01 Explode01"],
    [9688, "Spotanim Wardens01 Explosion01 Idle01"],
    [9689, "Spotanim Wardens01 Wakeup02"],
    [9690, "Spotanim Wardens01 Idle05 Idle01"],
    [9691, "Spotanim Wardens01 Death02 Offset01"],
    [9692, "Spotanim Wardens01 Death02 Offset02"],
    [9693, "Spotanim Wardens01 Death02 Offset03"],
    [9694, "Spotanim Wardens01 Death02 Offset04"],
    [9695, "Spotanim Wardens01 Death02 Offset05"],
    [9696, "Spotanim Wardens01 Death02 Idle01"],
    [9697, "Spotanim Wardens01 Undertile01 Explode01"],
    [9698, "Spotanim Wardens01 Undertile01 Explode02"],
    [9699, "Spotanim Wardens01 Undertile01 Explode03"],
    [9700, "Spotanim Wardens01 Undertile01 Explode04"],
    [9701, "Projanim Wardens01 Melee01 Spin01"],
    [9702, "Projanim Wardens01 Ranged01 Spin01"],
    [9703, "Projanim Wardens01 Entomb01 Spin01"],
    [9704, "Spotanim Wardens01 Core01 Beat01"],
    [9705, "Spotanim Amascut01 Sucking01 Idle01"],
    [9706, "Spotanim Amascut01 Sucking01 Flash01"],
    [9707, "Spotanim Amascut01 Sucking01 Enraged01"],
    [9708, "Spotanim Amascut01 Sucking01 Glow01"],
    [9709, "Spotanim Amascut01 Sucking01 Glow02"],
    [9710, "Spotanim Amascut01 Strike01 Fire01"],
    [9711, "Spotanim Wardens01 Dronestrike01 Fire01"],
    [9712, "Toa Wardens Debris Floating"],
    [9713, "Toa Wardens Entomb"],
    [9714, "Toa Wardens Entomb Loop"],
    [9715, "Toa Wardens Entomb End"],
    [9716, "Npc Amascut Giant01 Idle01"],
    [9717, "Npc Amascut Giant01 Suck01"],
    [9718, "Npc Amascut Giant01 Enrage01"],
    [9719, "Npc Amascut Giant01 Exit01"],
    [9720, "Fx Obelisk Wardens Phase01 Idle01"],
    [9721, "Fx Obelisk Wardens01 Cast"],
    [9722, "Wardens P3 Tile"],
    [9723, "Fx Obelisk Wardens01 Charge"],
    [9724, "Fx Obelisk Wardens01 Charge Part1"],
    [9725, "Fx Obelisk Wardens01 Charge Part2"],
    [9726, "Fx Obelisk Wardens01 Charge Part3"],
    [9727, "Fx Obelisk Wardens02 Bomb"],
    [9728, "Fx Obelisk Wardens02 Open"],
    [9729, "Fx Obelisk Wardens02 Close"],
    [9730, "Fx Obelisk Wardens02 Wave"],
    [9731, "Fx Obelisk Wardens02 Cast"],
    [9732, "Fx Obelisk Wardens02 Beam"],
    [9733, "Fx Obelisk Wardens02 Sweep"],
    [9734, "Fx Obelisk Wardens02 Death"],
    [9735, "Fx Wardens Energy Death01"],
    [9736, "Fx Wardens Energy Grounded01"],
    [9737, "Npc Mandrill Walk01"],
    [9738, "Npc Mandrill Walk01 Backwards"],
    [9739, "Npc Mandrill Walk02"],
    [9740, "Npc Mandrill Walk02 Backwards"],
    [9741, "Npc Mandrill Idle"],
    [9742, "Npc Mandrill Attack Melee"],
    [9743, "Npc Baba Attack Melee"],
    [9744, "Npc Mandrill Attack Ranged 01"],
    [9745, "Npc Mandrill Attack Ranged 02"],
    [9746, "Npc Mandrill Attack Magic"],
    [9747, "Npc Mandrill Attack Magic 02"],
    [9748, "Npc Mandrill Attack Special Jump01"],
    [9749, "Npc Mandrill Attack Special Ranged01"],
    [9750, "Npc Mandrill Attack Special Idle01"],
    [9751, "Npc Mandrill Attack Special End01"],
    [9752, "Npc Mandrill Spawn01"],
    [9753, "Npc Mandrill Spawn02"],
    [9754, "Npc Mandrill Despawn01"],
    [9755, "Npc Mandrill Despawn02"],
    [9756, "Npc Mandrill Explode"],
    [9757, "Spotanim Mandrill Explode"],
    [9758, "Toa Baba Banana Fall"],
    [9759, "Fx Symbol Floor Glow01"],
    [9760, "Npc Akkha Idle Spear"],
    [9761, "Npc Akkha Idle Sword"],
    [9762, "Npc Akkha Walk 01 Spear"],
    [9763, "Npc Akkha Walk 01 Sword"],
    [9764, "Npc Akkha Walk 02 Spear"],
    [9765, "Npc Akkha Walk 02 Sword"],
    [9766, "Npc Akkha Walk Backwards 01 Spear"],
    [9767, "Npc Akkha Walk Backwards 01 Sword"],
    [9768, "Npc Akkha Walk Backwards 02 Spear"],
    [9769, "Npc Akkha Walk Backwards 02 Sword"],
    [9770, "Npc Akkha Attack Melee Spear"],
    [9771, "Npc Akkha Attack Melee Sword"],
    [9772, "Npc Akkha Attack Ranged Spear"],
    [9773, "Npc Akkha Attack Ranged Sword"],
    [9774, "Npc Akkha Attack Magic Spear"],
    [9775, "Npc Akkha Attack Magic Sword"],
    [9776, "Npc Akkha Attack Magic 01 Spear"],
    [9777, "Npc Akkha Attack Magic 02 Spear"],
    [9778, "Npc Akkha Attack Magic 03 Spear"],
    [9779, "Npc Akkha Attack Magic 04 Spear"],
    [9780, "Npc Akkha Attack Magic 01 Sword"],
    [9781, "Npc Akkha Attack Magic 02 Sword"],
    [9782, "Npc Akkha Attack Magic 03 Sword"],
    [9783, "Npc Akkha Attack Magic 04 Sword"],
    [9784, "Npc Akkha Teleport Disappear Spear"],
    [9785, "Npc Akkha Teleport Appear Spear"],
    [9786, "Npc Akkha Teleport Disappear Sword"],
    [9787, "Npc Akkha Teleport Appear Sword"],
    [9788, "Npc Akkha Attack Stomp Spear"],
    [9789, "Npc Akkha Attack Stomp Sword"],
    [9790, "Npc Akkha Spawn Spear"],
    [9791, "Npc Akkha Spawn Sword"],
    [9792, "Npc Akkha Death Spear"],
    [9793, "Npc Akkha Death Sword"],
    [9794, "Fx Orb Dust Idle"],
    [9795, "Ghost Summon2 Priority"],
    [9796, "Boulder Rolling No Delay"],
    [9797, "Deserttreasure Scarab Cracks Floor Quick"],
    [9798, "Tol Homonculus Magic Spotanim Loop"],
    [9799, "Human Troll Flyback Merge"],
    [9800, "Contact Boss Spawn Quick"],
    [9801, "Contact Boss Death And Rev"],
    [9802, "Contact Boss Death No Delay"],
    [9803, "Npc Xamphur Demonbane Quick"],
    [9804, "Croc Attack Merge"],
    [9805, "Ga Beast Rock Fall Faster"],
    [9806, "Ga Beast Rock Fall Fastest"],
    [9807, "Nightmare Parasite Attack Ranged Merge"],
    [9808, "Fx Fire01 Idle"],
    [9809, "Npc Akkha Walk 03 Sword"],
    [9810, "Npc Akkha Walk Backwards 03 Spear"],
    [9811, "Npc Akkha Walk Backwards 03 Sword"],
    [9812, "Speedrun Scroll Read"],
    [9813, "Weapon Speedrunning01 Clock01 Walk01"],
    [9814, "Weapon Speedrunning01 Clock01 Ready01"],
    [9815, "Weapon Speedrunning01 Clock01 Run01"],
    [9816, "Weapon Speedrunning01 Clock01 Attack01"],
    [9817, "Weapon Speedrunning01 Clock01 Block01"],
    [9818, "Weapon Speedrunning01 Stopwatch01 Fx01"],
    [9819, "Speedrun Home Teleport"],
    [9820, "Speedrun Home Teleport 1"],
    [9821, "Speedrun Home Teleport 2"],
    [9822, "Speedrun Home Teleport 3"],
    [9823, "Speedrun Home Teleport 4"],
    [9824, "Speedrun Home Teleport 5"],
    [9825, "Speedrun Home Teleport 6"],
    [9826, "Spotanim Speedrun Home Teleport"],
    [9827, "Spotanim Speedrun Home Teleport 5"],
    [9828, "Spotanim Speedrun Home Teleport 6"],
    [9829, "Speedrun Home Teleport Return"],
    [9830, "Spotanim Speedrun Home Teleport Return"],
    [9831, "Emote Trick Or Treat 0"],
    [9832, "Emote Trick Or Treat 1"],
    [9833, "Emote Trick Or Treat 2"],
    [9834, "Emote Trick Or Treat 3"],
    [9835, "Emote Trick Or Treat 4"],
    [9836, "Straydog Ready02"],
    [9837, "Combat Achievements Teleport Player Tier 5 Avernic"],
    [9838, "Combat Achievements Teleport Woman Tier 5 Avernic"],
    [9839, "Combat Achievements Teleport Reappear Player Tier 5 Avernic"],
    [9840, "Combat Achievements Teleport Player Tier 6 Avernic"],
    [9841, "Combat Achievements Teleport Woman Tier 6 Avernic"],
    [9842, "Combat Achievements Teleport Reappear Player Tier 6 Avernic"],
    [9843, "Death Office Nutcracker Idle"],
    [9844, "Fairy Flower Idle"],
    [9845, "Light Beam Butterfly"],
    [9846, "Card Launch"],
    [9847, "Human Card Ready"],
    [9848, "Human Card Attack01"],
    [9849, "Human Card Walk01"],
    [9850, "Human Card Run01"],
    [9851, "Human Card Walk01 L"],
    [9852, "Human Card Walk01 R"],
    [9853, "Human Card Defend"],
    [9854, "Poh Smash Magic Tablet Priority"],
    [9855, "Arrow Venator01 Launch"],
    [9856, "Arrow Venator01 Travel"],
    [9857, "Human Weapon Bow Venator01 Ready"],
    [9858, "Human Weapon Bow Venator01 Shoot"],
    [9859, "Human Weapon Bow Venator01 Walk"],
    [9860, "Human Weapon Bow Venator01 Run"],
    [9861, "Human Weapon Bow Venator01 Stepleft"],
    [9862, "Human Weapon Bow Venator01 Stepright"],
    [9863, "Human Weapon Bow Venator01 Turn"],
    [9864, "Willowthewisp Fast"],
    [9865, "Mahjarrat Idle01"],
    [9866, "Mahjarrat Walk Forward01"],
    [9867, "Mahjarrat Walk Backwards01"],
    [9868, "Mahjarrat Attack Melee01"],
    [9869, "Mahjarrat Attack Magic01"],
    [9870, "Mahjarrat Attack Summon01"],
    [9871, "Mahjarrat Teleport Appear01"],
    [9872, "Mahjarrat Teleport Disappear01"],
    [9873, "Vfx Mahjarrat Teleport 01"],
    [9874, "Mahjarrat Idle02"],
    [9875, "Mahjarrat Walk Forward02"],
    [9876, "Mahjarrat Walk Backwards02"],
    [9877, "Mahjarrat Attack Melee02"],
    [9878, "Mahjarrat Attack Magic02"],
    [9879, "Mahjarrat Attack Summon02"],
    [9880, "Mahjarrat Teleport Appear02"],
    [9881, "Mahjarrat Teleport Disappear02"],
    [9882, "Vfx Mahjarrat Teleport 02"],
    [9883, "Mahjarrat Idle03"],
    [9884, "Mahjarrat Walk Forward03"],
    [9885, "Mahjarrat Walk Backwards03"],
    [9886, "Mahjarrat Attack Melee03"],
    [9887, "Mahjarrat Attack Magic03"],
    [9888, "Mahjarrat Attack Summon03"],
    [9889, "Mahjarrat Teleport Appear03"],
    [9890, "Mahjarrat Teleport Disappear03"],
    [9891, "Vfx Mahjarrat Teleport 03"],
    [9892, "Mahjarrat Idle04"],
    [9893, "Mahjarrat Walk Forward04"],
    [9894, "Mahjarrat Walk Backwards04"],
    [9895, "Mahjarrat Attack Magic04"],
    [9896, "Mahjarrat Attack Summon04"],
    [9897, "Mahjarrat Attack Melee Slash01"],
    [9898, "Mahjarrat Attack Melee Crush01"],
    [9899, "Mahjarrat Teleport Appear04"],
    [9900, "Mahjarrat Teleport Disappear04"],
    [9901, "Vfx Mahjarrat Teleport 04"],
    [9902, "Vfx Mahjarrat Attack Summon"],
    [9903, "Vfx Mahjarrat Attack Magic"],
    [9904, "Vfx Mahjarrat Attack Magic Impact"],
    [9905, "Vfx Mahjarrat Magic Sword"],
    [9906, "Mahjarrat Shapeshift Muspah 01"],
    [9907, "Vfx Mahjarrat Shapeshift Muspah 01"],
    [9908, "Mahjarrat Human Disappear 01"],
    [9909, "Mahjarrat Human Appear"],
    [9910, "Vfx Mahjarrat Teleport Human 01"],
    [9911, "Mahjarrat Human Disappear 02"],
    [9912, "Vfx Mahjarrat Shapeshift Human 01"],
    [9913, "Npc Muspah Idle 01"],
    [9914, "Npc Muspah Walk Forward 01"],
    [9915, "Npc Muspah Pet Walk Forward 01"],
    [9916, "Npc Muspah Walk Backward 01"],
    [9917, "Npc Muspah Pet Walk Backward 01"],
    [9918, "Npc Muspah Attack Magic 01"],
    [9919, "Vfx Muspah Attack Magic 01"],
    [9920, "Npc Muspah Attack Melee 01"],
    [9921, "Vfx Muspah Attack Melee 01"],
    [9922, "Npc Muspah Attack Ranged 01"],
    [9923, "Npc Muspah Attack Summon 01"],
    [9924, "Vfx Muspah Attack Summon 01"],
    [9925, "Npc Muspah Attack Explosion 01"],
    [9926, "Vfx Muspah Attack Explosion 01"],
    [9927, "Vfx Muspah Attack Explosion 02"],
    [9928, "Npc Muspah Teleport Disappear 01"],
    [9929, "Vfx Muspah Teleport Disappear 01"],
    [9930, "Npc Muspah Teleport Attack 01"],
    [9931, "Vfx Muspah Teleport Attack 01"],
    [9932, "Npc Muspah Teleport Appear 01"],
    [9933, "Vfx Muspah Teleport Appear 01"],
    [9934, "Npc Muspah Transform Disappear 01"],
    [9935, "Npc Muspah Transform Appear 01"],
    [9936, "Npc Muspah Transform Disappear 02"],
    [9937, "Npc Muspah Transform Appear 02"],
    [9938, "Npc Muspah Spawn 01"],
    [9939, "Npc Muspah Death 01"],
    [9940, "Vfx Muspah Death 01"],
    [9941, "Npc Muspah Death 02"],
    [9942, "Projectile Muspah Attack Magic 01"],
    [9943, "Impact Muspah Attack Magic 01"],
    [9944, "Projectile Muspah Attack Ranged 01"],
    [9945, "Projectile Muspah Attack Explode 02"],
    [9946, "Projectile Muspah Teleport Attack 01"],
    [9947, "Npc Muspah Smoke Idle 01"],
    [9948, "Npc Muspah Smoke Death 01"],
    [9949, "Npc Muspah Spike Spawn 01"],
    [9950, "Npc Muspah Spike Despawn 01"],
    [9951, "Npc Muspah Spike Idle 01"],
    [9952, "Npc Muspah Spike Spawn 02"],
    [9953, "Vfx Muspah Spike Marker 01"],
    [9954, "Vfx Muspah Spike Marker 02"],
    [9955, "Vfx Muspah Spike Spawn 01"],
    [9956, "Vfx Muspah Spike Despawn 01"],
    [9957, "Vfx Muspah Spike Spawn 02"],
    [9958, "Godwars Saradomin Magic Attack Spotanim Short"],
    [9959, "Human Opendoor Weapon"],
    [9960, "Human Smokepuff Tele Disappear Quick"],
    [9961, "Human Special Accursed"],
    [9962, "Human Special Ursine"],
    [9963, "Human Special02 Ursine"],
    [9964, "Human Special01 Webweaver"],
    [9965, "Npc Vetion Idle 01"],
    [9966, "Npc Vetion Idle 02"],
    [9967, "Npc Vetion Walk 01"],
    [9968, "Npc Vetion Walk 02"],
    [9969, "Npc Vetion Attack Magic 01"],
    [9970, "Npc Vetion Attack Magic 02"],
    [9971, "Npc Vetion Attack Melee 01"],
    [9972, "Npc Vetion Attack Melee 02"],
    [9973, "Npc Vetion Defend Parry 01"],
    [9974, "Npc Vetion Defend Parry 02"],
    [9975, "Npc Vetion Defend Shield 01"],
    [9976, "Npc Vetion Defend Shield 02"],
    [9977, "Npc Vetion Spawn 01"],
    [9978, "Npc Vetion Enrage 01"],
    [9979, "Npc Vetion Enrage 02"],
    [9980, "Npc Vetion Death 01"],
    [9981, "Npc Vetion Death 02"],
    [9982, "Vfx Spellcast Vetion 01"],
    [9983, "Vfx Spellimpact Vetion 01"],
    [9984, "Vfx Melee Impact Vetion 01"],
    [9985, "Wbr Vetion Entrance Frame"],
    [9986, "Npc Venenatis Idle 01"],
    [9987, "Npc Venenatis Walk 01"],
    [9988, "Npc Venenatis Run 01"],
    [9989, "Npc Venenatis Ranged 01"],
    [9990, "Npc Venenatis Magic 01"],
    [9991, "Npc Venenatis Melee 01"],
    [9992, "Npc Venenatis Death 01"],
    [9993, "Npc Venenatis Spawn 01"],
    [9994, "Vfx Venenatis Web Projectile"],
    [9995, "Vfx Venenatis Web Impact"],
    [9996, "Vfx Venenatis Magic Projectile"],
    [9997, "Vfx Venenatis Magic Impact"],
    [9998, "Trap Bear01 Spawn"],
    [9999, "Trap Bear01 Activate"],
    [10000, "Trap Bear01 Idle"],
    [10001, "Spells Vetion01 Travel"],
    [10002, "Spells Vetion01 Special"],
    [10003, "Fx Ursine01 Special"],
    [10004, "Fx Ursine02 Special"],
    [10005, "Fx Webweaver01 Impact"],
    [10006, "Fx Webweaver01 Launch"],
    [10007, "Wbr Wakeup"],
    [10008, "Wbr Wakeup2"],
    [10009, "Npc Callisto Walk01"],
    [10010, "Npc Callisto Pet Walk01"],
    [10011, "Npc Callisto Idle01"],
    [10012, "Npc Callisto Attack Melee01"],
    [10013, "Npc Callisto Attack Ranged01"],
    [10014, "Npc Callisto Attack Magic01"],
    [10015, "Npc Callisto Enraged01"],
    [10016, "Npc Callisto Spawn01"],
    [10017, "Npc Callisto Death01"],
    [10018, "Callisto Walk"],
    [10019, "Callisto Idle"],
    [10020, "Callisto Attack Melee"],
    [10021, "Callisto Attack Enraged"],
    [10022, "Callisto Defend"],
    [10023, "Callisto Death"],
    [10024, "Vfx Callisto Ranged Projectile"],
    [10025, "Vfx Callisto Ranged Impact"],
    [10026, "Vfx Callisto Ranged Spotanim"],
    [10027, "Vfx Callisto Enrage"],
    [10028, "Coffin Vetion Candles01"],
    [10029, "Slice Player Hide Start"],
    [10030, "Slice Player Hide Loop"],
    [10031, "Emote Party"],
    [10032, "Bday23 Balloon Idle"],
    [10033, "Bday23 Balloon Walk"],
    [10034, "Bday23 Balloon Run"],
    [10035, "Bday23 Balloon Attack"],
    [10036, "Bday23 Candle Special"],
    [10037, "Fx Dagger01 Candle01 Special"],
    [10038, "Fx Emote Party01 Active"],
    [10039, "Small Spider Attack Sound"],
    [10040, "Small Spider Defend Sound"],
    [10041, "Cat Leap"],
    [10042, "Cat Leap And Die"],
    [10043, "Human Climbing Down Loop"],
    [10044, "Human Onfloor"],
    [10045, "Human Dig Easter23 Spade"],
    [10046, "Human Poh Build Dwh Bh Corrupted"],
    [10047, "Godwars Hammer Gong Dwh Bh Corrupted"],
    [10048, "Emote Dance Loop"],
    [10049, "Emote Dance Scottish Loop"],
    [10050, "Emote Dance Headbang Loop"],
    [10051, "Human Emote Crabdance"],
    [10052, "Human Emote Crabdance Loop"],
    [10053, "Emote Sit"],
    [10054, "Human Weapon Giant01 Walkr"],
    [10055, "Human Weapon Giant01 Walkl"],
    [10056, "Agility Shortcut Crack Enter Loop"],
    [10057, "Chathap Idle"],
    [10058, "Booth Appear Default"],
    [10059, "Booth Appear Idle"],
    [10060, "Human Cute Ready"],
    [10061, "Emote Sit Loop"],
    [10062, "Emote Mime Lean Loop"],
    [10063, "Forestry Sapling Spawn"],
    [10064, "Forestry 2h Axe Chopping Bronze"],
    [10065, "Forestry 2h Axe Chopping Iron"],
    [10066, "Forestry 2h Axe Chopping Steel"],
    [10067, "Forestry 2h Axe Chopping Black"],
    [10068, "Forestry 2h Axe Chopping Mithril"],
    [10069, "Forestry 2h Axe Chopping Adamant"],
    [10070, "Forestry 2h Axe Chopping Rune"],
    [10071, "Forestry 2h Axe Chopping Dragon"],
    [10072, "Forestry 2h Axe Chopping Crystal"],
    [10073, "Forestry 2h Axe Chopping Crystal Inactive"],
    [10074, "Forestry 2h Axe Chopping 3a"],
    [10075, "Forestry 2h Axe Ready"],
    [10076, "Forestry 2h Axe Walk"],
    [10077, "Forestry 2h Axe Run"],
    [10078, "Forestry 2h Axe Special"],
    [10079, "Forestry 2h Axe Attack"],
    [10080, "Forestry 2h Axe Defend"],
    [10081, "Forestry Tea Brewing"],
    [10082, "Forestry Campfire"],
    [10083, "Forestry Sitting Tea"],
    [10084, "Forestry Sitting Tea Loop"],
    [10085, "Forestry Rising Roots Spawn"],
    [10086, "Forestry Rising Roots Despawn"],
    [10087, "Stunned 5cycle"],
    [10088, "Stunned 6cycle"],
    [10089, "Ice Barrage Impact Long"],
    [10090, "Ice Barrage Impact Short"],
    [10091, "Zaros Casting Walkmerge"],
    [10092, "Zaros Vertical Casting Walkmerge"],
    [10093, "Human Casting Tele Block Staff Walkmerge"],
    [10094, "Picking Low Short"],
    [10095, "Human Picklock Cagedoor Alt"],
    [10096, "Human Xbow Enchant Arrowtip Walkmerge"],
    [10097, "Human Grind"],
    [10098, "Spotanim Leviathan Smoke 01"],
    [10099, "Spotanim Leviathan Smoke 02"],
    [10100, "Spotanim Leviathan Smoke 03"],
    [10101, "Spotanim Leviathan Smoke 04"],
    [10102, "Spotanim Leviathan Smoke 05"],
    [10103, "Spotanim Leviathan Smoke 06"],
    [10104, "Spotanim Leviathan Smoke 07"],
    [10105, "Spotanim Leviathan Smoke 08"],
    [10106, "Zuk Proj Short"],
    [10107, "Imp Run"],
    [10108, "Dwarf Summon"],
    [10109, "Dog Hellhound Godwars Death Reverse"],
    [10110, "Small Spider Run"],
    [10111, "Zombie Crawl Normal"],
    [10112, "Zombie Run Normal"],
    [10113, "Zombie Crawl Weapon"],
    [10114, "Zombie Run Weapon"],
    [10115, "Zombie Crawl Dragging"],
    [10116, "Zombie Run Dragging"],
    [10117, "Zombie Crawl Champion"],
    [10118, "Zombie Run Champion"],
    [10119, "Ghost Tendrill Attack Merge"],
    [10120, "Mahjarrat Idle 05"],
    [10121, "Mahjarrat Walk Forward 05"],
    [10122, "Mahjarrat Walk Backwards 05"],
    [10123, "Mahjarrat Attack Magic 05"],
    [10124, "Mahjarrat Attack Melee Stab 01"],
    [10125, "Mahjarrat Attack Summon05"],
    [10126, "Mahjarrat Teleport Appear05"],
    [10127, "Mahjarrat Teleport Disappear05"],
    [10128, "Vfx Mahjarrat Teleport 05"],
    [10129, "Vfx Mahjarrat Teleport 06"],
    [10130, "Vfx Mahjarrat Attack Summon 02"],
    [10131, "Vfx Mahjarrat Attack Magic 02"],
    [10132, "Mahjarrat Human Disappear 01 Quick"],
    [10133, "Mahjarrat Human Disappear 01 Noheld"],
    [10134, "Mahjarrat Human Disappear 01 Noheld Quick"],
    [10135, "Mahjarrat Human Appear Quick"],
    [10136, "Mahjarrat Human Disappear 03"],
    [10137, "Vfx Mahjarrat Shapeshift Human Quick"],
    [10138, "Vfx Mahjarrat Ketla Smoke"],
    [10139, "Vfx Mahjarrat Ketla Smoke Quick"],
    [10140, "Mahjarrat Idle06"],
    [10141, "Mahjarrat Walk Forward06"],
    [10142, "Mahjarrat Walk Backwards06"],
    [10143, "Mahjarrat Attack Stab02"],
    [10144, "Mahjarrat Attack Magic06"],
    [10145, "Mahjarrat Attack Summon 06"],
    [10146, "Mahjarrat Teleport Appear06"],
    [10147, "Mahjarrat Teleport Disappear 06"],
    [10148, "Mahjarrat Teleport Item Idle Full"],
    [10149, "Mahjarrat Teleport Item Start"],
    [10150, "Mahjarrat Teleport Item Idle"],
    [10151, "Vfx Mahjarrat Teleport Item Spawn"],
    [10152, "Vfx Mahjarrat Teleport Item Idle"],
    [10153, "Mahjarrat Teleport Item End"],
    [10154, "Vfx Mahjarrat Teleport Item End"],
    [10155, "Mahjarrat Human Sliske Reveal"],
    [10156, "Mahjarrat Sliske Reveal"],
    [10157, "Vfx Mahjarrat Sliske Reveal"],
    [10158, "Mahjarrat Human Appear 02"],
    [10159, "Mahjarrat Human Appear 02 Quick"],
    [10160, "Mahjarrat Human Disappear 02 Quick"],
    [10161, "Mahjarrat Dwarf Appear 01"],
    [10162, "Mahjarrat Dwarf Appear 01 Quick"],
    [10163, "Mahjarrat Dwarf Disappear 01"],
    [10164, "Mahjarrat Dwarf Disappear 01 Quick"],
    [10165, "Vfx Muspah Spike Marker 01 Long"],
    [10166, "Drunk Holditem Ready Merge"],
    [10167, "Book Chuck Merge"],
    [10168, "Ancient Axe Special Spotanim"],
    [10169, "Ancient Axe Idle"],
    [10170, "Ancient Axe Walk"],
    [10171, "Ancient Axe Slash"],
    [10172, "Ancient Axe Crush"],
    [10173, "Ancient Axe Special"],
    [10174, "Npc Duke Sucellus01 Idle Sleep 01"],
    [10175, "Npc Duke Sucellus01 Rig Idle Awake 01"],
    [10176, "Npc Duke Sucellus01 Attack Melee 01"],
    [10177, "Npc Duke Sucellus01 Magic Attack 01"],
    [10178, "Npc Duke Sucellus01 Magic Attack Faster01"],
    [10179, "Npc Duke Sucellus01 Wake Up 01"],
    [10180, "Npc Duke Sucellus01 Sight Attack 01"],
    [10181, "Npc Duke Sucellus01 Death 01"],
    [10182, "Npc Duke Sucellus01 Death Reset 01"],
    [10183, "Npc Duke Sucellus01 Death Singleframe 01"],
    [10184, "Duke Door Eye 01 Asleep Idle 01"],
    [10185, "Duke Door Eye 01 Awake Idle 01"],
    [10186, "Duke Door Eye 01 Wake Up 01"],
    [10187, "Duke Door Eye 01 Rouse 01"],
    [10188, "Duke Door Eye 01 Rouse 02"],
    [10189, "Duke Door Eye 01 Rouse 03"],
    [10190, "Duke Door Eye 01 Death 01"],
    [10191, "Duke Door Eye 01 Dead 01"],
    [10192, "Spotanim Duke Vent 01 Spawn 01"],
    [10193, "Spotanim Duke Vent 01 Spawn 02"],
    [10194, "Spotanim Duke Vent 01 Spawn 03"],
    [10195, "Spotanim Duke Vent 01 Spawn 04"],
    [10196, "Spotanim Duke Vent 01 Idle 01"],
    [10197, "Spotanim Duke Vent 01 Idle 02"],
    [10198, "Spotanim Duke Vent 01 Idle 03"],
    [10199, "Spotanim Duke Vent 01 Idle 04"],
    [10200, "Spotanim Duke Vent 01 Despawn 01"],
    [10201, "Spotanim Duke Vent 01 Despawn 02"],
    [10202, "Spotanim Duke Vent 01 Despawn 03"],
    [10203, "Spotanim Duke Vent 01 Despawn 04"],
    [10204, "Projanim Duke Spit 01"],
    [10205, "Vfx Duke Sucellus Attack Magic Projectile 01"],
    [10206, "Vfx Duke Sucellus Attack Magic Projectile Impact 01"],
    [10207, "Spotanim Npc Duke Sucellus01 Attack Melee Chip 01"],
    [10208, "Spotanim Npc Duke Sucellus01 Attack Melee Main 01"],
    [10209, "Vfx Duke Sucellus Attack Melee Spotanim Npc 01"],
    [10210, "Vfx Duke Sucellus Attack Melee Spotanim Tile 01"],
    [10211, "Vfx Duke Sucellus Attack Melee Spotanim Tile 02"],
    [10212, "Vfx Duke Sucellus Attack Melee Spotanim Tile 03"],
    [10213, "Vfx Duke Sucellus Attack Melee Spotanim Tile 04"],
    [10214, "Interface Icon Cthonian01 Idle"],
    [10215, "Interface Icon Cthonian01 Disappear"],
    [10216, "Interface Icon Cthonian01 Appear"],
    [10217, "Duke Sucellus Pet 01 Idle 01"],
    [10218, "Duke Sucellus Pet 01 Walk 01"],
    [10219, "Duke Sucellus Pet 01 Attack 01"],
    [10220, "Vfx Whisperer 01 Attack Screech 01 End"],
    [10221, "Vfx Water Splash 01"],
    [10222, "Vfx Whisperer Tentacle 01 Spawn 01"],
    [10223, "Vfx Whisperer Tentacle 01 Idle 01"],
    [10224, "Vfx Whisperer Tentacle 01 Attack 01"],
    [10225, "Vfx Whisperer Tentacle 01 Death 01"],
    [10226, "Vfx Whisperer Column Spawn"],
    [10227, "Npc Whisperer 01 Spawn 01"],
    [10228, "Npc Whisperer 01 Spawn 02"],
    [10229, "Npc Whisperer 01 Despawn 01"],
    [10230, "Npc Whisperer 01 Idle 01"],
    [10231, "Npc Whisperer 01 Idle 03"],
    [10232, "Npc Whisperer 01 Walk 01"],
    [10233, "Npc Whisperer 01 Walk 01 Nosound"],
    [10234, "Npc Whisperer 01 Attack Melee 01"],
    [10235, "Npc Whisperer 01 Attack Ranged 01"],
    [10236, "Npc Whisperer 01 Attack Ranged 02"],
    [10237, "Npc Whisperer 01 Attack Ranged 03"],
    [10238, "Npc Whisperer 01 Attack Ranged 04"],
    [10239, "Npc Whisperer 01 Attack Ranged 05"],
    [10240, "Npc Whisperer 01 Attack Ranged 06"],
    [10241, "Npc Whisperer 01 Attack Magic 01"],
    [10242, "Npc Whisperer 01 Attack Magic 02"],
    [10243, "Npc Whisperer 01 Attack Magic 03"],
    [10244, "Npc Whisperer 01 Attack Magic 04"],
    [10245, "Npc Whisperer 01 Attack Magic 05"],
    [10246, "Npc Whisperer 01 Attack Magic 06"],
    [10247, "Npc Whisperer 01 Teleport 01"],
    [10248, "Npc Whisperer 01 Teleport 02"],
    [10249, "Npc Whisperer 01 Teleport 02 Pet"],
    [10250, "Npc Whisperer 01 Attack Screech 01 Start"],
    [10251, "Npc Whisperer 01 Attack Screech 01 Idle"],
    [10252, "Npc Whisperer 01 Attack Screech 01 End"],
    [10253, "Npc Whisperer 01 Attack Screech 01 End Pet"],
    [10254, "Npc Whisperer 01 Summon Leeches 01"],
    [10255, "Npc Whisperer 01 Teleport Summon Leeches 01"],
    [10256, "Npc Whisperer 01 Teleport Summon Souls 01 Start"],
    [10257, "Npc Whisperer 01 Teleport Summon Souls 01 Idle"],
    [10258, "Npc Whisperer 01 Teleport Summon Souls 01 End"],
    [10259, "Npc Whisperer 01 Teleport Summon Souls 01 Attack"],
    [10260, "Npc Whisperer 01 Death 01"],
    [10261, "Npc Whisperer 01 Death 02"],
    [10262, "Npc Whisperer 01 Death 02 Pet"],
    [10263, "Npc Whisperer Tentacle 01 Spawn 01"],
    [10264, "Npc Whisperer Tentacle 01 Idle 01"],
    [10265, "Npc Whisperer Tentacle 01 Idle 02"],
    [10266, "Npc Whisperer Tentacle 01 Attack 01"],
    [10267, "Npc Whisperer Tentacle 01 Death 01"],
    [10268, "Npc Whisperer Egg 01 Spawn 01"],
    [10269, "Npc Whisperer Egg 01 Spawn 02"],
    [10270, "Npc Whisperer Egg 01 Idle 01"],
    [10271, "Npc Whisperer Egg 01 Idle 02"],
    [10272, "Npc Whisperer Egg 01 Squash 01"],
    [10273, "Npc Whisperer Egg 01 Hatch 01"],
    [10274, "Npc Whisperer Egg 01 Vanish 01"],
    [10275, "Proj Whisperer Egg 01 Larvae 01"],
    [10276, "Npc Leviathan 01 Idle 01"],
    [10277, "Npc Leviathan 01 Idle 02"],
    [10278, "Npc Leviathan 01 Projectile Start 01"],
    [10279, "Npc Leviathan 01 Projectile Loop 01"],
    [10280, "Npc Leviathan 01 Projectile End 01"],
    [10281, "Npc Leviathan 01 Projectile Single 01"],
    [10282, "Npc Leviathan 01 Stun 01"],
    [10283, "Npc Leviathan 01 Melee 01"],
    [10284, "Npc Leviathan 01 Melee 02"],
    [10285, "Npc Leviathan 01 360 Start"],
    [10286, "Npc Leviathan 01 360 Loop"],
    [10287, "Npc Leviathan 01 360 End"],
    [10288, "Npc Leviathan 01 Spit Start"],
    [10289, "Npc Leviathan 01 Spit Loop"],
    [10290, "Npc Leviathan 01 Explosion Start"],
    [10291, "Npc Leviathan 01 Spawn"],
    [10292, "Npc Leviathan 01 Petwalk"],
    [10293, "Npc Leviathan 01 Death"],
    [10294, "Npc Leviathan 01 Stun Idle"],
    [10295, "Npc Buff01 Idle01"],
    [10296, "Npc Buff01 Spawn01"],
    [10297, "Npc Buff01 Despawn01"],
    [10298, "Npc Leviathan Tail01 Idle01"],
    [10299, "Npc Leviathan Tail01 Idlevariant01"],
    [10300, "Npc Leviathan Tail01 Idlevariant02"],
    [10301, "Npc Leviathan Tail01 Melee01"],
    [10302, "Npc Leviathan Tail01 Meleevariant01"],
    [10303, "Npc Leviathan Tail01 Meleevariant02"],
    [10304, "Npc Leviathan Tail01 Stun01"],
    [10305, "Npc Leviathan Tail01 Stunvariant01"],
    [10306, "Npc Leviathan Tail01 Stunvariant02"],
    [10307, "Beam 360 Attack Vfx 01"],
    [10308, "Spotanim Leviathan Explode"],
    [10309, "Spotanim Leviathan Explode 02"],
    [10310, "Projanim Brain 01"],
    [10311, "Projanim Brain 01 Impact 01"],
    [10312, "Projanim Brain 01 Impact 02"],
    [10313, "Spotanim Brain 01 Falling Break 01"],
    [10314, "Spotanim Brain 01 Falling Break 02"],
    [10315, "Spotanim Brain 01 Falling Stay 01"],
    [10316, "Spotanim Brain 01 Falling Stay 02"],
    [10317, "Spotanim Brain 01 Falling Stay 03"],
    [10318, "Spotanim Brain 01 Falling Stay 04"],
    [10319, "Spotanim Brain 01 Falling 01"],
    [10320, "Spotanim Brain 01 Falling 02"],
    [10321, "Vfx Leviathan 01 Projectile Spotanim Ranged 01"],
    [10322, "Vfx Leviathan 01 Projectile Spotanim Melee 01"],
    [10323, "Vfx Leviathan 01 Projectile Spotanim Magic 01"],
    [10324, "Vfx Leviathan 01 Projectile Spotanim Ranged 02"],
    [10325, "Vfx Leviathan 01 Projectile Spotanim Melee 02"],
    [10326, "Vfx Leviathan 01 Projectile Spotanim Magic 02"],
    [10327, "Vfx Leviathan 01 Projectile Ranged 01"],
    [10328, "Vfx Leviathan 01 Projectile Melee 01"],
    [10329, "Vfx Leviathan 01 Projectile Magic 01"],
    [10330, "Vfx Leviathan 01 Projectile Impact 01"],
    [10331, "Quest Dt2 Leviathan Sea Snake"],
    [10332, "Npc Vardorvis Projectile 01 Axe Spin 01"],
    [10333, "Npc Vardorvis Projectile 01 Axe Spin 02"],
    [10334, "Npc Vardorvis Axe 02 Spawn 01"],
    [10335, "Npc Vardorvis Axe 02 Spawn 02"],
    [10336, "Npc Vardorvis Axe 02 Attack End"],
    [10337, "Npc Vardorvis 01 Idle 01"],
    [10338, "Npc Vardorvis 01 Walk Forward 01"],
    [10339, "Npc Vardorvis 01 Walk Forward 01 No Sound"],
    [10340, "Npc Vardorvis 01 Melee 01"],
    [10341, "Npc Vardorvis 01 Dash 01"],
    [10342, "Npc Vardorvis 01 Entangle Start"],
    [10343, "Npc Vardorvis 01 Entangle Loop"],
    [10344, "Npc Vardorvis 01 Entangle End"],
    [10345, "Npc Vardorvis 01 Spawn 01"],
    [10346, "Npc Vardorvis 01 Death 01"],
    [10347, "Npc Vardorvis 01 Death 01 Pet"],
    [10348, "Npc Vardorvis 01 Head 01 Scream 01"],
    [10349, "Vfx Vardorvis 01 Head 01 Scream 01"],
    [10350, "Vfx Vardorvis Head Projectile Magic 01"],
    [10351, "Vfx Vardorvis Head Projectile Ranged 01"],
    [10352, "Vfx Vardorvis Head Projectile Impact 01"],
    [10353, "Npc Vardorvis Spike 01 Spawn 01"],
    [10354, "Npc Vardorvis Spike 01 Despawn 01"],
    [10355, "Npc Vardorvis Spike 01 Chase 01"],
    [10356, "Stranglewood Spike 01 Spawn 01"],
    [10357, "Stranglewood Spike Short Wall Spawn"],
    [10358, "Stranglewood Spike Short Wall Despawn"],
    [10359, "Stranglewood Spike Med Wall Spawn"],
    [10360, "Stranglewood Spike Med Wall Despawn"],
    [10361, "Stranglewood Spike Tall Wall Spawn"],
    [10362, "Stranglewood Spike Tall Wall Despawn"],
    [10363, "Npc Vardorvis Axe 01 Idle 01"],
    [10364, "Npc Vardorvis Axe 01 Spawn 01"],
    [10365, "Npc Vardorvis Axe 01 Attack Start"],
    [10366, "Proj Vardorvis Axe 01"],
    [10367, "Ui Vardorvis Qte Tentacles Spawn01"],
    [10368, "Ui Vardorvis Qte Tentacles Idle01"],
    [10369, "Ui Vardorvis Qte Tentacles Despawn01"],
    [10370, "Ui Vardorvis Qte Background Spawn01"],
    [10371, "Ui Vardorvis Qte Background Idle01"],
    [10372, "Ui Vardorvis Qte Background Despawn01"],
    [10373, "Ui Vardorvis Qte Spore Spawn01"],
    [10374, "Ui Vardorvis Qte Spore Idle01"],
    [10375, "Ui Vardorvis Qte Sport Death01"],
    [10376, "Vfx Player Vardorvis Spores Spawn"],
    [10377, "Vfx Player Vardorvis Spores Idle"],
    [10378, "Vfx Player Vardorvis Spores Despawn"],
    [10379, "Npc Shadow Creature Arm Spawn 01"],
    [10380, "Npc Shadow Creature Arm Idle 01"],
    [10381, "Npc Shadow Creature Arm Attack 01"],
    [10382, "Npc Shadow Creature Arm Defend 01"],
    [10383, "Npc Shadow Creature Arm Death 01"],
    [10384, "Dt2 Kasonde Explosion"],
    [10385, "Cage Sway"],
    [10386, "Fx Fire01"],
    [10387, "Dt2 Shadow Blocker"],
    [10388, "Elder Horn Teleport Start"],
    [10389, "Elder Horn Teleport Start Into Idle"],
    [10390, "Elder Horn Teleport Idle"],
    [10391, "Elder Horn Teleport End"],
    [10392, "Vfx Elder Horn Teleport End"],
    [10393, "Sote Raise Orb Hit"],
    [10394, "Sote Human Hit"],
    [10395, "Sote Human Injured"],
    [10396, "Sote Human Injured Dying"],
    [10397, "Fairy Flower Enchant Short"],
    [10398, "Brain Player Anchor Special Attack Long"],
    [10399, "Npc Ancient Guardian01 Zaros01 Walk01"],
    [10400, "Npc Ancient Guardian01 Zaros01 Walk02"],
    [10401, "Npc Ancient Guardian01 Zaros01 Idle01"],
    [10402, "Npc Ancient Guardian01 Zaros01 Attack Melee01"],
    [10403, "Npc Ancient Guardian01 Zaros01 Attack Melee02"],
    [10404, "Npc Ancient Guardian01 Zaros01 Death01"],
    [10405, "Npc Ancient Guardian01 Zaros01 Awaken01"],
    [10406, "Npc Ancient Guardian01 Zaros01 Inactive01"],
    [10407, "Misty Long"],
    [10408, "Rock Pool Slow"],
    [10409, "Human Running 30"],
    [10410, "Human Running 60"],
    [10411, "Human Quick Sprint 30"],
    [10412, "Human Quick Sprint 60"],
    [10413, "Human Castcurse Staff Walkmerge"],
    [10414, "Human Walk 30"],
    [10415, "Poh Pool Drink Silent"],
    [10416, "Statue Lassar Shadow 01 Idle"],
    [10417, "Vfx Dm Breach Spawn"],
    [10418, "Vfx Dm Breach Loop"],
    [10419, "Vfx Dm Breach Despawn"],
    [10420, "Vfx Dm Boss Spawn"],
    [10421, "Vfx Dm Boss Loop"],
    [10422, "Vfx Dm Boss Despawn"],
    [10423, "Vfx Dm Boss Transparent"],
    [10424, "Vfx Dm Boss Combined"],
    [10425, "Fx Cycle 6 Items Extended"],
    [10426, "Fx Cycle 6 Items"],
    [10427, "Ags Special Blighted Player"],
    [10428, "Pog Human Push 1x1 Block"],
    [10429, "Pog Human Push 2x2 Block"],
    [10430, "Pog Grapple Swing"],
    [10431, "Animated Sulphur Jet"],
    [10432, "Pog Animated Sulphur Jets Ready"],
    [10433, "Pog Striking Crystal Chime"],
    [10434, "Pog Mutated Battle Tortoise Walk"],
    [10435, "Pog Mutated Battle Tortoise Ready"],
    [10436, "Pog Mutated Battle Tortoise Death"],
    [10437, "Pog Mutated Battle Tortoise Defend"],
    [10438, "Pog Mutated Battle Tortoise Attack"],
    [10439, "Pog Mutant Terror Bird Projectile Attack"],
    [10440, "Pog Player Stuck In Tar"],
    [10441, "Pog Player Dizzy"],
    [10442, "Pog Tar Flowing"],
    [10443, "Pog Engineered Terror Bird Walk"],
    [10444, "Pog Engineered Terror Bird Ready"],
    [10445, "Pog Engineered Terror Bird Ready Extra"],
    [10446, "Pog Engineered Terror Bird Ready Reversed"],
    [10447, "Pog Engineered Terror Bird Ready Extra Reversed"],
    [10448, "Pog Engineered Terror Bird Panic Run"],
    [10449, "Pog Engineered Terror Bird Button Push"],
    [10450, "Pog Mutant Terror Bird Ready"],
    [10451, "Pog Mutant Terror Bird Bounce Walk"],
    [10452, "Pog Mutant Terror Bird Projectile"],
    [10453, "Pog Mutant Terror Bird Attack"],
    [10454, "Pog Mutant Terror Bird Death"],
    [10455, "Pog Mutant Terror Bird Defend"],
    [10456, "Pog Engineered Terror Bird Panic Ready"],
    [10457, "Pog Player Organic Teleport"],
    [10458, "Pog Organic Teleport Spotanim"],
    [10459, "Pog Player Organic Teleport Reversed"],
    [10460, "Pog Organic Teleport Spotanim Reversed"],
    [10461, "Pog Food Appearing Shanks"],
    [10462, "Pog Food Appearing Shanks Static"],
    [10463, "Pog Food Appearing Shanks Static 2"],
    [10464, "Pog Human Food Apples Bananas"],
    [10465, "Pog Human Food Apples Bananas Static"],
    [10466, "Pog Human Food Apples Bananas Static 2"],
    [10467, "Pog Healthorg Statue Fade"],
    [10468, "Pog Bolries Advisor Fade Reveal"],
    [10469, "Pog Bolries Advisor Fade Reveal Static"],
    [10470, "Pog Unok Operating Machine"],
    [10471, "Pog Bolries Adviser Ready"],
    [10472, "Pog Bolries Adviser Talking"],
    [10473, "Pog Bolrie Listening"],
    [10474, "Pog Bolrie Thinking"],
    [10475, "Pog Bolrie King"],
    [10476, "Pog Bolrie Angry"],
    [10477, "Pog Bolrie Ready"],
    [10478, "Pog Poster Hand"],
    [10479, "Pog Poster Hand Brush"],
    [10480, "Pog Bolrie Poster"],
    [10481, "Pog Arg Poster"],
    [10482, "Pog Arg Poster Rigged"],
    [10483, "Pog Bolrie Poster Rip"],
    [10484, "Pog Poster Hand Rip"],
    [10485, "Pog Bolrie Poster Static"],
    [10486, "Pog Arg Poster Static"],
    [10487, "Pog Spirit Tree Transform"],
    [10488, "Pog Eyeglo Singing Bowl Overcharge"],
    [10489, "Pog Seed Break"],
    [10490, "Pog Tele Seed Ready"],
    [10491, "Pog Hazelmere Cast Shield"],
    [10492, "Pog Hazelmere Cast Teleport"],
    [10493, "Pog Gas Clouds"],
    [10494, "Pog Gas Clouds Ready"],
    [10495, "Pog Hazelmere Seedpod Teleport Spot"],
    [10496, "Pog Hazelmere Reach Into Cloak"],
    [10497, "Pog Hazelmere Pod Teleport In"],
    [10498, "Lore Wolpertinger Proj"],
    [10499, "Pog Hazelmere Shield Loc"],
    [10500, "Vfx Warped Sceptre Cast"],
    [10501, "Pog Warped Sceptre Attack"],
    [10502, "Chatent Idle"],
    [10503, "Emote Trick"],
    [10504, "Hw23 Emote Bat Spotanim"],
    [10505, "Pruning Mid Single"],
    [10506, "Anma Chopping Fail Bronze 2h Axe"],
    [10507, "Anma Chopping Fail Iron 2h Axe"],
    [10508, "Anma Chopping Fail Steel 2h Axe"],
    [10509, "Anma Chopping Fail Black 2h Axe"],
    [10510, "Anma Chopping Fail Mithril 2h Axe"],
    [10511, "Anma Chopping Fail Adamant 2h Axe"],
    [10512, "Anma Chopping Fail Rune 2h Axe"],
    [10513, "Anma Chopping Fail Dragon 2h Axe"],
    [10514, "Anma Chopping Fail Crystal 2h Axe"],
    [10515, "Anma Chopping Fail Crystal 2h Axe Inactive"],
    [10516, "Anma Chopping Fail 3a 2h Axe"],
    [10517, "Human Canoeing Carve Bronze 2h Axe"],
    [10518, "Human Canoeing Carve Iron 2h Axe"],
    [10519, "Human Canoeing Carve Steel 2h Axe"],
    [10520, "Human Canoeing Carve Black 2h Axe"],
    [10521, "Human Canoeing Carve Mithril 2h Axe"],
    [10522, "Human Canoeing Carve Adamant 2h Axe"],
    [10523, "Human Canoeing Carve Rune 2h Axe"],
    [10524, "Human Canoeing Carve Dragon 2h Axe"],
    [10525, "Human Canoeing Carve Crystal 2h Axe"],
    [10526, "Human Canoeing Carve Crystal 2h Axe Inactive"],
    [10527, "Human Canoeing Carve 3a 2h Axe"],
    [10528, "Npc Ent Stump Spawn To Idle"],
    [10529, "Npc Ent Stump Idle01"],
    [10530, "Npc Ent Stump Spawn"],
    [10531, "Vfx Ent Stump Dust"],
    [10532, "Npc Ent Stump Despawn01"],
    [10533, "Forestry Poacher Sapling Spawn"],
    [10534, "Human Pheasant Feathers Crafting"],
    [10535, "Forestry Poacher Spawn"],
    [10536, "Forestry Poacher Despawn"],
    [10537, "Forestry Entling Idle"],
    [10538, "Forestry Entling Run"],
    [10539, "Forestry Entling Spawn"],
    [10540, "Forestry Entling Despawn"],
    [10541, "Forestry Dryad Ready"],
    [10542, "Forestry Dryad Spawn"],
    [10543, "Forestry Dryad Despawn"],
    [10544, "Forestry Dryad Despawn Spotanim"],
    [10545, "Forestry Dryad Spawn Spotanim"],
    [10546, "Forestry Enchanted Ritual Despawn"],
    [10547, "Forestry Enchanted Ritual Loop"],
    [10548, "Forestry Enchanted Ritual Spawn"],
    [10549, "Forestry Enchanted Ritual Combined"],
    [10550, "Forestry Enchanted Ritual Start End"],
    [10551, "Human Disarm Floor Loop"],
    [10552, "Human Disarm Floor Loop End"],
    [10553, "Forestry Fox Trap Spawn"],
    [10554, "Poacher Arm Floor Trap"],
    [10555, "Forestry Fox Trap Idle"],
    [10556, "Forestry Fox Trap Attack"],
    [10557, "Forestry Fox Trap Disarm"],
    [10558, "Forestry Pheasant Spawn Spotanim"],
    [10559, "Forestry Rainbow Glowing Circle"],
    [10560, "Forestry Pheasant Land Spotanim"],
    [10561, "Forestry Campfire Burning Generic"],
    [10562, "Forestry Campfire Burning Achey Tree Logs"],
    [10563, "Forestry Campfire Burning Arctic Pine Log"],
    [10564, "Forestry Campfire Burning Blisterwood Logs"],
    [10565, "Forestry Campfire Burning Logs"],
    [10566, "Forestry Campfire Burning Magic Logs"],
    [10567, "Forestry Campfire Burning Mahogany Logs"],
    [10568, "Forestry Campfire Burning Maple Logs"],
    [10569, "Forestry Campfire Burning Oak Logs"],
    [10570, "Forestry Campfire Burning Redwood Logs"],
    [10571, "Forestry Campfire Burning Teak Logs"],
    [10572, "Forestry Campfire Burning Willow Logs"],
    [10573, "Forestry Campfire Burning Yew Logs"],
    [10574, "Forestry Campfire Burning Spotanim"],
    [10575, "Human Woodcrafting Bronze 2h Axe"],
    [10576, "Human Woodcrafting Iron 2h Axe"],
    [10577, "Human Woodcrafting Steel 2h Axe"],
    [10578, "Human Woodcrafting Black 2h Axe"],
    [10579, "Human Woodcrafting Mithril 2h Axe"],
    [10580, "Human Woodcrafting Adamant 2h Axe"],
    [10581, "Human Woodcrafting Rune 2h Axe"],
    [10582, "Human Woodcrafting Dragon 2h Axe"],
    [10583, "Human Woodcrafting Crystal 2h Axe"],
    [10584, "Human Woodcrafting Crystal Inactive 2h Axe"],
    [10585, "Human Woodcrafting 3a 2h Axe"],
    [10586, "Human Brut Canoeing Carve Bronze 2h Axe"],
    [10587, "Human Brut Canoeing Carve Iron 2h Axe"],
    [10588, "Human Brut Canoeing Carve Steel 2h Axe"],
    [10589, "Human Brut Canoeing Carve Black 2h Axe"],
    [10590, "Human Brut Canoeing Carve Mithril 2h Axe"],
    [10591, "Human Brut Canoeing Carve Adamant 2h Axe"],
    [10592, "Human Brut Canoeing Carve Rune 2h Axe"],
    [10593, "Human Brut Canoeing Carve Dragon 2h Axe"],
    [10594, "Human Brut Canoeing Carve Crystal 2h Axe"],
    [10595, "Human Brut Canoeing Carve Crystal 2h Axe Inactive"],
    [10596, "Human Brut Canoeing Carve 3a 2h Axe"],
    [10597, "Human 2h Axe Chopping"],
    [10598, "Human 2h Axe Ready"],
    [10599, "Human 2h Axe Walk"],
    [10600, "Human 2h Axe Run"],
    [10601, "Human 2h Axe Special"],
    [10602, "Human 2h Axe Attack"],
    [10603, "Human 2h Axe Defend"],
    [10604, "Fx Beam Spawn"],
    [10605, "Fx Beam Spawn And Ready"],
    [10606, "Fx Beam Despawn"],
    [10607, "Human Trawler Hack Bronze 2h Axe"],
    [10608, "Human Trawler Hack Iron 2h Axe"],
    [10609, "Human Trawler Hack Steel 2h Axe"],
    [10610, "Human Trawler Hack Black 2h Axe"],
    [10611, "Human Trawler Hack Mithril 2h Axe"],
    [10612, "Human Trawler Hack Adamant 2h Axe"],
    [10613, "Human Trawler Hack Rune 2h Axe"],
    [10614, "Human Trawler Hack Dragon 2h Axe"],
    [10615, "Human Trawler Hack Crystal 2h Axe"],
    [10616, "Human Trawler Hack Crystal Inactive 2h Axe"],
    [10617, "Human Trawler Hack 3a 2h Axe"],
    [10618, "Pheasant Idle"],
    [10619, "Pheasant Spawn"],
    [10620, "Pheasant Launch"],
    [10621, "Pheasant Land"],
    [10622, "Pheasant Despawn"],
    [10623, "Human Castlowlvlalchemy Fire"],
    [10624, "Human Casthighlvlalchemy Fire"],
    [10625, "League 4 Trailblazer Reloaded Scroll Read"],
    [10626, "Trailblazer Vengeance Spotanim 01"],
    [10627, "Trailblazer Undying Retribution Spotanim 01"],
    [10628, "Trailblazer Undying Retribution Spotanim 02"],
    [10629, "Trailblazer Death Player 01"],
    [10630, "Trailblazer Death Spotanim"],
    [10631, "Trailblazer Spawn Player 01"],
    [10632, "Trailblazer Spawn Guardian 01"],
    [10633, "Trailblazer Spawn Guardian 02"],
    [10634, "Trailblazer Spawn Guardian 03"],
    [10635, "Trailblazer Spawn Spotanim"],
    [10636, "Trailblazer Guardian 01 Idle 01"],
    [10637, "Trailblazer Guardian 01 Defend 01"],
    [10638, "Trailblazer Guardian 01 Attack Magic 01"],
    [10639, "Trailblazer Guardian 01 Attack Magic 01 Spotanim 01"],
    [10640, "Trailblazer Guardian 01 Attack Magic 01 Projanim 01"],
    [10641, "Trailblazer Guardian 01 Attack Magic 01 Impactanim 01"],
    [10642, "Trailblazer Guardian 01 Attack Ranged 01 Projanim 01"],
    [10643, "Trailblazer Guardian 01 Attack Ranged 01 Impactanim 01"],
    [10644, "Trailblazer Summon Guardian Player 01"],
    [10645, "Trailblazer Summon Guardian Player 01 Female"],
    [10646, "Trailblazer Summon Guardian Player 01 Spotanim 01"],
    [10647, "Spotanim Castlowlvlalchemy Fire"],
    [10648, "Spotanim Casthighlvlalchemy Fire"],
    [10649, "Relics Executioner Attack"],
    [10650, "Relics Executioner Attack Spotanim"],
    [10651, "Relics Executioner Attack Slower"],
    [10652, "Relics Executioner Attack Slower Spotanim"],
    [10653, "Relics Executioner Projanim"],
    [10654, "Relics Executioner Impact Spotanim"],
    [10655, "Human Spellcast Dmm Noheld"],
    [10656, "Snakeboss Blowpipe Attack Ornament"],
    [10657, "Anti Santa Walk"],
    [10658, "Anti Santa Walk Back"],
    [10659, "Anti Santa Walk Right"],
    [10660, "Anti Santa Walk Left"],
    [10661, "Anti Santa Idle"],
    [10662, "Antisanta Attack"],
    [10663, "Antisanta Victory"],
    [10664, "Anti Santa Spawn"],
    [10665, "Anti Santa Despawn"],
    [10666, "Santa Walk"],
    [10667, "Santa Combat"],
    [10668, "Santa Attack"],
    [10669, "Santa Spawn"],
    [10670, "Santa Walk Back"],
    [10671, "Santa Walk Right"],
    [10672, "Santa Walk Left"],
    [10673, "Santa Death"],
    [10674, "Santa Idle"],
    [10675, "Santa Victory"],
    [10676, "Xmas 2023 Gub Xmas Human Snowball Throw"],
    [10677, "Xmas 2023 Human Jump Hurdle"],
    [10678, "Emote Yawn Short"],
    [10679, "Dttd Carrying Crate Walk Fast"],
    [10680, "Nervous Idle"],
    [10681, "Interrogated Idle"],
    [10682, "Sneaky Bag Walk"],
    [10683, "Sneaky Bag Idle"],
    [10684, "Sneaky Bag Look Around"],
    [10685, "Summon Point Merge"],
    [10686, "Npc Rat Boss Spawn 01"],
    [10687, "Npc Rat Boss Idle 01"],
    [10688, "Npc Rat Boss Feeding Idle 01"],
    [10689, "Npc Rat Boss Feeding Idle 02"],
    [10690, "Npc Rat Boss Walk 01"],
    [10691, "Npc Rat Boss Run 01"],
    [10692, "Npc Rat Boss Attack Melee 01"],
    [10693, "Npc Rat Boss Attack Melee 02"],
    [10694, "Npc Rat Boss Attack Ranged 01"],
    [10695, "Npc Rat Boss Feeding Attack Ranged 01"],
    [10696, "Npc Rat Boss Attack Magic 01"],
    [10697, "Npc Rat Boss Feeding Attack Magic 01"],
    [10698, "Npc Rat Boss Attack Stomp 01"],
    [10699, "Npc Rat Boss Feeding Attack Stomp 01"],
    [10700, "Npc Rat Boss Attack Summon 01"],
    [10701, "Npc Rat Boss Attack Summon 02"],
    [10702, "Npc Rat Boss Feeding Attack Summon 01"],
    [10703, "Npc Rat Boss Feeding Attack Summon 02"],
    [10704, "Npc Rat Boss Enrage 01"],
    [10705, "Npc Rat Boss Death 01"],
    [10706, "Npc Rat Boss Enrage 02"],
    [10707, "Vfx Rat Boss Attack Magic 01"],
    [10708, "Vfx Rat Boss Feeding Attack Magic 01"],
    [10709, "Vfx Rat Boss Proj Ranged 01"],
    [10710, "Vfx Rat Boss Proj Ranged Impact 01"],
    [10711, "Vfx Rat Boss Proj Ranged Impact 02"],
    [10712, "Vfx Rat Boss Proj Magic 01"],
    [10713, "Vfx Rat Boss Proj Magic Impact 01"],
    [10714, "Vfx Rat Boss Falling Debris 01"],
    [10715, "Pet Rat Boss Walk 01"],
    [10716, "Chathead Rat Boss Idle 01"],
    [10717, "Chathead Rat Boss Idle 02"],
    [10718, "Chathead Rat Boss Idle 03"],
    [10719, "Vfx Weapon Staff Rat01 Spotanim"],
    [10720, "Vfx Weapon Staff Rat01 Impact 01"],
    [10721, "Farming Seed Dibbing Nodib"],
    [10722, "Debug Orb"],
    [10723, "Killerwatt Ball Ready Update"],
    [10724, "Killerwatt Ball Death 01"],
    [10725, "Killerwatt Biped Spawn"],
    [10726, "Zombie Ready Normal Alt"],
    [10727, "Dov Red Mist"],
    [10728, "Dov Chain Lightning 3x1"],
    [10729, "Dov Chain Lightning 2x4 01"],
    [10730, "Dov Chain Lightning 2x4 02"],
    [10731, "Dov Chain Lightning 1x1"],
    [10732, "Dov Chain Lightning 3x1 Long"],
    [10733, "Dov Chain Lightning 2x4 01 Long"],
    [10734, "Dov Chain Lightning 2x4 02 Long"],
    [10735, "Dov Chain Lightning 1x1 Long"],
    [10736, "Sharathteerk Idle 01"],
    [10737, "Sharathteerk Walk 01"],
    [10738, "Sharathteerk Attack Melee 01"],
    [10739, "Sharathteerk Attack Magic 01"],
    [10740, "Sharathteerk Ascend 01"],
    [10741, "Sharathteerk Idle 02"],
    [10742, "Sharathteerk Descend 01"],
    [10743, "Coa Water Drops"],
    [10744, "Coa Human Detection Spell"],
    [10745, "Coa Pedestal Heart"],
    [10746, "Coa Falling Impassable Rubble"],
    [10747, "Coa Falling Impassable Rubble Fallen"],
    [10748, "Coa Fire Laser"],
    [10749, "Coa Player Grapple Spot"],
    [10750, "Coa Electricity Proj"],
    [10751, "Coa Blades"],
    [10752, "Coa Sliding Doors"],
    [10753, "Coa Sliding Doors Opened"],
    [10754, "Coa Sliding Doors Return"],
    [10755, "Coa Brazier Fire"],
    [10756, "Coa Floor Tile Raise"],
    [10757, "Coa Amascut Reform"],
    [10758, "Coa Het Reform"],
    [10759, "Coa Apmeken Reform"],
    [10760, "Coa Icthlarin Reform"],
    [10761, "Coa Scabaras Reform"],
    [10762, "Coa Crondis Reform"],
    [10763, "Coa Amascut Reformed"],
    [10764, "Coa Het Reformed"],
    [10765, "Coa Apmeken Reformed"],
    [10766, "Coa Icthlarin Reformed"],
    [10767, "Coa Scabaras Reformed"],
    [10768, "Coa Crondis Reformed"],
    [10769, "Coa Candle Effect"],
    [10770, "Coa Torch"],
    [10771, "Coa Torch Low"],
    [10772, "Coa Uzer Fire"],
    [10773, "Coa Fort Fire"],
    [10774, "Coa Fort Fire Small"],
    [10775, "Coa Stone Golem Walk"],
    [10776, "Coa Stone Golem Attack"],
    [10777, "Coa Stone Golem Defend"],
    [10778, "Coa Stone Golem Ready"],
    [10779, "Coa Stone Golem Death"],
    [10780, "Qip Dragon Slayer Player Unleashing Fire Short"],
    [10781, "Terrified Emote Long"],
    [10782, "Poh Fireplace Light Noreplace"],
    [10783, "Huntingfox Approach"],
    [10784, "Huntingfox Backoff"],
    [10785, "Huntingfox Missingloc"],
    [10786, "Huntingfox Deadfall Empty"],
    [10787, "Huntingfox Deadfall Failing"],
    [10788, "Huntingfox Deadfall Catching"],
    [10789, "Huntingfox Deadfall Catching South"],
    [10790, "Huntingfox Deadfall Full"],
    [10791, "Huntingfox Deadfall Catchingtest"],
    [10792, "Hunting Searching Bushes Walkmerge Norestart"],
    [10793, "Minnow Fishing Spot Location Loop"],
    [10794, "Human Crafting"],
    [10795, "Human Cooking Walkmerge Norestart"],
    [10796, "Emote Varlamore Salute"],
    [10797, "Emote Varlamore Salute Loop"],
    [10798, "Npc Colosseum Crystal Spawn 01"],
    [10799, "Npc Colosseum Crystal Idle 01"],
    [10800, "Npc Colosseum Crystal Despawn 01"],
    [10801, "Npc Colosseum Crystal Charge 01"],
    [10802, "Npc Colosseum Crystal Attack 01"],
    [10803, "Vfx Colosseum Crystal Charge 01 Beam 01"],
    [10804, "Vfx Colosseum Crystal Charge 01 Beam 02"],
    [10805, "Vfx Colosseum Crystal Charge 01 Beam 03"],
    [10806, "Vfx Colosseum Crystal Charge 01 Beam 04"],
    [10807, "Vfx Colosseum Crystal Attack 01 Beam 01"],
    [10808, "Vfx Colosseum Crystal Attack 01 Beam 02"],
    [10809, "Vfx Colosseum Crystal Attack 01 Beam 03"],
    [10810, "Vfx Colosseum Crystal Attack 01 Beam 04"],
    [10811, "Vfx Colosseum Crystal Attack 01 Impact 01"],
    [10812, "Vfx Colosseum Sunfire Lightning 01 Beam 01"],
    [10813, "Vfx Colosseum Hot Sand 01 Idle 01"],
    [10814, "Vfx Colosseum Hot Sand 01 Despawn 01"],
    [10815, "Vfx Colosseum Hot Sand 02 Projectile 01"],
    [10816, "Vfx Colosseum Hot Sand 02 Idle 01"],
    [10817, "Npc Colosseum Solar Flare Crystal Idle 01"],
    [10818, "Vfx Doom Scorpion Attack Impact 01"],
    [10819, "Vfx Doom Scorpion 01 Player Death 01"],
    [10820, "Vfx Colosseum Bees Jar Impact 01"],
    [10821, "Npc Colosseum Bees Spawn 01"],
    [10822, "Npc Colosseum Bees Idle 01"],
    [10823, "Npc Colosseum Bees Attack 01"],
    [10824, "Npc Colosseum Bees Despawn 01"],
    [10825, "Chest Colosseum01 Reward01 Spawn 01"],
    [10826, "Vfx Colosseum Totem Projectile 01"],
    [10827, "Npc Colosseum Totem Idle 01"],
    [10828, "Npc Colosseum Totem Attack 01"],
    [10829, "Vfx Colosseum Totem Impact 01"],
    [10830, "Vfx Colosseum Explosion01"],
    [10831, "Vfx Colosseum Explosion02"],
    [10832, "Vfx Colosseum Explosion03"],
    [10833, "Vfx Colosseum Explosion04"],
    [10834, "Vfx Colosseum Human Gib 01"],
    [10835, "Vfx Colosseum Manticore Gib 01"],
    [10836, "Vfx Colosseum Colossi Gib 01"],
    [10837, "Vfx Colosseum Minotaur Gib 01"],
    [10838, "Vfx Colosseum Manticore Explosion 01"],
    [10839, "Vfx Colosseum Colossi Explosion 01"],
    [10840, "Npc Minotaur Boss Idle"],
    [10841, "Npc Minotaur Boss Defend"],
    [10842, "Npc Minotaur Boss Walk"],
    [10843, "Npc Minotaur Boss Attack Melee"],
    [10844, "Npc Minotaur Boss Attack Magic"],
    [10845, "Npc Minotaur Boss Spawn"],
    [10846, "Npc Minotaur Boss Death"],
    [10847, "Npc Jaguar Ranger Claws Attack"],
    [10848, "Npc Jaguar Human Unarmed Def"],
    [10849, "Npc Jaguar Human Death"],
    [10850, "Npc Fremennik Warbander Archer Att Colosseum"],
    [10851, "Npc Fremennik Warband Archer Human Unarmed Def"],
    [10852, "Npc Fremennik Warband Archer Human Death"],
    [10853, "Npc Fremennik Warbander Mage Zaros Vertical Casting Walkmerge"],
    [10854, "Npc Fremennik Warband Mage Human Unarmed Def"],
    [10855, "Npc Fremennik Warband Mage Human Death"],
    [10856, "Npc Fremennik Warbander Melee Human Sword Stab"],
    [10857, "Npc Fremennik Warband Melee Human Unarmed Def"],
    [10858, "Npc Fremennik Warband Melee Human Death"],
    [10859, "Npc Serpent Mager Casting"],
    [10860, "Npc Serpent Mager Death"],
    [10861, "Npc Human Staffready Spawn"],
    [10862, "Npc Human Ready Spawn"],
    [10863, "Npc Manticore 01 Idle"],
    [10864, "Npc Manticore 01 Walk"],
    [10865, "Npc Manticore 01 Backwards Walk"],
    [10866, "Npc Manticore 01 Death"],
    [10867, "Npc Manticore 01 Death Explode"],
    [10868, "Npc Manticore 01 Triple Charge"],
    [10869, "Npc Manticore 01 Triple Throw"],
    [10870, "Npc Manticore 01 Spawn 01"],
    [10871, "Npc Manticore 01 Spawn 02"],
    [10872, "Human Shield Combatant Idle"],
    [10873, "Human Doom Scorpion 01 Player Death 01"],
    [10874, "Npc Colossi Finalboss 01 Idle"],
    [10875, "Npc Colossi Finalboss 01 Sitting Idle"],
    [10876, "Npc Colossi Finalboss 01 Arena Jump"],
    [10877, "Npc Colossi Finalboss 01 Arena Land"],
    [10878, "Npc Colossi Finalboss 01 Walk"],
    [10879, "Npc Colossi Javelin Walk"],
    [10880, "Npc Colossi Shockwave 01 Walk Nosound"],
    [10881, "Npc Colossi Shockwave 01 Walk"],
    [10882, "Npc Colossi Finalboss 01 Melee Attack"],
    [10883, "Npc Colossi Finalboss 01 Melee Attack Telegraph"],
    [10884, "Npc Colossi Finalboss 01 Grapple Attack Telegraph"],
    [10885, "Npc Colossi Finalboss 01 Shieldslam Telegraph"],
    [10886, "Npc Colossi Finalboss Tripleattack"],
    [10887, "Npc Colossi Finalboss Tripleattack Shorter"],
    [10888, "Npc Colossi Finalboss 01 Death"],
    [10889, "Npc Colossi Javelin 01 Idle"],
    [10890, "Npc Colossi Javelin 01 Walk"],
    [10891, "Npc Colossi Javelin 01 Walkfade"],
    [10892, "Npc Colossi Javelin 01 Range Attack"],
    [10893, "Npc Colossi Javelin 01 Artillery Attack"],
    [10894, "Npc Colossi Javelin 01 Death"],
    [10895, "Npc Colossi Shockwave 01 Death"],
    [10896, "Npc Colossi Javelin 01 Spearhead"],
    [10897, "Npc Colossi Javelin 01 Artillery Slow"],
    [10898, "Npc Colossi Javelin 01 Artillery Fast"],
    [10899, "Npc Colossi Javelin 01 Artillery Fire"],
    [10900, "Npc Colossi Javelin 01 Spearhead Fire Slow"],
    [10901, "Npc Colossi Javelin 01 Spearhead Fire Fast"],
    [10902, "Npc Colossi Shockwave 01 Idle"],
    [10903, "Npc Colossi Shockwave 01 Clapattack"],
    [10904, "Vfx Colossi Shockwave Clap Proj"],
    [10905, "Spotanim Colossi Finalboss 01 Death"],
    [10906, "Spotanim Colossi Finalboss 01 Land"],
    [10907, "Spotanim Colossi Finalboss 01 Triple Attack Shorter"],
    [10908, "Spotanim Colossi Finalboss 01 Triple Attack"],
    [10909, "Spotanim Colossi Finalboss 01 Melee"],
    [10910, "Projanim Glaive 01 Special"],
    [10911, "Projanim Glaive 01 Regular"],
    [10912, "Projanim Glaive 02 Special"],
    [10913, "Projanim Glaive 02 Regular"],
    [10914, "Human Glaive Ralos01 Charged Special"],
    [10915, "Spotanim Glaive Charged Special"],
    [10916, "Human Glaive Ralos01 Uncharged Special"],
    [10917, "Spotanim Glaive Uncharged Special"],
    [10918, "Spotanim Glaive 01 Impact Special 01"],
    [10919, "Spotanim Glaive 01 Impact Regular 01"],
    [10920, "Spotanim Glaive 02 Impact Special 01"],
    [10921, "Spotanim Glaive Charged Regular"],
    [10922, "Human Glaive Ralos01 Uncharged Throw"],
    [10923, "Human Glaive Ralos01 Charged Throw"],
    [10924, "Antelope Moonlight Attack"],
    [10925, "Antelope Sunlight Attack"],
    [10926, "Antelope Moonlight Attack"],
    [10927, "Antelope Sunlight Attack"],
    [10928, "Unicorn Rework Pitfall Death"],
    [10929, "Unicorn Rework Leap Npc"],
    [10930, "Unicorn Rework Leap Proj1"],
    [10931, "Unicorn Rework Leap Proj2"],
    [10932, "Unicorn Rework Pitfall Dead"],
    [10933, "Toucan Fly"],
    [10935, "Dog Fennecfox Walk"],
    [10936, "Hunterjerboa Attack Sfx"],
    [10937, "Human Cutting Knife"],
    [10938, "Human Enchanttalisman"],
    [10939, "Human Quetzal Tame"],
    [10940, "Civitas Fountain01 Idle 01"],
    [10941, "Civitas Fountain01 Knight01 Dunk Idle 01"],
    [10942, "Civitas Fountain01 Knight01 Dunk Walk 01"],
    [10943, "Civitas Fountain01 Knight01 Dunk Walk 02"],
    [10944, "Human Quetzal Whistle"],
    [10945, "Npc Quetzal Idle 01"],
    [10946, "Npc Quetzal Idle 02"],
    [10947, "Npc Quetzal Flying Idle 01"],
    [10948, "Npc Quetzal Flying Attack 01"],
    [10949, "Npc Quetzal Land 01"],
    [10950, "Npc Quetzal Takeoff 01"],
    [10951, "Npc Quetzal Tame 01"],
    [10952, "Npc Quetzal Flying Idle Pet 01"],
    [10953, "Npc Quetzal Flying Attack Pet 01"],
    [10954, "Npc Quetzal Whistle 01"],
    [10955, "Afl Hunter Lying Down"],
    [10956, "Restless Ghost Vanish Reverse"],
    [10957, "Giant Frog Jump"],
    [10958, "Npc Lynx Combat Walk Fast"],
    [10961, "Npc Capybara Idle01"],
    [10962, "Npc Capybara Walk01"],
    [10963, "Npc Capybara Water01"],
    [10964, "Npc Capybara Walk 01"],
    [10965, "Dwarf Ready Snooty"],
    [10966, "Vfx Djinn Blood Pool Idle 01"],
    [10967, "Vfx Djinn Blood Pool Despawn 01"],
    [10968, "Vfx Djinn Blood Pool Despawn 02"],
    [10969, "Vfx Djinn Blood Pool Attack 01"],
    [10970, "Vfx Djinn Blue Tempest Spawn 01"],
    [10971, "Vfx Djinn Blue Tempest Idle 01"],
    [10972, "Vfx Djinn Blue Tempest Despawn 01"],
    [10973, "Vfx Djinn Eclipse Moon Spawn 01"],
    [10974, "Vfx Djinn Eclipse Moon Idle 01"],
    [10975, "Vfx Djinn Eclipse Moon Despawn 01"],
    [10976, "Vfx Djinn Eclipse Moon Spotanim 01"],
    [10977, "Vfx Djinn Eclipse Moon Spotanim 02"],
    [10978, "Vfx Djinn Ueyatlalli Protection Spawn 01"],
    [10979, "Vfx Djinn Ueyatlalli Protection Idle 01"],
    [10980, "Vfx Djinn Ueyatlalli Protection Despawn 01"],
    [10981, "Vfx Djinn Ueyatlalli Protection Spawn 02"],
    [10982, "Vfx Djinn Ueyatlalli Protection Idle 02"],
    [10983, "Vfx Djinn Ueyatlalli Protection Despawn 02"],
    [10984, "Glowingcircle 30"],
    [10985, "Glowingcircle 60"],
    [10986, "Gg Rain Shadow 90"],
    [10987, "Npc Djinn 01 Melee"],
    [10988, "Npc Djinn 04 Melee"],
    [10989, "Pmoon Macuahuitl Crush"],
    [10990, "Sulphur Blade Slash"],
    [10991, "Npc Djinn 01 Walk"],
    [10992, "Npc Djinn 04 Slayer Death"],
    [10993, "Vfx Djinn 01 Magic 01"],
    [10994, "Vfx Djinn 01 Magic Proj"],
    [10995, "Npc Djinn 05 Idle"],
    [10996, "Npc Djinn 05 Spawn"],
    [10997, "Npc Djinn 05 Magic 02"],
    [10998, "Npc Djinn 05 Fadeout"],
    [10999, "Npc Djinn 01 Idle"],
    [11000, "Npc Djinn 01 Magic"],
    [11001, "Npc Djinn 01 Spawn"],
    [11002, "Npc Djinn 01 Teleport Idle Appear"],
    [11003, "Npc Djinn 01 Teleport Idle Disappear"],
    [11004, "Npc Djinn 01 Combo"],
    [11005, "Npc Djinn 01 Ending"],
    [11006, "Npc Djinn 03 Idle"],
    [11007, "Npc Djinn 03 Magic"],
    [11008, "Npc Djinn 03 Magic 02"],
    [11009, "Npc Djinn 03 Spawn"],
    [11010, "Npc Djinn 03 Beam Magic"],
    [11011, "Npc Djinn 03 Teleport Idle Appear"],
    [11012, "Npc Djinn 03 Teleport Idle Disappear"],
    [11013, "Npc Djinn 03 Melee"],
    [11014, "Npc Djinn 03 Combo"],
    [11015, "Npc Djinn 03 Ending"],
    [11016, "Npc Djinn 02 Idle"],
    [11017, "Npc Djinn 02 Magic"],
    [11018, "Npc Djinn 02 Magic 02"],
    [11019, "Npc Djinn 02 Spawn"],
    [11020, "Npc Djinn 02 Teleport Idle Appear"],
    [11021, "Npc Djinn 02 Teleport Idle Disappear"],
    [11022, "Npc Djinn 02 Melee"],
    [11023, "Npc Djinn 02 Combo"],
    [11024, "Npc Djinn 02 Ending"],
    [11025, "Vfx Djinn Blue Magic Player Spotanim 01"],
    [11026, "Vfx Djinn Blue Magic Player Spotanim 01 Reverse"],
    [11027, "Vfx Djinn Blue Magic Projectile 01"],
    [11028, "Vfx Djinn Blue Magic Player Spotanim 02"],
    [11029, "Vfx Djinn Blue Ice Block Spawn 01"],
    [11030, "Vfx Djinn Blue Ice Block Idle 01"],
    [11031, "Vfx Djinn Blue Ice Block Idle 02"],
    [11032, "Vfx Djinn Blue Ice Block Cracking 01"],
    [11033, "Vfx Djinn Blue Ice Block Uncracked 01"],
    [11034, "Vfx Djinn Blue Ice Block Idle 03"],
    [11035, "Vfx Djinn Blue Ice Block Explode 01"],
    [11036, "Vfx Djinn Blue Magic Projectile 02"],
    [11037, "Vfx Djinn Blue Magic Impact 01"],
    [11038, "Vfx Djinn Ice Floor Spawn 01"],
    [11039, "Vfx Djinn Ice Floor Idle 01"],
    [11040, "Vfx Djinn Ice Floor Attack 01"],
    [11041, "Npc Bream 01 Swim"],
    [11042, "Human Largenet Looping"],
    [11043, "Grimy Lizard Walk"],
    [11044, "Grimy Lizard Ready"],
    [11045, "Grimy Lizard Melee"],
    [11046, "Grimy Lizard Death"],
    [11047, "Moss Lizard Ready"],
    [11048, "Moss Lizard Walk"],
    [11049, "Moss Lizard Attack"],
    [11050, "Moss Lizard Defend"],
    [11051, "Moss Lizard Death"],
    [11052, "Statue Icosahedron01 Shake"],
    [11053, "Statue Icosahedron01 Idle"],
    [11054, "Special Dual Macuahuitl Spotanim"],
    [11055, "Ice Shatter Special Attack"],
    [11056, "Special Spell Spear Spotanim"],
    [11057, "Human Atlatl Attack Ranged 01"],
    [11058, "Vfx Atlatl Projectile 01"],
    [11059, "Vfx Atlatl Impact 01"],
    [11060, "Human Special Atlatl 01"],
    [11061, "Vfx Human Atlatl Special Attack 01"],
    [11062, "Vfx Human Atlatl Special Attack Impact 01"],
    [11063, "Special Atlatl Spotanim 02"],
    [11064, "Special Atlatl Cast Spotanim 02"],
    [11065, "Pmoon Lizard Trap Trigger"],
    [11066, "Moss Lizard Trapped"],
    [11067, "Boxtrap Jerboa Catching"],
    [11068, "Boxtrap Jerboa Catching East"],
    [11069, "Boxtrap Jerboa Catching South"],
    [11070, "Boxtrap Jerboa Catching West"],
    [11071, "Boxtrap Jerboa Ready"],
    [11072, "Boxtrap Jerboa Failed"],
    [11073, "Jerboa Approach"],
    [11074, "Jerboa Backoff"],
    [11075, "Varlamore Thieving Search"],
    [11076, "Fountain Wall"],
    [11077, "Vm Patrol Route Workmen No Plank Ready"],
    [11078, "Fx Fire02 Idle"],
    [11079, "Fx Fire02 Spawn"],
    [11080, "Fx Fire02 Spawn Idle"],
    [11081, "Fx Fire02 Spawn Idle Delay 1"],
    [11082, "Fx Fire02 Spawn Idle Delay 2"],
    [11083, "Fx Fire02 Spawn Idle Delay 3"],
    [11084, "Fx Fire02 Spawn Idle Delay 4"],
    [11085, "Human Stake3"],
    [11086, "Milk Buffalo"],
    [11087, "Human Getoutbed Delayed"],
    [11088, "Human Getoutbed Left Delayed"],
    [11089, "Human Walk F Quick"],
    [11090, "Human Walk B Quick"],
    [11091, "Human Pickuptable Walkmerge Noheld"],
    [11092, "Human Ready Alt"],
    [11093, "Varrock Heavybag Defend Delayed"],
    [11094, "Human Herbing Vial Restart"],
    [11095, "Human Herbing Grind Restart"],
    [11096, "Human Fletching Huntingbolts Single"],
    [11097, "Human Fletching Huntingbolts Chisel"],
    [11098, "Human Fletching Huntingbolts Chisel Single"],
    [11099, "Human Cutting Restart"],
    [11100, "Human Fletching Single"],
    [11101, "Human Lockedchest Walkmerge"],
    [11102, "Human Pray Blessed Bone Shards 01"],
    [11103, "Human Pushup 01"],
    [11104, "Npc Harpy Eagle Flying Idle 01"],
    [11105, "Easter Big Bird Ready"],
    [11106, "Easter Big Bird Laying"],
    [11107, "Easter24 Bunny Walk"],
    [11108, "Easter24 Bunny Ready"],
    [11109, "Easter Egg Idle"],
    [11110, "Easter Egg Run"],
    [11111, "Easter Egg Spawn"],
    [11112, "Easter Egg Despawn"],
    [11113, "Easter24 Cart Travel"],
    [11114, "Easter24 Preach Seq"],
    [11115, "Easter24 Readbook"],
    [11116, "Easter24 Human Readbook Turnright"],
    [11117, "Easter24 Human Readbook Turnleft"],
    [11118, "Human Spellspear Run"],
    [11119, "Human Spellspear Stab"],
    [11120, "Human Spellspear Ready"],
    [11121, "Farming Trowel Shortdig"],
    [11122, "Human Quetzal Headpat"],
    [11123, "Npc Quetzal Headpat"],
    [11124, "Human Elder Maul Spec"],
    [11125, "Vfx Elder Maul Special"],
    [11126, "Spotanim Elder Maul Special Impact"],
    [11127, "Human Poh Build Elder Maul"],
    [11128, "Human Poh Build Elder Maul Ornament"],
    [11129, "Godwars Hammer Gong Elder Maul"],
    [11130, "Godwars Hammer Gong Elder Maul Ornament"],
    [11131, "Human Sitting Transition Standing"],
    [11132, "Vfx Human Scorching Bow Special Attack 01"],
    [11133, "Human Weapon Bow Scorched 01 Spec"],
    [11134, "Vfx Scorching Bow Projectile"],
    [11135, "Vfx Scorching Bow Spotanim"],
    [11136, "Vfx Scorching Bow End Spotanim"],
    [11137, "Vfx Burning Claws Spec 02"],
    [11138, "Human Weapon Emberlight 01 Spec"],
    [11139, "Vfx Emberlight Spec 02"],
    [11140, "Human Weapon Burning Claws 02 Spec"],
    [11141, "Vfx Ignite Staff"],
    [11142, "Human Crafting Bone Claws"],
    [11143, "Wgs Armadyl Guardian Human Death"],
    [11144, "Wgs Armadyl Guardian Human Sword Slash"],
    [11145, "Wgs Idria Human Castwave"],
    [11146, "Wgs Armadyl Guardian Human Weapon Bow Venator01 Shoot"],
    [11147, "Wgs Snapdragon Desk Seed Enriched Ready"],
    [11148, "Wgs Snapdragon Desk Seed Enriched"],
    [11149, "Wgs Shining Light On Seed Spotanim"],
    [11150, "Wgs Shining Light On Seed Projanim"],
    [11151, "Luc2 Brazier Rock Ready"],
    [11152, "Luc2 Brazier Rock"],
    [11153, "Luc2 Shattered Halberd Spotanim"],
    [11154, "Luc2 Shattered Whip Spotanim"],
    [11155, "Luc2 Smoking Ash"],
    [11156, "Luc2 Mechanical Stairs"],
    [11157, "Luc2 Mechanical Stairs Complete"],
    [11158, "Luc2 Movario Base Floorspikes Activate"],
    [11159, "Luc2 Counter Snapdragon Seed"],
    [11160, "Luc2 Chasm Cutscene"],
    [11161, "Luc2 Chasm Cutscene Reverse"],
    [11162, "Luc2 Ingrediants Spot"],
    [11163, "Luc2 Bedchest Multiloc Opening"],
    [11164, "Luc2 Stone Jas Energy"],
    [11165, "Luc2 Stone Jas Energy Player"],
    [11166, "Luc2 Fools Treasure"],
    [11167, "Wgs Potion Spot"],
    [11168, "Luc2 Movario Ticker"],
    [11169, "Luc2 Movario Ticker Stop"],
    [11170, "Ancient Axe Run"],
    [11171, "Specialattack Unleash"],
    [11172, "Luc2 Herb Statue Strength Init"],
    [11173, "Luc2 Herb Statue Strength Done"],
    [11174, "Luc2 Herb Statue Strength"],
    [11175, "Luc2 Herb Statue Defence Init"],
    [11176, "Luc2 Herb Statue Defence Done"],
    [11177, "Luc2 Herb Statue Defence"],
    [11178, "Luc2 Herb Statue Agility Init"],
    [11179, "Luc2 Herb Statue Agility Done"],
    [11180, "Luc2 Herb Statue Agility"],
    [11181, "Luc2 Herb Statue Attack Init"],
    [11182, "Luc2 Herb Statue Attack Done"],
    [11183, "Luc2 Herb Statue Attack"],
    [11184, "Luc2 Herb Statue Balance Init"],
    [11185, "Luc2 Herb Statue Balance Done"],
    [11186, "Luc2 Herb Statue Balance"],
    [11187, "Luc2 Herb Statue Combat Init"],
    [11188, "Luc2 Herb Statue Combat Done"],
    [11189, "Luc2 Herb Statue Combat"],
    [11190, "Luc2 Herb Statue Energy Init"],
    [11191, "Luc2 Herb Statue Energy Done"],
    [11192, "Luc2 Herb Statue Energy"],
    [11193, "Luc2 Herb Statue Fishing Init"],
    [11194, "Luc2 Herb Statue Fishing Done"],
    [11195, "Luc2 Herb Statue Fishing"],
    [11196, "Luc2 Herb Statue Hunting Init"],
    [11197, "Luc2 Herb Statue Hunting Done"],
    [11198, "Luc2 Herb Statue Hunting"],
    [11199, "Luc2 Herb Statue Magic Init"],
    [11200, "Luc2 Herb Statue Magic Done"],
    [11201, "Luc2 Herb Statue Magic"],
    [11202, "Luc2 Herb Statue Prayer Init"],
    [11203, "Luc2 Herb Statue Prayer Done"],
    [11204, "Luc2 Herb Statue Prayer"],
    [11205, "Luc2 Herb Statue Ranged Init"],
    [11206, "Luc2 Herb Statue Ranged Done"],
    [11207, "Luc2 Herb Statue Ranged"],
    [11208, "Luc2 Herb Statue Restore Init"],
    [11209, "Luc2 Herb Statue Restore Done"],
    [11210, "Luc2 Herb Statue Restore"],
    [11211, "Luc2 Movario Stair Machine"],
    [11212, "Luc2 Movario Stair Machine Stop"],
    [11213, "Luc2 Book Lever Out"],
    [11214, "Luc2 Book Lever Back"],
    [11215, "Luc2 Book Lever Full"],
    [11216, "Luc2 Hazelmere Crystal Map Spot"],
    [11217, "Luc2 Hazelmere Crystal Impact"],
    [11218, "Luc2 Hazelmere Incineration Spot"],
    [11219, "Luc2 Hazelmere Incinerated"],
    [11220, "Luc2 Mage To Ash Spot"],
    [11221, "Movario Darts Proj"],
    [11222, "Weapon Sword Osmumten03 Special"],
    [11223, "Luc2 Movario Dart Launch Spot"],
    [11224, "Luc2 Rope Sway Middle"],
    [11225, "Luc2 Rope Sway Top"],
    [11226, "Luc2 Stone Sinking"],
    [11227, "Luc2 Stone Of Jas Energy Forming"],
    [11228, "Luc2 Movario Door"],
    [11229, "Luc2 Movario Door Close"],
    [11230, "Luc2 Movario Back Door"],
    [11231, "Luc2 Movario Door Back Close"],
    [11232, "Wgs Broav Ready And Extra"],
    [11233, "Wgs Broav Ready Timer"],
    [11234, "Wgs Broav Walk"],
    [11235, "Wgs Broav Clothes Scent"],
    [11236, "Wgs Broav Point"],
    [11237, "Wgs Broav Pitfall"],
    [11238, "Wgs Player Gives Clothes"],
    [11239, "Vfx Weapon Sword Osmumten Special"],
    [11240, "Human Special Voidwaker"],
    [11241, "Luc2 Henge Sink"],
    [11242, "Luc2 Henge Rise"],
    [11243, "Luc2 Henge Risen"],
    [11244, "Luc2 Henge Puzzle Rising"],
    [11245, "Luc2 Henge Door Opening"],
    [11246, "Luc2 Brick"],
    [11247, "Luc2 Hazelmere Seed Spot"],
    [11248, "Luc2 Floorwire Corner"],
    [11249, "Luc2 Floorwire"],
    [11250, "Luc2 Flower Sprouting"],
    [11251, "Luc2 Jail Bar Electricity No Sound"],
    [11252, "Luc2 Potion Tray Drop Spotanim Part One"],
    [11253, "Luc2 Potion Tray Drop Spotanim Part Two"],
    [11254, "Di2 Fire Wall Torch"],
    [11255, "Di2 Fire Wall Torch Low"],
    [11256, "Di2 Fire"],
    [11257, "Di2 Fire Cooking Pot"],
    [11258, "Luc2 Guthix Flames"],
    [11259, "Luc2 Brazier Fire"],
    [11260, "Bountyhunter Cave Entry"],
    [11261, "Bountyhunter Cave Exit"],
    [11262, "Wgs Pick Lock"],
    [11263, "Wgs Player Inspect"],
    [11264, "Wgs Human Electrocuted"],
    [11265, "Wgs Player Pulls Book Out"],
    [11266, "Wgs Player Pushes Book Back"],
    [11267, "Wgs Player Coughs"],
    [11268, "Wgs Player Coughs Loop"],
    [11269, "Wgs Player Opens Bedchest"],
    [11270, "Wgs Player Revealing Bedchest"],
    [11271, "Wgs Player Walk Through Painting"],
    [11272, "Wgs Player Going Unconscious"],
    [11273, "Wgs Player Unconscious"],
    [11274, "Wgs Player Regaining Consciousness"],
    [11275, "Human Special02 Voidwaker"],
    [11276, "Wgs Hit By Darts"],
    [11277, "Daggerheld Puncture"],
    [11278, "Wgs Assassin Smokebomb"],
    [11279, "Wgs Old Druid Drop"],
    [11280, "Wgs Old Druid Drop Ready"],
    [11281, "Wgs Player Slipping Spy The Orb"],
    [11282, "Wgs Player Slipping Spy The Orb Part Two"],
    [11283, "Wgs Shining Light On Seed"],
    [11284, "Wgs Washerman Ready"],
    [11285, "Human Fall Loop"],
    [11286, "Human Getup From Slip"],
    [11287, "Wgs Surok Banging Prison Bars"],
    [11288, "Wgs Thaersk Drinks Potion"],
    [11289, "Wgs Heroic Bridge Jump"],
    [11290, "Wgs Heroic Climb Success One"],
    [11291, "Wgs Heroic Climb Success Two"],
    [11292, "Luc2 Chasm Cutscene Player"],
    [11293, "Luc2 Chasm Cutscene Player Light Spot"],
    [11294, "Luc2 Chasm Cutscene Player Light Spot Reverse"],
    [11295, "Luc2 Chasm Cutscene Player Reverse"],
    [11296, "Wgs Spy Ready"],
    [11297, "Wgs Spy Ready Female"],
    [11298, "Luc2 Moving A Rock"],
    [11299, "Luc2 Put Orb Into Cheek"],
    [11300, "Luc2 Taking Ingot Out Of Cheek"],
    [11301, "Luc2 Crawl Into Skull"],
    [11302, "Luc2 Crawl Ready"],
    [11303, "Luc2 Crawl"],
    [11304, "Luc2 Place Key From Crawl"],
    [11305, "Luc2 Place Key From Crawl Floor"],
    [11306, "Wgs Touch Cube"],
    [11307, "Wgs Silif Prison Injured"],
    [11308, "Luc2 Druid Spirit Fade"],
    [11309, "Luc2 Player Herb Statue Add"],
    [11310, "Luc2 Player Henge Remove"],
    [11311, "Luc2 Touching The Stone Of Jas"],
    [11312, "Luc2 Touching The Stone Of Jas Silent"],
    [11313, "Luc2 Human Axe Def With Sound"],
    [11314, "Luc2 Human Axe Hack With Sound"],
    [11315, "Wgs Elite Guard Mage Zapped"],
    [11316, "Luc2 Church Roof Jump"],
    [11317, "Wgs Hazelmere Teleport"],
    [11318, "Wgs Hazelmere Seed"],
    [11319, "Wgs Hazelmere Teleport In"],
    [11320, "Wgs Player Dive"],
    [11321, "Wgs Lucien Powering Up Spot"],
    [11322, "Bolt Impact Update"],
    [11323, "Luc2 Hazelmere Death"],
    [11324, "Luc2 Hazelmere Telescope View"],
    [11325, "Luc2 Hazelmere Telescope View To Ready"],
    [11326, "Luc2 Hazelmere Telescope Ready"],
    [11327, "Luc2 Hazelmere Conceal Telescope"],
    [11328, "Luc2 Hazelmere Telescope Spotanim"],
    [11329, "Wgs Hazelmere Teleport Spotanim"],
    [11330, "Wgs Hazelmere Teleport In Spotanim"],
    [11331, "Wgs Human Ko"],
    [11332, "Wgs Human Ko Idle"],
    [11333, "Wgs Hazelmere Crystalspell"],
    [11334, "Wgs Dark Squall Shapeshift Part01"],
    [11335, "Wgs Dark Squall Shapeshift Part02"],
    [11336, "Wgs Surok Hit"],
    [11337, "Wgs Surok Injured"],
    [11338, "Npc Balance Elemental Fire Transition Water01"],
    [11339, "Npc Balance Elemental Water Transition Air01"],
    [11340, "Npc Balance Elemental Water Idle01"],
    [11341, "Npc Balance Elemental Water Walk01"],
    [11342, "Npc Balance Elemental Water Attack01"],
    [11343, "Npc Balance Elemental Water Attack Special01"],
    [11344, "Npc Balance Elemental Fire Transition Air01"],
    [11345, "Npc Balance Elemental Air Transition Water01"],
    [11346, "Npc Balance Elemental Air Idle01"],
    [11347, "Npc Balance Elemental Air Walk01"],
    [11348, "Npc Balance Elemental Air Attack01"],
    [11349, "Npc Balance Elemental Air Attack Special01"],
    [11350, "Npc Balance Elemental Water Transition Fire01"],
    [11351, "Npc Balance Elemental Air Transition Fire01"],
    [11352, "Npc Balance Elemental Fire Idle01"],
    [11353, "Npc Balance Elemental Fire Walk01"],
    [11354, "Npc Balance Elemental Fire Attack01"],
    [11355, "Npc Balance Elemental Fire Attack Special01"],
    [11356, "Npc Balance Elemental Spawn01 Part01"],
    [11357, "Npc Balance Elemental Spawn01 Part02"],
    [11358, "Npc Balance Elemental Water Death Part01"],
    [11359, "Npc Balance Elemental Air Death Part01"],
    [11360, "Npc Balance Elemental Fire Death Part01"],
    [11361, "Npc Balance Elemental 02 Death Part02"],
    [11362, "Vfx Balance Elemental02 Spawn01 Part01"],
    [11363, "Vfx Balance Elemental02 Death Part02"],
    [11364, "Vfx Balance Elemental Attack Special01 Spotanim"],
    [11365, "Vfx Balance Elemental Attack Special01 Projanim"],
    [11366, "Vfx Balance Elemental Attack Special01 Impactanim"],
    [11367, "Vfx Balance Elemental Water Attack01 Spotanim"],
    [11368, "Vfx Balance Elemental Water Attack01 Projanim"],
    [11369, "Vfx Balance Elemental Water Attack01 Impactanim"],
    [11370, "Vfx Balance Elemental Fire Attack01 Projanim"],
    [11371, "Luc2 Skeleton Break Out Of Ground"],
    [11372, "Luc2 Four Armed Skeleton Break Out Of Ground"],
    [11373, "Luc2 Skeleton Defend"],
    [11374, "Luc2 Skeleton Ready"],
    [11375, "Luc2 Skeleton Walk"],
    [11376, "Luc2 Skeleton Attack"],
    [11377, "Luc2 Four Armed Skeleton Defend"],
    [11378, "Luc2 Four Armed Skeleton Ready"],
    [11379, "Luc2 Four Armed Skeleton Walk"],
    [11380, "Luc2 Four Armed Skeleton Attack"],
    [11381, "Luc2 Skeleton Unique Ready"],
    [11382, "Luc2 Skeleton Unique Walk"],
    [11383, "Luc2 Skeleton Unique Attack"],
    [11384, "Luc2 Skeleton Unique Defend"],
    [11385, "Luc2 Skeleton Death"],
    [11386, "Luc2 Skeleton Unique Death"],
    [11387, "Luc2 Undead Demon Explosion Fire"],
    [11388, "Luc2 Undead Demon Firey Balls"],
    [11389, "Luc2 Undead Demon Spare Ribs"],
    [11390, "Luc2 Undead Demon Walk"],
    [11391, "Luc2 Undead Demon Ready"],
    [11392, "Luc2 Undead Demon Melee"],
    [11393, "Luc2 Undead Demon Defend"],
    [11394, "Luc2 Undead Demon Death"],
    [11395, "Luc2 Undead Demon Summon"],
    [11396, "Luc2 Rib Bone Shard Spotanim"],
    [11397, "Luc2 Rib Bone Shard Projectile"],
    [11398, "Luc2 Undead Demon Swipe Spot"],
    [11399, "Luc2 Undead Demon Shield Spot"],
    [11400, "Luc2 Undead Demon Explosion Fire Spot"],
    [11401, "Luc2 Undead Demon Shield Restore Spot"],
    [11402, "Luc2 Undead Demon Summon Spotanim"],
    [11403, "Luc2 Undead Demon Death Spot"],
    [11404, "Luc2 Undead Demon Summon Spotanim Prototype"],
    [11405, "Luc2 Undead Demon Fireball Large Proj"],
    [11406, "Eyeglo Hazelmere Mind Meld Short"],
    [11407, "Eyeglo Mind Meld Player Short"],
    [11408, "Mahjarrat Attack Lightning05"],
    [11409, "Mahjarrat Attack Lightning05 Silent"],
    [11410, "Mahjarrat Attack Summon Undead05"],
    [11411, "Mahjarrat Power Surge05"],
    [11412, "Mahjarrat Defend 05"],
    [11413, "Vfx Mahjarrat Attack Lightning05 Spotanim"],
    [11414, "Vfx Mahjarrat Attack Summon Undead05 Spotanim"],
    [11415, "Vfx Mahjarrat Attack Summon Undead05 Projanim"],
    [11416, "Mahjarrat Point05 Start"],
    [11417, "Mahjarrat Point05 Idle"],
    [11418, "Mahjarrat Point05 End"],
    [11419, "Human Death Idle"],
    [11420, "Human Stamp Delayanim"],
    [11421, "Smokepuff Quick"],
    [11422, "Surge Casting Fast"],
    [11423, "Human Caststrike Staff Walkmerge"],
    [11424, "Human Castconfuse Walkmerge"],
    [11425, "Human Castconfuse Staff Walkmerge"],
    [11426, "Human Castweaken Walkmerge"],
    [11427, "Human Castweaken Staff Walkmerge"],
    [11428, "Human Castcurse Walkmerge"],
    [11429, "Human Castwave Walkmerge"],
    [11430, "Human Castwave Staff Walkmerge"],
    [11431, "Human Cast Surge Fast"],
    [11432, "Human Bone Sacrifice Delayanim"],
    [11433, "Dragonkin Stasis 00"],
    [11434, "Dragonkin Stasis 01"],
    [11435, "Dragonkin Stasis 02"],
    [11436, "Dragonkin Stasis 02 Start"],
    [11437, "Dragonkin Stasis Broken 03"],
    [11438, "Vfx Skeleton Thrall Spawn 01"],
    [11439, "Wgs Hero Stand"],
    [11440, "Human Bone Sacrifice Walkmerge"],
    [11441, "Human Fall And Get Up"],
    [11442, "Spotanim Scorching Bow Impact"],
    [11443, "Fx Cycle Bow"],
    [11444, "Human Deadman Armageddon Reward Teleport 01"],
    [11445, "Vfx Dm Armageddon Teleport 01"],
    [11446, "Dmm2024 Home Teleport Human 1"],
    [11447, "Dmm2024 Home Teleport Human 2"],
    [11448, "Dmm2024 Home Teleport Human 3"],
    [11449, "Dmm2024 Home Teleport Human 4"],
    [11450, "Dmm2024 Home Teleport Human 5"],
    [11451, "Vfx Dmm2024 Home Teleport 01"],
    [11452, "Vfx Dmm2024 Home Teleport 02"],
    [11453, "Vfx Dmm2024 Home Teleport 03"],
    [11454, "Vfx Dmm2024 Home Teleport 04"],
    [11455, "Vfx Dmm2024 Home Teleport 05"],
    [11456, "Wgs Surok Surge Fire01"],
    [11457, "Wgs Surok Surge Wind01"],
    [11458, "Wgs Surok Surge Water01"],
    [11459, "Wgs Surok Surge Earth01"],
    [11460, "Wgs Gas Cloud 01"],
    [11461, "Wgs Gas Cloud 02"],
    [11462, "Wgs Vfx Human Electrocuted 01"],
    [11463, "Vfx Voidwaker02 Special"],
    [11464, "Vfx Voidwaker02 Impact"],
    [11465, "Xbows Human Fire And Reload No Stall"],
    [11466, "Barrow Dharok Run"],
    [11467, "Weapon Morrigans Javelin Special01"],
    [11468, "Weapon Morrigans Throwingaxe Special01"],
    [11469, "Weapon Morrigans Javelin Spotanim"],
    [11470, "Weapon Morrigans Taxe Spotanim"],
    [11471, "Weapon Morrigans Taxe Projanim"],
    [11472, "Weapon Morrigans Javelin Projanim"],
    [11473, "Npc Araxxor 01 Idle 01"],
    [11474, "Npc Araxxor 01 Walk 01"],
    [11475, "Npc Araxxor 01 Run 01"],
    [11476, "Npc Araxxor 01 Attack Ranged 01"],
    [11477, "Npc Araxxor 01 Attack Acid Leak 01"],
    [11478, "Npc Araxxor 01 Attack Acid Spray 01"],
    [11479, "Npc Araxxor 01 Attack Magic 01"],
    [11480, "Npc Araxxor 01 Attack Melee 01"],
    [11481, "Npc Araxxor 01 Death 01"],
    [11482, "Npc Araxxor 01 Spawn 01"],
    [11483, "Npc Araxxor 01 Attack Slow Melee 01"],
    [11484, "Npc Araxxor 01 Attack Slow Ranged 01"],
    [11485, "Npc Araxxor 01 Death Loop 01"],
    [11486, "Npc Araxxor 01 Death Loot 01"],
    [11487, "Npc Araxxor 01 Attack Melee Enraged 01"],
    [11488, "Npc Araxxor 01 Enrage Transition 01"],
    [11489, "Npc Araxxor 01 Enrage Transition 02"],
    [11490, "Araxxor Venom Drip"],
    [11491, "Araxxor Acid Cannon Projectile"],
    [11492, "Araxxor Acid Cannon Explode"],
    [11493, "Npc Araxxor 01 Acid Cannon 01"],
    [11494, "Npc Araxyte02 Idle"],
    [11495, "Npc Araxyte02 Walk"],
    [11496, "Npc Araxyte02 Walk Fast"],
    [11497, "Npc Araxyte02 Attack"],
    [11498, "Npc Araxyte Acidic 01 Attack"],
    [11499, "Npc Araxyte Acidic 02 Attack"],
    [11500, "Npc Araxyte Mirror Back 01 Attack"],
    [11501, "Npc Araxyte Mirror Back 02 Attack"],
    [11502, "Npc Araxyte02 Death"],
    [11503, "Npc Araxyte02 Hatch"],
    [11504, "Npc Araxyte Explode"],
    [11505, "Npc Explosive Araxyte Spot"],
    [11506, "Egg Araxyte Spawn 01"],
    [11507, "Egg Araxyte Idle 01"],
    [11508, "Egg Araxyte Death 01"],
    [11509, "Egg Araxyte Hatch 01"],
    [11510, "Npc Araxyte Mirror Back Death"],
    [11511, "Human Aranea Boots Wade"],
    [11512, "Human Craft Rancor"],
    [11513, "Human Halberd Virulence 01"],
    [11514, "Human Halberd Virulence 02"],
    [11515, "Human Halberd Virulence 03"],
    [11516, "Vfx Noxious Halberd Spec"],
    [11517, "Human Halberd Virulence 04"],
    [11518, "Human Craft Rancor 02"],
    [11519, "Vfx Human Craft Rancor 01"],
    [11520, "Vfx Human Craft Rancor Start"],
    [11521, "Vfx Human Craft Rancor End"],
    [11522, "Human Craft Rancor Start"],
    [11523, "Human Craft Rancor End"],
    [11524, "Human Fletching Noxious Halberd"],
    [11525, "Ii Human Walk Thru Wheat Fastest"],
    [11526, "Emote Bow Walkmerge"],
    [11527, "Amoxliatl Spawn"],
    [11528, "Amoxliatl Idle"],
    [11529, "Amoxliatl Walk"],
    [11530, "Amoxliatl Attack"],
    [11531, "Amoxliatl Point"],
    [11532, "Amoxliatl Death"],
    [11533, "Amoxliatl Summon"],
    [11534, "Amoxliatl Ice Destroy"],
    [11535, "Amoxliatl Pet Attack"],
    [11536, "Amoxliatl Unstable Ice Spawn"],
    [11537, "Vfx Amoxliatl Ice Block Projectile Impact 01"],
    [11538, "Vfx Amoxliatl Ice Block Projectile 01"],
    [11539, "Vfx Amoxliatl Crack Appear"],
    [11540, "Vfx Amoxliatl Crack Disappear"],
    [11541, "Vfx Amoxliatl Ice Floor Spawn 01"],
    [11542, "Vfx Amoxliatl Ice Floor Despawn 01"],
    [11543, "Vfx Amoxliatl Ice Floor Combined 01"],
    [11544, "Vfx Amoxliatl Crack Appear 02"],
    [11545, "Vfx Amoxliatl Crack Appear 03"],
    [11546, "Vfx Amoxliatl Crack Appear 04"],
    [11547, "Vfx Amoxliatl Crack Disappear 02"],
    [11548, "Vfx Amoxliatl Crack Disappear 03"],
    [11549, "Vfx Amoxliatl Crack Disappear 04"],
    [11550, "Vfx Amoxliatl Ice Floor Single"],
    [11551, "Tapoyauik Traverse Wall Fail R"],
    [11552, "Tapoyauik Traverse Wall Fail L"],
    [11553, "Vmq3 Cultist Hit"],
    [11554, "Vmq3 Take Knee"],
    [11555, "Vmq3 Stand"],
    [11556, "Vmq3 Cultist Special"],
    [11557, "Vmq3 Tower Trial 4 Boss Prayer"],
    [11558, "Vmq3 Tower Trial 4 Boss Injured"],
    [11559, "Vmq3 Tower Trial 4 Boss Injured Done"],
    [11560, "Vmq3 Entrance Unlock"],
    [11561, "Vmq3 Injured Walk"],
    [11562, "Vmq3 Spike Trap Idle"],
    [11563, "Vmq3 Spike Trap Activate"],
    [11564, "Vmq3 Spike Trap Spear"],
    [11565, "Vmq3 Spike Trap Spear02"],
    [11566, "Frost Nagua Slayer Basic"],
    [11567, "Frost Nagua Slayer Basic Louder"],
    [11568, "Frost Nagua Slayer Special"],
    [11569, "Frost Nagua Slayer Death"],
    [11570, "Frost Nagua Slayer Spawn"],
    [11571, "Frost Nagua Slayer Spawn Louder"],
    [11572, "Human Butler Idle Female 01"],
    [11573, "Human Butler Idle Male 01"],
    [11574, "Human Butler Walk Female 01"],
    [11575, "Human Butler Walk Male 01"],
    [11576, "Human Lead Actor Dead 01"],
    [11577, "Human Butler Run Male 01"],
    [11578, "Human Butler Run Female 01"],
    [11579, "Pog Seed Broken"],
    [11580, "Human Longcrawl Priority"],
    [11581, "Mag Minotaur Idle"],
    [11582, "Mag Minotaur Walk"],
    [11583, "Mag Minotaur Run"],
    [11584, "Mag Minotaur Melee"],
    [11585, "Mag Minotaur Magic"],
    [11586, "Mag Minotaur Ramp"],
    [11587, "Mag Minotaur Death"],
    [11588, "Vfx Minotaur Roar"],
    [11589, "Human Knockdown Loop Nodelay"],
    [11590, "Barrel Interaction"],
    [11591, "Human Wine Jug Pour"],
    [11592, "Wine Jug Splash"],
    [11593, "Human Walk B 2loops"],
    [11594, "Fx Beam Huey"],
    [11595, "Human Lockedhighcupboard Merge"],
    [11596, "Spotanim Zebak Attack Roar Short"],
    [11597, "Npc Porcupine Combat Melee"],
    [11598, "Npc Porcupine Combat Death"],
    [11599, "Npc Porcupine Combat Spawn"],
    [11600, "Human Aldarin Worker 02 Walk"],
    [11601, "Human Aldarin Worker 02 Idle"],
    [11602, "Human Aldarin Worker 02 Wobblewalk"],
    [11603, "Machinery Alchemy01 Mill01 Idle01"],
    [11604, "Human Alchemy01 Mill01 Interact01"],
    [11605, "Human Alchemy01 Hopper01 Interact01"],
    [11606, "Machinery Alchemy01 Mixer Clear Idle01"],
    [11607, "Machinery Alchemy01 Mixer Clear To Blue01"],
    [11608, "Machinery Alchemy01 Mixer Clear To Red01"],
    [11609, "Machinery Alchemy01 Mixer Clear To Green01"],
    [11610, "Machinery Alchemy01 Mixer Blue To Clear01"],
    [11611, "Machinery Alchemy01 Mixer Blue To Red01"],
    [11612, "Machinery Alchemy01 Mixer Blue To Green01"],
    [11613, "Machinery Alchemy01 Mixer Red To Clear01"],
    [11614, "Machinery Alchemy01 Mixer Red To Blue01"],
    [11615, "Machinery Alchemy01 Mixer Red To Green01"],
    [11616, "Machinery Alchemy01 Mixer Green To Clear01"],
    [11617, "Machinery Alchemy01 Mixer Green To Blue01"],
    [11618, "Machinery Alchemy01 Mixer Green To Red01"],
    [11619, "Human Alchemy01 Lever01 Interact01"],
    [11620, "Machinery Alchemy01 Lever01 Idle01"],
    [11621, "Machinery Alchemy01 Lever02 Idle01"],
    [11622, "Machinery Alchemy01 Lever03 Idle01"],
    [11623, "Machinery Alchemy01 Lever01 Interact01"],
    [11624, "Machinery Alchemy01 Lever02 Interact01"],
    [11625, "Machinery Alchemy01 Lever03 Interact01"],
    [11626, "Machinery Alchemy01 Conveyor01 Idle01"],
    [11627, "Machinery Alchemy01 Vessel01 Empty Idle01"],
    [11628, "Machinery Alchemy01 Vessel01 Filling01"],
    [11629, "Machinery Alchemy01 Vessel01 Full Idle01"],
    [11630, "Machinery Alchemy01 Vessel01 Emptying01"],
    [11631, "Machinery Alchemy01 Agitator01 Idle01"],
    [11632, "Machinery Alchemy01 Agitator01 Idle02"],
    [11633, "Machinery Alchemy01 Agitator01 Interact01"],
    [11634, "Human Machinery Alchemy01 Agitator01 Interact01"],
    [11635, "Vfx Machinery Alchemy01 Agitator01"],
    [11636, "Machinery Alchemy01 Alembic01 Idle01"],
    [11637, "Machinery Alchemy01 Alembic01 Idle02"],
    [11638, "Machinery Alchemy01 Alembic01 Interact01"],
    [11639, "Human Machinery Alchemy01 Alembic01 Interact01"],
    [11640, "Vfx Machinery Alchemy01 Alembic01"],
    [11641, "Machinery Alchemy01 Retort01 Idle01"],
    [11642, "Machinery Alchemy01 Retort01 Idle02"],
    [11643, "Machinery Alchemy01 Retort01 Interact01"],
    [11644, "Human Machinery Alchemy01 Retort01 Interact01"],
    [11645, "Prepot Device Drink Full"],
    [11646, "Human Grape Stomp"],
    [11647, "Grape Stomp Jug"],
    [11648, "Varlamore Wyrm Agility Longjump"],
    [11649, "Wyrm Agility Zipline Walk"],
    [11650, "Wyrm Agility Zipline On"],
    [11651, "Wyrm Agility Zipline Off"],
    [11652, "Wyrm Agility Zipline Ready"],
    [11653, "Wyrm Agility Ledge Walk"],
    [11654, "Wyrm Agility Ledge Ready"],
    [11655, "Wyrm Agility Ledge On"],
    [11656, "Wyrm Agility Ledge Off"],
    [11657, "Wyrm Agility Longjump"],
    [11658, "Wyrm Agility Shortjump"],
    [11659, "Wyrm Agility Zipline Cape Drag"],
    [11660, "Wyrm Agility Termite Idle"],
    [11661, "Wyrm Agility Termite Despawn"],
    [11662, "Bone Squirrel Idle"],
    [11663, "Bone Squirrel Hop"],
    [11664, "Bone Squirrel Attack"],
    [11665, "Wyrm Agility Tightrope Wobble"],
    [11666, "Wyrm Agility Zipline Jump"],
    [11667, "Wyrm Agility Knockdown Loop"],
    [11668, "Huey Idle"],
    [11669, "Huey Attack Melee"],
    [11670, "Huey Attack Range"],
    [11671, "Huey Attack Magic"],
    [11672, "Huey Shield Idle"],
    [11673, "Huey Shield Attack Melee"],
    [11674, "Huey Shield Attack Range"],
    [11675, "Huey Shield Attack Magic"],
    [11676, "Huey Shield Activation"],
    [11677, "Huey Screech"],
    [11678, "Huey Screech Reset"],
    [11679, "Huey Knockout"],
    [11680, "Huey Knockout Idle"],
    [11681, "Huey Awaken"],
    [11682, "Huey Awaken Reset"],
    [11683, "Huey Body Spawn"],
    [11684, "Huey Body Spawn Diag"],
    [11685, "Huey Body Idle"],
    [11686, "Huey Body Idle Diag"],
    [11687, "Huey Body Death"],
    [11688, "Huey Body Death Diag"],
    [11689, "Huey Body Death Idle"],
    [11690, "Huey Body Death Diag Idle"],
    [11691, "Pillar Zema01 Prayer01 Phase"],
    [11692, "Pillar Zema01 Prayer01 Phase Empty"],
    [11693, "Pillar Zema01 Prayer01 Phase 1"],
    [11694, "Pillar Zema01 Prayer01 Phase 2"],
    [11695, "Pillar Zema01 Prayer01 Phase 3"],
    [11696, "Pillar Zema01 Prayer01 Phase 4"],
    [11697, "Pillar Zema01 Prayer01 Phase 5"],
    [11698, "Npc Dwarf Summon Orb"],
    [11699, "Npc Dwarf Summon Orb End"],
    [11700, "Huey P2 Barrier Transition"],
    [11701, "Huey P2 Barrier Idle"],
    [11702, "Huey P2 Barrier Transition Start"],
    [11703, "Huey P2 Barrier Transition End"],
    [11704, "Huey P2 Barrier Transition End Idle"],
    [11705, "Huey P2 Barrier Idle 01"],
    [11706, "Huey P2 Barrier Damage 01"],
    [11707, "Huey P2 Barrier Respawn 01"],
    [11708, "Vfx Huey Attack Melee Spotanim 01"],
    [11709, "Vfx Huey Attack Melee Projanim 01"],
    [11710, "Vfx Huey Attack Melee Impactanim 01"],
    [11711, "Vfx Huey Attack Melee Impactanim 02"],
    [11712, "Vfx Huey Attack Magic Spotanim 01"],
    [11713, "Vfx Huey Attack Magic Projanim 01"],
    [11714, "Vfx Huey Attack Magic Impactanim 01"],
    [11715, "Vfx Huey Attack Magic Impactanim 02"],
    [11716, "Vfx Huey Attack Ranged Spotanim 01"],
    [11717, "Vfx Huey Attack Ranged Projanim 01"],
    [11718, "Vfx Huey Attack Ranged Impactanim 01"],
    [11719, "Vfx Huey Attack Ranged Impactanim 02"],
    [11720, "Npc Huey Tail Appear 01"],
    [11721, "Npc Huey Tail Disappear 01"],
    [11722, "Npc Huey Tail Idle 01"],
    [11723, "Npc Huey Tail Break 01"],
    [11724, "Vfx Huey Tail Slam Shockwave"],
    [11725, "Vfx Huey Tail Slam Shockwave Diag"],
    [11726, "Vfx Huey Tail Slam Shockwave Second Layer"],
    [11727, "Vfx Huey Tail Slam Shockwave Diag Second Layer"],
    [11728, "Vfx Huey Tail Slam Shockwave Impact"],
    [11729, "Vfx Huey Tail Slam Shockwave Impact Diag"],
    [11730, "Vfx Hueycoatl Prayer 01"],
    [11731, "Vfx Hueycoatl Prayer 02"],
    [11732, "Npc Hueycoatl Pet Idle 01"],
    [11733, "Npc Hueycoatl Pet Walk 01"],
    [11734, "Npc Hueycoatl Pet Attack 01"],
    [11735, "Human Cooking Loop"],
    [11736, "Human Unarmedpunch Quick"],
    [11737, "Human Unarmedkick Quick"],
    [11738, "Human Unarmed Def Long"],
    [11739, "Brewing Pour Water"],
    [11740, "Brewing Fill Keg"],
    [11741, "Brewing Fill Glass"],
    [11742, "Brewing Turn Valve"],
    [11743, "Brewing Add Ingredient"],
    [11744, "Human Spinningwheel Walkmerge"],
    [11745, "Human Fishing Casting Npc"],
    [11746, "Npc Minotaur Boss Walk Fast"],
    [11747, "Npc Minotaur Boss Attack Melee Louder"],
    [11748, "Npc Minotaur Boss Death Louder"],
    [11749, "Urn Search Reverse"],
    [11750, "League Trophy Glint Spot Silent"],
    [11751, "Raccoon Idle Slow"],
    [11752, "Raccoon Walk Slow"],
    [11753, "Dog Wolf Walk Slow"],
    [11754, "Wbr Vention Hellhound Death"],
    [11755, "Wbr Vention Hellhound Defend"],
    [11756, "Wbr Vention Hellhound Attack"],
    [11757, "Bird Flying Attack Merge"],
    [11758, "Picking Mid Shorter"],
    [11759, "Hw24 Marika Throw"],
    [11760, "Human Throw Pumpkin Beige"],
    [11761, "Human Throw End"],
    [11762, "Human Throw Pumpkin White"],
    [11763, "Human Throw Pumpkin Yellow"],
    [11764, "Human Throw Pumpkin Orange"],
    [11765, "Human Throw Pumpkin Red"],
    [11766, "Human Throw Pumpkin Darkgreen"],
    [11767, "Human Throw Pumpkin Powdergrey"],
    [11768, "Hw24 Carve Pumpkin"],
    [11769, "Hw24 Crow Group Land"],
    [11770, "Hw24 Crow Group Takeoff"],
    [11771, "Hw24 Crow Group Idle"],
    [11772, "Hw24 Crow Idle"],
    [11773, "Hw24 Crow Launch"],
    [11774, "Hw24 Cat Spawn"],
    [11775, "Hw24 Cat Despawn"],
    [11776, "Luc2 Undead Accuracy Debuff"],
    [11777, "Mahjarrat Zemouregal Elias Bind 01"],
    [11778, "Mahjarrat Zemouregal Elias Bind Impactanim 01"],
    [11779, "Mahjarrat Zemouregal Elias Bind Impactanim 02"],
    [11780, "Mom2 Scarab Ready"],
    [11781, "Mom2 Scarab Attack"],
    [11782, "Mom2 Scarab Defend"],
    [11783, "Mom2 Scarab Death"],
    [11784, "Mom2 Scarab Walk"],
    [11785, "Coa Arrav Throwaxe"],
    [11786, "Coa Arrav Catchaxe"],
    [11787, "Coa Arrav Catchaxe Back"],
    [11788, "Coa Tumeken Fire"],
    [11789, "Coa Grapple Start"],
    [11790, "Coa Grapple Cross"],
    [11791, "Coa Grapple Drop"],
    [11792, "Coa Elias Bind 01"],
    [11793, "Coa Elias Bind Spotanim 01"],
    [11794, "Coa Arrav Axe Projanim 01"],
    [11795, "Coa Arrav Axe Projanim 02"],
    [11796, "Coa Arrav Axe Spotanim 01"],
    [11797, "Coa Zombie Spawn"],
    [11798, "Sharathteerk Attack Magic 02"],
    [11799, "Sharathteerk Attack Summon 01"],
    [11800, "Sharathteerk Attack Summon 01 Spotanim"],
    [11801, "Sharathteerk Attack Summon 01 Impactanim"],
    [11802, "Sharathteerk Elias Bind 01"],
    [11803, "Sharathteerk Elias Bind Impactanim 01"],
    [11804, "Sharathteerk Elias Bind Impactanim 02"],
    [11805, "Human Monkeybars Walk Long"],
    [11806, "Human Killerwatt Electricshock Long"],
    [11807, "Human Killerwatt Electricshock Merge"],
    [11808, "Human Killerwatt Electricshock Long Merge"],
    [11809, "Tol Homonculus Magic Spotanim Quick"],
    [11810, "Vfx Khopesh Lightning Extra"],
    [11811, "Vfx Khopesh Lightning Impact"],
    [11812, "Human Special Khopesh"],
    [11813, "Kalphite Queen Ranged Attack Dupe"],
    [11814, "Kalphite Lightning Dupe"],
    [11815, "Human Woodcrafting Axe Trailblazer"],
    [11816, "Human Woodcrafting Axe Trailblazer Reloaded"],
    [11817, "Human Woodcrafting Axe Trailblazer Reloaded No Infernal"],
    [11818, "Brut Human Canoeing Carve Trailblazer Axe"],
    [11819, "Brut Human Canoeing Carve Trailblazer Reloaded Axe"],
    [11820, "Brut Human Canoeing Carve Trailblazer Reloaded Axe No Infernal"],
    [11821, "Rockknocker Trailblazer"],
    [11822, "Rockknocker Trailblazer Reloaded"],
    [11823, "Fishstabber Trailblazer"],
    [11824, "Fishstabber Trailblazer Reloaded"],
    [11825, "Human Mining Trailblazer Pickaxe Wall"],
    [11826, "Human Mining Trailblazer Reloaded Pickaxe Wall"],
    [11827, "Human Mining Trailblazer Reloaded Pickaxe No Infernal Wall"],
    [11828, "Sang Mining Wall Trailblazer Pickaxe"],
    [11829, "Sang Mining Wall Trailblazer Reloaded Pickaxe"],
    [11830, "Sang Mining Wall Trailblazer Reloaded Pickaxe No Infernal"],
    [11831, "Human Mining Trailblazer Pickaxe"],
    [11832, "Human Mining Trailblazer Reloaded Pickaxe"],
    [11833, "Human Mining Trailblazer Reloaded Pickaxe No Infernal"],
    [11834, "Human Mining Het Trailblazer Pickaxe"],
    [11835, "Human Mining Het Trailblazer Reloaded Pickaxe"],
    [11836, "Human Mining Het Trailblazer Reloaded Pickaxe No Infernal"],
    [11837, "Human Mining Trailblazer Pickaxe Noreachforward"],
    [11838, "Human Mining Trailblazer Reloaded Pickaxe Noreachforward"],
    [11839, "Human Mining Trailblazer Reloaded Pickaxe No Infernal Noreachforward"],
    [11840, "Human Mining Zalcano Trailblazer Pickaxe"],
    [11841, "Human Mining Zalcano Trailblazer Reloaded Pickaxe"],
    [11842, "Human Mining Zalcano Trailblazer Reloaded Pickaxe No Infernal"],
    [11843, "Gg Projectile Lightning Fast"],
    [11844, "Gg Projectile Lightning Enraged Start"],
    [11845, "Gg Projectile Lightning Enraged Middle"],
    [11846, "Gg Projectile Lightning Enraged End"],
    [11847, "Smouderstone Recharge Trailblazer Axe"],
    [11848, "Smouderstone Recharge Trailblazer Reloaded Axe"],
    [11849, "Smouderstone Recharge Trailblazer Reloaded Pickaxe"],
    [11850, "Smouderstone Recharge Trailblazer Pickaxe"],
    [11851, "Smouderstone Recharge Trailblazer Harpoon"],
    [11852, "Smouderstone Recharge Trailblazer Reloaded Harpoon"],
    [11853, "Lore Lust Devil Spawn"],
    [11854, "Lore Dust Devil Attack Special 01"],
    [11855, "Lore Dust Devil Attack Special 02"],
    [11856, "Vfx Lore Dust Devil Spawn Spotanim"],
    [11857, "Vfx Lore Dust Devil Attack Ranged Projanim"],
    [11858, "Vfx Lore Dust Devil Attack Ranged Impactanim"],
    [11859, "Vfx Lore Dust Devil Attack Special Projanim"],
    [11860, "Vfx Lore Dust Devil Attack Special Impactanim"],
    [11861, "Vfx Lore Dust Devil Attack Special Player Death 01"],
    [11862, "Vfx Smoke Devil Pool Spawn"],
    [11863, "Vfx Smoke Devil Pool Idle 01"],
    [11864, "Vfx Smoke Devil Pool Idle 02"],
    [11865, "Vfx Smoke Devil Pool Despawn"],
    [11866, "Vfx Smoke Devil Pool Shield"],
    [11867, "Human Harpoon Trailblazer Reloaded"],
    [11868, "Human Harpoon Trailblazer Reloaded No Infernal"],
    [11869, "Hunllef Attack Transition Magic Lowprio"],
    [11870, "Hunllef Attack Transition Ranged Lowprio"],
    [11871, "Human Trawler Hack Axe Trailblazer"],
    [11872, "Human Trawler Hack Axe Trailblazer Reloaded"],
    [11873, "Human Trawler Hack Axe Trailblazer Reloaded No Infernal"],
    [11874, "Home Teleport Echoes Full"],
    [11875, "Home Teleport Human Echoes 1"],
    [11876, "Home Teleport Human Echoes 2"],
    [11877, "Home Teleport Human Echoes 3"],
    [11878, "Home Teleport Human Echoes 4"],
    [11879, "Home Teleport Human Echoes 5"],
    [11880, "Leagues 5 Teleport Vfx"],
    [11881, "Leagues 5 Teleport Vfx 01"],
    [11882, "Leagues 5 Teleport Vfx 02"],
    [11883, "Leagues 5 Teleport Vfx 03"],
    [11884, "Leagues 5 Teleport Vfx 04"],
    [11885, "Leagues 5 Teleport Vfx 05"],
    [11886, "League 5 Home Teleport Scroll Read"],
    [11887, "League 5 Npc Contact Scroll Read"],
    [11888, "The Godsword Special Trail 1"],
    [11889, "The Godsword Trail 2"],
    [11890, "The Godsword Trail 3"],
    [11891, "The Godsword Trail 4"],
    [11892, "The Godsword Trail 5"],
    [11893, "The Godsword Special Attack"],
    [11894, "The Godsword Special Attack Part 1"],
    [11895, "The Godsword Special Attack Part 2"],
    [11896, "The Godsword Special Attack Part 3"],
    [11897, "The Godsword Special Attack Part 4"],
    [11898, "The Godsword Special Attack Part 5"],
    [11899, "Tangled Lizard Charge"],
    [11900, "League 5 Death Player Longer01"],
    [11901, "Vfx League 05 Echo Trail Longer Death"],
    [11902, "League 5 Death Player 01"],
    [11903, "Vfx League 05 Echo Trail Death"],
    [11904, "League 5 Npc Contact"],
    [11905, "League 5 Npc Contact Spot"],
    [11906, "Human Case01 Open"],
    [11907, "Human Case01 Idle"],
    [11908, "Human Case01 Idle Kingdom01"],
    [11909, "Human Case01 Close"],
    [11910, "Animated Case01 Open"],
    [11911, "Animated Case01 Idle"],
    [11912, "Animated Case01 Close"],
    [11913, "Leagues 5 Godsword Special"],
    [11914, "Leagues 5 Godsword Special Vfx"],
    [11915, "Herspray Attack"],
    [11916, "Herspray Walk"],
    [11917, "Herspray Ready"],
    [11918, "Hespori Seed Proj"],
    [11919, "Herspori Seed Start Spot"],
    [11920, "League05 Guardian Attack Magic 01"],
    [11921, "League05 Guardian Attack Magic Spotanim 01"],
    [11922, "League05 Guardian Attack Magic Projanim 01"],
    [11923, "League05 Guardian Attack Magic Impactanim 01"],
    [11924, "League 5 Melee Mastery Proj"],
    [11925, "League 5 Melee Mastery Proj Left"],
    [11926, "League 5 Melee Mastery Proj Right"],
    [11927, "League 5 Spear Shield Ready"],
    [11928, "League 5 Spear Shield Walk"],
    [11929, "League 5 Spear Shield Run"],
    [11930, "League 5 Spear Shield Block"],
    [11931, "League 5 Spear Shield Stab"],
    [11932, "League 5 Spear Shield Slash"],
    [11933, "League 5 Spear Shield Special"],
    [11934, "League 5 Spear Shield Special Vfx"],
    [11935, "League 5 Khopesh Ready"],
    [11936, "League 5 Khopesh Walk F"],
    [11937, "League 5 Khopesh Run F"],
    [11938, "Drygore Blowpipe Attack"],
    [11939, "Human Woodcutting Trailblazer Reloaded Axe"],
    [11940, "Human Woodcutting Trailblazer Reloaded Axe No Infernal"],
    [11941, "League 5 Death Scroll Read"],
    [11942, "Human Weapon Staff Book01 Ready"],
    [11943, "Human Weapon Staff Book01 Walk"],
    [11944, "Human Weapon Staff Book01 Run"],
    [11945, "Fire Minion Idle01"],
    [11946, "Fire Minion Walk01"],
    [11947, "Fire Minion Attack01"],
    [11948, "Ice Minion Idle01"],
    [11949, "Ice Minion Walk01"],
    [11950, "Ice Minion Attack01"],
    [11951, "Ice Minion Death01"],
    [11952, "Ice Minion Death Spotanim"],
    [11953, "Ice Minion Spawn Spotanim"],
    [11954, "Ice Minion Spawn01"],
    [11955, "Fire Minion Spawn Spotanim"],
    [11956, "Fire Minion Spawn01"],
    [11957, "Fire Minion Death01"],
    [11958, "Fire Minion Death Spotanim"],
    [11959, "Ice Minion Explode01"],
    [11960, "Ice Minion Explode Spotanim"],
    [11961, "Fire Minion Explode01"],
    [11962, "Fire Minion Explode Spotanim"],
    [11963, "Ice Giant Eldric King Spawn01"],
    [11964, "Loc Ice Giant Eldric King Spawn01 Floor01"],
    [11965, "Loc Ice Giant Eldric King Spawn01 Floor02"],
    [11966, "Fire Giant Branda Queen Spawn01"],
    [11967, "Loc Fire Giant Branda Queen Spawn01 Floor01"],
    [11968, "Loc Fire Giant Branda Queen Spawn01 Floor02"],
    [11969, "Ice Giant Eldric King Idle01"],
    [11970, "Fire Giant Branda Queen Idle01"],
    [11971, "Ice Giant Eldric King Walk01"],
    [11972, "Fire Giant Branda Queen Walk01"],
    [11973, "Ice Giant Eldric King Attack Melee01"],
    [11974, "Fire Giant Branda Queen Attack Melee01"],
    [11975, "Ice Giant Eldric King Attack Summon01"],
    [11976, "Fire Giant Branda Queen Attack Summon01"],
    [11977, "Ice Giant Eldric King Attack Summon02"],
    [11978, "Fire Giant Branda Queen Attack Summon02"],
    [11979, "Ice Giant Edric King Attack Aoe01"],
    [11980, "Ice Giant Edric King Attack Aoe02"],
    [11981, "Fire Giant Branda Queen Attack Aoe01"],
    [11982, "Fire Giant Branda Queen Attack Aoe02"],
    [11983, "Ice Giant Eldric King Teleport01"],
    [11984, "Fire Giant Branda Queen Teleport01"],
    [11985, "Ice Giant Eldric King Inactive01"],
    [11986, "Ice Giant Eldric King Inactive02"],
    [11987, "Ice Giant Eldric King Death01"],
    [11988, "Loc Ice Giant Eldric King Death01 Floor01"],
    [11989, "Loc Ice Giant Eldric King Death01 Floor02"],
    [11990, "Fire Giant Branda Queen Inactive01"],
    [11991, "Fire Giant Branda Queen Inactive02"],
    [11992, "Fire Giant Branda Queen Death01"],
    [11993, "Loc Fire Giant Branda Queen Death01 Floor01"],
    [11994, "Loc Fire Giant Branda Queen Death01 Floor02"],
    [11995, "Vfx Fire Giant Branda Queen Spawn01"],
    [11996, "Vfx Fire Giant Branda Queen Attack Summon01"],
    [11997, "Vfx Fire Giant Branda Queen Attack Summon02"],
    [11998, "Vfx Fire Giant Branda Queen Teleport01"],
    [11999, "Vfx Fire Giant Branda Queen Attack Aoe01"],
    [12000, "Vfx Fire Giant Branda Queen Attack Aoe02"],
    [12001, "Vfx Fire Giant Branda Queen Death01"],
    [12002, "Vfx Placeholder Fire Queen Loc Attack"],
    [12003, "Vfx Branda Queen Loc01 Spawn01"],
    [12004, "Vfx Branda Queen Loc01 Spawn02"],
    [12005, "Vfx Branda Queen Loc01 Idle01"],
    [12006, "Vfx Branda Queen Loc01 Attack01"],
    [12007, "Vfx Branda Queen Loc01 Despawn01"],
    [12008, "Vfx Ice King Loc01 Spawn01"],
    [12009, "Vfx Ice King Loc01 Spawn02"],
    [12010, "Vfx Ice King Loc01 Idle01"],
    [12011, "Vfx Ice King Loc01 Despawn01"],
    [12012, "Vfx Ice Giant Eldric King Melee01 Proj01"],
    [12013, "Vfx Branda Queen Aoe Loc01"],
    [12014, "Vfx Eldric King Aoe Loc01"],
    [12015, "Vfx Giant Attack Aoe Protection01"],
    [12016, "Human Teleport Giantsoul Amulet 01"],
    [12017, "Vfx Human Teleport Giantsoul Amulet 01"],
    [12018, "Vfx Human Twin Flame Craft01"],
    [12019, "Human Male Prayer Scroll Read 01 Deadeye"],
    [12020, "Human Male Prayer Scroll Read 01 Mystic Vigour"],
    [12021, "Vfx Human Prayer Scroll Read 01 Deadeye"],
    [12022, "Human Female Prayer Scroll Read 02 Deadeye"],
    [12023, "Human Female Prayer Scroll Read 02 Mystic Vigour"],
    [12024, "Vfx Human Prayer Scroll Read 02 Mystic Vigour"],
    [12025, "Human Woodcutting League Axe"],
    [12026, "Human Woodcutting Trailblazer Axe"],
    [12027, "Throne Sit Ready"],
    [12028, "Chair Sit Ready Throne B"],
    [12029, "Chair Sit Ready Throne 1b"],
    [12030, "Chair Sit Ready Throne 2b"],
    [12031, "Chair Sit Ready Throne 3b"],
    [12032, "Chair Sit Ready Throne 4b"],
    [12033, "Chair Sit Ready Throne 5b"],
    [12034, "Chair Sit Ready Throne 6b"],
    [12035, "Chair Sit Ready Throne 7b"],
    [12036, "Globe Spin"],
    [12037, "Globe Idle"],
    [12038, "Gnome Rack Ready"],
    [12039, "Gnome Cry"],
    [12040, "Gnome Takes Photographs"],
    [12041, "Trek Gnome Eat"],
    [12042, "Gnome Walk"],
    [12043, "Gnome Attackbow"],
    [12044, "Gnome Attackunarmed"],
    [12045, "Gnome Attacksword"],
    [12046, "Gnome Block"],
    [12047, "Gnome Blockshield"],
    [12048, "Gnome Death"],
    [12049, "Gnome Chanting"],
    [12050, "Emote Panic Loop"],
    [12051, "Emote Jump With Joy Loop"],
    [12052, "Emote Ya Boo Sucks Loop"],
    [12053, "Emote Yawn Loop"],
    [12054, "Emote Yawn Short Loop"],
    [12055, "Emote Fremmenik Salute Loop"],
    [12056, "Emote Shrug Loop"],
    [12057, "Rabbit Emote Loop"],
    [12058, "Emote Run On Spot Loop"],
    [12059, "Emote Starjump 5 Loop"],
    [12060, "Emote Pushups 5 Loop"],
    [12061, "Emote Situps 5 Loop"],
    [12062, "Ash Emote Loop"],
    [12063, "Emote Explore Loop"],
    [12064, "Emote Flex Loop"],
    [12065, "Emote Party Loop"],
    [12066, "Emote Glass Wall Loop"],
    [12067, "Emote Climbing Rope Loop"],
    [12068, "Emote Glass Box Loop"],
    [12069, "Zombie Dance Loop"],
    [12070, "Zombie Walk Emote Loop"],
    [12071, "Emote Slap Head Loop"],
    [12072, "Emote Lightbulb Loop"],
    [12073, "Emote Panic Flap Loop"],
    [12074, "Human Cave Goblin Dance Loop"],
    [12075, "Terrified Emote Loop"],
    [12076, "Trail Bow Emote Loop"],
    [12077, "Trail Yawn Emote Loop"],
    [12078, "Trail Angry Emote Loop"],
    [12079, "Trail Dance Emote Loop"],
    [12080, "Emote Stampfeet Loop"],
    [12081, "Emote Stampfeet Dust Spotanim Loop"],
    [12082, "Human Cave Goblin Bow Loop"],
    [12083, "Bday17 Style Loop"],
    [12084, "Bday17 Lasso Loop"],
    [12085, "Emote Dance Spin Loop"],
    [12086, "Trail Yawn Emote Spotanim Loop"],
    [12087, "Easter25 Bowling01 Pin01 Idle"],
    [12088, "Easter25 Bowling01 Pin01 Hit"],
    [12089, "Easter25 Bowling01 Pin01 Dead"],
    [12090, "Humantree Hug"],
    [12091, "Human Climb Trellis"],
    [12092, "Vfx Ignite Staff Loop"],
    [12093, "Dragon Slayer Qip Fire1x1 Noloop"],
    [12094, "Vfx Surge Potion"],
    [12095, "Vfx Npc Yama Magic Shadow Spotanim01"],
    [12096, "Vfx Player Yama Magic Shadow Impact01"],
    [12097, "Vfx Player Yama Magic Shadow Impact End"],
    [12098, "Vfx Npc Yama Magic Fire Spotanim01"],
    [12099, "Vfx Player Yama Magic Fire Impact01"],
    [12100, "Vfx Player Yama Magic Fire Impact End"],
    [12101, "Vfx Npc Yama Fire Skull Spotanim01"],
    [12102, "Vfx Proj Yama Fire Skull 01"],
    [12103, "Vfx Player Yama Falling Rock Shadow Tremor01"],
    [12104, "Vfx Yama Flaming Rock Spotanim 01"],
    [12105, "Vfx Yama Flaming Rock Projectile 01"],
    [12106, "Vfx Yama Flaming Rock Impact 01"],
    [12107, "Vfx Yama Shadow Spike Spotanim 01"],
    [12108, "Vfx Yama Shadow Spike Projectile 01"],
    [12109, "Vfx Yama Shadow Spike Impact 01"],
    [12110, "Vfx Yama Shadow Root Spotanim 01"],
    [12111, "Vfx Yama Shadow Root Projectile 01"],
    [12112, "Vfx Yama Shadow Root Impact 01"],
    [12113, "Vfx Yama Meteor Spotanim01"],
    [12114, "Vfx Yama Meteor Projectile 01"],
    [12115, "Vfx Yama Meteor Projectile 02"],
    [12116, "Vfx Yama Meteor Projectile 03"],
    [12117, "Vfx Yama Meteor Impact 01"],
    [12118, "Vfx Yama Meteor Impact 02"],
    [12119, "Vfx Yama Meteor Impact 03"],
    [12120, "Vfx Player Yama Falling Rock Impact01"],
    [12121, "Vfx Player Yama Falling Rock Fire Tremor01"],
    [12122, "Vfx Shadow Wall01"],
    [12123, "Vfx Shadow Wall02"],
    [12124, "Vfx Shadow Wall03"],
    [12125, "Vfx Fire Wall 01"],
    [12126, "Vfx Fire Wall 02"],
    [12127, "Vfx Fire Wall 03"],
    [12128, "Vfx Yama Floor Portal01"],
    [12129, "Vfx Yama Portal Shadow"],
    [12130, "Vfx Yama Floor Portal02"],
    [12131, "Vfx Shadow Wall Original"],
    [12132, "Vfx Soulflame Horn Spotanim01"],
    [12133, "Npc Voidflare Idle"],
    [12134, "Npc Voidflare Death"],
    [12135, "Npc Voidflare Spawn"],
    [12136, "Npc Voidflare Explode"],
    [12137, "Vfx Voidflare Explode"],
    [12138, "Vfx Voidflare Explode Yama Impact"],
    [12139, "Vfx Voidflare Human Impact"],
    [12140, "Npc Yama01 Idle01"],
    [12141, "Npc Yama01 Walk01"],
    [12142, "Npc Yama01 Walk02"],
    [12143, "Npc Yama01 Walk03"],
    [12144, "Npc Yama01 Magic01"],
    [12145, "Npc Yama01 Magic02"],
    [12146, "Npc Yama01 Melee01"],
    [12147, "Npc Yama01 Portal01"],
    [12148, "Npc Yama01 Stomp01"],
    [12149, "Human Yama Portalfall"],
    [12150, "Soulflame Horn Blow 01"],
    [12151, "Soulflame Horn Blow 02"],
    [12152, "Human Yama Portal Fall On Face"],
    [12153, "Npc Yama Noncombat Idle01"],
    [12154, "Npc Yama Noncombat Summon01"],
    [12155, "Vfx Yama Noncombat Summon01"],
    [12156, "Npc Yama Summon01"],
    [12157, "Vfx Combat Summon01"],
    [12158, "Soulflame Horn Blow 03"],
    [12159, "Soulflame Horn Blow 03 No Fire"],
    [12160, "Npc Yama01 Portal02"],
    [12161, "Npc Yama01 Despawn01"],
    [12162, "Vfx Combat Despawn01"],
    [12163, "Npc Yama Noncombat Spawn01"],
    [12164, "Vfx Yama Noncombat Spawn01"],
    [12165, "Npc Yama Noncombat Spawn02"],
    [12166, "Vfx Yama Noncombat Spawn02"],
    [12167, "Npc Yama Noncombat Click01"],
    [12168, "Vfx Yama Noncombat Click01"],
    [12169, "Yama Loc Glyph Activate Fire"],
    [12170, "Yama Loc Glyph Deactivate Fire"],
    [12171, "Yama Loc Glyph Activate Shadow"],
    [12172, "Yama Loc Glyph Deactivate Shadow"],
    [12173, "Yama Loc Inactive"],
    [12174, "Yama Immunity Fire"],
    [12175, "Yama Immunity Shadow"],
    [12176, "Vfx Player Yama Immunity 01"],
    [12177, "Pickaxe Power Swing"],
    [12178, "Pickaxe Power Swing Bronze"],
    [12179, "Pickaxe Power Swing Iron"],
    [12180, "Pickaxe Power Swing Steel"],
    [12181, "Pickaxe Power Swing Black"],
    [12182, "Pickaxe Power Swing Mithril"],
    [12183, "Pickaxe Power Swing Adamant"],
    [12184, "Pickaxe Power Swing Rune"],
    [12185, "Pickaxe Power Swing Gilded"],
    [12186, "Pickaxe Power Swing Dragon"],
    [12187, "Pickaxe Power Swing Pretty"],
    [12188, "Pickaxe Power Swing Zalcano"],
    [12189, "Pickaxe Power Swing Infernal"],
    [12190, "Pickaxe Power Swing 3a"],
    [12191, "Pickaxe Power Swing Crystal"],
    [12192, "Pickaxe Power Swing Trailblazer"],
    [12193, "Pickaxe Power Swing League Trailblazer"],
    [12194, "Pickaxe Power Swing Trailblazer No Infernal"],
    [12195, "Human Wipe Head 1"],
    [12196, "Human Yama Shortjump01"],
    [12197, "Human Hammer Heft"],
    [12198, "Human Hammer Hit Loop"],
    [12199, "Human Hammer Flip"],
    [12200, "Human Smithing Enter"],
    [12201, "Human Smithing Idle"],
    [12202, "Spotanim Chasm Of Fire Anvil Sparks"],
    [12203, "Human Furnace Nostall"],
    [12204, "Judgeofyama Attack Slow"],
    [12205, "Hippo Idle"],
    [12206, "Human Lead Actor Dead 01 Loop"],
    [12207, "Npc Nature Spirit Snake Spawn"],
    [12208, "Npc Nature Spirit Snake Despawn"],
    [12209, "Wgs Human Ko Dead Idle"],
    [12210, "Soc Victim Pose 1"],
    [12211, "Soc Victim Pose 2"],
    [12212, "Human Troll Flyback Withsound"],
    [12213, "Human Troll Flyback Abort"],
    [12214, "Human Fade Out"],
    [12215, "Human Fade Out 30"],
    [12216, "Human Fade In"],
    [12217, "Human Fade In 30"],
    [12218, "Human Invisible"],
    [12219, "Npc Parrot Idle 01"],
    [12220, "Npc Parrot Flying Idle 01"],
    [12221, "Npc Spirit Harpy Eagle Flying Idle 01"],
    [12222, "Npc Nature Spirit Eagle Spawn"],
    [12223, "Npc Nature Spirit Eagle Despawn"],
    [12224, "Restless Ghost Vanish Highpriority"],
    [12225, "Restless Ghost Vanish Reverse Nodelay"],
    [12226, "Vmq4 Cultist Ranged Fire Launch 01"],
    [12227, "Vfx Vmq4 Cultist Ranged Fire Launch 01"],
    [12228, "Vmq4 Metzli Ranged Fire Launch Enraged 01"],
    [12229, "Vfx Vmq4 Metzli Ranged Fire Launch Enraged 01"],
    [12230, "Vfx Vmq4 Metzli Ranged Fire Projectile Enraged 01"],
    [12231, "Vmq4 Metzli Magic Water Cast01"],
    [12232, "Vfx Vmq4 Metzli Magic Water Cast01"],
    [12233, "Vmq4 Metzli Cast"],
    [12234, "Vfx Vmq4 Metzli Cast"],
    [12235, "Vfx Vmq4 Metzli Fire Wall Cast"],
    [12236, "Vfx Vmq4 Metzli Fire Wall Walk"],
    [12237, "Vfx Vmq4 Metzli Fire Wall Walk Withsound"],
    [12238, "Vfx Vmq4 Metzli Fire Wall Despawn"],
    [12239, "Vfx Vmq4 Metzli Fire Wall Despawn Withsound"],
    [12240, "Vfx Vmq4 Metzli Water Wall Cast"],
    [12241, "Vfx Vmq4 Metzli Water Wall Walk"],
    [12242, "Vfx Vmq4 Metzli Water Wall Walk Withsound"],
    [12243, "Vfx Vmq4 Metzli Water Wall Despawn"],
    [12244, "Vfx Vmq4 Metzli Water Wall Despawn Withsound"],
    [12245, "Vmq4 Teleport Metzli Disappear Idle 01"],
    [12246, "Vmq4 Teleport Metzli Disappear Despawn 01"],
    [12247, "Vmq4 Teleport Metzli Reappear Idle 01"],
    [12248, "Vmq4 Transform Metzli Sun"],
    [12249, "Vmq4 Transform Metzli Moon"],
    [12250, "Vmq4 Metzli Kneel Down"],
    [12251, "Vmq4 Metzli Kneel Down Highpriority"],
    [12252, "Vmq4 Metzli Kneeling Loop"],
    [12253, "Vmq4 Metzli Standup"],
    [12254, "Vmq4 Ennius Spin"],
    [12255, "Vmq4 Moon Puzzle Fire 01 Spawn"],
    [12256, "Vmq4 Moon Puzzle Fire 01 Idle"],
    [12257, "Vmq4 Moon Puzzle Fire 01 Despawn"],
    [12258, "Vmq4 Enforcer Attack"],
    [12259, "Vmq4 Human Fadeout Walkmerge"],
    [12260, "Vmq4 Human Fadein Walkmerge"],
    [12261, "Vmq4 Cultist Magic Water Cast01"],
    [12262, "Vfx Vmq4 Projectile Magic Water Cast01"],
    [12263, "Vmq4 Projectile Cultist Magic Water 01"],
    [12264, "Vmq4 Impact Cultist Magic Water 01"],
    [12265, "Vmq4 Cultist Magic Water Cast02"],
    [12266, "Vfx Vmq4 Projectile Magic Water Cast02"],
    [12267, "Vmq4 Projectile Cultist Magic Water 02"],
    [12268, "Vmq4 Impact Cultist Magic Water 02"],
    [12269, "Vmq4 Projectile Cultist Ranged Fire 01"],
    [12270, "Vmq4 Impact Cultist Ranged Fire 01"],
    [12271, "Vmq4 Protection Cultist Magic Air Spawn 01"],
    [12272, "Vmq4 Protection Cultist Magic Air Idle 01"],
    [12273, "Vmq4 Protection Cultist Magic Air Despawn 01"],
    [12274, "Vmq4 Protection Cultist Magic Absorb"],
    [12275, "Vmq4 Ennius Lines Special"],
    [12276, "Vfx Vmq4 Ennius Lines Special"],
    [12277, "Vmq4 Ennius Cast"],
    [12278, "Vfx Vmq4 Ennius Cast"],
    [12279, "Vfx Vmq4 Ennius Fire Loc Marker Spawn"],
    [12280, "Vfx Vmq4 Ennius Fire Loc Spawn"],
    [12281, "Vmq4 Protection Ennius Cast"],
    [12282, "Vmq4 Bound Walk F"],
    [12283, "Entrance Tonali01 Opening"],
    [12284, "Entrance Tonali01 Opening Wider"],
    [12285, "Entrance Tonali01 Open"],
    [12286, "Entrance Tonali01 Closed"],
    [12287, "Npc Djinn Earth01 Idle01"],
    [12288, "Npc Djinn Earth01 Idle02"],
    [12289, "Npc Djinn Earth01 Walk01"],
    [12290, "Npc Djinn Earth01 Walk02"],
    [12291, "Npc Djinn Earth01 Attack01"],
    [12292, "Npc Djinn Earth01 Attack02"],
    [12293, "Npc Djinn Earth01 Reinforce01"],
    [12294, "Npc Djinn Earth01 Break01"],
    [12295, "Npc Djinn Earth01 Death01"],
    [12296, "Statue Icosahedron01 Despawn"],
    [12297, "Vmq4 Arkan Blade Special"],
    [12298, "Vmq4 Arkan Blade Special Spotanim"],
    [12299, "Vmq4 Arkan Blade Special Spotanim F"],
    [12300, "Vmq4 Slap Anim"],
    [12301, "Vmq4 Chamber Guard Charge"],
    [12302, "Vmq4 Chamber Guard Smoke"],
    [12303, "Vmq4 Zyanyi Sitting Idle"],
    [12304, "Vmq4 Ikniu Idle"],
    [12305, "Vmq4 Human Caique Pet"],
    [12306, "Vmq4 Caique Peck"],
    [12307, "Scrambled Egg Idle"],
    [12308, "Scrambled Egg Splat"],
    [12309, "Scrambled Egg Splat Offset01"],
    [12310, "Scrambled Egg Splat Offset02"],
    [12311, "Scrambled Egg Splattered Idle"],
    [12312, "Scrambled Alan Enter Hands On Hip"],
    [12313, "Scrambled Alan Hands On Hip"],
    [12314, "Scrambled Alan Fall"],
    [12315, "Scrambled Alan Walk Offset"],
    [12316, "Scrambled Alan Walk Into Hands On Hips"],
    [12317, "Petegg Human Ready"],
    [12318, "Petegg Human Walk"],
    [12319, "Petegg Human Walk B"],
    [12320, "Petegg Human Running"],
    [12321, "Petegg Human Turnonspot"],
    [12322, "Petegg Human Walk L"],
    [12323, "Petegg Human Walk R"],
    [12324, "Petegg Human Kick"],
    [12325, "Petegg Human Punch"],
    [12326, "Petegg Human Defend"],
    [12327, "Petegg Human Running F"],
    [12328, "Scrambled Human Whetstone"],
    [12329, "Human Fletching Single Rock Shard"],
    [12330, "Human Fletching No Items"],
    [12331, "Human Sword Def Leather Hit 3"],
    [12332, "Human Sword Slash Withsound"],
    [12333, "Human Blunt Pound Withsound"],
    [12334, "Human Staff Block Leather Hit 3"],
    [12335, "Human Unarmedblock Leather Hit 3"],
    [12336, "Human Spear Spike Withsound"],
    [12337, "Human Spear Block Leather Hit 3"],
    [12338, "Human Climbing Merge"],
    [12339, "Human Straighten Up"],
    [12340, "Zygomite Leap Out Npc"],
    [12341, "Entangle Impact No Red"],
    [12342, "Tecpatl Stab"],
    [12343, "Nature Ent01 Trail01 Spawn"],
    [12344, "Nature Ent01 Trail01 Inactive Idle"],
    [12345, "Nature Ent01 Trail01 Inactive Spawn To Idle"],
    [12346, "Nature Ent01 Trail01 Active Idle"],
    [12347, "Nature Ent01 Trail01 Inactive Despawn"],
    [12348, "Nature Ent01 Trail01 Active Despawn"],
    [12349, "Vfx Nature Spirit Bison Spawn"],
    [12350, "Vfx Nature Spirit Bison Despawn"],
    [12351, "Vfx Nature Spirit Jaguar Spawn"],
    [12352, "Vfx Nature Spirit Jaguar Despawn"],
    [12353, "Vfx Nature Spirit Eagle Spawn"],
    [12354, "Vfx Nature Spirit Eagle Despawn"],
    [12355, "Vfx Nature Spirit Snake Spawn"],
    [12356, "Vfx Nature Spirit Snake Despawn"],
    [12357, "Vfx Nature Spirit Wolf Spawn"],
    [12358, "Vfx Nature Spirit Wolf Despawn"],
    [12359, "Vfx Nature Spirit Scorpion Spawn"],
    [12360, "Vfx Nature Spirit Scorpion Despawn"],
    [12361, "Npc Custodian Stalker01 Walk01"],
    [12362, "Npc Custodian Stalker01 Ready01"],
    [12363, "Npc Custodian Stalker02 Ready01"],
    [12364, "Npc Custodian Stalker02 Ready02"],
    [12365, "Npc Custodian Stalker02 Walk01"],
    [12366, "Npc Custodian Stalker02 Stomp01"],
    [12367, "Npc Custodian Stalker02 Run01"],
    [12368, "Npc Custodian Stalker02 Death01"],
    [12369, "Npc Custodian Stalker02 Attack01"],
    [12370, "Npc Custodian Stalker03 Ready01"],
    [12371, "Npc Custodian Stalker03 Death01"],
    [12372, "Npc Custodian Stalker03 Ready02"],
    [12373, "Npc Custodian Stalker03 Walk01"],
    [12374, "Npc Custodian Stalker03 Stomp01"],
    [12375, "Npc Custodian Stalker03 Attack01"],
    [12376, "Npc Custodian Stalker04 Ready01"],
    [12377, "Npc Custodian Stalker04 Walk01"],
    [12378, "Npc Custodian Stalker04 Walk02"],
    [12379, "Npc Custodian Stalker04 Walk03"],
    [12380, "Npc Custodian Stalker04 Attack01"],
    [12381, "Npc Custodian Stalker04 Howl01"],
    [12382, "Npc Custodian Stalker04 Stomp01"],
    [12383, "Npc Custodian Stalker04 Death01"],
    [12384, "Npc Custodian Stalker05 Ready01"],
    [12385, "Npc Custodian Stalker05 Ready02"],
    [12386, "Npc Custodian Stalker05 Ready03"],
    [12387, "Npc Custodian Stalker05 Walk01"],
    [12388, "Npc Custodian Stalker05 Attack01"],
    [12389, "Npc Custodian Stalker05 Howl01"],
    [12390, "Npc Custodian Stalker05 Stomp01"],
    [12391, "Npc Custodian Stalker05 Death01"],
    [12392, "Vfx Player Custodian Stalker Special"],
    [12393, "Vfx Player Custodian Stalker 05 Special"],
    [12394, "Human Eye Of Ayak Special"],
    [12395, "Eye Of Ayak Special Spotanim"],
    [12396, "Eye Of Ayak Special Impact"],
    [12397, "Human Eye Of Ayak Normal"],
    [12398, "Vfx Ayak Normal Proj"],
    [12399, "Eye Of Ayak Normal Spotanim"],
    [12400, "Vfx Ayak Normal Impact"],
    [12401, "Npc Doom Boss Pet Idle"],
    [12402, "Npc Doom Boss Pet Walk"],
    [12403, "Human Craft Confliction"],
    [12404, "Spotanim Confliction Craft"],
    [12405, "Dom Idle"],
    [12406, "Dom Standard Range Attack"],
    [12407, "Dom Rock Throw Attack"],
    [12408, "Dom Beam Charge"],
    [12409, "Dom Beam Charge Loop"],
    [12410, "Dom Beam Cancel"],
    [12411, "Dom Beam Fire"],
    [12412, "Dom Area Charge"],
    [12413, "Dom Area Charge Loop"],
    [12414, "Doom Area Slam"],
    [12415, "Doom Area Slam Return Idle"],
    [12416, "Dom Melee Attack"],
    [12417, "Dom Burrowed Movement"],
    [12418, "Dom Burrowed Emerge"],
    [12419, "Dom Burrowed Explosion"],
    [12420, "Dom Burrow"],
    [12421, "Dom Burrow Idle"],
    [12422, "Dom Despawn"],
    [12423, "Vfx Doom Area Slam"],
    [12424, "Vfx Dom Burrowed Movement"],
    [12425, "Vfx Dom Burrowed Emerge"],
    [12426, "Vfx Dom Burrowed Explosion"],
    [12427, "Vfx Dom Burrowed Explosion Aoe"],
    [12428, "Vfx Dom Burrow"],
    [12429, "Vfx Dom Burrow Idle"],
    [12430, "Vfx Dom Despawn"],
    [12431, "Area Node Idle"],
    [12432, "Area Node Spawn"],
    [12433, "Area Node Death"],
    [12434, "Area Node Pop"],
    [12435, "Shield Idle"],
    [12436, "Shield Spawn"],
    [12437, "Shield Death"],
    [12438, "Vfx Rock Projectile Launch"],
    [12439, "Vfx Rock Split"],
    [12440, "Vfx Rock Projectile Proj"],
    [12441, "Vfx Rock Projectile Proj Alt"],
    [12442, "Vfx Rock Impact"],
    [12443, "Vfx Area Slam 01"],
    [12444, "Vfx Area Slam 02"],
    [12445, "Vfx Area Slam 03"],
    [12446, "Vfx Area Slam 04"],
    [12447, "Vfx Beam Attack Head 01"],
    [12448, "Vfx Beam Middle Segment 01"],
    [12449, "Vfx Beam End Segment 01"],
    [12450, "Vfx Beam Impact 01"],
    [12451, "Vfx Beam Charge Up 01"],
    [12452, "Vfx Beam Charge Up Burrow 01"],
    [12453, "Npc Doom Boss Idle Ca"],
    [12454, "Vfx Doom Boss Burrowed Movement Telegraph"],
    [12455, "Vfx Doom Boss Burrowed Telegraph Spawn"],
    [12456, "Npc Demonic Grub Walk"],
    [12457, "Vfx Demonic Grub Spawn"],
    [12458, "Npc Demonic Grub Spawn"],
    [12459, "Npc Demonic Grub Death"],
    [12460, "Vfx Demonic Grub Explosion01"],
    [12461, "Vfx Demonic Grub Explosion02"],
    [12462, "Vfx Demonic Grub Explosion03"],
    [12463, "Vfx Demonic Grub Explosion04"],
    [12464, "Vfx Demonic Grub Explosion05"],
    [12465, "Vfx Demonic Grub Explosion06"],
    [12466, "Vfx Demonic Grub Explosion07"],
    [12467, "Vfx Demonic Grub Explosion08"],
    [12468, "Vfx Demonic Grub Player Impact02"],
    [12469, "Vfx Doom Blood Splat"],
    [12470, "Vfx Doom Blood Splat Despawn"],
    [12471, "Vfx Doom Mound"],
    [12472, "Vfx Doom Mound Beam Cancel"],
    [12473, "Vfx Doom Mound Melee Attack"],
    [12474, "Vfx Doom Mound Burrowed Emerge"],
    [12475, "Vfx Doom Mound Burrow"],
    [12476, "Vfx Doom Mound Despawn"],
    [12477, "Vfx Doom Hole Spawn"],
    [12478, "Kastori Vase Snake"],
    [12479, "Fountain Talteklan01 Default01 Idle01"],
    [12480, "Crab Boss Idle"],
    [12481, "Crab Boss Spawn"],
    [12482, "Crab Boss Death"],
    [12483, "Crab Boss Attack"],
    [12484, "Crab Boss Remains Disintegrate"],
    [12485, "Crab Boss Remains Idle"],
    [12486, "Crab Boss Remains Idle Spot"],
    [12487, "Vfx Crab Boss Spawn"],
    [12488, "Vfx Crab Boss Death"],
    [12489, "Vfx Crab Boss Disintegrate"],
    [12490, "Npc Boar Combat Idle Silent"],
    [12491, "Blood Jaguar Combat Melee"],
    [12492, "Blood Jaguar Combat Death"],
    [12493, "Npc Nature Spirit Jaguar Spawn"],
    [12494, "Npc Nature Spirit Jaguar Despawn"],
    [12495, "Npc Ocelot Combat Idle"],
    [12496, "Npc Ocelot Combat Melee"],
    [12497, "Npc Ocelot Combat Death"],
    [12498, "Npc Jaguar Combat Melee"],
    [12499, "Npc Jaguar Combat Death"],
    [12500, "Npc Ent Walk 01"],
    [12501, "Npc Ent Walk 02"],
    [12502, "Npc Ent Ready 01"],
    [12503, "Npc Ent Ready 02"],
    [12504, "Npc Ent Defend 01"],
    [12505, "Npc Ent Defend 02"],
    [12506, "Npc Ent Attack 01"],
    [12507, "Npc Ent Attack 02"],
    [12508, "Npc Ent Death 01"],
    [12510, "Npc Ent Worship 01"],
    [12511, "Npc Ent Worship 02"],
    [12512, "Vfx Ent Auburn Reward Spawn 01"],
    [12513, "Waterwheel Spin Counter"],
    [12514, "Emote Sit To Stand"],
    [12515, "Npc Nature Spirit Wolf Spawn"],
    [12516, "Npc Nature Spirit Wolf Despawn"],
    [12517, "Npc Nature Spirit Bison Spawn"],
    [12518, "Npc Nature Spirit Bison Despawn"],
    [12519, "Npc Nature Spirit Scorpion Spawn"],
    [12520, "Npc Nature Spirit Scorpion Despawn"],
    [12521, "Vfx Lightning Flicker"],
    [12522, "Squirrel Monkey Idle"],
    [12523, "Squirrel Monkey Walk"],
    [12524, "Squirrel Fly"],
    [12525, "Human Walk 60"],
    [12526, "Human Eat Withsound"],
    [12527, "Human Stamp Merge"],
]);

/**
 * Get the human-readable name for an animation ID, or undefined if not known.
 */
export function getAnimationName(seqId: number): string | undefined {
    return ANIMATION_NAMES.get(seqId);
}
